window.DREAMNOTE_TRACKS = [
  {
    "title": "Relaxing Piano Background",
    "description": "A calm and atmospheric track featuring solo piano. Ideal for use in meditation audio, documentaries, movie/film soundtracks or any project of a reflective or tranquil nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "ambient, atmospheric, beautiful, calm, cinematic, dream, elegant, emotional, ethereal, film, melancholy, mellow, memories, movie, nostalgic, peaceful, pianist, piano, reflective, relaxed, romantic, sad, sentimental, serene, soothing, sorrow, sublime, thoughtful, tranquil",
    "price": 20,
    "date": "2024-05-09",
    "videoId": "ootKboBS_PQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=ootKboBS_PQ",
    "productUrl": "http://audiojungle.net/item/relaxing-piano-background/52145429",
    "duration": "4:04"
  },
  {
    "title": "Energetic Positive Logo",
    "description": "A motivational rock music intro/ident/opener/jingle featuring distorted guitar, bass and drums. Ideal for use as a YouTube video intro, or in TV/radio adverts, commercials, vlogs, or podcasts.",
    "genre": "Corporate",
    "instrumentation": "Distorted electric guitar, bass and drums",
    "tags": "achievement, adventure, advert, brand, business, commercial, confident, corporate, dynamic, energetic, guitar, ident, inspirational, inspiring, intro, logo, marketing, motivation, motivational, opener, optimistic, positive, powerful, promotional, short, success, upbeat, uplifting, vlog",
    "price": 10,
    "date": "2024-05-08",
    "videoId": "tFPr2ehaG8w",
    "youtubeUrl": "https://www.youtube.com/watch?v=tFPr2ehaG8w",
    "productUrl": "https://audiojungle.net/item/energetic-positive-logo/52128136",
    "duration": "0:12"
  },
  {
    "title": "Positive Upbeat Pop Logo",
    "description": "A motivational and happy music intro/ident/opener featuring voice, synths, bass and drums. Ideal for use as a YouTube video opener, TV/radio advert/commercial backing, or vlog intro.",
    "genre": "Corporate",
    "instrumentation": "Female voice, synths, bass and drums",
    "tags": "achievement, adventure, advert, brand, business, commercial, confident, corporate, family, holiday, hopeful, ident, inspirational, inspiring, intro, logo, marketing, motivation, motivational, opener, optimistic, positive, promotional, short, success, summer, upbeat, uplifting, vacation, vlog",
    "price": 12,
    "date": "2024-05-06",
    "videoId": "U8g2BC1Z2-8",
    "youtubeUrl": "https://www.youtube.com/watch?v=U8g2BC1Z2-8",
    "productUrl": "http://audiojungle.net/item/positive-upbeat-pop-logo/52099996",
    "duration": "0:15"
  },
  {
    "title": "Simple Background Groove",
    "description": "A positive track featuring acoustic guitar, electric guitar, bass, and percussion. Ideal for use in adverts/commercials, corporate promotional material, business presentations, TV/radio, or YouTube videos/vlogs.",
    "genre": "Acoustic",
    "instrumentation": "Acoustic guitar, electric guitar, bass, percussion",
    "tags": "advert, advertisement, ambient, background, bass, bluesy, catchy, chill, commercial, cool, corporate, easy, funk, funky, groove, groovy, guitar, instrumental, laid-back, light, mellow, percussion, positive, relaxing, rhythmic, serene, smooth, soulful, subtle",
    "price": 16,
    "date": "2024-02-15",
    "videoId": "zfx4K6pEnAk",
    "youtubeUrl": "https://www.youtube.com/watch?v=zfx4K6pEnAk",
    "productUrl": "https://audiojungle.net/item/simple-background-groove/50777474",
    "duration": "1:17"
  },
  {
    "title": "Horror Voice with Orchestra",
    "description": "A dark, atmospheric track featuring haunting girl’s vocals (instrumental version also included) with creepy celesta, piano, violin, glockenspiel and sustained orchestral strings. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audio books, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Female voice, celesta, piano, violin, glockenspiel and orchestral strings",
    "tags": "atmospheric, child, creepy, dark, fantasy, female, ghost, girl, gothic, halloween, haunting, horror, kid, kids, lullaby, murder, mysterious, mystery, nightmare, scary, sing, singing, song, soundtrack, spooky, suspense, thriller, twisted, vocal, voice",
    "price": 18,
    "date": "2023-10-13",
    "videoId": "9n4UdHFnudY",
    "youtubeUrl": "https://www.youtube.com/watch?v=9n4UdHFnudY",
    "productUrl": "http://audiojungle.net/item/horror-voice-with-orchestra/48613561",
    "duration": "1:30"
  },
  {
    "title": "Fantasy Horror Child Vocals",
    "description": "A dark, atmospheric track featuring haunting female voice (instrumental version also included) with creepy celesta, piano, glockenspiel and expressive orchestral strings. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audio books, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Female voice, celesta, piano, glockenspiel and orchestral strings",
    "tags": "atmospheric, child, creepy, dark, fantasy, female, ghost, girl, gothic, halloween, haunting, horror, kid, kids, lullaby, murder, mysterious, mystery, nightmare, scary, sing, singing, song, soundtrack, spooky, suspense, thriller, twisted, vocal, voice",
    "price": 20,
    "date": "2023-10-02",
    "videoId": "VBPtZv9r0V8",
    "youtubeUrl": "https://www.youtube.com/watch?v=VBPtZv9r0V8",
    "productUrl": "http://audiojungle.net/item/fantasy-horror-child-vocals/48366124",
    "duration": "2:47"
  },
  {
    "title": "Upbeat Kids' Theme",
    "description": "‘Upbeat Kids’ Theme’ is a positive, happy theme-tune featuring cheerful synth melody, piano, banjo, ukulele, glockenspiel, bass and percussion. This jolly, playful track is perfect for TV shows, kids cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos or any project with a lively, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Synth, piano, banjo, ukulele, glockenspiel, bass and percussion",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, child, children, comedy, fun, funny, game, happy, ident, intro, kids, logo, party, play, playful, positive, quirky, school, theme-tune, tv, tv theme, upbeat, uptempo, video intro, youtube",
    "price": 16,
    "date": "2023-09-20",
    "videoId": "gu71wqH-d3k",
    "youtubeUrl": "https://www.youtube.com/watch?v=gu71wqH-d3k",
    "productUrl": "http://audiojungle.net/item/upbeat-kids-theme/48110320",
    "duration": "1:27"
  },
  {
    "title": "Horror Background Loop",
    "description": "A haunting, mysterious and atmospheric track featuring piano, celesta, music box and sustained orchestral strings (version without strings also included). Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audio books, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Piano, celesta, music box and orchestral strings",
    "tags": "atmospheric, audio book, creepy, dark, dream, evil, fantasy, ghost, ghostly, girl, gothic, halloween, haunted, haunting, horror, innocent, lullaby, mysterious, mystery, nightmare, scary, soundtrack, spooky, strings, suspense, theme, thriller, trailer, twisted, underscore",
    "price": 16,
    "date": "2023-09-15",
    "videoId": "TwNM9rPipk0",
    "youtubeUrl": "https://www.youtube.com/watch?v=TwNM9rPipk0",
    "productUrl": "http://audiojungle.net/item/horror-background-loop/48056649",
    "duration": "1:06"
  },
  {
    "title": "Happy Uplifting Pop",
    "description": "An upbeat and energetic track featuring synths, funky electric guitars, vocal shouts, bass and drums. Ideal for use in motivational TV/radio adverts/commercials and vacation/summer holiday videos/YouTube vlogs.",
    "genre": "Corporate",
    "instrumentation": "Synth, electric guitar, bass and drums",
    "tags": "advert, bright, catchy, celebrate, cheerful, commercial, dance, dancing, driving, energetic, energy, exciting, fun, funky, guitar, happy, hey, inspiring, lively, motivational, optimistic, party, pop, positive, summer, upbeat, uplifting, vlog, youthful, youtube",
    "price": 20,
    "date": "2023-09-09",
    "videoId": "mDMPYKNs9pY",
    "youtubeUrl": "https://www.youtube.com/watch?v=mDMPYKNs9pY",
    "productUrl": "http://audiojungle.net/item/happy-uplifting-pop/47937685",
    "duration": "2:45"
  },
  {
    "title": "Cinematic Vocal Horror",
    "description": "A dark, atmospheric track featuring haunting female voice (instrumental versions also included) with piano, violin, cello, choir and sustained orchestral strings. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audio books, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Female voice. piano, violin, cello, choir and orchestral strings",
    "tags": "atmospheric, book trailer, child, creepy, dark, dream, evil, fantasy, female voice, ghost, ghostly, girl, gothic, halloween, haunted, haunting, horror, kids voice, lullaby, mysterious, mystery, nightmare, scary, soundtrack, spooky, suspense, thriller, trailer, twisted, young girl",
    "price": 20,
    "date": "2023-08-28",
    "videoId": "ym1Se2wzquY",
    "youtubeUrl": "https://www.youtube.com/watch?v=ym1Se2wzquY",
    "productUrl": "http://audiojungle.net/item/cinematic-vocal-horror/47708896",
    "duration": "2:09"
  },
  {
    "title": "Kids' Fun Ident",
    "description": "‘Kids’ Fun Ident’ is a happy jingle/ident/theme-tune featuring upbeat piano, synth, banjo, percussion, bass and glockenspiel. This bright, playful music intro is perfect for children’s TV shows, cartoons/animations, computer games/apps, party games, comedy videos or YouTube videos.",
    "genre": "Children's",
    "instrumentation": "Piano, synth, banjo, percussion, bass and glockenspiel",
    "tags": "animation, bouncy, cartoon, catchy, cheerful, childlike, children, energetic, entertaining, enthusiastic, fun, funny, happy, ident, intro, jingle, jolly, joyful, kids, lively, merry, playful, positive, quirky, upbeat, uplifting, vibrant, youthful",
    "price": 10,
    "date": "2023-08-21",
    "videoId": "ddu7uhJElPY",
    "youtubeUrl": "https://www.youtube.com/watch?v=ddu7uhJElPY",
    "productUrl": "http://audiojungle.net/item/kids-fun-ident/47592669",
    "duration": "0:14"
  },
  {
    "title": "Joyful Baroque",
    "description": "A regal, uplifting traditional classical track featuring orchestral strings, woodwind, harpsichord. Perfect for advertising/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, harpsichord and trumpet.",
    "tags": "advert, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, majestic, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 16,
    "date": "2023-03-15",
    "videoId": "Yt0R1vA73AY",
    "youtubeUrl": "https://www.youtube.com/watch?v=Yt0R1vA73AY",
    "productUrl": "https://audiojungle.net/item/joyful-baroque/44227625",
    "duration": "1:39"
  },
  {
    "title": "Lazy Lofi Chillhop",
    "description": "A laid-back, relaxed, downtempo track featuring acoustic piano, electric piano, electric guitar, bass and drums, blending elements of hip hop music and classic lofi beats. Perfect for TV, adverts/commercials, YouTube video background music or lofi study/relaxing beats playlists.",
    "genre": "Corporate",
    "instrumentation": "Piano, electric piano, electric guitar, bass and drums",
    "tags": "background, beat, calm, chill, chill hop, chill-hop, chillHop, downtempo, easy, good mood, groove, hip hop, hiphop, lazy, lo fi, lo-fi, lofi, LoFi Hip Hop, lounge, piano, r & b, relax, relaxing, slow, smooth, study, trip hop, urban, vintage, vlog",
    "price": 20,
    "date": "2023-03-08",
    "videoId": "CbpWyakrvxs",
    "youtubeUrl": "https://www.youtube.com/watch?v=CbpWyakrvxs",
    "productUrl": "https://audiojungle.net/item/lazy-lofi-chillhop/44071882",
    "duration": "2:54"
  },
  {
    "title": "Christmas Magic",
    "description": "An atmospheric, cinematic xmas track featuring piano with orchestral strings, sleigh bells, brass and choir. Ideal for use in YouTube Vlogmas video intros, Christmas TV adverts/commercials, greetings cards, xmas games/apps or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells. Piano, orchestra",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv, xmas",
    "price": 20,
    "date": "2022-11-19",
    "videoId": "2lOfif7tqrw",
    "youtubeUrl": "https://www.youtube.com/watch?v=2lOfif7tqrw",
    "productUrl": "https://audiojungle.net/item/christmas-magic/40953195",
    "duration": "2:27"
  },
  {
    "title": "Fun Logo",
    "description": "An upbeat, happy ident/opener/jingle/intro/logo featuring recorder, xylophone, glockenspiel, vibraphone, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Recorder, xylophone, glockenspiel, vibraphone, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, childrens, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2022-07-14",
    "videoId": "7kaBJAcGYFw",
    "youtubeUrl": "https://www.youtube.com/watch?v=7kaBJAcGYFw",
    "productUrl": "http://audiojungle.net/item/fun-logo/38669064",
    "duration": "0:09"
  },
  {
    "title": "Kids' Comedy Logo",
    "description": "An upbeat, happy ident/opener/jingle/intro featuring piano, xylophone, synth, percussion and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Piano, xylophone, synth, percussion, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2021-08-03",
    "videoId": "_eGsvM82Ero",
    "youtubeUrl": "https://www.youtube.com/watch?v=_eGsvM82Ero",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794907-Kids-Comedy-Logo-0m10?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Classic Baroque",
    "description": "A regal, traditional classical track featuring orchestral strings, harpsichord and trumpet. Perfect for advertising/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, trumpet",
    "tags": "advert, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, majestic, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 20,
    "date": "2021-07-27",
    "videoId": "t04obr5bFzs",
    "youtubeUrl": "https://www.youtube.com/watch?v=t04obr5bFzs",
    "productUrl": "https://audiojungle.net/item/classic-baroque/33233998",
    "duration": "1:56"
  },
  {
    "title": "Happy Fun Logo",
    "description": "An upbeat, cheerful ident/opener/jingle/logo featuring glockenspiel, recorder, xylophone, piano, percussion and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, xylophone, piano, percussion, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 12,
    "date": "2021-06-03",
    "videoId": "UaO9A7qEX1Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=UaO9A7qEX1Y",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786060-Happy-Fun-Logo-0m13?ref=dreamnotemusic",
    "duration": "0:13"
  },
  {
    "title": "English Classical Waltz",
    "description": "A charming, traditional, classical track featuring piano, oboe, orchestral strings, choir and woodwind. Perfect for adverts/commercials, nature/history documentaries, farming/country living videos, TV dramas or YouTube videos.",
    "genre": "Classical",
    "instrumentation": "Piano, oboe, orchestral strings, choir, woodwind",
    "tags": "advert, baking, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, farming, food, happy, innocent, kitchen, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 20,
    "date": "2021-05-20",
    "videoId": "1XNbjdyTfj8",
    "youtubeUrl": "https://www.youtube.com/watch?v=1XNbjdyTfj8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201782830-English-Classical-Waltz-1m21?ref=dreamnotemusic",
    "duration": "1:21"
  },
  {
    "title": "Happy Fun Children",
    "description": "An upbeat, positive track featuring recorder, piano, xylophone, synth, glockenspiel, percussion and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, comedy YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, xylophone, synth, glockenspiel, percussion, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, video intro, youtube",
    "price": 16,
    "date": "2021-03-26",
    "videoId": "LKXrF2cleIg",
    "youtubeUrl": "https://www.youtube.com/watch?v=LKXrF2cleIg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786350-Happy-Fun-Children-0m39?ref=dreamnotemusic",
    "duration": "0:39"
  },
  {
    "title": "Magical Emotional Cinematic",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, woodwind, brass, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, glockenspiel",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 20,
    "date": "2021-03-18",
    "videoId": "TVrnVPTF40g",
    "youtubeUrl": "https://www.youtube.com/watch?v=TVrnVPTF40g",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795527-Magical-Emotional-Cinematic-1m47?ref=dreamnotemusic",
    "duration": "1:47"
  },
  {
    "title": "Creative Documentary",
    "description": "A positive, lively track featuring vibraphone, marimba, piano, pizzicato orchestral strings and rhythmic, staccato woodwind. Perfect for adverts/commercials, documentaries, nature/country living videos, baking/cooking/food channels or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Vibraphone, marimba, piano, orchestral strings, woodwind",
    "tags": "advert, baking, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, farming, food, happy, innocent, kitchen, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 20,
    "date": "2021-02-26",
    "videoId": "bzHvWwSVyRA",
    "youtubeUrl": "https://www.youtube.com/watch?v=bzHvWwSVyRA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755846-Creative-Documentary-1m37?ref=dreamnotemusic",
    "duration": "1:37"
  },
  {
    "title": "Haunting Drama",
    "description": "A dark, mysterious cinematic track featuring piano, celesta, orchestral strings, choir and atmospheric synth pads. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Piano, celesta, orchestral strings, choir, synth pads",
    "tags": "atmospheric, creepy, dark, dead, death, demented, evil, film score, ghost, ghost story, gothic, halloween, haunted house, haunting, hell, history, horror, murder, music box, mysterious, mystery, night, nightmare, scary, sinister, soundtrack, spooky, suspense, thriller, twisted",
    "price": 20,
    "date": "2021-02-14",
    "videoId": "9nSrpr6kbmw",
    "youtubeUrl": "https://www.youtube.com/watch?v=9nSrpr6kbmw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786091-Haunting-Drama-1m47?ref=dreamnotemusic",
    "duration": "1:47"
  },
  {
    "title": "Sneaky Fun",
    "description": "A quirky, comedic track featuring pizzicato strings, staccato woodwind, clarinet, vibraphone, xylophone, banjo, bass and percussion. Perfect for comedy compilation/bloopers videos, YouTube videos/hauls/vlogs, apps/computer games, kids cartoons/animations, adverts/commercials or children’s TV shows.",
    "genre": "Comedy",
    "instrumentation": "Strings, woodwind, clarinet, vibraphone, xylophone, banjo, bass, percussion",
    "tags": "advert, app, background, comedic, comedy, comedy drama, comedy movie, commercial, computer game, cute, Daytime TV, fun, funny, gag, game, happy, humor, humorous, humour, lifestyle, lively, playful, playing, quirky, reality show, reality TV, silly, stupid, vlog, youtube",
    "price": 24,
    "date": "2021-02-03",
    "videoId": "b0ybAGWk0nM",
    "youtubeUrl": "https://www.youtube.com/watch?v=b0ybAGWk0nM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/200976411-Sneaky-Fun-2m06?ref=dreamnotemusic",
    "duration": "2:06"
  },
  {
    "title": "Cinematic Atmospheric Piano and Strings",
    "description": "An emotional and thought-provoking track featuring piano, cello and orchestral strings. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, cello, orchestral strings",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, reflective, religion, romantic, sad, sentimental, sorrow, story, strings, thoughtful",
    "price": 20,
    "date": "2021-01-25",
    "videoId": "2tML0a71jbc",
    "youtubeUrl": "https://www.youtube.com/watch?v=2tML0a71jbc",
    "productUrl": "https://audiojungle.net/item/cinematic-atmospheric-piano-strings/29989863",
    "duration": "3:45"
  },
  {
    "title": "Cute Happy Intro",
    "description": "A bright, positive track featuring piano, synth, xylophone, glockenspiel, percussion and bass. This upbeat, cheerful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, comedy videos, commercials/adverts, YouTube video intros or any project with a jolly, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, synth, xylophone, glockenspiel, percussion, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, ident, intro, jolly, kids, kids tv, logo, party, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, video intro, youtube",
    "price": 12,
    "date": "2020-12-23",
    "videoId": "D1m4pYsY1wA",
    "youtubeUrl": "https://www.youtube.com/watch?v=D1m4pYsY1wA",
    "productUrl": "https://audiojungle.net/item/cute-happy-intro/29625679",
    "duration": "0:23"
  },
  {
    "title": "Classical Drama",
    "description": "A powerful and dramatic orchestral track in a classical/baroque style featuring rhythmic orchestral strings, staccato woodwind and choir. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, choir",
    "tags": "advert, antiques, bach, baroque, classic, classical, countdown, documentary, drama, dramatic, exciting, historical, history, intense, old, old-fashioned, period drama, powerful, proud, renaissance, royal, royalty, stately, traditional, tv, vivaldi",
    "price": 20,
    "date": "2020-12-15",
    "videoId": "_w-b1jpaC70",
    "youtubeUrl": "https://www.youtube.com/watch?v=_w-b1jpaC70",
    "productUrl": "https://audiojungle.net/item/classical-drama/29520289",
    "duration": "2:02"
  },
  {
    "title": "Hopeful Fantasy",
    "description": "An atmospheric, inspirational track featuring piano, violin, cello, orchestral strings, woodwind, brass and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, animations or any project of an uplifting or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, violin, cello, orchestral strings, woodwind, brass, choir",
    "tags": "advert, atmospheric, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv, uplifting",
    "price": 20,
    "date": "2020-11-24",
    "videoId": "Nx17qDjuaZo",
    "youtubeUrl": "https://www.youtube.com/watch?v=Nx17qDjuaZo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786161-Hopeful-Fantasy-1m22?ref=dreamnotemusic",
    "duration": "1:22"
  },
  {
    "title": "Upbeat Fun Kids",
    "description": "A happy, positive track featuring recorder, piano, guitar, xylophone, glockenspiel, percussion and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, comedy YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, guitar, xylophone, glockenspiel, percussion, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, video intro, youtube",
    "price": 16,
    "date": "2020-11-05",
    "videoId": "xyyolqTyiJk",
    "youtubeUrl": "https://www.youtube.com/watch?v=xyyolqTyiJk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805220-Upbeat-Fun-Kids-0m52?ref=dreamnotemusic",
    "duration": "0:52"
  },
  {
    "title": "Dark Fantasy Vocal Lullaby",
    "description": "An atmospheric cinematic track featuring female voice (Instrumental version also included) with piano, harp, music box, glockenspiel, choir and orchestral strings. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Female voice, piano, harp, music box, glockenspiel, choir, orchestral strings",
    "tags": "atmospheric, book trailer, child, creepy, dark, death, dream, evil, fantasy, female voice, ghost, ghostly, girl, gothic, halloween, haunted, haunting, horror, kids voice, lullaby, magical, nightmare, scary, soundtrack, spooky, suspense, thriller, trailer, twisted, young girl",
    "price": 20,
    "date": "2020-10-07",
    "videoId": "vvRWZoKtzPU",
    "youtubeUrl": "https://www.youtube.com/watch?v=vvRWZoKtzPU",
    "productUrl": "https://audiojungle.net/item/dark-fantasy-vocal-lullaby/28715288",
    "duration": "3:04"
  },
  {
    "title": "Emotional Atmospheric Cinematic Background",
    "description": "An expressive cinematic track featuring piano, orchestral strings, choir, violin and cello. Perfect for use in dramatic TV/movie/film soundtracks or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings, choir, violin, cello",
    "tags": "atmosphere, atmospheric, background, cinematic, classical, dark, deep, drama, dramatic, emotional, film, haunting, intense, movie, mysterious, mystery, night, orchestra, orchestral, piano, reflective, romance, sad, sadness, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 20,
    "date": "2020-10-07",
    "videoId": "OUccTwhTuSs",
    "youtubeUrl": "https://www.youtube.com/watch?v=OUccTwhTuSs",
    "productUrl": "https://audiojungle.net/item/emotional-atmospheric-cinematic-background/28330515",
    "duration": "3:07"
  },
  {
    "title": "Kids' Fun",
    "description": "A positive, upbeat theme-tune featuring cheerful melody, piano, synth, glockenspiel, bass and percussion. This happy, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos or any project with a lively, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, synth, glockenspiel, bass, percussion",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, ident, intro, kids, kids tv, logo, party, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, uptempo, video intro, youtube",
    "price": 14,
    "date": "2020-09-24",
    "videoId": "cZ2F6kqASpI",
    "youtubeUrl": "https://www.youtube.com/watch?v=cZ2F6kqASpI",
    "productUrl": "https://audiojungle.net/item/kids-fun/28506748",
    "duration": "0:48"
  },
  {
    "title": "Dramatic Cinematic Background",
    "description": "An atmospheric orchestral track featuring strings, brass, piano and percussion. Perfect for use in dramatic TV/movie/film soundtracks or history documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, brass, piano, percussion",
    "tags": "action, adventure, anxious, atmospheric, background, cinematic, danger, dark, documentary, drama, dramatic, fear, film score, game trailer, historical, history, military, movie trailer, mystery, promo, soundtrack, spy, suspense, teaser, tense, tension, thriller, trailer, underscore, war",
    "price": 20,
    "date": "2020-09-16",
    "videoId": "mOZL7kq5EpY",
    "youtubeUrl": "https://www.youtube.com/watch?v=mOZL7kq5EpY",
    "productUrl": "https://audiojungle.net/item/dramatic-cinematic-background/28425706",
    "duration": "2:04"
  },
  {
    "title": "Passionate Cinematic Female Vocals",
    "description": "An expressive, emotional female voice accompanied by sustained orchestral strings and brass. Perfect for use as a movie/film/game trailer or soundtrack.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Female voice, orchestral strings, brass",
    "tags": "atmospheric, cinematic, crying, dark, drama, dramatic, emotion, emotional, epic, expressive, female vocal, female voice, film trailer, game trailer, girls voice, grand, haunting, movie trailer, orchestral, passion, passionate, sad, sadness, tragedy, tragic, vocal, vocals, voice, womans voice, yearning",
    "price": 20,
    "date": "2020-08-30",
    "videoId": "L1gsF-uTKS0",
    "youtubeUrl": "https://www.youtube.com/watch?v=L1gsF-uTKS0",
    "productUrl": "http://audiojungle.net/item/passionate-cinematic-female-vocals/63723709",
    "duration": "2:23"
  },
  {
    "title": "City Timelapse",
    "description": "An ambient, atmospheric track featuring soft pianos, smooth synth pads and subtle drums. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Pianos, synth pads, drums",
    "tags": "advert, ambient, art, beautiful, chill, chillout, cityscape, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time, timelapse",
    "price": 24,
    "date": "2020-08-23",
    "videoId": "ZueIW5XXEU8",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZueIW5XXEU8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755906-City-Timelapse-2m42?ref=dreamnotemusic",
    "duration": "2:42"
  },
  {
    "title": "Royal Majestic Baroque",
    "description": "A regal, traditional classical track featuring orchestral strings, woodwind, harpsichord and trumpet. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, harpsichord, trumpet",
    "tags": "advert, allegro, antiques, bach, baroque, brandenburg, british, classic, classical, documentary, drama, heritage, historical, history, lively, majestic, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 16,
    "date": "2020-08-13",
    "videoId": "NLRy9ABUauk",
    "youtubeUrl": "https://www.youtube.com/watch?v=NLRy9ABUauk",
    "productUrl": "https://audiojungle.net/item/royal-majestic-baroque/27938686",
    "duration": "1:26"
  },
  {
    "title": "Church Choir Intro",
    "description": "A peaceful, atmospheric intro/logo/ident/opener featuring a glorious blend of sustained voices singing in harmony. Perfect for spiritual/holy videos, adverts, documentaries, company openers or any project with an emotional, religious tone.",
    "genre": "Classical",
    "instrumentation": "Choir",
    "tags": "angelic, atmospheric, beautiful, belief, believe, charity, choir, church, expressive, faith, god, heaven, heavenly, holy, hymn, intro, logo, opener, peaceful, prayer, reflective, religion, religious, singers, singing, spiritual, vocal, voice, voices, worship",
    "price": 12,
    "date": "2020-08-03",
    "videoId": "iGRxv4IRKpE",
    "youtubeUrl": "https://www.youtube.com/watch?v=iGRxv4IRKpE",
    "productUrl": "https://audiojungle.net/item/church-choir-intro-ident/27797585",
    "duration": "0:21"
  },
  {
    "title": "Kids' Happy Intro",
    "description": "An upbeat, fun ident/opener/jingle/logo featuring glockenspiel, recorder, xylophone, piano, percussion and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, xylophone, piano, percussion, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2020-07-28",
    "videoId": "uQhkKLDxILI",
    "youtubeUrl": "https://www.youtube.com/watch?v=uQhkKLDxILI",
    "productUrl": "https://audiojungle.net/item/kids-happy-intro-ident/27690104",
    "duration": "0:07"
  },
  {
    "title": "Live a Magical Life",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, promo, promotional, sales, tv, uplifting",
    "price": 24,
    "date": "2020-07-24",
    "videoId": "kspt00eUYJc",
    "youtubeUrl": "https://www.youtube.com/watch?v=kspt00eUYJc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794939-Live-a-Magical-Life-2m04?ref=dreamnotemusic",
    "duration": "2:04"
  },
  {
    "title": "Baby Ballet",
    "description": "A happy, bright, playful kids track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2020-07-19",
    "videoId": "XdlRvQWXW_w",
    "youtubeUrl": "https://www.youtube.com/watch?v=XdlRvQWXW_w",
    "productUrl": "http://audiojungle.net/item/baby-ballet/27556336",
    "duration": "1:27"
  },
  {
    "title": "A New Future",
    "description": "An optimistic, positive track featuring ambient cinematic electric guitars, pianos, acoustic rhythm guitar, strings, atmospheric synth pads, bass and drums. Ideal for use in corporate promotional material, business presentations, inspirational TV/radio adverts/commercials and YouTube videos/vlogs.",
    "genre": "Corporate",
    "instrumentation": "Electric guitars, piano, acoustic, guitar, strings, synth pads, bass, drums",
    "tags": "achievement, adventure, advert, ambient, atmosphere, atmospheric, business, cinematic, cinematic guitars, commercial, confidence, confident, corporate, encouraging, future, hope, hopeful, inspirational, inspiring, marketing, motivation, optimism, optimistic, positive, promotional, short, success, summer, uplifting, vlog",
    "price": 24,
    "date": "2020-06-25",
    "videoId": "wljGYbw5rdk",
    "youtubeUrl": "https://www.youtube.com/watch?v=wljGYbw5rdk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311037-A-New-Future-2m02?ref=dreamnotemusic",
    "duration": "2:02"
  },
  {
    "title": "Happy Kids' Jingle",
    "description": "An upbeat, fun ident/opener/intro/logo featuring glockenspiel, recorder, xylophone, piano, percussion and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, xylophone, piano, percussion, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2020-06-22",
    "videoId": "wrJ3AU3Omc8",
    "youtubeUrl": "https://www.youtube.com/watch?v=wrJ3AU3Omc8",
    "productUrl": "https://audiojungle.net/item/happy-kids-jingle/27008723",
    "duration": "0:11"
  },
  {
    "title": "Emotional Acoustic Cinematic",
    "description": "An expressive, atmospheric track featuring piano, acoustic guitar, violin, viola, cello and orchestral strings. Ideal for use in adverts/commercials, movie/film/TV soundtracks, wedding videos or any project requiring an atmospheric, hopeful musical backing.",
    "genre": "Acoustic",
    "instrumentation": "Piano, acoustic guitar, violin, viola, cello, orchestral strings",
    "tags": "acoustic, advert, beautiful, cello, cinematic, dreamy, emotion, emotional, expressive, family, guitar, happy, heartfelt, hope, hopeful, inspirational, inspiring, life, love, memories, nature, orchestral, peaceful, piano, romance, romantic, sentimental, strings, violin, wedding",
    "price": 24,
    "date": "2020-06-08",
    "videoId": "hjSz5xlop-M",
    "youtubeUrl": "https://www.youtube.com/watch?v=hjSz5xlop-M",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201782535-Emotional-Acoustic-Cinematic-2m44?ref=dreamnotemusic",
    "duration": "2:44"
  },
  {
    "title": "Kids' Cute ident",
    "description": "A happy, fun intro opener/jingle/logo featuring piano, pizzicato strings, glockenspiel, xylophone and triangle. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Piano, strings, glockenspiel, xylophone, triangle",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2020-05-22",
    "videoId": "Kq-9eH4fx2E",
    "youtubeUrl": "https://www.youtube.com/watch?v=Kq-9eH4fx2E",
    "productUrl": "https://audiojungle.net/item/kids-cute-ident/26610968",
    "duration": "0:16"
  },
  {
    "title": "Positive Mood",
    "description": "An optimistic, inspiring track featuring ambient cinematic electric guitars, pianos, acoustic rhythm guitar, strings, atmospheric synth pads, bass and drums. Ideal for use in corporate promotional material, business presentations, inspirational TV/radio adverts/commercials and YouTube videos/vlogs.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, piano, acoustic guitar, strings, synth pads, bass, drums",
    "tags": "achievement, adventure, advert, ambient, atmosphere, atmospheric, business, cinematic, cinematic guitars, commercial, confidence, confident, corporate, encouraging, future, hope, hopeful, inspirational, inspiring, marketing, motivation, optimism, optimistic, positive, promotional, short, success, summer, uplifting, vlog",
    "price": 24,
    "date": "2020-05-21",
    "videoId": "EcYduyOC5Rk",
    "youtubeUrl": "https://www.youtube.com/watch?v=EcYduyOC5Rk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799227-Positive-Mood-2m09?ref=dreamnotemusic",
    "duration": "2:09"
  },
  {
    "title": "Kids' Ident",
    "description": "A fun, upbeat ident/opener/jingle/logo featuring synth, xylophone, piano, guitar, percussion and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Synth, xylophone, piano, guitar, percussion, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2020-05-14",
    "videoId": "gDyQemxIWgQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=gDyQemxIWgQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794953-Kids-Ident-0m12?ref=dreamnotemusic",
    "duration": "0:12"
  },
  {
    "title": "Ambient Space",
    "description": "An atmospheric, dreamy track featuring electric guitar, layered pianos, synth pads, strings and bass. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Electric guitar, piano, synth pads, strings, bass",
    "tags": "ambient, atmosphere, atmospheric, chill, cityscape, documentary, dreaming, dreamy, inspiring, lonely, montage, nature, night, peace, peaceful, photography, reflective, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, spacious, still, thoughts, time, time-lapse, timelapse",
    "price": 24,
    "date": "2020-05-08",
    "videoId": "1ygQj9OjDR8",
    "youtubeUrl": "https://www.youtube.com/watch?v=1ygQj9OjDR8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/200848983-Ambient-Space-3m40?ref=dreamnotemusic",
    "duration": "3:40"
  },
  {
    "title": "Positive Drive",
    "description": "A motivational, inspiring pop track featuring pianos, acoustic guitar, strings, bass and drums. Ideal for use as a video intro/logo/ident/opener, corporate/business presentations, motivational TV/radio adverts/commercials and family vacation/holiday videos/YouTube vlogs.",
    "genre": "Corporate",
    "instrumentation": "Piano, acoustic guitar, strings, bass, drums",
    "tags": "achievement, adventure, advert, brand, business, commercial, confident, corporate, family, holiday, hopeful, ident, inspirational, inspiring, intro, logo, marketing, motivation, motivational, opener, optimistic, positive, promotional, short, success, summer, upbeat, uplifting, vacation, vlog",
    "price": 20,
    "date": "2020-05-05",
    "videoId": "GFXyh5ocFO0",
    "youtubeUrl": "https://www.youtube.com/watch?v=GFXyh5ocFO0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799102-Positive-Drive-1m23?ref=dreamnotemusic",
    "duration": "1:23"
  },
  {
    "title": "Too Cute",
    "description": "A happy, bright, playful track featuring piano, glockenspiel, pizzicato strings, woodwind and triangle. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, strings, woodwind, triangle",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2020-05-04",
    "videoId": "PzVWADNl_Us",
    "youtubeUrl": "https://www.youtube.com/watch?v=PzVWADNl_Us",
    "productUrl": "https://audiojungle.net/item/too-cute/26441981",
    "duration": "1:16"
  },
  {
    "title": "Majestic Baroque Royalty",
    "description": "A regal, traditional classical track featuring orchestral strings, harpsichord and trumpet. Perfect for advertising/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, trumpet",
    "tags": "advert, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, majestic, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 24,
    "date": "2020-04-28",
    "videoId": "H-B8FBzeoZ4",
    "youtubeUrl": "https://www.youtube.com/watch?v=H-B8FBzeoZ4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795528-Majestic-Baroque-Royalty-2m39?ref=dreamnotemusic",
    "duration": "2:39"
  },
  {
    "title": "Magical Beauty",
    "description": "An atmospheric, inspirational track featuring pianos, violin, cello, orchestral strings, choir and glockenspiel (simplified versions also included without melody). Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, violin, cello, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 24,
    "date": "2020-04-22",
    "videoId": "wdjMibscDYc",
    "youtubeUrl": "https://www.youtube.com/watch?v=wdjMibscDYc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795561-Magical-Beauty-2m44?ref=dreamnotemusic",
    "duration": "2:44"
  },
  {
    "title": "Upbeat Country Fun",
    "description": "A fast, lively and energetic country dance track featuring banjos, acoustic guitar, upright bass, drums, foot stomps, claps and harmonica (version included without harmonica), blending elements of American country folk and bluegrass music. Perfect for TV, comedy, adverts/commercials, YouTube videos, computer games/apps, cartoons/animations or any country-themed project.",
    "genre": "Acoustic",
    "instrumentation": "Banjo, acoustic guitar, upright bass, drums, foot stomps, claps, harmonica",
    "tags": "america, american, americana, banjo, barn dance, car chase, cartoon, cartoon chase, chase, cheerful, comedy, comedy chase, cop chase, country, country chase, fast, folk, fun, funny, happy, hillbilly, hillbilly chase, lively, police chase, redneck, silly, southern, upbeat, upbeat country, usa",
    "price": 16,
    "date": "2020-04-15",
    "videoId": "vHz_ofc8Np4",
    "youtubeUrl": "https://www.youtube.com/watch?v=vHz_ofc8Np4",
    "productUrl": "https://audiojungle.net/item/upbeat-country-fun/26266379",
    "duration": "0:47"
  },
  {
    "title": "Happy Kids' Fun",
    "description": "An upbeat, positive track featuring recorder, piano, guitar, xylophone, glockenspiel, percussion and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, comedy YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, guitar, xylophone, glockenspiel, percussion, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, video intro, youtube",
    "price": 14,
    "date": "2020-04-06",
    "videoId": "24up4G_SfLw",
    "youtubeUrl": "https://www.youtube.com/watch?v=24up4G_SfLw",
    "productUrl": "https://audiojungle.net/item/happy-kids-fun/26170078",
    "duration": "0:47"
  },
  {
    "title": "Jazz Intro",
    "description": "A cool, upbeat ident/opener/jingle/logo featuring piano, vibraphone, muted trumpet, clarinet, sax, bass and drums. Ideal for use in YouTube videos/vlogs, adverts/commercials, comedy shows/podcasts, radio jingles or as a TV chat show/sitcom theme.",
    "genre": "Jazz",
    "instrumentation": "Piano, vibraphone, trumpet, clarinet, sax, bass, drums",
    "tags": "advert, advertising, chat show, chatshow, comedy, commercial, cool, fun, funny, gameshow, happy, ident, intro, jazz, jazzy, jingle, logo, opener, podcast, quirky, radio, retro, sitcom, talk show, theme, theme tune, tv, video intro, vlog, youtube",
    "price": 10,
    "date": "2020-04-02",
    "videoId": "BvH4uSscMuc",
    "youtubeUrl": "https://www.youtube.com/watch?v=BvH4uSscMuc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794800-Jazz-Intro?ref=dreamnotemusic",
    "duration": "0:15"
  },
  {
    "title": "Church Choir Ident",
    "description": "A peaceful, atmospheric intro/logo/opener featuring a glorious blend of sustained voices singing in harmony. Perfect for spiritual/holy videos, adverts, documentaries, company openers or any project with an emotional, religious tone.",
    "genre": "Classical",
    "instrumentation": "Choir, voices",
    "tags": "angelic, atmospheric, beautiful, belief, believe, charity, choir, church, expressive, faith, god, heaven, heavenly, holy, hymn, intro, logo, opener, peaceful, prayer, reflective, religion, religious, singers, singing, spiritual, vocal, voice, voices, worship",
    "price": 12,
    "date": "2020-03-31",
    "videoId": "y2bL9Tupu9s",
    "youtubeUrl": "https://www.youtube.com/watch?v=y2bL9Tupu9s",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755668-Church-Choir-Ident?ref=dreamnotemusic",
    "duration": "0:17"
  },
  {
    "title": "Fun Kids' Intro",
    "description": "An upbeat, happy ident/opener/jingle/logo featuring glockenspiel, recorder, xylophone, piano, percussion and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, hand-claps, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2020-03-28",
    "videoId": "EgHNAKrddac",
    "youtubeUrl": "https://www.youtube.com/watch?v=EgHNAKrddac",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784919-Fun-Kids-Intro?ref=dreamnotemusic",
    "duration": "0:08"
  },
  {
    "title": "Happy Kids' Comedy",
    "description": "‘Happy Kids Comedy’ is a fun, upbeat theme-tune featuring recorder, piano, guitar, xylophone, glockenspiel, hand-claps and bass. This bright, playful track is perfect for TV shows, kids cartoons/animations, computer games/apps, children’s party games, commercials/adverts, comedy YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, guitar, xylophone, glockenspiel, percussion, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, video intro, youtube",
    "price": 20,
    "date": "2020-03-20",
    "videoId": "8lWV9K3_Q-s",
    "youtubeUrl": "https://www.youtube.com/watch?v=8lWV9K3_Q-s",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786204-Happy-Kids-Comedy-1m37?ref=dreamnotemusic",
    "duration": "1:37"
  },
  {
    "title": "Happy Kids' Intro",
    "description": "An upbeat, fun ident/opener/jingle/logo featuring glockenspiel, recorder, xylophone, piano, percussion and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, xylophone, piano, percussion, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2020-03-05",
    "videoId": "hjgpEpVe4Sg",
    "youtubeUrl": "https://www.youtube.com/watch?v=hjgpEpVe4Sg",
    "productUrl": "https://audiojungle.net/item/happy-kids-intro/25855770",
    "duration": "0:08"
  },
  {
    "title": "Life Story",
    "description": "An atmospheric, emotional and expressive track featuring orchestral strings, cello, acoustic guitar, sustained brass, choir and woodwind. Perfect for use in movie/film/game trailers, soundtracks, adverts/commercials or documentaries/charity campaigns.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, cello, acoustic guitar, sustained brass, choir, woodwind",
    "tags": "advert, atmosphere, atmospheric, belief, believe, charity, cinematic, commercial, documentary, dreamy, emotional, expressive, heartfelt, hope, journey, life, love, melancholy, mellow, memories, nostalgic, orchestra, passionate, reflective, religion, romantic, sentimental, sorrow, story, thoughtful",
    "price": 24,
    "date": "2020-03-03",
    "videoId": "2V4YUml9Z4s",
    "youtubeUrl": "https://www.youtube.com/watch?v=2V4YUml9Z4s",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794846-Life-Story-2m32?ref=dreamnotemusic",
    "duration": "2:32"
  },
  {
    "title": "Happy Folk",
    "description": "A positive, upbeat track featuring acoustic guitars, electric guitars, female vocals, bass guitar, drums, foot stomps and hand claps, blending elements of American country music. Perfect for TV/radio adverts/commercials, travel vacation/holiday videos, presentations, promotions or YouTube videos.",
    "genre": "Acoustic",
    "instrumentation": "Acoustic guitar, electric guitar, female vocals, bass guitar, drums, percussion",
    "tags": "acoustic guitar, advert, america, american, americana, catchy, cheerful, claps, commercial, country, female vocal, folk, fun, happy, holiday, indie, joyful, lively, optimistic, positive, radio, southern, stomps, summer, travel, upbeat, uplifting, vacation, vocals, voice",
    "price": 24,
    "date": "2020-02-20",
    "videoId": "6IWf43y2XO8",
    "youtubeUrl": "https://www.youtube.com/watch?v=6IWf43y2XO8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786224-Happy-Folk-2m24?ref=dreamnotemusic",
    "duration": "2:24"
  },
  {
    "title": "Dark Cinematic Tension Loop",
    "description": "An atmospheric, suspenseful looping background track featuring orchestral strings, synths and percussion. Perfect for use in computer games, apps, dramatic TV/movie/film soundtracks or history documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, synth, percussion",
    "tags": "adventure, anxious, app, atmospheric, background, cinematic, danger, dark, documentary, drama, dramatic, fear, game, game trailer, historical, history, loop, loopable, looping, movie trailer, mystery, promo, spy, suspense, suspenseful, tense, tension, thriller, trailer, underscore",
    "price": 20,
    "date": "2020-01-09",
    "videoId": "0fXwdbcBr9o",
    "youtubeUrl": "https://www.youtube.com/watch?v=0fXwdbcBr9o",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780844-Dark-Cinematic-Tension-Loop?ref=dreamnotemusic",
    "duration": "1:20"
  },
  {
    "title": "Kids' Game",
    "description": "A happy, positive track featuring piano, recorder, xylophone, glockenspiel, drums and bass. This playful track is perfect for kids' cartoons/animations, computer games/apps, children’s party games, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, recorder, xylophone, glockenspiel, drums, bass",
    "tags": "animation, app, background, bright, cartoon, catchy, cheerful, children, comedy, fun, game, happy, holiday, kids, kids music, kids tv, loop, party, party game, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, vacation, youtube",
    "price": 14,
    "date": "2019-12-22",
    "videoId": "fk9voJMM71E",
    "youtubeUrl": "https://www.youtube.com/watch?v=fk9voJMM71E",
    "productUrl": "https://audiojungle.net/item/kids-game/25315512",
    "duration": "0:58"
  },
  {
    "title": "Dark Atmospheric Cinematic",
    "description": "An expressive, mysterious soundtrack featuring piano, harp, woodwind, brass, choir and emotional orchestral strings. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a dramatic, suspenseful tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, woodwind, brass, choir, orchestral strings",
    "tags": "atmosphere, atmospheric, cinematic, dark, death, deep, drama, dramatic, emotional, fantasy, fear, film, forbidden, haunting, intense, love, lovers, mysterious, mystery, night, reflective, romance, sad, tense, tension, thriller, tragic, trailer, twilight, worry",
    "price": 24,
    "date": "2019-12-17",
    "videoId": "N2egOVQMCtE",
    "youtubeUrl": "https://www.youtube.com/watch?v=N2egOVQMCtE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780733-Dark-Atmospheric-Cinematic-2m34?ref=dreamnotemusic",
    "duration": "2:34"
  },
  {
    "title": "Cute Waltz",
    "description": "A light, happy and positive track featuring pizzicato orchestral strings, piano and staccato woodwind. Perfect for use in children’s cartoons/animation, kids' TV, ballet videos or advert/commercials.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, piano, woodwind",
    "tags": "ball, ballerina, ballet, children, cute, dance, dancer, dancing, dream, dreamy, enchanted, enchanting, fairies, fantasy, fun, happy, innocence, innocent, kids, light, love, magic, magical, positive, princess, royal, theme, tutorial, tv, waltz",
    "price": 20,
    "date": "2019-11-11",
    "videoId": "qI8IhlCLPZ8",
    "youtubeUrl": "https://www.youtube.com/watch?v=qI8IhlCLPZ8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755728-Cute-Waltz-1m13?ref=dreamnotemusic",
    "duration": "1:13"
  },
  {
    "title": "Country Logo 3",
    "description": "An American country music ident/opener/jingle/intro featuring acoustic guitars, slide guitar, bass, foot stomps and claps. Perfect for use as an opening theme for YouTube videos/vlogs, apps, TV adverts/commercials, comedy sketches, podcasts or as a TV/radio jingle.",
    "genre": "Acoustic",
    "instrumentation": "Acoustic guitar, slide guitar, bass, percussion",
    "tags": "acoustic guitar, america, american, americana, banjo, catchy, cheerful, comedy, country, folk, fun, funny, happy, ident, intro, jingle, line dancing, line-dancing, lively, logo, opener, quirky, redneck, slide guitar, southern, steel guitar, upbeat, usa, vlog, youtube",
    "price": 12,
    "date": "2019-10-27",
    "videoId": "rgZDEqwhWR0",
    "youtubeUrl": "https://www.youtube.com/watch?v=rgZDEqwhWR0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755727-Country-Logo-3-0m16?ref=dreamnotemusic",
    "duration": "0:16"
  },
  {
    "title": "Kids' Intro",
    "description": "An upbeat, happy ident/opener/jingle/intro featuring funny synth, recorder, banjo, glockenspiel, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Synth, recorder, banjo, glockenspiel, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2019-10-19",
    "videoId": "Gy0hIA2ljDE",
    "youtubeUrl": "https://www.youtube.com/watch?v=Gy0hIA2ljDE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794845-Kids-Intro-0m08?ref=dreamnotemusic",
    "duration": "0:08"
  },
  {
    "title": "Dark Atmospheric Vocal Intro",
    "description": "A haunting logo/opener/ident featuring female vocals accompanied by sustained orchestral strings, piano and glockenspiel. Perfect for use in a movie/film/game soundtrack, trailer, teaser, TV drama or YouTube intro/video.",
    "genre": "Horror",
    "instrumentation": "Female vocals, orchestral strings, piano, glockenspiel",
    "tags": "angelic, apocalypse, atmosphere, atmospheric, beautiful, cinematic, dark, documentary, emotional, fantasy, female voice, film, game, ghostly, girl, haunting, heavenly, horror, ident, intro, logo, movie, mysterious, mystery, opener, scary, suspense, teaser, tense",
    "price": 12,
    "date": "2019-10-13",
    "videoId": "j8_Xs5Vz_CM",
    "youtubeUrl": "https://www.youtube.com/watch?v=j8_Xs5Vz_CM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780755-Dark-Atmospheric-Vocal-Intro?ref=dreamnotemusic",
    "duration": "0:15"
  },
  {
    "title": "Vocal Horror Lullaby",
    "description": "A haunting, cinematic track featuring female vocals (Instrumental version also included), piano, music box and celesta. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Female voice, piano, music box, celesta",
    "tags": "atmospheric, child, creepy, dark, dead, death, fantasy, female, female voice, ghost, girl, gothic, halloween, haunted house, haunting, horror, lullaby, murder, mysterious, mystery, night, nightmare, scary, soundtrack, spooky, suspense, thriller, twisted, vocal, voice",
    "price": 20,
    "date": "2026-07-13",
    "videoId": "fmTA-zk5Uqk",
    "youtubeUrl": "https://www.youtube.com/watch?v=fmTA-zk5Uqk",
    "productUrl": "http://audiojungle.net/item/vocal-horror-lullaby/64256797",
    "duration": "2:11"
  },
  {
    "title": "Retro Horror Trailer",
    "description": "An atmospheric, cinematic track featuring 80s synths, arpeggiators and dramatic drums. Ideal for use in horror/thriller movie/film soundtracks, trailers, Halloween TV/radio shows, video games or YouTube videos.",
    "genre": "Horror",
    "instrumentation": "Synths, drums",
    "tags": "action, atmospheric, cinematic, creepy, dark, drama, dramatic, epic, film, game, gritty, halloween, haunted, haunting, horror, ident, movie, murder, mysterious, mystery, opener, scary, sinister, spooky, suspense, teaser, theme, thriller, trailer, twisted",
    "price": 24,
    "date": "2019-09-26",
    "videoId": "88NW6ioxBpk",
    "youtubeUrl": "https://www.youtube.com/watch?v=88NW6ioxBpk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801952-Retro-Horror-Trailer-2m52?ref=dreamnotemusic",
    "duration": "2:52"
  },
  {
    "title": "Uplifting Baroque",
    "description": "A bright and happy traditional classical track featuring orchestral strings, woodwind, harpsichord and trumpet. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, harpsichord, trumpet",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 20,
    "date": "2019-09-03",
    "videoId": "I-auwjhKk5A",
    "youtubeUrl": "https://www.youtube.com/watch?v=I-auwjhKk5A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201270103-Uplifting-Baroque-1m40?ref=dreamnotemusic",
    "duration": "1:40"
  },
  {
    "title": "Corporate",
    "description": "A positive, confident and motivational pop/rock track featuring pianos, electric guitar, acoustic guitar, synth strings, bass and drums. Ideal for use in corporate promotional material, business presentations, motivational TV/radio adverts /commercials and family vacation/holiday videos/YouTube vlogs.",
    "genre": "Corporate",
    "instrumentation": "Piano, electric guitar, acoustic guitar, synth strings, bass, drums",
    "tags": "achievement, adventure, advert, brand, business, commercial, confident, corporate, happy, holiday, hopeful, inspirational, inspiring, intro, marketing, motivation, motivational, opener, optimistic, pop, positive, promotional, rock, success, summer, upbeat, uplifting, vacation, video intro, vlog",
    "price": 20,
    "date": "2019-08-10",
    "videoId": "OU2GV3H_iK8",
    "youtubeUrl": "https://www.youtube.com/watch?v=OU2GV3H_iK8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755755-Corporate-1m24?ref=dreamnotemusic",
    "duration": "1:24"
  },
  {
    "title": "Cartoon",
    "description": "A fast and fun comedy track featuring lively orchestral strings, woodwind, brass, vibraphone, glockenspiel, bass, drums and silly cartoon sound effects (version included without the sound effects). Perfect for cartoon chase scenes, comedy compilation/bloopers videos, YouTube videos, apps/computer games, kids animations or children’s TV shows.",
    "genre": "Comedy",
    "instrumentation": "Orchestral strings, woodwind, brass, vibraphone, glockenspiel, bass, drums, sound effects",
    "tags": "animation, app, bloopers, capers, cartoon capers, chase, children, comedic, comedy, computer game, fun, funny, gag, game, happy, hilarious, humor, humorous, humour, joke, kids, lively, playful, quirky, reality show, reality TV, silly, sketch, stupid, vlog",
    "price": 18,
    "date": "2019-08-03",
    "videoId": "QpCUbl_2RsA",
    "youtubeUrl": "https://www.youtube.com/watch?v=QpCUbl_2RsA",
    "productUrl": "https://audiojungle.net/item/cartoon/24260386",
    "duration": "1:30"
  },
  {
    "title": "Country Intro",
    "description": "An American country music ident/opener/jingle/intro featuring acoustic guitar, slide guitar, banjo, drums, foot stomps and claps. Perfect for use as an opening theme for YouTube videos/vlogs, apps, TV adverts/commercials, podcasts or as a TV/radio jingle.",
    "genre": "Acoustic",
    "instrumentation": "Acoustic guitar, slide guitar, banjo,",
    "tags": "acoustic guitar, america, american, americana, banjo, catchy, cheerful, comedy, country, folk, fun, funny, happy, ident, intro, jingle, line dancing, line-dancing, lively, logo, opener, quirky, redneck, slide guitar, southern, steel guitar, upbeat, usa, vlog, youtube",
    "price": 10,
    "date": "2019-07-28",
    "videoId": "kyxrF3qiyJM",
    "youtubeUrl": "https://www.youtube.com/watch?v=kyxrF3qiyJM",
    "productUrl": "https://audiojungle.net/item/country-intro/24211603",
    "duration": "0:13"
  },
  {
    "title": "Relaxing Sleep",
    "description": "An atmospheric, meditative and dreamy chillout track with soft pianos, atmospheric synth pads, strings and ambient guitars. Ideal for healing/relaxation meditation, TV/movie/film soundtracks, space/sci-fi documentaries, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, strings, electric guitar",
    "tags": "ambient, atmosphere, atmospheric, beautiful, chill, chillout, cityscape, documentary, downtempo, dream, dreaming, dreamy, meditation, meditative, nature, night, photography, relaxing, scenery, scenic, scifi, sleep, sleepy, soft, soundscape, space, thoughtful, time, time-lapse, timelapse",
    "price": 24,
    "date": "2019-07-25",
    "videoId": "ZEsj7T-kag4",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZEsj7T-kag4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802051-Relaxing-Sleep?ref=dreamnotemusic",
    "duration": "4:14"
  },
  {
    "title": "Inspirational Wedding Intro",
    "description": "A beautiful, expressive and romantic track featuring piano with orchestral strings, choir, woodwind and brass. Perfect for wedding videos, wedding promos, YouTube channel intros, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, orchestral strings, choir, woodwind, brass",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, intro, love, magic, magical, memories, movie, opener, photo, romance, romantic, sentimental, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 16,
    "date": "2019-07-16",
    "videoId": "fPoCngvaRE8",
    "youtubeUrl": "https://www.youtube.com/watch?v=fPoCngvaRE8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201792814-Inspirational-Wedding-Intro-0m55?ref=dreamnotemusic",
    "duration": "0:55"
  },
  {
    "title": "Dark Cinematic Fantasy",
    "description": "An emotional, atmospheric soundtrack featuring piano with orchestral strings, cello, woodwind, brass and choir. Perfect for film/movie/game trailers, teasers, horror/fantasy soundtracks, e-book promos, TV dramas or any project with a haunting, expressive tone.",
    "genre": "Horror",
    "instrumentation": "Piano, orchestral strings, cello, woodwind, brass, choir",
    "tags": "atmosphere, atmospheric, cello, cinematic, classical, dark, death, drama, dramatic, emotional, expressive, fantasy, film, haunting, horror, intense, misery, movie, mysterious, mystery, night, orchestra, romance, sad, soundtrack, tragic, trailer, twilight, underscore, wonder",
    "price": 20,
    "date": "2019-07-03",
    "videoId": "2pvr3p7JuE0",
    "youtubeUrl": "https://www.youtube.com/watch?v=2pvr3p7JuE0",
    "productUrl": "https://audiojungle.net/item/dark-cinematic-fantasy/24054316",
    "duration": "2:00"
  },
  {
    "title": "Classical Piano Theme",
    "description": "A traditional classical track featuring piano with orchestral strings and woodwind. Perfect for history documentaries, adverts/commercials, TV period dramas or business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "answerphone, antiques, architecture, background, bank, british, call waiting, classic, classical, drama, dramatic, english, historical, history, loop, looped, mozart, old, old-fashioned, on hold, orchestra, phone, phone call, piano, regal, royal, royalty, telephone, traditional, waiting",
    "price": 20,
    "date": "2019-06-27",
    "videoId": "8A_USO4MmP0",
    "youtubeUrl": "https://www.youtube.com/watch?v=8A_USO4MmP0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755765-Classical-Piano-Theme-1m21?ref=dreamnotemusic",
    "duration": "1:21"
  },
  {
    "title": "Inspirational Vibes",
    "description": "A positive, hopeful track featuring pianos, acoustic guitars, electric guitar, atmospheric synth pad and kick drum (simplified version also included). Ideal for use in corporate promotional material, business presentations or tv/radio adverts/commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, acoustic guitar, electric guitar, synth pad, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, marketing, motivating, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 24,
    "date": "2019-06-21",
    "videoId": "og-HDVxqzIs",
    "youtubeUrl": "https://www.youtube.com/watch?v=og-HDVxqzIs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201792910-Inspirational-Vibes-3m12?ref=dreamnotemusic",
    "duration": "3:12"
  },
  {
    "title": "Fun Happy Kids' Ident",
    "description": "‘Fun Happy Kids’ Ident’ is a happy, upbeat ident/opener/jingle/intro featuring recorder, xylophone, synth, glockenspiel, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Recorder, xylophone, synth, glockenspiel, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, childrens, comedy, commercial, fun, happy, ident, intro, jingle, kids, logo, opener, play, playful, quirky, school, theme tune, tv, upbeat, video, vlog, youtube",
    "price": 10,
    "date": "2019-06-13",
    "videoId": "A5-4ytFt3-k",
    "youtubeUrl": "https://www.youtube.com/watch?v=A5-4ytFt3-k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784911-Fun-Happy-Kids-Ident?ref=dreamnotemusic",
    "duration": "0:07"
  },
  {
    "title": "Beautiful Romantic Wedding",
    "description": "An expressive, emotional track featuring piano, cello, acoustic guitar, violin, orchestral strings and woodwind. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, violin, orchestral strings, woodwind",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, video, wedding, wedding ceremony, wedding day",
    "price": 24,
    "date": "2019-06-04",
    "videoId": "MPclG-DGmJk",
    "youtubeUrl": "https://www.youtube.com/watch?v=MPclG-DGmJk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483721-Beautiful-Romantic-Wedding-5m45?ref=dreamnotemusic",
    "duration": "5:45"
  },
  {
    "title": "Cute Happy Children's Logo",
    "description": "‘Cute Happy Children’s Logo’ is a fun, upbeat ident/opener/jingle/intro featuring recorder, xylophone, glockenspiel, vibraphone, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Recorder, xylophone, glockenspiel, vibraphone, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, childrens, comedy, commercial, fun, happy, ident, intro, jingle, kids, logo, opener, play, playful, quirky, school, theme tune, tv, upbeat, video, vlog, youtube",
    "price": 8,
    "date": "2019-05-25",
    "videoId": "YTzvcAJj_PA",
    "youtubeUrl": "https://www.youtube.com/watch?v=YTzvcAJj_PA",
    "productUrl": "https://audiojungle.net/item/cute-happy-childrens-logo/23822640",
    "duration": "0:07"
  },
  {
    "title": "Happy Kids' Ident",
    "description": "A fun, bright logo/opener/jingle/intro featuring glockenspiel, recorder, xylophone and piano. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, xylophone, piano",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2019-05-23",
    "videoId": "SZKqNDqpw3E",
    "youtubeUrl": "https://www.youtube.com/watch?v=SZKqNDqpw3E",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786251-Happy-Kids-Ident?ref=dreamnotemusic",
    "duration": "0:06"
  },
  {
    "title": "Sneaky Comedy",
    "description": "A sinister, funny cartoon-style background track featuring staccato orchestral woodwind, tuba, pizzicato strings, piano and vibraphone. Perfect for comedy compilation/bloopers videos, adverts/commercials, TV shows, comedy films/movies, apps/computer games or YouTube videos/vlogs.",
    "genre": "Comedy",
    "instrumentation": "Orchestral woodwind, strings, piano, tuba, vibraphone",
    "tags": "advert, app, background, children, comedic, comedy, comedy drama, comedy movie, computer game, Daytime TV, fun, funny, gag, game, happy, humor, humour, humourous, kids, lifestyle, mysterious, playful, playing, quirky, silly, sinister, stupid, suspense, vlog, youtube",
    "price": 20,
    "date": "2019-05-06",
    "videoId": "z1VpthmI9bU",
    "youtubeUrl": "https://www.youtube.com/watch?v=z1VpthmI9bU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802108-Sneaky-Comedy-1m43?ref=dreamnotemusic",
    "duration": "1:43"
  },
  {
    "title": "Emotional Cello and Orchestra",
    "description": "An atmospheric, cinematic track featuring cello melody accompanied by piano, orchestral strings, woodwind and brass (version included without cello). Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a passionate or dark tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Cello, orchestral strings",
    "tags": "atmosphere, atmospheric, cello, cinematic, classical, dark, deep, drama, dramatic, emotion, emotional, expressive, fantasy, forbidden, haunting, intense, love, mysterious, mystery, night, orchestra, passion, passionate, romance, sad, soundtrack, thriller, tragic, trailer, underscore",
    "price": 24,
    "date": "2019-05-01",
    "videoId": "y9LUcljvykc",
    "youtubeUrl": "https://www.youtube.com/watch?v=y9LUcljvykc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201782477-Emotional-Cello-and-Orchestra-2m22?ref=dreamnotemusic",
    "duration": "2:22"
  },
  {
    "title": "Fun Children's Logo",
    "description": "‘Fun Children’s Logo’ is an upbeat, happy ident/opener/jingle/intro featuring recorder, xylophone, glockenspiel, vibraphone, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Recorder, xylophone, glockenspiel, vibraphone, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, childrens, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2019-04-22",
    "videoId": "gEFkaOs1f50",
    "youtubeUrl": "https://www.youtube.com/watch?v=gEFkaOs1f50",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784912-Fun-Childrens-Logo?ref=dreamnotemusic",
    "duration": "0:07"
  },
  {
    "title": "Vocal Horror Fantasy",
    "description": "An atmospheric, mysterious track featuring young female voice (Instrumental version also included) with piano, cello, glockenspiel, orchestral strings and french horn. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Female voice, piano, cello, glockenspiel, orchestral strings, french horn",
    "tags": "atmospheric, book trailer, child, creepy, dark, death, dream, evil, fantasy, female voice, ghost, ghostly, girl, gothic, halloween, haunted, haunting, horror, kids voice, lullaby, magical, nightmare, scary, soundtrack, spooky, suspense, thriller, trailer, twisted, young girl",
    "price": 24,
    "date": "2019-04-16",
    "videoId": "q-dbgBDabFE",
    "youtubeUrl": "https://www.youtube.com/watch?v=q-dbgBDabFE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805142-Vocal-Horror-Fantasy-2m50?ref=dreamnotemusic",
    "duration": "2:50"
  },
  {
    "title": "Sweet Classical Logo",
    "description": "A light, melodic ident/opener/jingle/intro featuring classical-style piano with light orchestral strings and woodwind accompaniment. Ideal for use in YouTube videos, adverts/commercials, history documentaries or as a TV/radio jingle.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "advert, antique, beautiful, british, classic, classical, documentary, english, happy, historical, history, ident, intro, jingle, logo, mozart, old, old fashioned, opener, period drama, podcast, radio, stately home, sweet, theme, traditional, tv, twee, video, youtube",
    "price": 10,
    "date": "2019-04-05",
    "videoId": "Z4KStY7WGjw",
    "youtubeUrl": "https://www.youtube.com/watch?v=Z4KStY7WGjw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802062-Sweet-Classical-Logo?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Dramatic Emotional Cinematic Trailer",
    "description": "An expressive, atmospheric track featuring piano with violin and cello (piano solo versions also included). Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a suspenseful or mysterious tone.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Piano, violin, cello",
    "tags": "atmosphere, atmospheric, cello, cinematic, classical, dark, deep, drama, dramatic, emotional, fantasy, film, haunting, intense, love, mysterious, mystery, night, piano, reflective, romance, sad, soundtrack, suspense, thriller, tragic, trailer, underscore, violin",
    "price": 18,
    "date": "2019-04-03",
    "videoId": "mrWDUgBAr2E",
    "youtubeUrl": "https://www.youtube.com/watch?v=mrWDUgBAr2E",
    "productUrl": "https://audiojungle.net/item/dramatic-emotional-cinematic-trailer/23505397",
    "duration": "1:54"
  },
  {
    "title": "Majestic Baroque Logo",
    "description": "A positive, bright, traditional intro/ident/opener featuring orchestral strings, woodwind, trumpet and harpsichord. Perfect for historical documentaries, classical YouTube videos or any project requiring a royal or regal musical intro.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, trumpet, harpsichord",
    "tags": "advert, antiques, baroque, british, classic, classical, documentary, drama, dramatic, english, historical, history, ident, intro, logo, Monarchy, old, old-fashioned, opener, period drama, positive, proud, regal, renaissance, royal, royalty, stately, traditional, tv, uplifting",
    "price": 10,
    "date": "2019-03-28",
    "videoId": "cDhi8rBRcfY",
    "youtubeUrl": "https://www.youtube.com/watch?v=cDhi8rBRcfY",
    "productUrl": "https://audiojungle.net/item/majestic-baroque-logo/23468213",
    "duration": "0:11"
  },
  {
    "title": "Inspirational Orchestral Advert",
    "description": "An uplifting, cinematic track featuring piano, orchestra and choir. Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, travel videos, corporate presentations or any project requiring a motivational, thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, strings, woodwind, brass, chor, percussion",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, hope, inspirational, journey, magical, motivational, movie, moving, powerful, religious, success, thought-provoking, trailer, travel, triumph, uplifting, win, wonder",
    "price": 20,
    "date": "2019-03-23",
    "videoId": "528nm2dJkvM",
    "youtubeUrl": "https://www.youtube.com/watch?v=528nm2dJkvM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201792952-Inspirational-Orchestral-Advert-1m00?ref=dreamnotemusic",
    "duration": "1:00"
  },
  {
    "title": "Family Home",
    "description": "A heart-warming, sentimental track featuring piano, acoustic guitar, bass, orchestral strings and light drums. Perfect for family/real estate/wedding videos, photo slide shows, TV, movies/films or any project of an expressive nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, bass, orchestral strings, drums",
    "tags": "advert, album, beautiful, charity, commercial, dreamy, emotional, family, family album, family tree, family video, friendship, happy, heartfelt, home, inspirational, inspiring, life, love, memories, montage, moving, photo, photography, real estate, relaxing, romantic, sentimental, slideshow, wedding",
    "price": 24,
    "date": "2019-03-07",
    "videoId": "GVBll6vxso8",
    "youtubeUrl": "https://www.youtube.com/watch?v=GVBll6vxso8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784920-Family-Home-2m24?ref=dreamnotemusic",
    "duration": "2:24"
  },
  {
    "title": "Playful Cute Waltz",
    "description": "A happy, cheerful, fun track featuring piano, glockenspiel, pizzicato strings and staccato woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, pizzicato strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, loop, playful, sweet, twee, youtube",
    "price": 20,
    "date": "2019-02-23",
    "videoId": "ZwUWiemOZM4",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZwUWiemOZM4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799144-Playful-Cute-Waltz-1m09?ref=dreamnotemusic",
    "duration": "1:09"
  },
  {
    "title": "Time and Space",
    "description": "An ambient, dreamy track featuring piano melody, atmospheric synth pads, soft sustained strings and subtle drums. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos, photography presentations or background music for YouTube videos.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, strings, drums",
    "tags": "advert, ambient, background, beautiful, chill, cityscape, commercial, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time, time-lapse, timelapse",
    "price": 24,
    "date": "2019-02-18",
    "videoId": "HSI7HG3Q82A",
    "youtubeUrl": "https://www.youtube.com/watch?v=HSI7HG3Q82A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805205-Time-and-Space-2m44?ref=dreamnotemusic",
    "duration": "2:44"
  },
  {
    "title": "The Sadness of War",
    "description": "A slow, sombre and tragic track featuring orchestral strings, marching snare-drum, brass, choir and solo cello melody (version also included without melody). Ideal for use in history documentaries, TV dramas or movie/film/game soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, snare-drum, brass, choir, cello",
    "tags": "army, atmospheric, battle, cinematic, dark, darkness, death, death march, depressing, fear, funeral, funeral march, honor, honour, march, memorial, military, miserable, misery, patriotic, pride, proud, remembrance, sad, sadness, sombre, suffering, tragedy, tragic, war",
    "price": 20,
    "date": "2019-02-10",
    "videoId": "86D2Eecbuuw",
    "youtubeUrl": "https://www.youtube.com/watch?v=86D2Eecbuuw",
    "productUrl": "https://audiojungle.net/item/the-sadness-of-war/23221836",
    "duration": "2:48"
  },
  {
    "title": "Emotional Atmospheric Trailer with Vocals",
    "description": "Heavenly female voice accompanied by full orchestra and drums. This cinematic track is both expressive and uplifting. Perfect for use as a movie/film/game trailer or soundtrack.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Female vocals, orchestral strings, percussion",
    "tags": "angelic, atmospheric, beautiful, cinematic, dramatic, dystopia, emotional, enchanting, epic, fantasy, female vocal, female voice, film trailer, game trailer, girls voice, grand, haunting, heavenly, hope, inspirational, inspiring, magical, movie trailer, orchestral, patriotic, uplifting, vocal, voice, womans voice, wonderland",
    "price": 20,
    "date": "2026-07-11",
    "videoId": "AMUcQZ5dzPE",
    "youtubeUrl": "https://www.youtube.com/watch?v=AMUcQZ5dzPE",
    "productUrl": "http://audiojungle.net/item/emotional-atmospheric-trailer-with-vocals/64248613",
    "duration": "2:54"
  },
  {
    "title": "Modern News Theme",
    "description": "A pulsing drum beat, synths and strings with an exciting orchestral build-up towards a powerful close. Ideal for TV news channels, YouTube news videos, radio station news reports or any type of corporate announcements, breaking news, headlines, media or broadcasting.",
    "genre": "Corporate",
    "instrumentation": "Drums, synths, orchestral strings",
    "tags": "announcement, broadcast, broadcasting, business report, corporate, dramatic, entertainment, evening news, exciting, feature, featurette, global, gripping, headlines, ident, intro, logo, media, network, news, opening, powerful, presentation, promo, radio, sports report, strong, tense, tv, youtube",
    "price": 16,
    "date": "2019-01-23",
    "videoId": "GUOKRTR8FCc",
    "youtubeUrl": "https://www.youtube.com/watch?v=GUOKRTR8FCc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795580-Modern-News-Theme-0m34?ref=dreamnotemusic",
    "duration": "0:34"
  },
  {
    "title": "Modern Magic",
    "description": "An atmospheric, magical/fantasy track featuring vibraphone, piano, synth string pads, orchestral pizzicato strings and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Vibraphone, piano, synth string pads, orchestral pizzicato strings, glockenspiel",
    "tags": "advert, banking, bright, business, christmas, commercial, company, dream, fantasy, future, futuristic, happy, hopeful, inspirational, investment, magic, magical, marketing, modern, money, optimistic, product, promo, promotional, sales, science, space, technology, timelapse, tv",
    "price": 20,
    "date": "2019-01-19",
    "videoId": "2DKNSH0Mm00",
    "youtubeUrl": "https://www.youtube.com/watch?v=2DKNSH0Mm00",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795632-Modern-Magic-1m06?ref=dreamnotemusic",
    "duration": "1:06"
  },
  {
    "title": "Emotional Atmospheric Background",
    "description": "A minimalistic and thought-provoking track featuring piano, synth bass, string pads and light drums (simplified versions also included without drums, bass and strings). Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks, time-lapse photography videos or any project of an expressive or heartfelt nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, synth bass, string pads, drums",
    "tags": "advert, atmospheric, belief, believe, calm, charity, documentary, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, minimal, minimalism, minimalistic, nostalgic, peaceful, piano, reflective, religion, romantic, sad, sentimental, sorrow, thoughtful, time-lapse, timelapse",
    "price": 20,
    "date": "2019-01-15",
    "videoId": "EZQvYlWrIqY",
    "youtubeUrl": "https://www.youtube.com/watch?v=EZQvYlWrIqY",
    "productUrl": "https://audiojungle.net/item/emotional-atmospheric-background/23113032",
    "duration": "2:47"
  },
  {
    "title": "Lively Baroque",
    "description": "A happy, joyful traditional classical track featuring orchestral strings, harpsichord and trumpet. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, trumpet",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 18,
    "date": "2019-01-05",
    "videoId": "nQ-tDv5xzyo",
    "youtubeUrl": "https://www.youtube.com/watch?v=nQ-tDv5xzyo",
    "productUrl": "https://audiojungle.net/item/lively-baroque/23070323",
    "duration": "1:36"
  },
  {
    "title": "Kids' Game Loop",
    "description": "A happy, positive background track featuring piano, guitar, banjo, glockenspiel and bass. This playful track is perfect for kids' cartoons/animations, computer games/apps, children’s party games, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, guitar, banjo, glockenspiel, bass",
    "tags": "animation, app, background, bright, cartoon, catchy, cheerful, children, comedy, fun, game, happy, holiday, kids, kids music, kids tv, loop, party, party game, play, playful, positive, reggae, school, theme tune, tv, tv theme, upbeat, vacation, youtube",
    "price": 14,
    "date": "2019-01-02",
    "videoId": "hNNOhbjfXXA",
    "youtubeUrl": "https://www.youtube.com/watch?v=hNNOhbjfXXA",
    "productUrl": "https://audiojungle.net/item/kids-game-loop/23052441",
    "duration": "0:39"
  },
  {
    "title": "Reality Show Comedy Background",
    "description": "A fun, quirky and mysterious track featuring pizzicato strings, woodwind, piano, glockenspiel, xylophone and percussion. Perfect for adverts/commercials, TV shows, comedy films/movies, apps/games or YouTube videos/vlogs.",
    "genre": "Comedy",
    "instrumentation": "Strings, woodwind, piano, glockenspiel, xylophone, percussion",
    "tags": "advert, app, background, cleaning, comedic, comedy, comedy drama, comedy movie, commercial, computer game, Daytime TV, fun, funny, gag, game, happy, humor, humour, humourous, lifestyle, mysterious, mystery, playful, quirky, reality show, reality TV, silly, stupid, vlog, youtube",
    "price": 16,
    "date": "2018-12-25",
    "videoId": "4rg2VfsTFxI",
    "youtubeUrl": "https://www.youtube.com/watch?v=4rg2VfsTFxI",
    "productUrl": "https://audiojungle.net/item/reality-show-comedy-background/23026328",
    "duration": "1:05"
  },
  {
    "title": "Silly Fun Comedy",
    "description": "A happy, positive theme-tune featuring upbeat recorder, guitars, piano, synth, percussion, bass, hand-claps and glockenspiel. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts or funny comedy/bloopers videos.",
    "genre": "Comedy",
    "instrumentation": "Recorder, guitar, piano, synth, percussion, bass, glockenspiel",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, ident, intro, kids, kids tv, logo, loop, party, play, playful, quirky, school, silly, theme tune, tv, tv theme, upbeat, video intro, youtube",
    "price": 12,
    "date": "2018-12-22",
    "videoId": "WZLBmBjhQVU",
    "youtubeUrl": "https://www.youtube.com/watch?v=WZLBmBjhQVU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802111-Silly-Fun-Comedy-0m24?ref=dreamnotemusic",
    "duration": "0:24"
  },
  {
    "title": "Atmosphere",
    "description": "An ambient, spacious and dreamy track featuring atmospheric pianos and smooth synth pads. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV or time-lapse videos.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "ambient, atmosphere, atmospheric, beautiful, chill, cityscape, cool, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, night, peace, peaceful, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, stars, thoughts, time-lapse, timelapse",
    "price": 24,
    "date": "2018-12-16",
    "videoId": "Eh2BTMGxbFE",
    "youtubeUrl": "https://www.youtube.com/watch?v=Eh2BTMGxbFE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201310874-Atmosphere-2m23?ref=dreamnotemusic",
    "duration": "2:23"
  },
  {
    "title": "Passionate Cinematic Cello",
    "description": "An intense, emotional track featuring a rich, expressive cello melody accompanied by sustained orchestral strings, woodwind, brass and choir. Ideal for movie/film soundtracks, TV, history documentaries or any project with a stirring, dramatic atmosphere.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Cello, orchestral strings, woodwind, brass, choir",
    "tags": "atmosphere, atmospheric, cellist, cello, cello solo, celtic, cinematic, dark, death, drama, dramatic, drone, folk, grief, history, lament, loneliness, lonely, loss, moody, passion, period drama, remembrance, sad, sadness, solitude, sorrow, tragedy, tragic, war",
    "price": 20,
    "date": "2018-12-12",
    "videoId": "y1ACE19ox_M",
    "youtubeUrl": "https://www.youtube.com/watch?v=y1ACE19ox_M",
    "productUrl": "https://audiojungle.net/item/passionate-cinematic-cello/22959229",
    "duration": "2:24"
  },
  {
    "title": "Magical Christmas Background",
    "description": "A bright, atmospheric xmas track featuring sleigh bells, piano, tubular bells and orchestral strings. Ideal for use in YouTube vlogmas videos, Christmas TV adverts/commercials, greetings cards, radio intros, xmas games/apps or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, piano, tubular bells, orchestral strings",
    "tags": "atmospheric, background, beautiful, bells, bright, cheerful, children, christmas, festive, fun, greetings, greetings card, happy, happy holidays, holiday, intro, jingle, jolly, kids, loop, merry, playful, seasonal, sleigh bells, video intro, vlog, vlogmas, xmas, youtube, youtube intro",
    "price": 24,
    "date": "2018-12-06",
    "videoId": "Znrh39aSco8",
    "youtubeUrl": "https://www.youtube.com/watch?v=Znrh39aSco8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795705-Magical-Christmas-Background-3m00?ref=dreamnotemusic",
    "duration": "3:00"
  },
  {
    "title": "Romantic and Emotional",
    "description": "A beautiful, atmospheric and inspirational track featuring piano, orchestral strings, trumpet and french horn. Perfect for wedding videos, photo slideshows, family videos or any project of an expressive nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, trumpet, french horn",
    "tags": "advert, beautiful, dreaming, dreamy, emotion, emotional, expressive, family, heartfelt, inspirational, inspire, inspiring, life, love, magical, memories, moving, orchestral, piano, reflective, rich, romance, romantic, sentimental, strings, uplifting, valentines, video, wedding, wedding video",
    "price": 24,
    "date": "2018-12-03",
    "videoId": "NgUJtt-TBtc",
    "youtubeUrl": "https://www.youtube.com/watch?v=NgUJtt-TBtc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802305-Romantic-and-Emotional-3m18?ref=dreamnotemusic",
    "duration": "3:18"
  },
  {
    "title": "Christmas Anthem",
    "description": "A joyous, uplifting and triumphant xmas track featuring orchestral strings, sleigh-bells, woodwind, brass, drums and choir. Ideal for use in YouTube vlogmas video intros, Christmas TV adverts/commercials, xmas games/apps or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Orchestral strings, sleigh-bells, woodwind, brass, drums, zchoir.",
    "tags": "bright, cheerful, children, christmas, festive, fun, grand, greetings, greetings card, happy, holiday, ident, intro, jingle, jolly, joyous, logo, merry, playful, seasonal, sleigh bells, triumphant, upbeat, vlog, xmas",
    "price": 20,
    "date": "2018-11-29",
    "videoId": "VGsm8cW2p_w",
    "youtubeUrl": "https://www.youtube.com/watch?v=VGsm8cW2p_w",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755714-Christmas-Anthem-1m48?ref=dreamnotemusic",
    "duration": "1:48"
  },
  {
    "title": "Dark Emotional Theme",
    "description": "An atmospheric, cinematic track featuring piano with violin, cello and dramatic orchestral strings. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a haunting, tense tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, violin, cello, orchestral strings",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, death, deep, drama, dramatic, emotional, fantasy, film, forbidden, haunting, intense, love, lovers, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 24,
    "date": "2018-11-26",
    "videoId": "u-u5Hdjy1Hc",
    "youtubeUrl": "https://www.youtube.com/watch?v=u-u5Hdjy1Hc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780788-Dark-Emotional-Theme-2m02?ref=dreamnotemusic",
    "duration": "2:02"
  },
  {
    "title": "Beautiful Fantasy",
    "description": "An atmospheric, magical track featuring piano, violin, cello, orchestral strings, brass, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, violin, cello, orchestral strings, brass, choir, glockenspiel",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 24,
    "date": "2018-11-22",
    "videoId": "DEXvqXsBa0M",
    "youtubeUrl": "https://www.youtube.com/watch?v=DEXvqXsBa0M",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483512-Beautiful-Fantasy-2m07?ref=dreamnotemusic",
    "duration": "2:07"
  },
  {
    "title": "Beautiful Magical Wedding Day",
    "description": "An expressive, romantic track featuring piano, violin, cello, orchestral strings and brass. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, violin, cello, orchestral strings, brass",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 24,
    "date": "2018-11-15",
    "videoId": "j-owmxHcjLU",
    "youtubeUrl": "https://www.youtube.com/watch?v=j-owmxHcjLU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483581-Beautiful-Magical-Wedding-Day-2m52?ref=dreamnotemusic",
    "duration": "2:52"
  },
  {
    "title": "Cute Kids' Comedy",
    "description": "A fun, happy and upbeat track featuring cheerful recorder melody, glockenspiel, vibraphone, piano, banjo, finger-clicks and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, glockenspiel, vibraphone, piano, banjo, percussion, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, jingle, kids, kids tv, logo, loop, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, youtube",
    "price": 16,
    "date": "2018-11-09",
    "videoId": "MJ0IQ-xjyjE",
    "youtubeUrl": "https://www.youtube.com/watch?v=MJ0IQ-xjyjE",
    "productUrl": "https://audiojungle.net/item/cute-kids-comedy/22774154",
    "duration": "1:21"
  },
  {
    "title": "My Inspiration",
    "description": "An uplifting, cinematic track featuring piano and orchestra. Ideal for use in adverts/commercials, documentaries, trailers, movie/film soundtracks, travel videos or any project requiring a motivational, positive musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass,choir",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, hope, inspirational, journey, magical, motivational, movie, moving, powerful, religious, success, thought-provoking, trailer, travel, triumph, uplifting, win, wonder",
    "price": 20,
    "date": "2018-11-03",
    "videoId": "D4hQb31twS8",
    "youtubeUrl": "https://www.youtube.com/watch?v=D4hQb31twS8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/200252823-My-Inspiration-1m07?ref=dreamnotemusic",
    "duration": "1:07"
  },
  {
    "title": "Dark Drama Theme",
    "description": "An atmospheric, emotional track featuring pianos, violin, cello, orchestral strings, woodwind and percussion. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a haunting, expressive tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Pianos, violin, cello, orchestral strings, woodwind, percussion",
    "tags": "atmosphere, atmospheric, cello, cinematic, dark, deep, drama, drama theme, dramatic, emotional, expressive, haunting, intense, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, theme, thriller, tragic, trailer, TV Drama, twilight, underscore, violin",
    "price": 20,
    "date": "2018-10-28",
    "videoId": "U6ofE2uvpWM",
    "youtubeUrl": "https://www.youtube.com/watch?v=U6ofE2uvpWM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780842-Dark-Drama-Theme-1m44?ref=dreamnotemusic",
    "duration": "1:44"
  },
  {
    "title": "Inspiring Timelapse",
    "description": "A dreamy, atmospheric track featuring layered pianos with soft, ambient synth pads. Ideal for adverts/commercials, TV/movie/film soundtracks, documentaries, time-lapse/nature videos or photography montages.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, atmospheric, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, montage, moving, nature, peaceful, photography, relaxing, scenery, scenic, sleep, soundscape, space, thoughts, time, time-lapse, timelapse",
    "price": 24,
    "date": "2018-10-23",
    "videoId": "QoJTgJVpbp0",
    "youtubeUrl": "https://www.youtube.com/watch?v=QoJTgJVpbp0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201792987-Inspiring-Timelapse-2m19?ref=dreamnotemusic",
    "duration": "2:19"
  },
  {
    "title": "Atmospheric Female Vocals",
    "description": "Heavenly young woman’s voice accompanied by a low orchestral strings drone. This haunting, mysterious vocal track is perfect for use in movie/film/game trailers, teasers or soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Voice, orchestral strings",
    "tags": "angelic, atmospheric, beautiful, cinematic, dark, death, drama, dramatic, drone, emotional, enchanting, epic, fantasy, female vocal, film, game, girls voice, haunting, heavenly, inspirational, movie, moving, mysterious, romance, sad, singer, trailer, vocal, voice, war",
    "price": 16,
    "date": "2018-10-19",
    "videoId": "E9JjaEDenlk",
    "youtubeUrl": "https://www.youtube.com/watch?v=E9JjaEDenlk",
    "productUrl": "https://audiojungle.net/item/atmospheric-female-vocals/22675317",
    "duration": "1:28"
  },
  {
    "title": "Horror Mystery",
    "description": "An expressive, dark, mysterious track featuring harp, piano, violin, cello, sustained orchestral strings, woodwind and church organ. Perfect for horror film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a haunting, emotional tone.",
    "genre": "Horror",
    "instrumentation": "Harp, piano, violin, cello, orchestral strings, woodwind, church organ",
    "tags": "atmosphere, atmospheric, cinematic, creepy, dark, death, drama, emotional, fantasy, ghost, gothic, halloween, haunting, horror, movie, murder, mysterious, mystery, night, romance, sad, scary, sinister, soundtrack, spooky, suspense, thriller, tragic, twilight, twisted",
    "price": 24,
    "date": "2018-10-12",
    "videoId": "8hE46a3g8d0",
    "youtubeUrl": "https://www.youtube.com/watch?v=8hE46a3g8d0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786289-Horror-Mystery-2m37?ref=dreamnotemusic",
    "duration": "2:37"
  },
  {
    "title": "Romantic and Sentimental",
    "description": "An expressive track featuring piano with orchestral strings, woodwind, brass and acoustic guitar. An ideal backing for adverts/commercials, documentaries, wedding videos, TV/film/movie soundtracks, family videos, photo slide-shows or any project with an inspirational, hopeful tone.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, acoustic guitar",
    "tags": "advert, advertisement, beautiful, classic, commemorative, commercial, dreams, dreamy, family, heartfelt, hope, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, piano, reflective, romantic, sentimental, strings, timeless, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2018-10-07",
    "videoId": "4U8HkfZrD1k",
    "youtubeUrl": "https://www.youtube.com/watch?v=4U8HkfZrD1k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802312-Romantic-and-Sentimental-2m32?ref=dreamnotemusic",
    "duration": "2:32"
  },
  {
    "title": "Inspiring Magical Advert",
    "description": "A dreamy, enchanting fantasy track featuring piano, orchestral strings, woodwind, brass, choir and glockenspiel. Ideal for use in adverts/commercials, fantasy TV film/movie soundtracks, children’s animations or any project of a hopeful or positive nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 20,
    "date": "2018-10-03",
    "videoId": "ANBUphn3qq8",
    "youtubeUrl": "https://www.youtube.com/watch?v=ANBUphn3qq8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793035-Inspiring-Magical-Advert-1m10?ref=dreamnotemusic",
    "duration": "1:10"
  },
  {
    "title": "Magical Moments in Life",
    "description": "A dreamy, atmospheric fantasy track featuring piano, orchestral strings, woodwind and sustained brass. Perfect for use in movies/films, TV, animations, documentaries, adverts/commercials or any magical fantasy scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, advertising, atmospheric, baby, bank, banking, beautiful, birth, bright, child, christmas, commercial, dream, fairytale, family, fantasy, festive, future, happy, home, hopeful, innocent, inspirational, love, magic, magical, money, optimistic, positive, tv",
    "price": 20,
    "date": "2018-09-29",
    "videoId": "Dz2oLfB9Cyc",
    "youtubeUrl": "https://www.youtube.com/watch?v=Dz2oLfB9Cyc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795746-Magical-Moments-in-Life-1m20?ref=dreamnotemusic",
    "duration": "1:20"
  },
  {
    "title": "Cinematic Magical Advert",
    "description": "A dreamy, atmospheric track featuring piano, sustained orchestral strings, woodwind, brass and choir. Perfect for use in movies/films, TV, animations, documentaries, adverts/commercials or any magical fantasy scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, sustained orchestral strings, woodwind, brass and choir.",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 20,
    "date": "2018-09-25",
    "videoId": "_YpIfVJ4g68",
    "youtubeUrl": "https://www.youtube.com/watch?v=_YpIfVJ4g68",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755789-Cinematic-Magical-Advert-1m22?ref=dreamnotemusic",
    "duration": "1:22"
  },
  {
    "title": "Horror Lullaby with Voice",
    "description": "An atmospheric, mysterious track featuring young girl’s voice (Instrumental version also included) with creepy celesta, piano, glockenspiel and eerie orchestral strings. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audio books, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Celesta, piano, glockenspiel, orchestral strings",
    "tags": "atmospheric, book trailer, child, creepy, dark, death, dream, evil, fantasy, female voice, ghost, ghostly, girl, gothic, halloween, haunted, haunting, horror, kids voice, lullaby, magical, nightmare, scary, soundtrack, spooky, suspense, thriller, trailer, twisted, young girl",
    "price": 20,
    "date": "2018-09-19",
    "videoId": "ymDsqQjJ7nM",
    "youtubeUrl": "https://www.youtube.com/watch?v=ymDsqQjJ7nM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786308-Horror-Lullaby-with-Voice-1m56?ref=dreamnotemusic",
    "duration": "1:56"
  },
  {
    "title": "Playful and Cute",
    "description": "A happy, bright, fun track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, pizzicato strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, loop, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2018-09-16",
    "videoId": "J34qyTL_Bys",
    "youtubeUrl": "https://www.youtube.com/watch?v=J34qyTL_Bys",
    "productUrl": "https://audiojungle.net/item/playful-and-cute/22552436",
    "duration": "1:01"
  },
  {
    "title": "Playful Kids' Theme",
    "description": "A positive, upbeat theme-tune featuring cheerful melody, piano, bass, glockenspiel and finger-clicks. This bright, playful track is perfect for TV shows, kids cartoons/animations, computer games/apps, children’s party games, commercials/adverts or any project with a lively, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, bass, glockenspiel, synth, percussion",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, loop, party, play, playful, quirky, school, theme, tune, tv, upbeat, vacation, video, youtube",
    "price": 20,
    "date": "2018-09-12",
    "videoId": "ExwH0zsv7j0",
    "youtubeUrl": "https://www.youtube.com/watch?v=ExwH0zsv7j0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799155-Playful-Kids-Theme-1m01?ref=dreamnotemusic",
    "duration": "1:01"
  },
  {
    "title": "Magical and Uplifting",
    "description": "An atmospheric fantasy track featuring piano, orchestral strings, woodwind, brass, choir, cello and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, cello, glockenspiel",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 20,
    "date": "2018-09-11",
    "videoId": "sgupFpHQ77Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=sgupFpHQ77Y",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795775-Magical-and-Uplifting-1m09?ref=dreamnotemusic",
    "duration": "1:09"
  },
  {
    "title": "Peaceful Atmospheric Background",
    "description": "An emotional and thought-provoking track featuring tranquil piano chords and sustained strings. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, piano solo, reflective, religion, romantic, sad, sentimental, sorrow, still, story, thoughtful",
    "price": 20,
    "date": "2018-09-06",
    "videoId": "ukssuO4GG7s",
    "youtubeUrl": "https://www.youtube.com/watch?v=ukssuO4GG7s",
    "productUrl": "https://audiojungle.net/item/peaceful-atmospheric-background/22505156",
    "duration": "2:32"
  },
  {
    "title": "Kids' Game Background Loop",
    "description": "A happy, positive background looping track featuring piano, pizzicato strings, banjo and bass. This playful track is perfect for kids' cartoons/animations, computer games/apps, children’s party games, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, pizzicato strings, banjo, bass",
    "tags": "animation, app, background, bright, cartoon, catchy, cheerful, children, comedy, fun, game, happy, holiday, kids, kids music, kids tv, loop, party, party game, play, playful, positive, quirky, school, theme tune, tv, tv theme, upbeat, vacation, youtube",
    "price": 14,
    "date": "2018-09-04",
    "videoId": "Iy7Hn_3NXYk",
    "youtubeUrl": "https://www.youtube.com/watch?v=Iy7Hn_3NXYk",
    "productUrl": "https://audiojungle.net/item/kids-game-background-loop/22493377",
    "duration": "0:46"
  },
  {
    "title": "Cute Fun Comedy",
    "description": "A happy, bright, playful track featuring piano, pizzicato strings and staccato woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Comedy",
    "instrumentation": "Piano, strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2018-09-01",
    "videoId": "SVPKnvvrl2g",
    "youtubeUrl": "https://www.youtube.com/watch?v=SVPKnvvrl2g",
    "productUrl": "https://audiojungle.net/item/cute-fun-comedy/22482883",
    "duration": "1:02"
  },
  {
    "title": "Emotional Atmospheric Piano and Strings",
    "description": "A tranquil, thought-provoking cinematic track featuring sustained piano chords and strings. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, expressive, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, reflective, religion, romantic, sad, sentimental, sorrow, story, thoughtful",
    "price": 24,
    "date": "2018-08-28",
    "videoId": "OKtupH7t1V0",
    "youtubeUrl": "https://www.youtube.com/watch?v=OKtupH7t1V0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201782800-Emotional-Atmospheric-Piano-and-Strings-2m30?ref=dreamnotemusic",
    "duration": "2:30"
  },
  {
    "title": "Happy Fun Kids' Theme",
    "description": "A positive, upbeat theme-tune featuring cheerful melody, piano, bass, glockenspiel and finger-clicks. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a lively, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, bass, glockenspiel, percussion",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 14,
    "date": "2018-08-27",
    "videoId": "xcEAdMIx_1M",
    "youtubeUrl": "https://www.youtube.com/watch?v=xcEAdMIx_1M",
    "productUrl": "https://audiojungle.net/item/happy-fun-kids-theme/22452436",
    "duration": "0:36"
  },
  {
    "title": "A Magical Place",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, woodwind, brass, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, glockenspiel",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 16,
    "date": "2018-08-22",
    "videoId": "ImE_XOdV-iI",
    "youtubeUrl": "https://www.youtube.com/watch?v=ImE_XOdV-iI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201310884-A-Magical-Place-0m58?ref=dreamnotemusic",
    "duration": "0:58"
  },
  {
    "title": "Trumpet Fanfare",
    "description": "A confident, majestic, regal trumpet fanfare. Ideal for use in games/apps or as an ident/opener/intro, e-card sound sample or animation sound effect.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Trumpets",
    "tags": "app, army, brass, celebration, ceremony, event, fanfare, festive, game, glory, graduation, heroes, honor, honour, ident, intro, logo, majestic, march, memorial, military, opener, patriotic, pride, regal, remembrance, royal, royalty, trumpet, trumpets",
    "price": 2,
    "date": "2018-08-18",
    "videoId": "Gi5WBvNGinw",
    "youtubeUrl": "https://www.youtube.com/watch?v=Gi5WBvNGinw",
    "productUrl": "https://audiojungle.net/item/trumpet-fanfare/22421540",
    "duration": "0:04"
  },
  {
    "title": "Choir Ident",
    "description": "A beautiful, atmospheric intro/logo/opener featuring a glorious blend of sustained voices singing in harmony. Perfect for spiritual/holy videos, adverts, documentaries, company openers or any project with an emotional, religious tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Choir",
    "tags": "angelic, atmospheric, beautiful, belief, believe, charity, choir, church, expressive, faith, god, heaven, heavenly, holy, hymn, intro, logo, opener, peaceful, prayer, reflective, religion, religious, singers, singing, spiritual, vocal, voice, voices, worship",
    "price": 12,
    "date": "2018-08-15",
    "videoId": "DVdYE_c_v1g",
    "youtubeUrl": "https://www.youtube.com/watch?v=DVdYE_c_v1g",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755795-Choir-Ident?ref=dreamnotemusic",
    "duration": "0:22"
  },
  {
    "title": "Choir",
    "description": "An atmospheric, beautiful track featuring a glorious blend of sustained voices singing in harmony. Perfect for documentaries, remembrance services, commemorative videos, funerals, photo slide shows or any project spiritual/religious or faithful/hopeful in tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Choir",
    "tags": "angelic, angels, atmospheric, cathedral, children, choir, chorus, church, emotional, expressive, faith, faithful, funeral, glorious, glory, god, heaven, heavenly, hopeful, hymn, peaceful, religious, singers, singing, spiritual, uplifting, vocal, vocals, voice, voices",
    "price": 20,
    "date": "2018-08-10",
    "videoId": "S8RWRlxtXOM",
    "youtubeUrl": "https://www.youtube.com/watch?v=S8RWRlxtXOM",
    "productUrl": "https://audiojungle.net/item/choir/22392375",
    "duration": "2:45"
  },
  {
    "title": "Atmospheric Cinematic Piano and Strings",
    "description": "An emotional, expressive track featuring piano with rich orchestral strings, cello and choir. Perfect for film/movie/game soundtracks, teasers, e-book promos or TV dramas.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings, cello, choir",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, death, deep, drama, dramatic, emotional, fantasy, film, forbidden, haunting, intense, love, lovers, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 24,
    "date": "2018-08-03",
    "videoId": "tz060dmqQQA",
    "youtubeUrl": "https://www.youtube.com/watch?v=tz060dmqQQA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311003-Atmospheric-Cinematic-Piano-and-Strings-3m40?ref=dreamnotemusic",
    "duration": "3:40"
  },
  {
    "title": "Happy Fun Kids' Logo",
    "description": "‘Happy Fun Kids’ Logo’ is an upbeat, cheerful ident/opener/jingle/intro featuring recorder, glockenspiel, piano, bass and hand-claps. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Recorder, glockenspiel, piano, bass, percussion",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 8,
    "date": "2018-08-02",
    "videoId": "VNYTfeC3za8",
    "youtubeUrl": "https://www.youtube.com/watch?v=VNYTfeC3za8",
    "productUrl": "https://audiojungle.net/item/happy-fun-kids-logo/22348273",
    "duration": "0:04"
  },
  {
    "title": "Sad Tragic Cello",
    "description": "An emotional, atmospheric lament featuring an expressive cello solo accompanied by dark orchestral tones. Ideal for movie/film soundtracks, documentaries or any project with a tense, mysterious atmosphere.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Cello, orchestra",
    "tags": "atmosphere, atmospheric, cellist, cello, cello solo, celtic, cinematic, dark, death, drama, dramatic, drone, folk, grief, history, lament, loneliness, lonely, loss, passion, period drama, remembrance, sad, sadness, solitude, sorrow, tragedy, tragic, violin, war",
    "price": 20,
    "date": "2018-07-31",
    "videoId": "hFdCAElPvC4",
    "youtubeUrl": "https://www.youtube.com/watch?v=hFdCAElPvC4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802402-Sad-Tragic-Cello-1m46?ref=dreamnotemusic",
    "duration": "1:46"
  },
  {
    "title": "Magical Fantasy Advert",
    "description": "A dreamy, atmospheric track featuring layered pianos, sustained orchestral strings, choir, expressive cello, woodwind and brass. Perfect for use in movies/films, TV, animations, documentaries, adverts/commercials or any magical fantasy scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, cello, woodwind, brass",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 20,
    "date": "2018-07-30",
    "videoId": "bLKzlmOZ9jA",
    "youtubeUrl": "https://www.youtube.com/watch?v=bLKzlmOZ9jA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795811-Magical-Fantasy-Advert-1m14?ref=dreamnotemusic",
    "duration": "1:14"
  },
  {
    "title": "Fun Happy Kids' Logo",
    "description": "‘Fun Happy Kids’ Logo’ is an upbeat ident/opener/jingle/intro featuring recorder, glockenspiel, piano and tuba. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Recorder, glockenspiel, piano, tuba",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2018-07-27",
    "videoId": "U95UEQnj0-Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=U95UEQnj0-Y",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784927-Fun-Happy-Kids-Logo?ref=dreamnotemusic",
    "duration": "0:03"
  },
  {
    "title": "Majestic Royal Baroque",
    "description": "A positive, traditional classical track featuring orchestral strings, harpsichord and trumpet. Perfect for advertising/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, trumpet",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 20,
    "date": "2018-07-26",
    "videoId": "ejraF-KIqxw",
    "youtubeUrl": "https://www.youtube.com/watch?v=ejraF-KIqxw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795867-Majestic-Royal-Baroque-1m22?ref=dreamnotemusic",
    "duration": "1:22"
  },
  {
    "title": "Fun Kids' Theme",
    "description": "A happy, upbeat theme-tune featuring cheerful recorder melody, piano, bass, glockenspiel and finger-clicks. This bright, playful track is perfect for TV shows, kids cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, bass, glockenspiel, percussion",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 16,
    "date": "2018-07-25",
    "videoId": "SV7t6sdbOy4",
    "youtubeUrl": "https://www.youtube.com/watch?v=SV7t6sdbOy4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784948-Fun-Kids-Theme-0m39?ref=dreamnotemusic",
    "duration": "0:39"
  },
  {
    "title": "Magical Commercial",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, woodwind, brass, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, glockenspiel",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 14,
    "date": "2018-07-23",
    "videoId": "eXBBZjtEKZg",
    "youtubeUrl": "https://www.youtube.com/watch?v=eXBBZjtEKZg",
    "productUrl": "https://audiojungle.net/item/magical-commercial/22279718",
    "duration": "0:45"
  },
  {
    "title": "English Summer",
    "description": "A charming, traditional classical orchestral track featuring piano, glockenspiel, orchestral strings, woodwind and brass. Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Classical",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind, brass",
    "tags": "advert, antiques, baking, british, charming, classic, classical, commercial, country, countryside, documentary, drama, england, english, heritage, historical, history, kitchen, nature, orchestra, orchestral, period, royal, royalty, summer, traditional, tv, twee, wedding, youtube",
    "price": 20,
    "date": "2018-07-19",
    "videoId": "rmec7maFVgs",
    "youtubeUrl": "https://www.youtube.com/watch?v=rmec7maFVgs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201782754-English-Summer-1m23?ref=dreamnotemusic",
    "duration": "1:23"
  },
  {
    "title": "Kids' Theme",
    "description": "‘Kids’ Theme’ is a fun, happy and upbeat track featuring cheerful recorder, glockenspiel, vibraphone, piano, synth, banjo, finger-clicks and bass guitar This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, glockenspiel, vibraphone, piano, synth, banjo, percussion, bass guitar",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, jingle, kids, kids tv, logo, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 16,
    "date": "2018-07-13",
    "videoId": "Fj8owDOW5GM",
    "youtubeUrl": "https://www.youtube.com/watch?v=Fj8owDOW5GM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794908-Kids-Theme-0m28?ref=dreamnotemusic",
    "duration": "0:28"
  },
  {
    "title": "Magical Vocal Movie Logo",
    "description": "An atmospheric, expressive, cinematic logo/intro/ident featuring angelic female voice with orchestral strings, woodwind, brass, choir and piano (Instrumental version, without voice, also included). Ideal for use as a movie opening/intro or film company logo.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Female voice, orchestral strings, woodwind, brass, choir, piano",
    "tags": "advert, angelic, atmospheric, beautiful, cinematic, crescendo, dream, dreamy, enchanted, fantasy, female vocal, female voice, film ident, film intro, girls voice, heavenly, hopeful, ident, innocent, intro, logo, magic, magical, movie, movie intro, singer, trailer, wonder, wonderland",
    "price": 12,
    "date": "2018-07-12",
    "videoId": "ZmE4OLeR9d8",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZmE4OLeR9d8",
    "productUrl": "https://audiojungle.net/item/magical-vocal-movie-logo/22196868",
    "duration": "0:20"
  },
  {
    "title": "Sweet Magical",
    "description": "An uplifting, inspirational track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 24,
    "date": "2018-07-09",
    "videoId": "oVIy855jSJM",
    "youtubeUrl": "https://www.youtube.com/watch?v=oVIy855jSJM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802519-Sweet-Magical-2m10?ref=dreamnotemusic",
    "duration": "2:10"
  },
  {
    "title": "Atmospheric Creepy Horror",
    "description": "A sad, haunting track featuring piano, celesta, orchestral strings and eerie choir (versions without strings and choir also included). Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games/apps.",
    "genre": "Horror",
    "instrumentation": "Piano, celesta, orchestral strings, choir",
    "tags": "atmospheric, creepy, dark, death, evil, ghost, gothic, halloween, haunted, haunting, hell, horror, horror movie, lonely, lullaby, murder, mysterious, mystery, night, nightmare, psycho, sad, scary, serial killer, soundtrack, spooky, suspense, thriller, trailer, twisted",
    "price": 18,
    "date": "2018-07-07",
    "videoId": "CB2ZYXGGpoc",
    "youtubeUrl": "https://www.youtube.com/watch?v=CB2ZYXGGpoc",
    "productUrl": "https://audiojungle.net/item/atmospheric-creepy-horror/22149403",
    "duration": "1:34"
  },
  {
    "title": "Fun Happy Kids' Theme",
    "description": "A positive, jolly theme-tune featuring upbeat recorder, piano, banjo, bass, glockenspiel and light drums. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, banjo, bass, glockenspiel, drums",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 14,
    "date": "2018-07-05",
    "videoId": "hkAdHwmh3ow",
    "youtubeUrl": "https://www.youtube.com/watch?v=hkAdHwmh3ow",
    "productUrl": "https://audiojungle.net/item/fun-happy-kids-theme/22138612",
    "duration": "0:55"
  },
  {
    "title": "Dark Emotional Trailer with Vocals",
    "description": "Atmospheric female voice accompanied by piano, cello, orchestra, choir and percussion (version also included without vocals). This expressive track is both ethereal and uplifting. Perfect for use as a movie/film/game trailer or soundtrack.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Female voice, piano, cello, orchestra, choir, percussion",
    "tags": "angelic, atmospheric, beautiful, cinematic, dark, dramatic, dystopia, emotional, epic, fantasy, female vocal, female voice, film trailer, game trailer, girls voice, heavenly, hope, inspirational, inspiring, movie trailer, mysterious, new world, orchestral, positive, proud, uplifting, utopia, vocals, voice, womans voice",
    "price": 20,
    "date": "2018-07-03",
    "videoId": "r01vIe6bj2I",
    "youtubeUrl": "https://www.youtube.com/watch?v=r01vIe6bj2I",
    "productUrl": "https://audiojungle.net/item/dark-emotional-trailer-with-vocals/22127805",
    "duration": "2:10"
  },
  {
    "title": "Magical Ambient Background",
    "description": "An atmospheric, dreamy track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, ambient, atmospheric, background, bank, banking, bright, christmas, commercial, company, corporate, dream, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, tv",
    "price": 16,
    "date": "2018-06-27",
    "videoId": "GEw-2xUF3MM",
    "youtubeUrl": "https://www.youtube.com/watch?v=GEw-2xUF3MM",
    "productUrl": "https://audiojungle.net/item/magical-ambient-background/22096062",
    "duration": "1:04"
  },
  {
    "title": "Magical Wedding Day",
    "description": "A dreamy, beautiful and romantic track featuring piano, cello, expressive orchestral strings, choir, glockenspiel and bells. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, expressive orchestral strings, choir, glockenspiel, bells",
    "tags": "beautiful, believe, bride, ceremony, christmas, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, fantasy, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 24,
    "date": "2018-06-25",
    "videoId": "SoYSUVVfzO0",
    "youtubeUrl": "https://www.youtube.com/watch?v=SoYSUVVfzO0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795897-Magical-Wedding-Day-2m04?ref=dreamnotemusic",
    "duration": "2:04"
  },
  {
    "title": "Sweet Summer Day",
    "description": "A light-hearted, twee track featuring pizzicato strings, piano and glockenspiel accompanying a clarinet melody (versions also included without melody). Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos or kids' TV.",
    "genre": "Classical",
    "instrumentation": "Clarinet, strings, piano, glockenspiel",
    "tags": "advert, baking, beautiful, british, charming, children, clarinet, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, england, english, garden, heritage, historical, history, kids, kitchen, nature, period drama, spring, summer, sweet, traditional, twee",
    "price": 20,
    "date": "2018-06-15",
    "videoId": "VQQx7rLYCco",
    "youtubeUrl": "https://www.youtube.com/watch?v=VQQx7rLYCco",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802567-Sweet-Summer-Day-1m29?ref=dreamnotemusic",
    "duration": "1:29"
  },
  {
    "title": "Sneaky Comedy Suspense",
    "description": "A quirky background track featuring tuba, pizzicato strings, clarinet, piano, woodwind and vibraphone. Perfect for comedy compilation/bloopers videos, adverts/commercials, TV shows, comedy films/movies, apps/computer games or YouTube videos/vlogs.",
    "genre": "Comedy",
    "instrumentation": "Tuba, strings, clarinet, piano, woodwind, vibraphone",
    "tags": "advert, app, background, children, comedic, comedy, comedy drama, comedy movie, commercial, computer game, Daytime TV, fun, funny, gag, game, happy, humor, humour, humourous, kids, lifestyle, lively, playful, playing, quirky, silly, stupid, suspense, vlog, youtube",
    "price": 16,
    "date": "2018-06-05",
    "videoId": "Zz2_MLv_FOE",
    "youtubeUrl": "https://www.youtube.com/watch?v=Zz2_MLv_FOE",
    "productUrl": "https://audiojungle.net/item/sneaky-comedy-suspense/21991702",
    "duration": "1:06"
  },
  {
    "title": "Inspiring Ambient Background",
    "description": "A positive, atmospheric track featuring piano, guitar and synth pads. Ideal for use in TV/radio adverts/commercials, corporate promotional material or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Piano, guitar, synth pads",
    "tags": "achievement, advert, advertising, ambient, atmospheric, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, positive, presentation, promotional, subtle, success, successful, uplifting",
    "price": 20,
    "date": "2018-06-04",
    "videoId": "0f0az8cqFDA",
    "youtubeUrl": "https://www.youtube.com/watch?v=0f0az8cqFDA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793053-Inspiring-Ambient-Background-1m42?ref=dreamnotemusic",
    "duration": "1:42"
  },
  {
    "title": "Magical and Hopeful",
    "description": "An uplifting, inspirational track featuring piano, harp, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a bright or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, harp, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 20,
    "date": "2018-05-28",
    "videoId": "dJAeqsn48Hk",
    "youtubeUrl": "https://www.youtube.com/watch?v=dJAeqsn48Hk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795924-Magical-and-Hopeful-1m11?ref=dreamnotemusic",
    "duration": "1:11"
  },
  {
    "title": "Inspiring Faith with Vocals",
    "description": "An atmospheric and inspirational cinematic track featuring heavenly female voice accompanied by orchestral strings, choir, cello, woodwind and brass. This emotional, expressive vocal track is perfect for use in movie/film/game trailers/teasers, soundtracks or any religious/spiritual/church project.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Female voice, orchestral strings, choir, cello, woodwind, brass",
    "tags": "angelic, atmospheric, beautiful, belief, believe, celestial, church, cinematic, dramatic, emotional, faith, fantasy, female vocal, god, heavenly, holy, jesus, moving, pray, prayer, religion, religious, sacred, sad, spiritual, uplifting, vocal, voice, wonder, worship",
    "price": 20,
    "date": "2018-05-24",
    "videoId": "DyPcBLOiu2g",
    "youtubeUrl": "https://www.youtube.com/watch?v=DyPcBLOiu2g",
    "productUrl": "https://audiojungle.net/item/inspiring-faith-with-vocals/21911270",
    "duration": "3:08"
  },
  {
    "title": "Cute Kids' Logo",
    "description": "‘Cute Kids’ Logo’ is an upbeat, happy ident/opener/jingle/intro featuring glockenspiel, guitar, hand-claps, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, guitar, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 8,
    "date": "2018-05-16",
    "videoId": "nshbkYkrupI",
    "youtubeUrl": "https://www.youtube.com/watch?v=nshbkYkrupI",
    "productUrl": "https://audiojungle.net/item/cute-kids-logo/21872267",
    "duration": "0:07"
  },
  {
    "title": "Happy and Cute",
    "description": "A fun, bright and playful track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 20,
    "date": "2018-05-15",
    "videoId": "476sSaUqm2U",
    "youtubeUrl": "https://www.youtube.com/watch?v=476sSaUqm2U",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786351-Happy-and-Cute-1m12?ref=dreamnotemusic",
    "duration": "1:12"
  },
  {
    "title": "Simply Magical",
    "description": "A hopeful, inspirational track featuring piano, harp, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a dreamy or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, harp, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2018-05-11",
    "videoId": "9szdVMyo820",
    "youtubeUrl": "https://www.youtube.com/watch?v=9szdVMyo820",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802625-Simply-Magical-0m59?ref=dreamnotemusic",
    "duration": "0:59"
  },
  {
    "title": "Ambient Hopeful Background",
    "description": "A positive, atmospheric track featuring piano, guitars and synth pads. Ideal for use in TV/radio adverts/commercials, corporate promotional material or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Piano, guitars, synth pads",
    "tags": "achievement, advert, advertising, ambient, atmospheric, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, positive, presentation, promotional, subtle, success, successful, uplifting",
    "price": 24,
    "date": "2018-05-10",
    "videoId": "n0HEMQJfJeY",
    "youtubeUrl": "https://www.youtube.com/watch?v=n0HEMQJfJeY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201310974-Ambient-Hopeful-Background-2m26?ref=dreamnotemusic",
    "duration": "2:26"
  },
  {
    "title": "Atmospheric and Emotional Background with Vocals",
    "description": "Sustained, heavenly female voice accompanied by cello, orchestral strings, brass and percussion. This expressive, inspirational track is perfect for use in movies/films/games, trailers, teasers or TV soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Female voice, cello, orchestral strings, brass, percussion",
    "tags": "angelic, atmospheric, background, beautiful, cinematic, dark, drama, dramatic, emotional, enchanting, epic, fantasy, female vocal, female voice, film, game, girls voice, heavenly, inspirational, love, magical, movie, mysterious, singer, thriller, trailer, uplifting, vocal, voice, wonder",
    "price": 20,
    "date": "2018-05-07",
    "videoId": "c8ZZ4mAMVfE",
    "youtubeUrl": "https://www.youtube.com/watch?v=c8ZZ4mAMVfE",
    "productUrl": "https://audiojungle.net/item/atmospheric-and-emotional-background-with-vocals/56162210",
    "duration": "2:02"
  },
  {
    "title": "Elegant Classical",
    "description": "A traditional track featuring piano with orchestral strings and woodwind. Perfect for history documentaries, adverts/commercials, TV period dramas or business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "answerphone, antiques, architecture, background, bank, british, call waiting, classic, classical, drama, english, historical, history, loop, looped, mozart, old, old-fashioned, on hold, orchestra, phone, phone call, piano, regal, royal, royalty, telephone, traditional, twee, waiting",
    "price": 16,
    "date": "2018-05-02",
    "videoId": "YrC2_gk4pEE",
    "youtubeUrl": "https://www.youtube.com/watch?v=YrC2_gk4pEE",
    "productUrl": "https://audiojungle.net/item/elegant-classical/21781559",
    "duration": "1:17"
  },
  {
    "title": "Making Magic",
    "description": "A dreamy, magical track featuring layered pianos, vibraphone and atmospheric synth pads. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV or time-lapse videos.",
    "genre": "Ambient",
    "instrumentation": "Piano, vibraphone, atmospheric synth pads",
    "tags": "advert, advertising, ambient, atmospheric, beautiful, commercial, corporate, documentary, dream, dreaming, dreamy, explainer video, fantasy, inspirational, inspiring, life, magic, magical, montage, night, photography, scenery, scenic, sci-fi, space, technology, thoughts, time-lapse, timelapse, wonder",
    "price": 20,
    "date": "2018-04-27",
    "videoId": "BwmNq9hc5tU",
    "youtubeUrl": "https://www.youtube.com/watch?v=BwmNq9hc5tU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795942-Making-Magic-1m56?ref=dreamnotemusic",
    "duration": "1:56"
  },
  {
    "title": "Haunting Horror Theme with Voice",
    "description": "A dark, atmospheric track featuring ghostly female voice (instrumental versions also included) with creepy celesta, piano, glockenspiel and eerie orchestral strings. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Female voice, celesta, piano, glockenspiel, orchestral strings",
    "tags": "atmospheric, book trailer, child, creepy, dark, death, dream, evil, fantasy, female voice, ghost, ghostly, girl, gothic, halloween, haunted, haunting, horror, kids voice, lullaby, magical, nightmare, scary, soundtrack, spooky, suspense, thriller, trailer, twisted, young girl",
    "price": 18,
    "date": "2018-04-21",
    "videoId": "AuZ4g0GL3Ps",
    "youtubeUrl": "https://www.youtube.com/watch?v=AuZ4g0GL3Ps",
    "productUrl": "https://audiojungle.net/item/haunting-horror-theme-with-voice/21726287",
    "duration": "1:40"
  },
  {
    "title": "Circus Comedy",
    "description": "A lively, quirky and playful track featuring piano, clarinet, banjo, accordion, bass and percussion. Perfect for comedy compilation/bloopers videos, YouTube videos/hauls/vlogs, party games, apps/computer games, cartoons/animations or adverts/commercials.",
    "genre": "Comedy",
    "instrumentation": "Piano, clarinet, banjo, accordion, bass, percussion",
    "tags": "bloopers, cartoon, cheese, cheesy, children, circus, clown, comedy, corny, fair, fairground, fast, fun, funny, gag, game, happy, humor, humorous, humour, kids, laugh, laughter, lively, playful, quick, quirky, silly, stupid, upbeat",
    "price": 16,
    "date": "2018-04-17",
    "videoId": "Z_gIvyLw3u8",
    "youtubeUrl": "https://www.youtube.com/watch?v=Z_gIvyLw3u8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755816-Circus-Comedy-0m56?ref=dreamnotemusic",
    "duration": "0:56"
  },
  {
    "title": "Cheeky Comedy",
    "description": "A quirky, fun track featuring pizzicato strings, piano, vibraphone, bass, percussion and staccato woodwind. Perfect for comedy compilation/bloopers videos, YouTube videos/hauls/vlogs, apps/computer games, kids' cartoons/animations, adverts/commercials or children’s TV shows.",
    "genre": "Comedy",
    "instrumentation": "Strings, piano, vibraphone, bass, percussion, woodwind",
    "tags": "advert, app, background, comedic, comedy, commercial, computer game, cute, Daytime TV, fun, funny, gag, game, happy, humor, humorous, humour, lifestyle, lively, playful, playing, quirky, reality show, silly, stupid, vlog",
    "price": 14,
    "date": "2018-04-09",
    "videoId": "9tJXMY8WLPM",
    "youtubeUrl": "https://www.youtube.com/watch?v=9tJXMY8WLPM",
    "productUrl": "https://audiojungle.net/item/cheeky-comedy/21662242",
    "duration": "0:55"
  },
  {
    "title": "Cute Kids' Theme",
    "description": "A cheerful, upbeat theme-tune featuring piano, banjo, guitar, recorder, bass and glockenspiel. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, fun YouTube videos or any project with a positive, happy vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, banjo, guitar, recorder, glockenspiel, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro",
    "price": 16,
    "date": "2018-04-05",
    "videoId": "1ZDueibBXA8",
    "youtubeUrl": "https://www.youtube.com/watch?v=1ZDueibBXA8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755952-Cute-Kids-Theme-0m39?ref=dreamnotemusic",
    "duration": "0:39"
  },
  {
    "title": "English Baking",
    "description": "A charming, traditional track featuring piano, orchestral strings, woodwind and brass. Perfect for adverts/commercials, documentaries, nature/country living videos, baking/cooking/food channels or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, baking, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, farming, food, happy, innocent, kitchen, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 14,
    "date": "2018-04-03",
    "videoId": "UTC9iTiFaH8",
    "youtubeUrl": "https://www.youtube.com/watch?v=UTC9iTiFaH8",
    "productUrl": "https://audiojungle.net/item/english-baking/21623790",
    "duration": "0:45"
  },
  {
    "title": "Beautiful Magical Life",
    "description": "An uplifting, inspirational track featuring piano, orchestral strings, woodwind, brass, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2018-03-30",
    "videoId": "q_w49rr9_n4",
    "youtubeUrl": "https://www.youtube.com/watch?v=q_w49rr9_n4",
    "productUrl": "https://audiojungle.net/item/beautiful-magical-life/21606682",
    "duration": "1:11"
  },
  {
    "title": "Night Sky Time-lapse",
    "description": "An atmospheric, tranquil and dreamy track with soft layered pianos, ambient guitars, ethereal synth pads and bass. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, electric guitar, synth pads, bass",
    "tags": "advert, advertising, ambient, art, atmospheric, beautiful, chill, cityscape, corporate, documentary, dreaming, dreamy, modern, montage, nature, night, photography, relaxing, scenery, scenic, sci-fi, sky, sleep, soundscape, space, stars, technology, time-lapse, timelapse, tranquil",
    "price": 24,
    "date": "2018-03-27",
    "videoId": "6mv5tUFbhTQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=6mv5tUFbhTQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799345-Night-Sky-Time-lapse-3m16?ref=dreamnotemusic",
    "duration": "3:16"
  },
  {
    "title": "Inspiring Fantasy",
    "description": "A magical, uplifting track featuring piano, orchestral strings, brass, woodwind and choir. Ideal for use in adverts/commercials, TV/film/movie soundtracks, games or trailers.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, brass, woodwind, choir",
    "tags": "advert, advertising, atmospheric, beautiful, believe, bright, christmas, commercial, dream, dreamy, fairy, fairytale, fantasy, game, hopeful, innocent, inspirational, inspiring, magic, magical, melodic, mystical, mythical, optimistic, positive, soundtrack, trailer, tv, uplifting, wonder",
    "price": 20,
    "date": "2018-03-15",
    "videoId": "Ge3X76kjTHM",
    "youtubeUrl": "https://www.youtube.com/watch?v=Ge3X76kjTHM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793062-Inspiring-Fantasy-1m14?ref=dreamnotemusic",
    "duration": "1:14"
  },
  {
    "title": "Sentimental Cinematic Piano",
    "description": "An emotional, atmospheric and thought-provoking track featuring solo piano. Ideal for use in adverts/commercials, documentaries, TV charity appeals, wedding videos, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, beautiful, calm, charity, cinematic, commercial, documentary, dream, dreamy, emotional, expressive, heartfelt, home, love, mellow, memories, nostalgic, peaceful, piano, piano solo, proposal, reflective, romantic, sad, sentimental, story, thoughtful, tranquil, wedding",
    "price": 24,
    "date": "2018-03-13",
    "videoId": "Q8pZ_Lwm2GE",
    "youtubeUrl": "https://www.youtube.com/watch?v=Q8pZ_Lwm2GE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802942-Sentimental-Cinematic-Piano-2m54?ref=dreamnotemusic",
    "duration": "2:54"
  },
  {
    "title": "Magical Inspiration",
    "description": "A uplifting, inspiring track featuring pianos, orchestral strings and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir",
    "tags": "advert, advertising, atmospheric, bright, business, commercial, company, corporate, dream, fantasy, future, happy, hope, hopeful, innocent, inspirational, inspiring, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, radio, tv, uplifting",
    "price": 16,
    "date": "2018-03-06",
    "videoId": "8fRHD2fSYA4",
    "youtubeUrl": "https://www.youtube.com/watch?v=8fRHD2fSYA4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795943-Magical-Inspiration-0m51?ref=dreamnotemusic",
    "duration": "0:51"
  },
  {
    "title": "Emotional Atmospheric Cinematic",
    "description": "An expressive, spacious and thought-provoking track featuring rich, sustained piano chords with warm orchestral strings. Ideal for use in adverts/commercials, documentaries, TV/radio charity appeals, movie/film soundtracks or any project romantic or heartfelt in nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, atmospheric, background, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, heartfelt, intimate, lonely, love, mellow, memories, peaceful, piano, reflective, religion, romantic, sad, sorrow, space, spacious, story, sustained, thoughtful",
    "price": 24,
    "date": "2018-02-23",
    "videoId": "4z8AFPfQyq8",
    "youtubeUrl": "https://www.youtube.com/watch?v=4z8AFPfQyq8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201783350-Emotional-Atmospheric-Cinematic-3m10?ref=dreamnotemusic",
    "duration": "3:10"
  },
  {
    "title": "Atmospheric and Emotional Cinematic Trailer",
    "description": "An expressive and inspirational track featuring piano, cello, orchestral strings, woodwind, brass and percussion. Perfect for use in movie/film/game trailers, soundtracks, adverts or documentaries.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Piano, cello, orchestral strings, woodwind, brass, percussion",
    "tags": "atmosphere, atmospheric, cellist, cello, cinematic, dark, drama, dramatic, emotional, forbidden, grief, haunting, intense, lonely, loss, love, movie, mysterious, mystery, night, reflective, romance, sad, sorrow, soundtrack, thriller, tragedy, tragic, trailer, twilight",
    "price": 24,
    "date": "2018-01-02",
    "videoId": "RByUemAp_Ns",
    "youtubeUrl": "https://www.youtube.com/watch?v=RByUemAp_Ns",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311025-Atmospheric-and-Emotional-Cinematic-Trailer-3m14?ref=dreamnotemusic",
    "duration": "3:14"
  },
  {
    "title": "Magical Dreams",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, brass, woodwind and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, brass, woodwind, choir",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 18,
    "date": "2017-12-26",
    "videoId": "nvRFx1nAwaw",
    "youtubeUrl": "https://www.youtube.com/watch?v=nvRFx1nAwaw",
    "productUrl": "https://audiojungle.net/item/magical-dreams/21135494",
    "duration": "1:36"
  },
  {
    "title": "English Country Home",
    "description": "A charming, traditional track featuring piano, clarinet, cello, orchestral strings, woodwind and brass. Perfect for adverts/commercials, documentaries, baking/cooking/gardening channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, clarinet, cello, orchestral strings, woodwind, brass",
    "tags": "antiques, baking, british, castle, ceremony, charming, classic, classical, country, country living, countryside, Daytime TV, documentary, english, gardening, heritage, historical, history, nature, period drama, proud, regal, royal, royalty, spring, summer, traditional, twee, wedding, youtube",
    "price": 16,
    "date": "2017-12-21",
    "videoId": "dYIZpbzk51k",
    "youtubeUrl": "https://www.youtube.com/watch?v=dYIZpbzk51k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201782823-English-Country-Home-1m12?ref=dreamnotemusic",
    "duration": "1:12"
  },
  {
    "title": "Christmas Logo 9",
    "description": "A short, bright jingle/logo/ident/intro based on ‘Jingle Bells’ featuring sleigh-bells, piano, glockenspiel, xylophone and orchestral woodwind. Ideal for use in Christmas adverts/commercials, YouTube Vlogmas videos, radio intros, video games, xmas apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh-bells, piano, glockenspiel, xylophone, orchestral woodwind",
    "tags": "advert, app, bells, bright, carol, christmas, christmas jingle, commercial, festive, glockenspiel, happy, ident, intro, jingle, jingle bells, jolly, logo, merry, orchestra, radio, ring-tone, seasonal, sleigh bells, video intro, vlog, vlogmas, web intro, xmas, xmas video intro, youtube",
    "price": 10,
    "date": "2017-12-19",
    "videoId": "qi-H3FpctYo",
    "youtubeUrl": "https://www.youtube.com/watch?v=qi-H3FpctYo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755808-Christmas-Logo-9?ref=dreamnotemusic",
    "duration": "0:13"
  },
  {
    "title": "Baroque Christmas",
    "description": "A happy, cheerful traditional classical track featuring orchestral strings, woodwind, harpsichord, trumpet, sleigh bells and choir. Perfect for Xmas adverts/commercials, YouTube vlogmas videos, history documentaries, period dramas or any festive/seasonal project.",
    "genre": "Christmas",
    "instrumentation": "Orchestral strings, woodwind, harpsichord, trumpet, sleigh bells, choir",
    "tags": "bach, baroque, bells, bright, british, christian, christmas, classical, documentary, festive, happy, heritage, history, holiday, jingle, jolly, lively, merry, old-fashioned, period drama, regal, renaissance, royal, royalty, seasonal, sleigh-bells, traditional, vivaldi, vlogmas, xmas",
    "price": 20,
    "date": "2017-12-13",
    "videoId": "uqw0J5LmiII",
    "youtubeUrl": "https://www.youtube.com/watch?v=uqw0J5LmiII",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483282-Baroque-Christmas-1m01?ref=dreamnotemusic",
    "duration": "1:01"
  },
  {
    "title": "Christmas Fun",
    "description": "A happy, bright and upbeat xmas track featuring cheerful melody and jolly orchestral backing. Ideal for use in YouTube Vlogmas video intros, Christmas TV adverts/commercials, greetings cards, radio intros, xmas games/apps or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Piano, sleigh bells, tubular bells, strings, choir",
    "tags": "bright, catchy, cheerful, children, christmas, comedy, festive, fun, greetings, greetings card, happy, happy holidays, holiday, ident, intro, jingle, jolly, kids, logo, merry, playful, seasonal, sleigh bells, upbeat, video intro, vlog, vlogmas, xmas, youtube, youtube intro",
    "price": 14,
    "date": "2017-12-08",
    "videoId": "YvXGIkK1hU4",
    "youtubeUrl": "https://www.youtube.com/watch?v=YvXGIkK1hU4",
    "productUrl": "https://audiojungle.net/item/christmas-fun/21042440",
    "duration": "0:57"
  },
  {
    "title": "Romantic Wedding Day",
    "description": "A beautiful, expressive track featuring piano, cello, acoustic guitar and orchestral strings. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, orchestral strings",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 24,
    "date": "2017-12-07",
    "videoId": "NzY5WIefBUA",
    "youtubeUrl": "https://www.youtube.com/watch?v=NzY5WIefBUA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802701-Romantic-Wedding-Day-2m12?ref=dreamnotemusic",
    "duration": "2:12"
  },
  {
    "title": "The Magic of Christmas",
    "description": "A bright, uplifting and magical track featuring piano, glockenspiel, sleigh bells and orchestral strings (versions without sleigh bells also included). Ideal for use in Christmas adverts/commercials, TV, fantasy film/movie soundtracks, children’s xmas animations or any project of a hopeful or optimistic nature.",
    "genre": "Christmas",
    "instrumentation": "Piano, glockenspiel, sleigh bells, orchestral strings",
    "tags": "advert, advertising, bank, banking, bright, children, christmas, christmas advert, commercial, fantasy, festive, happy, holidays, hopeful, inspirational, inspiring, kids, magic, magical, motivational, optimistic, positive, seasonal, sleigh-bells, tv, uplifting, wonder, wonderland, xmas, youtube",
    "price": 16,
    "date": "2017-12-05",
    "videoId": "JeGyFHhoHeg",
    "youtubeUrl": "https://www.youtube.com/watch?v=JeGyFHhoHeg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805253-The-Magic-of-Christmas-0m54?ref=dreamnotemusic",
    "duration": "0:54"
  },
  {
    "title": "Classical Elegance",
    "description": "A traditional track featuring piano with subtle orchestral strings. Perfect for history documentaries, adverts/commercials, TV period dramas or business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings",
    "tags": "answerphone, antiques, architecture, background, beautiful, british, call waiting, classic, classical, dramatic, english, historical, history, loop, looped, mozart, old, old-fashioned, on hold, orchestra, period drama, phone, phone call, piano, regal, royal, royalty, telephone, traditional, waiting",
    "price": 14,
    "date": "2017-12-04",
    "videoId": "cNBNZunKnwQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=cNBNZunKnwQ",
    "productUrl": "https://audiojungle.net/item/classical-elegance/21018544",
    "duration": "0:52"
  },
  {
    "title": "Peaceful Hope",
    "description": "A sentimental, emotional track featuring expressive cello melody, piano, choir and sustained orchestral strings. An ideal backing for adverts, documentaries, charity campaigns, wedding/family videos or photo slide shows.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Cello, piano, choir, orchestral strings",
    "tags": "advert, beautiful, believe, charity, commercial, dream, dreamy, emotional, expressive, faith, family, family tree, heartfelt, hope, inspirational, inspiring, life, love, memories, montage, moving, nature, orchestra, piano, reflective, romantic, sentimental, strings, uplifting, wedding",
    "price": 24,
    "date": "2017-11-08",
    "videoId": "U99Cyqse_Bk",
    "youtubeUrl": "https://www.youtube.com/watch?v=U99Cyqse_Bk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799430-Peaceful-Hope-2m53?ref=dreamnotemusic",
    "duration": "2:53"
  },
  {
    "title": "Kids' Theme Tune",
    "description": "A fun, happy and upbeat track featuring cheerful recorder melody, glockenspiel, vibraphone, piano, banjo, finger-clicks and bass guitar. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder melody, glockenspiel, vibraphone, piano, banjo, percussion, bass guitar",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, jingle, kids, kids tv, logo, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 12,
    "date": "2017-11-03",
    "videoId": "2BSLAbEn1sE",
    "youtubeUrl": "https://www.youtube.com/watch?v=2BSLAbEn1sE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794972-Kids-Theme-Tune-0m23?ref=dreamnotemusic",
    "duration": "0:23"
  },
  {
    "title": "Dark Drama",
    "description": "A tense, tragic movie soundtrack featuring harp, expressive cello, choir and emotional orchestral strings. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a dramatic, mysterious tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Harp, cello, choir, orchestral strings",
    "tags": "atmosphere, atmospheric, cinematic, dark, death, deep, drama, dramatic, emotional, fantasy, fear, film, forbidden, haunting, intense, love, lovers, mysterious, mystery, night, reflective, romance, sad, tense, tension, thriller, tragic, trailer, twilight, worry",
    "price": 20,
    "date": "2017-10-30",
    "videoId": "VPnaBl4-4Yk",
    "youtubeUrl": "https://www.youtube.com/watch?v=VPnaBl4-4Yk",
    "productUrl": "https://audiojungle.net/item/dark-drama/20841505",
    "duration": "2:46"
  },
  {
    "title": "The Miracle of Life",
    "description": "A heartfelt and emotional track featuring atmospheric layered pianos with subtle, sustained strings. An ideal backing for documentaries, adverts/commercials, wedding/family videos, photo slideshows, time-lapse videos or any project with an expressive or sentimental tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, strings",
    "tags": "advert, baby, beautiful, believe, birth, charity, commercial, dream, dreamy, emotional, expressive, faith, family, hope, hopeful, inspirational, inspiring, life, love, memories, miracle, moving, nature, piano, religious, romantic, sentimental, time-lapse, timelapse, wedding",
    "price": 24,
    "date": "2017-10-26",
    "videoId": "5wHX-Z0yE6k",
    "youtubeUrl": "https://www.youtube.com/watch?v=5wHX-Z0yE6k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805331-The-Miracle-of-Life-2m09?ref=dreamnotemusic",
    "duration": "2:09"
  },
  {
    "title": "Magical and Inspiring",
    "description": "An uplifting, atmospheric track featuring piano, cello, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, cello, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 20,
    "date": "2017-10-24",
    "videoId": "PyBx4wLxj8w",
    "youtubeUrl": "https://www.youtube.com/watch?v=PyBx4wLxj8w",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796136-Magical-and-Inspiring-1m19?ref=dreamnotemusic",
    "duration": "1:19"
  },
  {
    "title": "Twisted Vocal Horror",
    "description": "A creepy, haunting, cinematic track featuring female vocals, music box, celesta and eerie, sustained strings. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, mysterious tone.",
    "genre": "Horror",
    "instrumentation": "Female voice, music box, celesta, orchestra strings",
    "tags": "atmospheric, child, creepy, dark, dead, death, fantasy, female, female voice, ghost, girl, gothic, halloween, haunted house, haunting, horror, lullaby, murder, music box, mysterious, mystery, night, nightmare, scary, soundtrack, spooky, suspense, thriller, twisted, vocal",
    "price": 16,
    "date": "2017-10-20",
    "videoId": "COfKINa4ieg",
    "youtubeUrl": "https://www.youtube.com/watch?v=COfKINa4ieg",
    "productUrl": "https://audiojungle.net/item/twisted-vocal-horror/20794858",
    "duration": "1:10"
  },
  {
    "title": "Vocal Horror Logo",
    "description": "‘Vocal Horror Logo’ is a haunting, cinematic horror ident/opener/intro/logo featuring atmospheric female vocals, piano, music box, celesta and sustained orchestral strings. Ideal for use in horror and thriller movie/film trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Female vocals, piano, music box, celesta, orchestral strings",
    "tags": "atmospheric, child, creepy, dark, fantasy, female, female voice, ghost, girl, girls voice, halloween, haunting, horror, ident, intro, kids voice, logo, lullaby, mysterious, mystery, opener, scary, spooky, suspense, thriller, twisted, video intro, vlog, vocal, youtube",
    "price": 10,
    "date": "2017-10-16",
    "videoId": "w5AfmnO9B2g",
    "youtubeUrl": "https://www.youtube.com/watch?v=w5AfmnO9B2g",
    "productUrl": "https://audiojungle.net/item/vocal-horror-logo/20768726",
    "duration": "0:14"
  },
  {
    "title": "Creepy Horror Ident",
    "description": "A dark, haunting ident/logo/opener/intro featuring piano, music box, celesta and sinister orchestral strings. Perfect for horror documentaries, openers, movie/book trailers or halloween/YouTube videos.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, orchestral strings",
    "tags": "atmospheric, creepy, dark, death, evil, ghostly, gothic, halloween, haunted, haunted house, haunting, hell, horror, ident, intro, murder, mysterious, mystery, nightmare, opener, outro, psycho, scary, soundtrack, spooky, suspense, thriller, twisted, youtube",
    "price": 12,
    "date": "2017-10-13",
    "videoId": "oL1lK-9y2QA",
    "youtubeUrl": "https://www.youtube.com/watch?v=oL1lK-9y2QA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755953-Creepy-Horror-Ident-0m26?ref=dreamnotemusic",
    "duration": "0:26"
  },
  {
    "title": "Scary Ghost Story",
    "description": "A dark, haunting, cinematic track featuring piano, music box, celesta, sustained tremolo strings and sinister orchestral tones. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, orchestral strings",
    "tags": "atmospheric, creepy, dark, dead, death, demented, evil, film score, ghost, ghost story, gothic, halloween, haunted house, haunting, hell, history, horror, murder, music box, mysterious, mystery, night, nightmare, scary, sinister, soundtrack, spooky, suspense, thriller, twisted",
    "price": 20,
    "date": "2017-10-09",
    "videoId": "-RAG7bU3TPA",
    "youtubeUrl": "https://www.youtube.com/watch?v=-RAG7bU3TPA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201802940-Scary-Ghost-Story-1m17?ref=dreamnotemusic",
    "duration": "1:17"
  },
  {
    "title": "Atmospheric Horror Trailer",
    "description": "A dark, cinematic track featuring piano, music box, celesta, orchestral strings and sinister sound effects. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games/apps, YouTube videos or any project with a tense, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, orchestral strings, sound effects",
    "tags": "app, atmospheric, creepy, dark, dead, dramatic, evil, game, ghost, gothic, halloween, haunted house, haunting, hell, history, horror, murder, music box, mysterious, mystery, night, nightmare, scary, sinister, spooky, suspense, tense, thriller, trailer, twisted",
    "price": 16,
    "date": "2017-10-04",
    "videoId": "g2wjoYXJUFk",
    "youtubeUrl": "https://www.youtube.com/watch?v=g2wjoYXJUFk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311141-Atmospheric-Horror-Trailer-0m42?ref=dreamnotemusic",
    "duration": "0:42"
  },
  {
    "title": "Horror Lullaby with Child's Voice",
    "description": "‘Horror Lullaby with Child’s Voice’ is a haunting cinematic track featuring young girl’s voice, music box, celesta and eerie, sustained strings. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Female voice, music box, celesta, sustained strings",
    "tags": "atmospheric, child, creepy, dark, death, fantasy, female, female voice, ghost, girl, gothic, halloween, haunted house, haunting, horror, kids voice, lullaby, murder, music box, mysterious, mystery, night, nightmare, scary, spooky, suspense, thriller, twisted, vocal, voice",
    "price": 16,
    "date": "2017-09-29",
    "videoId": "iKT5gJJehmU",
    "youtubeUrl": "https://www.youtube.com/watch?v=iKT5gJJehmU",
    "productUrl": "https://audiojungle.net/item/horror-lullaby-with-childs-voice/20686285",
    "duration": "1:07"
  },
  {
    "title": "Fun Kids' Ident",
    "description": "An upbeat, happy intro/opener/jingle featuring glockenspiel, recorder, hand-claps, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, hand-claps, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 8,
    "date": "2017-09-27",
    "videoId": "V3-wOkX-T8Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=V3-wOkX-T8Y",
    "productUrl": "https://audiojungle.net/item/fun-kids-ident/20676815",
    "duration": "0:07"
  },
  {
    "title": "Horror Logo with Voice",
    "description": "A haunting, cinematic horror ident/opener/intro featuring female child vocals, music box, celesta and eerie, sustained strings. Ideal for use in horror and thriller movie/film trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Female voice, music box, celesta, sustained strings",
    "tags": "atmospheric, child, creepy, dark, fantasy, female, female voice, ghost, girl, girls voice, halloween, haunting, horror, ident, intro, kids voice, logo, lullaby, mysterious, mystery, opener, scary, spooky, suspense, thriller, twisted, video intro, vlog, vocal, youtube",
    "price": 10,
    "date": "2017-09-26",
    "videoId": "t4CzgxqbScA",
    "youtubeUrl": "https://www.youtube.com/watch?v=t4CzgxqbScA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786365-Horror-Logo-with-Voice-0m12?ref=dreamnotemusic",
    "duration": "0:12"
  },
  {
    "title": "Welcome Home",
    "description": "A positive and sentimental track featuring piano, acoustic guitar, electric guitar, strings, bass and drums. Perfect for family videos, real estate adverts/commercials, photo slide shows, TV or movie/film soundtracks.",
    "genre": "Corporate",
    "instrumentation": "piano, acoustic guitar, electric guitar, strings, bass and drums.",
    "tags": "advert, advertisement, album, commercial, emotional, family, family album, family tree, family video, friendship, happy, heartfelt, home, inspirational, inspiring, life, love, memories, montage, photo, photo album, photography, positive, property, real estate, realty, relaxing, romantic, sentimental, slideshow",
    "price": 20,
    "date": "2017-09-24",
    "videoId": "xiG97YjOdqs",
    "youtubeUrl": "https://www.youtube.com/watch?v=xiG97YjOdqs",
    "productUrl": "https://audiojungle.net/item/welcome-home/20655770",
    "duration": "2:31"
  },
  {
    "title": "Magical Life",
    "description": "A positive and atmospheric track featuring piano, harp, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, harp, orchestral strings, cello, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 20,
    "date": "2017-09-21",
    "videoId": "H6yWMDdiTIs",
    "youtubeUrl": "https://www.youtube.com/watch?v=H6yWMDdiTIs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796205-Magical-Life-1m00?ref=dreamnotemusic",
    "duration": "1:00"
  },
  {
    "title": "Atmospheric Horror Piano",
    "description": "A creepy, haunting lullaby-style track featuring an eerie blend of old detuned pianos. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Piano",
    "tags": "atmospheric, child, creepy, dark, death, demented, evil, film score, ghost, gothic, halloween, haunted, haunting, hell, horror, lullaby, murder, music box, night, nightmare, psycho, sad, scary, serial killer, soundtrack, spooky, suspense, thriller, trailer, twisted",
    "price": 16,
    "date": "2017-09-18",
    "videoId": "sNN5irDh7N0",
    "youtubeUrl": "https://www.youtube.com/watch?v=sNN5irDh7N0",
    "productUrl": "https://audiojungle.net/item/atmospheric-horror-piano/20615610",
    "duration": "0:57"
  },
  {
    "title": "Dramatic Horror Trailer",
    "description": "A dark, cinematic track featuring piano, music box, celesta, expressive cello, haunting voices, sustained tremolo strings and sinister orchestral tones. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a tense, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, cello, haunting voices, violin, orchestral strings",
    "tags": "atmospheric, creepy, dark, dead, dramatic, evil, film score, ghost, gothic, halloween, haunted house, haunting, hell, history, horror, murder, music box, mysterious, mystery, night, nightmare, scary, sinister, soundtrack, spooky, suspense, tense, thriller, trailer, twisted",
    "price": 20,
    "date": "2017-09-15",
    "videoId": "y2kojwr-dsw",
    "youtubeUrl": "https://www.youtube.com/watch?v=y2kojwr-dsw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780900-Dramatic-Horror-Trailer-1m57?ref=dreamnotemusic",
    "duration": "1:57"
  },
  {
    "title": "Majestic Baroque",
    "description": "A lively, traditional classical track featuring orchestral strings, woodwind, harpsichord and trumpet. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, harpsichord, trumpet",
    "tags": "allegro, antiques, bach, baroque, brandenburg, brandenburg concerto, british, classic, classical, documentary, drama, heritage, historical, history, lively, majestic, old, old-fashioned, orchestra, period drama, proud, regal, renaissance, royal, royalty, traditional, tv, twee, vivaldi, wedding",
    "price": 20,
    "date": "2017-09-08",
    "videoId": "GNEyIAOy010",
    "youtubeUrl": "https://www.youtube.com/watch?v=GNEyIAOy010",
    "productUrl": "https://audiojungle.net/item/majestic-baroque/20576529",
    "duration": "2:00"
  },
  {
    "title": "Imagination Becomes Reality",
    "description": "An atmospheric and expressive cinematic soundtrack featuring violin, cello, orchestral strings, brass and woodwind. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a haunting, emotional tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Violin, cello, orchestral strings, brass, woodwind",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, deep, drama, dramatic, emotional, expressive, fantasy, film, forbidden, haunting, intense, love, lovers, movie, mysterious, mystery, reflective, romance, romantic, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 24,
    "date": "2017-09-04",
    "videoId": "b_gtCqis7iA",
    "youtubeUrl": "https://www.youtube.com/watch?v=b_gtCqis7iA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793147-Imagination-Becomes-Reality-2m07?ref=dreamnotemusic",
    "duration": "2:07"
  },
  {
    "title": "Uplifting Magical",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 14,
    "date": "2017-08-29",
    "videoId": "r1KzlM1He9k",
    "youtubeUrl": "https://www.youtube.com/watch?v=r1KzlM1He9k",
    "productUrl": "https://audiojungle.net/item/uplifting-magical/20532251",
    "duration": "Length TBC"
  },
  {
    "title": "Positive Motivational Corporate",
    "description": "An optimistic, upbeat track featuring a repeating motif surrounded by warm synth pads, piano and drum beat. Ideal for use in corporate promotional material, business presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Synths, piano, bass drums",
    "tags": "achievement, advert, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, marketing, motivation, motivational, optimistic, positive, presentation, progress, promo, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2017-08-28",
    "videoId": "QMKHuLZMQMg",
    "youtubeUrl": "https://www.youtube.com/watch?v=QMKHuLZMQMg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799469-Positive-Motivational-Corporate-1m27?ref=dreamnotemusic",
    "duration": "1:27"
  },
  {
    "title": "Creepy Vocal Theme",
    "description": "A haunting, cinematic horror track featuring female vocals, music box, celesta and eerie, sustained strings. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Female vocals, music box, celesta, strings",
    "tags": "atmospheric, child, creepy, dark, dead, death, fantasy, female, female voice, ghost, girl, gothic, halloween, haunted house, haunting, horror, lullaby, music box, mysterious, mystery, night, nightmare, scary, soundtrack, spooky, suspense, thriller, twisted, vocal, young",
    "price": 16,
    "date": "2017-08-27",
    "videoId": "79L03E8DPl0",
    "youtubeUrl": "https://www.youtube.com/watch?v=79L03E8DPl0",
    "productUrl": "https://audiojungle.net/item/creepy-vocal-theme/20519524",
    "duration": "1:00"
  },
  {
    "title": "Sexy Sax",
    "description": "A smooth, laid-back jazz track featuring saxophone, piano, trumpets, trombones, upright bass and cool drums. Perfect for comedy sketches, YouTube videos, cartoons/animations or adverts/commercials.",
    "genre": "Jazz",
    "instrumentation": "Saxophone, piano, trumpet, trombone, upright bass, drums",
    "tags": "animation, big band, bloopers, brass, cartoon, cheese, cheesy, comedy, cool, fun, funny, jazz, jazzy, laid back, provocative, relaxed, risque, sax, saxophone, seduce, seductive, sexy, silly, slow, smooth, spoof, strip, strip tease, striptease, sultry",
    "price": 18,
    "date": "2017-08-23",
    "videoId": "nk9Z_VXrRKM",
    "youtubeUrl": "https://www.youtube.com/watch?v=nk9Z_VXrRKM",
    "productUrl": "https://audiojungle.net/item/sexy-sax/20497884",
    "duration": "1:16"
  },
  {
    "title": "Happy Kids' Logo",
    "description": "An upbeat, fun ident/opener/jingle/intro featuring glockenspiel, recorder, ukulele, guitar, hand-claps, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, ukulele, guitar, percussion, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2017-08-22",
    "videoId": "BAZBwihGtI0",
    "youtubeUrl": "https://www.youtube.com/watch?v=BAZBwihGtI0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786377-Happy-Kids-Logo-0m13?ref=dreamnotemusic",
    "duration": "0:13"
  },
  {
    "title": "Dramatic Theme",
    "description": "A rhythmic, tense baroque/classical style track featuring piano, orchestral strings and choir. Perfect for documentaries, TV/movie/film scenes/trailers, period dramas or any project of a historical nature.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Piano, orchestral strings, choir",
    "tags": "announcement, broadcast, broadcasting, business report, corporate, dramatic, entertainment, evening news, exciting, feature, featurette, global, gripping, headlines, ident, intro, logo, media, network, news, opening, powerful, presentation, promo, radio, sport report, strong, tense, tv, youtube",
    "price": 10,
    "date": "2017-08-21",
    "videoId": "KyR54wxr7qI",
    "youtubeUrl": "https://www.youtube.com/watch?v=KyR54wxr7qI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780915-Dramatic-Theme-0m41?ref=dreamnotemusic",
    "duration": "0:41"
  },
  {
    "title": "Inspiring English Life",
    "description": "A charming, light-hearted and inspirational track featuring harp, pianos and orchestral strings. Perfect for adverts/commercials, documentaries, nature/country living videos, baking/cooking channels or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Harp, piano, orchestral strings",
    "tags": "advert, baking, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, farming, happy, innocent, kitchen, light, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 20,
    "date": "2017-08-17",
    "videoId": "M6FFPc-BbaE",
    "youtubeUrl": "https://www.youtube.com/watch?v=M6FFPc-BbaE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793178-Inspiring-English-Life-1m24?ref=dreamnotemusic",
    "duration": "1:24"
  },
  {
    "title": "Positive Corporate",
    "description": "An optimistic, upbeat track featuring a repeating motif surrounded by warm synth pads, piano and drum beat. Ideal for use in corporate promotional material, business presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Synth pad, piano, drum beat",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2017-08-17",
    "videoId": " -nrN7qjGtyc",
    "youtubeUrl": "https://www.youtube.com/watch?v= -nrN7qjGtyc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799529-Positive-Corporate-1m09?ref=dreamnotemusic",
    "duration": "1:09"
  },
  {
    "title": "Positive Ambient",
    "description": "A hopeful, inspiring track featuring a repeating motif surrounded by synth pads, strings, pianos, bass and drums. Ideal for use in corporate promotional material, presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Synth pads, strings, piano, bass, drums",
    "tags": "achievement, advert, advertisement, advertising, background, brand, business, commercial, confidence, confident, corporate, happy, hope, hopeful, inspiration, inspirational, inspiring, marketing, motivation, motivational, optimistic, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 24,
    "date": "2017-08-15",
    "videoId": "YjhsxvRaoNA",
    "youtubeUrl": "https://www.youtube.com/watch?v=YjhsxvRaoNA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799599-Positive-Ambient-2m03?ref=dreamnotemusic",
    "duration": "2:03"
  },
  {
    "title": "Magical Fairy Tale",
    "description": "An atmospheric, dreamy track featuring harp, acoustic guitar, piano, cello, violins, flute and oboe. Perfect for use in movies/films, TV, adverts/commercials, fantasy book trailers, wedding videos or romantic/sentimental projects.",
    "genre": "Wedding",
    "instrumentation": "Harp, acoustic guitar, piano, cello, violins, flute, oboe",
    "tags": "advert, atmospheric, beautiful, children, cinematic, commercial, dream, dreamy, emotional, enchanted, enchanting, fairies, fairy, fairytale, fantasy, harp, innocence, inspirational, inspiring, love, magic, magical, sentimental, soft, trailer, tv, twilight, uplifting, wedding, wonderland",
    "price": 24,
    "date": "2017-08-13",
    "videoId": "_Sxj2rfPYWY",
    "youtubeUrl": "https://www.youtube.com/watch?v=_Sxj2rfPYWY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795971-Magical-Fairy-Tale-2m24?ref=dreamnotemusic",
    "duration": "2:24"
  },
  {
    "title": "Atmospheric Fantasy",
    "description": "A magical, dreamy track featuring soft, layered pianos with orchestral strings and glockenspiel. Perfect for use in movies/films, TV, animations, documentaries, adverts/commercials or any magical fantasy/sci-fi scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Pianos, orchestral strings, glockenspiel",
    "tags": "advert, atmospheric, beautiful, children, cinematic, commercial, dream, dreamy, emotional, enchanted, enchanting, fairies, fairy, fairytale, fantasy, innocence, inspirational, inspiring, love, magic, magical, piano, soft, space, trailer, tv, twilight, uplifting, utopian, wonderland",
    "price": 20,
    "date": "2017-08-04",
    "videoId": "YbtpYbaqL-4",
    "youtubeUrl": "https://www.youtube.com/watch?v=YbtpYbaqL-4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311187-Atmospheric-Fantasy-1m23?ref=dreamnotemusic",
    "duration": "1:23"
  },
  {
    "title": "Classical Theme",
    "description": "A light, happy ident/opener/jingle/intro featuring classical style piano with orchestral strings and woodwind. Ideal for use in YouTube videos, history documentaries, advertising, podcasts or as a TV/radio jingle.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "advert, antique, british, classic, classical, documentary, english, fun, happy, historical, history, ident, intro, jingle, logo, mozart, old, old fashioned, opener, period drama, podcast, radio, stately home, theme, traditional, tv, twee, video intro, vlog, youtube",
    "price": 14,
    "date": "2017-08-03",
    "videoId": "WRDnWSOWRoA",
    "youtubeUrl": "https://www.youtube.com/watch?v=WRDnWSOWRoA",
    "productUrl": "https://audiojungle.net/item/classical-theme/20403988",
    "duration": "0:38"
  },
  {
    "title": "Positive Upbeat Corporate",
    "description": "An optimistic, motivational track featuring lively acoustic guitar, piano, strings, bass and drums. Ideal for use in TV/radio adverts/commercials, corporate promotional material or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Acoustic guitar, piano, strings, bass, drums",
    "tags": "achievement, advert, advertisement, advertising, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, livley, marketing, motivation, motivational, optimistic, pop, positive, presentation, promotional, success, successful, upbeat, uplifting",
    "price": 24,
    "date": "2017-08-02",
    "videoId": "m5fjuSqHc-4",
    "youtubeUrl": "https://www.youtube.com/watch?v=m5fjuSqHc-4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201799658-Positive-Upbeat-Corporate-2m04?ref=dreamnotemusic",
    "duration": "2:04"
  },
  {
    "title": "Hopeful Orchestral Trailer",
    "description": "An inspirational and atmospheric track featuring piano, orchestral strings, woodwind, brass and choir. Perfect for use in movie/film/game trailers, TV, soundtracks, adverts or documentaries.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir",
    "tags": "atmospheric, believe, builds, charity, cinematic, dramatic, emotional, epic, expressive, fantasy, film trailer, game trailer, grand, honor, honour, hope, hopeful, inspirational, inspiring, journey, movie trailer, passion, pride, proud, soundtrack, strings, teaser, thriller, trailer, uplifting",
    "price": 24,
    "date": "2017-07-28",
    "videoId": "Y-Rwrn8VzKI",
    "youtubeUrl": "https://www.youtube.com/watch?v=Y-Rwrn8VzKI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786459-Hopeful-Orchestral-Trailer-3m09?ref=dreamnotemusic",
    "duration": "3:09"
  },
  {
    "title": "Piano Dream",
    "description": "An emotional, dreamy and thought-provoking track featuring layered pianos with atmospheric delay effects. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, piano solo, reflective, religion, romantic, sad, sentimental, sorrow, story, thoughtful",
    "price": 24,
    "date": "2017-07-25",
    "videoId": "-eRprINgV1U",
    "youtubeUrl": "https://www.youtube.com/watch?v=-eRprINgV1U",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800068-Piano-Dream-3m05?ref=dreamnotemusic",
    "duration": "3:05"
  },
  {
    "title": "Kids' Logo",
    "description": "A happy, upbeat ident/opener/jingle/intro featuring glockenspiel, recorder, guitar, piano, bass and percussion. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, guitar, piano, bass, percussion",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 8,
    "date": "2017-07-20",
    "videoId": "YgI78NK6yQs",
    "youtubeUrl": "https://www.youtube.com/watch?v=YgI78NK6yQs",
    "productUrl": "https://audiojungle.net/item/kids-logo/20324810",
    "duration": "0:06"
  },
  {
    "title": "Cinematic Chillout",
    "description": "An ambient, soothing and dreamy track featuring soft pianos, atmospheric synth pads and subtle drums. Ideal for timelapse videos, photography presentations, meditation/relaxation, TV/movie/film soundtracks or space/sci-fi documentaries.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "ambient, art, atmospheric, beautiful, chill, chillout, cinematic, cityscape, documentary, dreaming, dreamy, inspiring, life, meditation, montage, nature, night, photography, relaxation, relaxing, scenery, scifi, sleep, soundscape, spa, space, technology, thoughts, timelapse, yoga",
    "price": 24,
    "date": "2017-07-19",
    "videoId": "hO-Nlt6Zqkc",
    "youtubeUrl": "https://www.youtube.com/watch?v=hO-Nlt6Zqkc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756041-Cinematic-Chillout-4m09?ref=dreamnotemusic",
    "duration": "4:09"
  },
  {
    "title": "Home is Where the Heart is",
    "description": "A relaxing, sentimental and beautiful track featuring piano, acoustic guitar, cello, choir and orchestral strings. Perfect for family videos, weddings, photo slide shows or TV/movies/films.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, cello, choir, orchestral strings",
    "tags": "advert, advertisement, album, beautiful, birth, charity, dreamy, emotional, family, family album, family tree, family video, friendship, happy, heartfelt, home, inspirational, inspiring, life, love, memories, montage, moving, photo, photography, relaxing, romantic, sentimental, slideshow, wedding",
    "price": 24,
    "date": "2017-07-19",
    "videoId": "9sSRX7-wBXU",
    "youtubeUrl": "https://www.youtube.com/watch?v=9sSRX7-wBXU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786487-Home-Is-Where-the-Heart-Is-2m54?ref=dreamnotemusic",
    "duration": "2:54"
  },
  {
    "title": "Dramatic Documentary Background",
    "description": "An atmospheric, cinematic track featuring orchestral strings, brass, woodwind and percussion. Perfect for use in dramatic TV/movie/film soundtracks or history documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, brass, woodwind, percussion",
    "tags": "action, adventure, anxious, atmospheric, background, cinematic, danger, dark, documentary, drama, dramatic, fear, film score, game trailer, historical, history, military, movie trailer, mystery, promo, soundtrack, spy, suspense, teaser, tense, tension, thriller, trailer, underscore, war",
    "price": 18,
    "date": "2017-07-18",
    "videoId": "khhzKlY1Zz4",
    "youtubeUrl": "https://www.youtube.com/watch?v=khhzKlY1Zz4",
    "productUrl": "https://audiojungle.net/item/dramatic-documentary-background/20298095",
    "duration": "1:49"
  },
  {
    "title": "Sad Atmospheric Piano and Strings",
    "description": "An emotional and thought-provoking track featuring piano, cello and orchestral strings. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, cello, orchestral strings",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, reflective, religion, romantic, sad, sentimental, sorrow, story, strings, thoughtful",
    "price": 20,
    "date": "2017-07-16",
    "videoId": "5q5Pim8wrmc",
    "youtubeUrl": "https://www.youtube.com/watch?v=5q5Pim8wrmc",
    "productUrl": "https://audiojungle.net/item/sad-atmospheric-piano-strings/20288986",
    "duration": "2:06"
  },
  {
    "title": "Magic",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, woodwind, brass, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, glockenspiel",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 16,
    "date": "2017-07-15",
    "videoId": "AgzTkkT3pUA",
    "youtubeUrl": "https://www.youtube.com/watch?v=AgzTkkT3pUA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/199648483-Magic-0m55?ref=dreamnotemusic",
    "duration": "0:55"
  },
  {
    "title": "Positive Intro",
    "description": "A motivational and inspiring pop/rock intro/logo/ident/opener featuring electric guitars, acoustic guitars, strings, piano, synths, bass and drums. Ideal for use in corporate promotional material, business presentations, motivational TV/radio adverts/commercials and family vacation/holiday videos/YouTube vlogs.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, acoustic guitar, strings, piano, synths, bass, drums",
    "tags": "achievement, adventure, advert, brand, business, commercial, confident, corporate, family, holiday, hopeful, ident, inspirational, inspiring, intro, logo, marketing, motivation, motivational, opener, optimistic, positive, promotional, short, success, summer, upbeat, uplifting, vacation, vlog",
    "price": 14,
    "date": "2017-07-14",
    "videoId": "uwWezQDNf08",
    "youtubeUrl": "https://www.youtube.com/watch?v=uwWezQDNf08",
    "productUrl": "https://audiojungle.net/item/positive-intro/20276267",
    "duration": "0:36"
  },
  {
    "title": "Cinematic History",
    "description": "An atmospheric and inspirational track featuring piano, cello, orchestral strings, woodwind, brass and percussion. Perfect for use in movie/film/game trailers, soundtracks, adverts or as a documentary background.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, cello, orchestral strings, woodwind, brass, percussion",
    "tags": "atmospheric, believe, charity, cinematic, dark, documentary, dramatic, dream, fantasy, film trailer, game trailer, grand, history, honor, honour, hope, hopeful, inspirational, inspiring, journey, military, movie trailer, proud, soundtrack, strings, teaser, thriller, trailer, uplifting, wonder",
    "price": 20,
    "date": "2017-07-12",
    "videoId": "QSAJlOekPS8",
    "youtubeUrl": "https://www.youtube.com/watch?v=QSAJlOekPS8",
    "productUrl": "https://audiojungle.net/item/cinematic-history/20259704",
    "duration": "1:49"
  },
  {
    "title": "Uplifting and Inspirational",
    "description": "A positive, hopeful track featuring piano and orchestra. Ideal for use in adverts/commercials, documentaries, trailers, movie/film soundtracks, travel videos, corporate presentations or any project requiring an inspiring, atmospheric backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, holiday, hope, inspirational, journey, motivational, movie, moving, powerful, religious, struggle, success, thought-provoking, trailer, travel, triumph, uplifting, win",
    "price": 20,
    "date": "2017-06-30",
    "videoId": "j0cBwwHDb7o",
    "youtubeUrl": "https://www.youtube.com/watch?v=j0cBwwHDb7o",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805355-Uplifting-and-Inspirational-1m05?ref=dreamnotemusic",
    "duration": "1:05"
  },
  {
    "title": "Inspirational Life",
    "description": "An uplifting, hopeful track featuring piano and orchestra. Ideal for use in adverts/commercials, documentaries, cinematic trailers, movie/film soundtracks or any project requiring an inspiring, thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, strings, woodwind, brass, chor, percussion",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, documentary, emotional, faith, film, grand, hope, hopeful, inspirational, inspiring, journey, life, movie, moving, powerful, religious, struggle, success, thought-provoking, trailer, travel, triumph, uplifting",
    "price": 24,
    "date": "2017-06-29",
    "videoId": "36MRN3I3vv0",
    "youtubeUrl": "https://www.youtube.com/watch?v=36MRN3I3vv0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793230-Inspirational-Life-2m27?ref=dreamnotemusic",
    "duration": "2:27"
  },
  {
    "title": "Classical Waltz",
    "description": "A traditional classical/romantic track featuring piano, orchestral strings, woodwind, brass and percussion. Perfect for use in movies/films, dance videos, period dramas, children’s cartoons/animation, kids' TV or advert/commercials.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind, brass and percussion.",
    "tags": "advert, antiques, ball, british, ceremony, charming, classic, classical, country, country living, dance, dancing, documentary, english, heritage, historical, history, johann strauss, love, period drama, princess, proud, regal, romantic, royal, royalty, strauss, traditional, waltz, wedding",
    "price": 24,
    "date": "2017-06-27",
    "videoId": "7c-Aj1yegZM",
    "youtubeUrl": "https://www.youtube.com/watch?v=7c-Aj1yegZM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756035-Classical-Waltz-2m20?ref=dreamnotemusic",
    "duration": "2:20"
  },
  {
    "title": "English Baroque",
    "description": "A traditional classical track featuring orchestral strings, woodwind and harpsichord. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, harpsichord",
    "tags": "advert, allegro, antiques, bach, baroque, british, classic, classical, commercial, cooking, documentary, drama, english, heritage, historical, history, lively, old, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 14,
    "date": "2017-06-19",
    "videoId": "rt6-jyHZKFE",
    "youtubeUrl": "https://www.youtube.com/watch?v=rt6-jyHZKFE",
    "productUrl": "https://audiojungle.net/item/english-baroque/20113162",
    "duration": "0:57"
  },
  {
    "title": "Happy Kids' Theme",
    "description": "‘Happy Kids’ Theme’ is a fun, upbeat track featuring recorder, piano, drums, hand-claps and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, piano, drums, percussion, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 14,
    "date": "2017-06-16",
    "videoId": "_V-UR5V06jg",
    "youtubeUrl": "https://www.youtube.com/watch?v=_V-UR5V06jg",
    "productUrl": "https://audiojungle.net/item/happy-kids-theme/20104965",
    "duration": "0:53"
  },
  {
    "title": "Church Choir",
    "description": "An atmospheric, beautiful track featuring a glorious blend of sustained voices singing in harmony. Perfect for documentaries, remembrance services, commemorative videos, funerals, photo slide shows or any project spiritual/religious or faithful/hopeful in tone.",
    "genre": "Classical",
    "instrumentation": "Choir",
    "tags": "angelic, angels, atmospheric, beautiful, cathedral, children, choir, church, emotional, expressive, faith, faithful, funeral, glorious, glory, god, heaven, heavenly, hopeful, hymn, peaceful, religious, singers, singing, spiritual, uplifting, vocal, vocals, voice, voices",
    "price": 20,
    "date": "2017-06-15",
    "videoId": "S5e0WTb7nEU",
    "youtubeUrl": "https://www.youtube.com/watch?v=S5e0WTb7nEU",
    "productUrl": "https://audiojungle.net/item/church-choir/20093011",
    "duration": "2:34"
  },
  {
    "title": "Medieval",
    "description": "A traditional renaissance-style dance featuring recorder, shawm, crumhorn, lute and percussion. Perfect for historical documentaries, period dramas or TV/movie/film scenes.",
    "genre": "Classical",
    "instrumentation": "Recorder, shawm, crumhorn, lute, percussion",
    "tags": "ancient, baroque, british, classic, court, dance, documentary, elizabeth elizabethan, england, film, folk, historical, history, king, majestic, medieval, monarch, movie, old, period, period drama, queen, regal, renaissance, royal, royalty, soundtrack, tudors, tv",
    "price": 18,
    "date": "2017-06-11",
    "videoId": "of_77knzVy8",
    "youtubeUrl": "https://www.youtube.com/watch?v=of_77knzVy8",
    "productUrl": "https://audiojungle.net/item/medieval/20069262",
    "duration": "1:36"
  },
  {
    "title": "Sentimental Moments",
    "description": "An expressive, emotional track featuring piano, orchestral strings and acoustic guitar. Ideal for use in adverts/commercials, documentaries, charity campaigns, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, acoustic guitar",
    "tags": "advert, beautiful, dream, dreaming, dreamy, emotional, expressive, family, family tree, heartfelt, inspirational, inspire, inspiring, life, love, memories, moments, montage, nature, nostalgic, peaceful, piano, reflective, romance, romantic, sentimental, strings, uplifting, violins, wedding",
    "price": 24,
    "date": "2017-06-10",
    "videoId": "9bHaTWspxCM",
    "youtubeUrl": "https://www.youtube.com/watch?v=9bHaTWspxCM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803027-Sentimental-Moments-2m19?ref=dreamnotemusic",
    "duration": "2:19"
  },
  {
    "title": "Dark Horror Trailer",
    "description": "A dramatic, cinematic track featuring orchestral strings, brass, percussion and atmospheric sound effects. Ideal for use in horror/thriller movie/film soundtracks, trailers, Halloween TV/radio shows, video games or YouTube videos.",
    "genre": "Horror",
    "instrumentation": "Orchestral strings, brass, percussion, sound effects",
    "tags": "action, atmospheric, cinematic, creepy, dark, drama, dramatic, epic, film, game, gritty, halloween, haunted, haunting, horror, ident, movie, murder, mysterious, mystery, opener, scary, sinister, spooky, suspense, teaser, theme, thriller, trailer, twisted",
    "price": 14,
    "date": "2017-06-05",
    "videoId": "Asa0eHVvyfE",
    "youtubeUrl": "https://www.youtube.com/watch?v=Asa0eHVvyfE",
    "productUrl": "https://audiojungle.net/item/dark-horror-trailer/20236234",
    "duration": "0:50"
  },
  {
    "title": "Happy Fun",
    "description": "An upbeat track featuring clarinet, acoustic guitar, tuba and drums. This bright, playful track is perfect for TV/radio shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Comedy",
    "instrumentation": "Clarinet, acoustic guitar, tuba, drums",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 14,
    "date": "2017-06-05",
    "videoId": "iTPufssSzgg",
    "youtubeUrl": "https://www.youtube.com/watch?v=iTPufssSzgg",
    "productUrl": "https://audiojungle.net/item/happy-fun/20029342",
    "duration": "0:42"
  },
  {
    "title": "Atmospheric and Emotional Cinematic",
    "description": "A thought-provoking track featuring piano with orchestral strings. Perfect for film/movie/game trailers, soundtracks, e-book promos, TV dramas or any project with a mysterious mood.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestra",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, death, deep, drama, dramatic, emotional, expressive, fantasy, film, haunting, intense, love, lovers, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 24,
    "date": "2017-06-01",
    "videoId": "4pi8rXUrJrc",
    "youtubeUrl": "https://www.youtube.com/watch?v=4pi8rXUrJrc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311226-Atmospheric-and-Emotional-Cinematic-2m30?ref=dreamnotemusic",
    "duration": "2:30"
  },
  {
    "title": "Funny Comedy",
    "description": "A lively, fun Trad jazz/Dixieland-style track featuring clarinet, banjo, tuba, ukulele and drums. Perfect for comedy compilation/bloopers videos, YouTube videos/hauls/vlogs, party games, apps/computer games, cartoons/animations or adverts/commercials.",
    "genre": "Comedy",
    "instrumentation": "Clarinet, banjo, tuba, ukulele, drums",
    "tags": "animation, app, bloopers, cartoon, chase, cheerful, cheesy, children, comedian, comedy, dixie, dixieland, fast, fun, funny, gag reel, game, happy, haul, jazz, livley, party, playful, quick, quirky, silly, spoof, tidying, trad jazz, vlog",
    "price": 18,
    "date": "2017-05-31",
    "videoId": "2VLBsrDdvrs",
    "youtubeUrl": "https://www.youtube.com/watch?v=2VLBsrDdvrs",
    "productUrl": "https://audiojungle.net/item/funny-comedy/20002256",
    "duration": "1:41"
  },
  {
    "title": "Creepy Mysterious Horror",
    "description": "A dark, haunting, cinematic track featuring piano, celesta, sustained tremolo strings and sinister orchestral tones. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Piano, celesta, orchestral strings",
    "tags": "atmospheric, creepy, dark, dead, death, demented, demon, evil, film score, ghost, gothic, halloween, haunted, haunting, horror, murder, mysterious, mystery, night, nightmare, possessed, psycho, scary, sinister, soundtrack, spooky, suspense, thriller, twisted",
    "price": 16,
    "date": "2017-05-28",
    "videoId": "g5ZYfmmNuJ8",
    "youtubeUrl": "https://www.youtube.com/watch?v=g5ZYfmmNuJ8",
    "productUrl": "https://audiojungle.net/item/creepy-mysterious-horror/19991906",
    "duration": "1:23"
  },
  {
    "title": "Baroque Royalty",
    "description": "A lively, traditional classical track featuring orchestral strings, harpsichord and woodwind. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, woodwind",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 18,
    "date": "2017-05-24",
    "videoId": "Z2cCBrAKqVQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=Z2cCBrAKqVQ",
    "productUrl": "https://audiojungle.net/item/baroque-royalty/19973989",
    "duration": "1:54"
  },
  {
    "title": "Sweet Classical",
    "description": "A traditional classical track featuring piano with orchestral strings and woodwind. Perfect for history documentaries, adverts/commercials, TV period dramas or business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "answerphone, antiques, architecture, background, bank, british, call waiting, classic, classical, drama, english, historical, history, loop, looped, mozart, old, old-fashioned, on hold, orchestra, phone, phone call, piano, regal, royal, royalty, sweet, telephone, traditional, waiting",
    "price": 24,
    "date": "2017-05-24",
    "videoId": "QKAMPRJK1rQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=QKAMPRJK1rQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803155-Sweet-Classical-2m38?ref=dreamnotemusic",
    "duration": "2:38"
  },
  {
    "title": "Charity Appeal",
    "description": "An atmospheric and thought-provoking track featuring piano, cello and orchestra. Perfect for use in TV/radio adverts/commercials, documentaries, charity campaigns, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, cello, orchestra",
    "tags": "advert, atmospheric, beautiful, belief, believe, campaign, charity, commercial, documentary, donate, dreamy, emotional, faith, heartfelt, hope, lonely, love, melancholy, mellow, memories, peaceful, piano, reflective, religion, romantic, sad, sentimental, sorrow, story, thoughtful",
    "price": 20,
    "date": "2017-05-21",
    "videoId": "JehGguGN91M",
    "youtubeUrl": "https://www.youtube.com/watch?v=JehGguGN91M",
    "productUrl": "https://audiojungle.net/item/charity-appeal/19940090",
    "duration": "2:24"
  },
  {
    "title": "Dark Fantasy",
    "description": "An atmospheric, emotional track featuring a harp and piano motif with expressive cello melody accompanied by orchestral strings. Ideal for use in adverts/commercials, TV, fantasy/mystery/suspense film/movie soundtracks or computer games/apps.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Harp, piano, cello, orchestral strings",
    "tags": "beautiful, book trailer, dark, darkness, dream, dreamy, enchanted, fairies, fairytale, fantasy, film, folk, innocence, inspirational, inspiring, love, magic, magical, movie, mysterious, mystery, space, strings, suspense, trailer, tv, twilight, uplifting, utopian, wonderland",
    "price": 18,
    "date": "2017-05-18",
    "videoId": "F2Orki1g5n0",
    "youtubeUrl": "https://www.youtube.com/watch?v=F2Orki1g5n0",
    "productUrl": "https://audiojungle.net/item/dark-fantasy/19922828",
    "duration": "1:57"
  },
  {
    "title": "Expressive Cello",
    "description": "An emotional, sentimental track featuring a passionate, sustained cello melody accompanied by atmospheric piano with orchestral strings and brass. An ideal backing for TV/movie/film scenes, charity campaigns or any project requiring a thought-provoking, inspiring backing.",
    "genre": "Sentimental",
    "instrumentation": "Cello, piano, orchestral strings, brass",
    "tags": "atmospheric, beautiful, cellist, cello, charity, cinematic, dreaming, dreamy, emotional, expressive, family, heartfelt, inspirational, inspire, inspiring, life, love, memories, moving, passionate, piano, reflective, romance, romantic, sentimental, strings, sustained, video, violoncello, wedding",
    "price": 24,
    "date": "2017-05-09",
    "videoId": "0GT-ELvL9MU",
    "youtubeUrl": "https://www.youtube.com/watch?v=0GT-ELvL9MU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201783522-Expressive-Cello-2m22?ref=dreamnotemusic",
    "duration": "2:22"
  },
  {
    "title": "Happy Times",
    "description": "A fun, positive track featuring ukulele, acoustic guitar, xylophone, bass and percussion. This playful, upbeat track is perfect for TV shows, kids cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos/vlogs/hauls or any project with a cheerful, feel-good mood.",
    "genre": "Corporate",
    "instrumentation": "Ukulele, acoustic guitar, xylophone, bass, percussion",
    "tags": "app, beach, bright, cartoon, cheerful, children, comedy, fun, game, happy, haul, holiday, intro, kids, kids tv, play, playful, quirky, reggae, school, summer, theme tune, tv, tv theme, upbeat, vacation, video background, vlog, vlog background, youtube",
    "price": 20,
    "date": "2017-05-08",
    "videoId": "6PS0nxiCDPI",
    "youtubeUrl": "https://www.youtube.com/watch?v=6PS0nxiCDPI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786518-Happy-Times-1m36?ref=dreamnotemusic",
    "duration": "1:36"
  },
  {
    "title": "A Magical Dream",
    "description": "An atmospheric, inspiring and hopeful track featuring layered pianos, orchestral strings and choir. Perfect for use in fantasy movie/film scenes, TV, animations, documentaries or adverts/commercials.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir",
    "tags": "beautiful, book trailer, children, dream, dreamy, enchanted, fairies, fairytale, fantasy, film, folk, innocence, inspirational, inspiring, love, magic, magical, movie, mysterious, orchestra, piano, space, strings, theme, trailer, tv, twilight, uplifting, utopian, wonderland",
    "price": 18,
    "date": "2017-05-07",
    "videoId": "w7s9hcRR4Sw",
    "youtubeUrl": "https://www.youtube.com/watch?v=w7s9hcRR4Sw",
    "productUrl": "https://audiojungle.net/item/a-magical-dream/19834310",
    "duration": "1:43"
  },
  {
    "title": "Ambient Background",
    "description": "An atmospheric track featuring soft, layered pianos and dreamy synth pads. Ideal for adverts/commercials, TV, photo montages or YouTube videos.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 24,
    "date": "2017-05-05",
    "videoId": "FP3eHFX70T0",
    "youtubeUrl": "https://www.youtube.com/watch?v=FP3eHFX70T0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311236-Ambient-Background-2m01?ref=dreamnotemusic",
    "duration": "2:01"
  },
  {
    "title": "Silly Comedy",
    "description": "A quirky, fun, cute track featuring pizzicato strings, vibraphone, glockenspiel, bass, percussion and staccato woodwind. Perfect for comedy compilation/bloopers videos, YouTube videos/hauls/vlogs, apps/computer games, kids' cartoons/animations, adverts/commercials or children’s TV shows.",
    "genre": "Comedy",
    "instrumentation": "Strings, vibraphone, glockenspiel, bass, percussion, woodwind",
    "tags": "advert, app, background, comedic, comedy, comedy drama, comedy movie, commercial, computer game, cute, Daytime TV, fun, funny, gag, game, happy, humor, humorous, humour, lifestyle, lively, playful, playing, quirky, reality show, reality TV, silly, stupid, vlog, youtube",
    "price": 16,
    "date": "2017-04-27",
    "videoId": "qt2m_y2cP_8",
    "youtubeUrl": "https://www.youtube.com/watch?v=qt2m_y2cP_8",
    "productUrl": "https://audiojungle.net/item/silly-comedy/19777656",
    "duration": "1:17"
  },
  {
    "title": "This Beautiful Life",
    "description": "An atmospheric, thought-provoking track featuring layered pianos. Perfect for use in adverts/commercials, documentaries, charity campaigns, photo/video montages or TV/movie/film soundtracks.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano",
    "tags": "advert, beautiful, believe, charity, commercial, dream, dreaming, dreamy, emotional, expressive, family, family tree, happy, heartfelt, hope, hopeful, inspirational, inspiring, life, love, memories, montage, moving, nature, positive, romantic, sentimental, slideshow, uplifting, wedding",
    "price": 24,
    "date": "2017-04-26",
    "videoId": "wnwfl3ulog0",
    "youtubeUrl": "https://www.youtube.com/watch?v=wnwfl3ulog0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805443-This-Beautiful-Life-2m07?ref=dreamnotemusic",
    "duration": "2:07"
  },
  {
    "title": "Emotional Cello and Piano",
    "description": "An expressive, sentimental track featuring a sustained cello melody accompanied by atmospheric piano and soft orchestral strings. An ideal backing for TV/movie/film scenes, charity campaigns or any project requiring a thought-provoking, inspiring backing.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Cello, piano, orchestral strings",
    "tags": "atmospheric, beautiful, cellist, cello, charity, cinematic, dreaming, dreamy, emotional, expressive, family, heartfelt, inspirational, inspire, inspiring, life, love, memories, moving, piano, reflective, romance, romantic, sentimental, strings, sustained, uplifting, video, violoncello, wedding",
    "price": 20,
    "date": "2017-04-25",
    "videoId": "OcDFlI99fI8",
    "youtubeUrl": "https://www.youtube.com/watch?v=OcDFlI99fI8",
    "productUrl": "https://audiojungle.net/item/emotional-cello-piano/19758745",
    "duration": "2:05"
  },
  {
    "title": "Fantasy",
    "description": "A magical, dreamy track featuring an atmospheric piano motif surrounded by expressive orchestral strings, choir and woodwind. Perfect for use in movies/films, TV, animations, documentaries, adverts/commercials or any magical fantasy/sci-fi scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, brass, choir, woodwind",
    "tags": "beautiful, book trailer, children, dream, dreamy, enchanted, fairies, fairytale, fantasy, film, folk, innocence, inspirational, inspiring, love, magic, magical, movie, mysterious, orchestra, piano, space, strings, theme, trailer, tv, twilight, uplifting, utopian, wonderland",
    "price": 18,
    "date": "2017-04-22",
    "videoId": "eJE-OjD-WW0",
    "youtubeUrl": "https://www.youtube.com/watch?v=eJE-OjD-WW0",
    "productUrl": "https://audiojungle.net/item/fantasy/19751722",
    "duration": "1:41"
  },
  {
    "title": "Children's",
    "description": "A fun, happy theme-tune featuring upbeat melody, piano, guitars, hand-claps, bass and glockenspiel. This bright, playful track is perfect for TV shows, kids' cartoons/animations, comedy, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Piano, guitars, bass, glockenspiel, percussion",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 16,
    "date": "2017-04-18",
    "videoId": "CKOJNb3p2ig",
    "youtubeUrl": "https://www.youtube.com/watch?v=CKOJNb3p2ig",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756056-Children-0m33?ref=dreamnotemusic",
    "duration": "0:33"
  },
  {
    "title": "Country Logo 2",
    "description": "An American country music ident/opener/jingle/intro featuring guitars, bass and harmonica. Perfect for use as an opening theme for YouTube videos/vlogs, apps, TV adverts/commercials, comedy sketches, podcasts or as a TV/radio jingle.",
    "genre": "Acoustic",
    "instrumentation": "Guitars, bass, harmonica",
    "tags": "acoustic guitar, america, american, americana, app, catchy, comedy, country, country intro, country music, folk, fun, funny, happy, harmonica, ident, intro, jingle, logo, opener, quirky, redneck, short, slide guitar, southern, steel guitar, usa, video intro, vlog, youtube",
    "price": 10,
    "date": "2017-04-15",
    "videoId": "a1f3ABnIh74",
    "youtubeUrl": "https://www.youtube.com/watch?v=a1f3ABnIh74",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201219057-Country-Logo-2?ref=dreamnotemusic",
    "duration": "0:07"
  },
  {
    "title": "Romantic and Inspiring",
    "description": "A beautiful, emotional track featuring soft piano, cello, acoustic guitar, orchestral strings and choir. Perfect for wedding videos, family videos, photo slide shows, TV, movies/films or any project of a romantic or sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, orchestral strings, choir",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding",
    "price": 24,
    "date": "2017-04-13",
    "videoId": "yQQKJaTYRi8",
    "youtubeUrl": "https://www.youtube.com/watch?v=yQQKJaTYRi8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803262-Romantic-and-Inspiring-2m39?ref=dreamnotemusic",
    "duration": "2:39"
  },
  {
    "title": "Uplifting Classical",
    "description": "A lively, positive track featuring piano, orchestral strings, woodwind, brass and choir. Perfect for adverts/commercials, documentaries, period dramas, nature/country living videos or TV/radio shows.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir",
    "tags": "advert, antiques, baking, british, ceremony, charming, cinematic, classic, classical, commercial, cooking, country, country living, countryside, documentary, english, heritage, historical, history, inspirational, inspiring, motivational, nature, period drama, proud, traditional, twee, wedding, youtube",
    "price": 20,
    "date": "2017-04-12",
    "videoId": "Dc_WR3-r29o",
    "youtubeUrl": "https://www.youtube.com/watch?v=Dc_WR3-r29o",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805454-Uplifting-Classical-1m29?ref=dreamnotemusic",
    "duration": "1:29"
  },
  {
    "title": "Fun and Cute",
    "description": "A happy, bright, playful track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids' ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, pizzicato strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2017-04-09",
    "videoId": "tfkLZtH2Q-k",
    "youtubeUrl": "https://www.youtube.com/watch?v=tfkLZtH2Q-k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785012-Fun-and-Cute-0m55?ref=dreamnotemusic",
    "duration": "0:55"
  },
  {
    "title": "Sad Atmospheric Background",
    "description": "An emotional and thought-provoking track featuring piano, cello and orchestral strings. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, cello, orchestral strings",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, piano solo, reflective, religion, romantic, sad, sentimental, sorrow, story, thoughtful",
    "price": 20,
    "date": "2017-04-07",
    "videoId": "vylcpY8icJ0",
    "youtubeUrl": "https://www.youtube.com/watch?v=vylcpY8icJ0",
    "productUrl": "https://audiojungle.net/item/sad-atmospheric-background/19680813",
    "duration": "3:06"
  },
  {
    "title": "Uplifting and Dramatic Vocal Trailer",
    "description": "Heavenly female voice accompanied by full orchestra and mighty drums (version also included without vocals). This epic, dramatic track is both atmospheric and uplifting. Perfect for use as a movie/film/game trailer or soundtrack.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Female voice, orchestra, percussion",
    "tags": "angelic, atmospheric, beautiful, cinematic, dramatic, dystopia, enchanting, epic, fantasy, female vocal, female voice, film trailer, flying, game trailer, girls voice, heavenly, hope, inspirational, inspiring, movie trailer, new world, orchestral, positive, proud, uplifting, utopia, vocals, voice, womans voice, wonderland",
    "price": 20,
    "date": "2017-04-06",
    "videoId": "J3HuuVdPNEo",
    "youtubeUrl": "https://www.youtube.com/watch?v=J3HuuVdPNEo",
    "productUrl": "https://audiojungle.net/item/uplifting-dramatic-vocal-trailer/19675978",
    "duration": "2:40"
  },
  {
    "title": "Uplifting Magical Advert",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 14,
    "date": "2017-03-28",
    "videoId": "GHUXSEQi_-4",
    "youtubeUrl": "https://www.youtube.com/watch?v=GHUXSEQi_-4",
    "productUrl": "https://audiojungle.net/item/uplifting-magical-advert/19619881",
    "duration": "0:38"
  },
  {
    "title": "Fun Kids",
    "description": "A happy, upbeat track featuring recorder, ukulele, guitar, cheerful whistling, hand-claps, piano and bass. This bright, playful track is perfect for TV shows, kids cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, ukulele, guitar, whistling, percussion, piano, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 20,
    "date": "2017-03-25",
    "videoId": "IUrkUyatno4",
    "youtubeUrl": "https://www.youtube.com/watch?v=IUrkUyatno4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785041-Fun-Kids-1m00?ref=dreamnotemusic",
    "duration": "1:00"
  },
  {
    "title": "Happy Country",
    "description": "A lively, positive track featuring banjo, acoustic guitar, slide guitar, upright bass, drums, foot stomps and claps, blending elements of American folk and bluegrass music. Perfect for TV, comedy, adverts/commercials, YouTube videos, computer games/apps, cartoons/animations or any country-themed project.",
    "genre": "Acoustic",
    "instrumentation": "Banjo, acoustic guitar, slide guitar, upright bass, drums, percussion",
    "tags": "acoustic guitar, america, american, americana, banjo, barn dance, boogie, bright, cartoon, catchy, cheerful, comedy, country, farmer, fiddle, folk, fun, funny, happy, joyful, lively, positive, quirky, redneck, slide guitar, southern, steel guitar, upbeat, usa",
    "price": 20,
    "date": "2017-03-17",
    "videoId": "EK8zGWSdcrk",
    "youtubeUrl": "https://www.youtube.com/watch?v=EK8zGWSdcrk",
    "productUrl": "https://audiojungle.net/item/happy-country/19566458",
    "duration": "2:25"
  },
  {
    "title": "Haunting Child Vocals",
    "description": "An atmospheric, cinematic horror/suspense track featuring female vocals (Instrumental version also included), orchestral strings, harp, celesta and glockenspiel. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any horror, mystery or fantasy project.",
    "genre": "Horror",
    "instrumentation": "Female vocals, orchestral strings, harp, celesta, glockenspiel",
    "tags": "atmospheric, child, creepy, dark, documentary, drama, fantasy, female, film, ghost, girl, haunted, haunting, history, horror, kid, lullaby, magical, movie, mysterious, mystery, paranormal, period drama, scary, singing, song, tv, twisted, vocals, voice",
    "price": 20,
    "date": "2017-03-16",
    "videoId": "ev-V1aHfGdQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=ev-V1aHfGdQ",
    "productUrl": "https://audiojungle.net/item/haunting-child-vocals/19562949",
    "duration": "2:32"
  },
  {
    "title": "Summer Vacation Background",
    "description": "A happy, positive, atmospheric track combining elements of traditional African and Jamaican music, featuring percussion, guitars, bass, mixed voice choir and steel drums. Perfect for vacation adverts/commercials, family videos, documentaries, TV holiday channels, YouTube videos/vlogs or any project needing a cheerful backing.",
    "genre": "Corporate",
    "instrumentation": "Percussion, guitar, bass, choir, steel drums",
    "tags": "adventure, africa, african, background, beach, cheerful, choir, cultural, culture, documentary, ethnic, fun, happy, holiday, jamaican, religious, safari, singers, spiritual, summer, traditional, travel, uplifting, vacation, vocals, voices, wildlife, world music, youtube",
    "price": 18,
    "date": "2017-03-11",
    "videoId": "VqWaKeJeMDo",
    "youtubeUrl": "https://www.youtube.com/watch?v=VqWaKeJeMDo",
    "productUrl": "https://audiojungle.net/item/summer-vacation-background/19526161",
    "duration": "1:49"
  },
  {
    "title": "Atmospheric and Emotional Trailer with Vocals",
    "description": "Heavenly female voice accompanied by full orchestra, choir and percussion. This inspiring, cinematic track is both dramatic and uplifting. Perfect for use as a movie/film/game trailer or soundtrack.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Female voice, orchestra, choir, percussion",
    "tags": "angelic, atmospheric, beautiful, believe, chilling, choir, cinematic, dramatic, emotional, enchanting, epic, faith, fantasy, female vocal, film trailer, game trailer, haunting, heavenly, hope, inspirational, inspiring, magical, melancholic, movie trailer, moving, mystical, orchestral, soulful, uplifting, vocals",
    "price": 20,
    "date": "2026-07-15",
    "videoId": "vCeFQaDufrg",
    "youtubeUrl": "https://www.youtube.com/watch?v=vCeFQaDufrg",
    "productUrl": "http://audiojungle.net/item/atmospheric-and-emotional-trailer-with-vocals/64280241",
    "duration": "2:49"
  },
  {
    "title": "Dramatic Drums",
    "description": "A powerful, driving percussion track featuring a collection of energetic, epic cinematic drums. Big, bold and tense, this track is perfect for film/movie/game trailers/teasers or soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Drums, percussion",
    "tags": "action, battle, big, big drums, blockbuster, cinematic, cinematic percussion, combat, drama, dramatic, drums, drums of war, epic, epic drums, exciting, film trailer, forceful, game trailer, hard, loud, massive, movie trailer, percussion, power, powerful, sports, sports drums, teaser, tense, war",
    "price": 18,
    "date": "2017-02-24",
    "videoId": "ij7nj_zA6MI",
    "youtubeUrl": "https://www.youtube.com/watch?v=ij7nj_zA6MI",
    "productUrl": "https://audiojungle.net/item/dramatic-drums/19463961",
    "duration": "1:49"
  },
  {
    "title": "Drama",
    "description": "A powerful, dramatic baroque/classical style track featuring orchestral strings, woodwind, harpsichord, brass and choir. Perfect for documentaries, TV/movie/film scenes/trailers, period dramas or any project of a historical nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Orchestral strings, woodwind, harpsichord, brass, choir",
    "tags": "advert, advertising, antiques, architecture, bank, baroque, british, classic, classical, countdown, documentary, drama, dramatic, english, exciting, historical, history, intense, old, old-fashioned, period drama, powerful, proud, regal, renaissance, royal, royalty, stately, traditional, tv",
    "price": 20,
    "date": "2017-02-21",
    "videoId": "FwLJnNnPAjw",
    "youtubeUrl": "https://www.youtube.com/watch?v=FwLJnNnPAjw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201780969-Drama-1m58?ref=dreamnotemusic",
    "duration": "1:58"
  },
  {
    "title": "Kids",
    "description": "A fun, happy theme-tune featuring upbeat recorder, guitars, cheerful whistling, hand-claps, piano, bass and glockenspiel. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Recorder, guitars, percussion, piano, bass, glockenspiel",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 10,
    "date": "2017-02-17",
    "videoId": "cfVIMbUs9Kk",
    "youtubeUrl": "https://www.youtube.com/watch?v=cfVIMbUs9Kk",
    "productUrl": "https://audiojungle.net/item/kids/19440763",
    "duration": "0:30"
  },
  {
    "title": "Have a Little Hope",
    "description": "A positive, uplifting track featuring piano, acoustic guitar, choir, glockenspiel and orchestra. An ideal backing for TV/radio adverts/commercials or any project with a hopeful, optimistic tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, acoustic guitar, choir, glockenspiel, orchestra",
    "tags": "advert, beautiful, bright, business, charity, commercial, education, faith, family, family tree, farming, happy, heartfelt, inspirational, inspiring, life, love, memories, nature, optimistic, pizzicato, positive, romantic, sentimental, strings, thanksgiving, unity, uplifting, video, wedding",
    "price": 16,
    "date": "2017-02-10",
    "videoId": "urV-4CpbKe4",
    "youtubeUrl": "https://www.youtube.com/watch?v=urV-4CpbKe4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786527-Have-a-Little-Hope?ref=dreamnotemusic",
    "duration": "1:01"
  },
  {
    "title": "Classical",
    "description": "A traditional track featuring piano with orchestral strings and woodwind. Perfect for history documentaries, adverts/commercials, TV period dramas or business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "answerphone, antiques, architecture, background, british, call waiting, classic, classical, drama, dramatic, english, happy, historical, history, loop, looped, mozart, old, old-fashioned, on hold, orchestra, orchestral, phone, piano, regal, royal, royalty, telephone, traditional, waiting",
    "price": 16,
    "date": "2017-02-03",
    "videoId": "iSOPEEM-7zk",
    "youtubeUrl": "https://www.youtube.com/watch?v=iSOPEEM-7zk",
    "productUrl": "https://audiojungle.net/item/classical/19382559",
    "duration": "1:25"
  },
  {
    "title": "Ambient Atmospheric",
    "description": "A relaxing background track featuring dreamy layered pianos and soft synth pads. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV or time-lapse/photography videos.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 20,
    "date": "2017-02-02",
    "videoId": "yLrkMPUymZM",
    "youtubeUrl": "https://www.youtube.com/watch?v=yLrkMPUymZM",
    "productUrl": "https://audiojungle.net/item/ambient-atmospheric/19374716",
    "duration": "2:27"
  },
  {
    "title": "So Cute",
    "description": "A happy, bright, playful track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2017-01-31",
    "videoId": "MRefqnQV7tI",
    "youtubeUrl": "https://www.youtube.com/watch?v=MRefqnQV7tI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803367-So-Cute-0m54?ref=dreamnotemusic",
    "duration": "0:54"
  },
  {
    "title": "Creepy Lullaby with Child's Voice",
    "description": "‘Creepy Lullaby with Child’s Voice’ is a haunting, cinematic horror track featuring female vocals (Instrumental versions also included), music box, celesta and eerie, sustained strings. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Female vocals, music box, celesta, orchestral strings",
    "tags": "atmospheric, child, creepy, dark, dead, death, fantasy, female, female voice, ghost, girl, gothic, halloween, haunted house, haunting, horror, lullaby, murder, music box, mysterious, mystery, night, nightmare, scary, soundtrack, spooky, suspense, thriller, twisted, vocal",
    "price": 18,
    "date": "2017-01-30",
    "videoId": "2pwiUoTR3WY",
    "youtubeUrl": "https://www.youtube.com/watch?v=2pwiUoTR3WY",
    "productUrl": "https://audiojungle.net/item/creepy-lullaby-with-childs-voice/19365104",
    "duration": "1:34"
  },
  {
    "title": "Enchanting",
    "description": "A magical, inspirational track featuring piano, orchestral strings, woodwind, and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2017-01-27",
    "videoId": "oaGC1TE4Mmo",
    "youtubeUrl": "https://www.youtube.com/watch?v=oaGC1TE4Mmo",
    "productUrl": "https://audiojungle.net/item/enchanting/19349059",
    "duration": "1:24"
  },
  {
    "title": "The Science of Time",
    "description": "An ambient, soothing, dreamy track with soft pianos and atmospheric synth pads. Ideal for adverts/commercials, TV/movie/film soundtracks, space/sci-fi documentaries, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, timelapse",
    "price": 20,
    "date": "2017-01-27",
    "videoId": "STL5XfSkRjQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=STL5XfSkRjQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805791-The-Science-of-Time-1m55?ref=dreamnotemusic",
    "duration": "1:55"
  },
  {
    "title": "Dark Cinematic",
    "description": "An atmospheric, tense and emotional track featuring expressive orchestral strings with sustained woodwind and brass. Perfect for use in movie/film/game trailers/soundtracks, TV dramas, book trailers or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, woodwind, brass",
    "tags": "atmospheric, believe, book trailer, charity, cinematic, dark, dramatic, dream, emotional, epic, fantasy, film trailer, game trailer, honor, honour, hope, hopeful, inspirational, inspiring, journey, military, movie trailer, proud, soundtrack, space, strings, teaser, tense, thriller, trailer",
    "price": 24,
    "date": "2017-01-26",
    "videoId": "P_-37n0UDhY",
    "youtubeUrl": "https://www.youtube.com/watch?v=P_-37n0UDhY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781146-Dark-Cinematic-2m42?ref=dreamnotemusic",
    "duration": "2:42"
  },
  {
    "title": "English Classical",
    "description": "A charming, traditional track featuring oboe, french horn, orchestral strings, woodwind and brass. Perfect for adverts/commercials, period dramas, history documentaries, baking/cooking channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Classical",
    "instrumentation": "Oboe, french horn, orchestral strings, woodwind, brass",
    "tags": "advert, antiques, baking, british, castle, ceremony, charming, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, english, heritage, historical, history, kitchen, nature, period drama, proud, regal, royal, royalty, traditional, twee, wedding, youtube",
    "price": 18,
    "date": "2017-01-24",
    "videoId": "vQXg2Jk7zLs",
    "youtubeUrl": "https://www.youtube.com/watch?v=vQXg2Jk7zLs",
    "productUrl": "https://audiojungle.net/item/english-classical/19335351",
    "duration": "1:44"
  },
  {
    "title": "Positive",
    "description": "A hopeful, inspirational track featuring piano, strings, acoustic guitar and drums. Ideal for use in corporate promotional material, business presentations, TV/radio adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, acoustic guitar, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 16,
    "date": "2017-01-20",
    "videoId": "4iLCxKZErM0",
    "youtubeUrl": "https://www.youtube.com/watch?v=4iLCxKZErM0",
    "productUrl": "https://audiojungle.net/item/positive/19324675",
    "duration": "1:15"
  },
  {
    "title": "Believe",
    "description": "A hopeful, inspiring track featuring piano and orchestra. Ideal for use in adverts/commercials, TV documentaries, trailers/soundtracks, movies/films, videos of a religious or spiritual nature, charity appeals or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestra",
    "tags": "advert, atmospheric, beautiful, belief, believe, champion, charity, church, cinematic, documentary, education, emotional, faith, god, grand, hope, hopeful, inspirational, love, memories, moving, prayer, religious, soundtrack, spiritual, sport, thought-provoking, trailer, uplifting, worship",
    "price": 24,
    "date": "2017-01-17",
    "videoId": "NU0pbG30d4E",
    "youtubeUrl": "https://www.youtube.com/watch?v=NU0pbG30d4E",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483870-Believe-2m17?ref=dreamnotemusic",
    "duration": "2:17"
  },
  {
    "title": "Magical Moments",
    "description": "An atmospheric, inspirational track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2017-01-13",
    "videoId": "fSPL4Qn5SqM",
    "youtubeUrl": "https://www.youtube.com/watch?v=fSPL4Qn5SqM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796225-Magical-Moments-0m54?ref=dreamnotemusic",
    "duration": "0:54"
  },
  {
    "title": "Baroque Period Drama",
    "description": "Traditional classical track featuring orchestral strings, woodwind, harpsichord and trumpet. Perfect for advertising/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, woodwind, rumpet",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 16,
    "date": "2017-01-12",
    "videoId": "8Y9TWQbI7R0",
    "youtubeUrl": "https://www.youtube.com/watch?v=8Y9TWQbI7R0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483418-Baroque-Period-Drama-0m58?ref=dreamnotemusic",
    "duration": "0:58"
  },
  {
    "title": "New Beginnings",
    "description": "A positive, optimistic track featuring muted electric guitar, piano, synths, bass and drums. Ideal for use in TV/radio adverts/commercials, corporate business presentations, holiday/vacation videos, YouTube vlogs or any project with an inspiring, motivational tone.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, piano, synth, bass, drums",
    "tags": "achievement, adventure, advert, advertising, bright, business, commercial, confident, corporate, goal, healthcare, holiday, inspiration, inspirational, inspiring, marketing, motivation, motivational, new year, optimistic, pop, positive, presentation, promotional, resolution, rock, success, upbeat, uplifting, vacation",
    "price": 24,
    "date": "2017-01-03",
    "videoId": "OL2hAcHbsRc",
    "youtubeUrl": "https://www.youtube.com/watch?v=OL2hAcHbsRc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800104-New-Beginnings-2m10?ref=dreamnotemusic",
    "duration": "2:10"
  },
  {
    "title": "Positive Advert",
    "description": "An inspiring track featuring piano, synth pads, bass, strings and drums. Ideal for use in TV/radio adverts/commercials, corporate material, YouTube videos/vlogs or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Piano, synth pads, bass, strings, drums",
    "tags": "achievement, advert, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 16,
    "date": "2016-12-27",
    "videoId": "FF9gIG3sQfA",
    "youtubeUrl": "https://www.youtube.com/watch?v=FF9gIG3sQfA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800130-Positive-Advert-0m41?ref=dreamnotemusic",
    "duration": "0:41"
  },
  {
    "title": "Hopeful Advert",
    "description": "A positive, inspirational background track featuring piano and subtle strings. An ideal backing for TV/radio adverts/commercials, documentaries or any project with a light-hearted, optimistic tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, beautiful, bright, business, charity, commercial, education, faith, family, family tree, farming, happy, heartfelt, inspirational, inspiring, life, love, memories, nature, optimistic, pizzicato, positive, romantic, sentimental, strings, thanksgiving, unity, uplifting, video, wedding",
    "price": 16,
    "date": "2016-12-24",
    "videoId": "N8nAk0crLEw",
    "youtubeUrl": "https://www.youtube.com/watch?v=N8nAk0crLEw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786548-Hopeful-Advert-0m44?ref=dreamnotemusic",
    "duration": "0:44"
  },
  {
    "title": "Inspiring TV Advert",
    "description": "An uplifting, magical track featuring piano and orchestra. Ideal for use in TV/radio adverts/commercials, documentaries, trailers, movie/film soundtracks, travel videos, corporate presentations or any project requiring a motivational, hopeful musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir",
    "tags": "accomplish, achieve, adventure, advert, advertisement, believe, challenge, cinematic, commercial, corporate, documentary, faith, holiday, hope, hopeful, inspirational, inspiring, journey, motivational, movie, positive, powerful, struggle, success, thought-provoking, trailer, travel, triumph, uplifting, win",
    "price": 16,
    "date": "2016-12-22",
    "videoId": "BC6abKBKwRY",
    "youtubeUrl": "https://www.youtube.com/watch?v=BC6abKBKwRY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793234-Inspiring-TV-Advert-0m44?ref=dreamnotemusic",
    "duration": "0:44"
  },
  {
    "title": "Dark Dramatic Cinematic Background",
    "description": "A tense, atmospheric track featuring orchestral strings, french horn, woodwind and percussion. Perfect for use in movie/film/game trailers/teasers, soundtracks or TV dramas/thrillers.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, french horn, woodwind, percussion",
    "tags": "action, anxious, atmospheric, background, chase, cinematic, danger, dark, drama, dramatic, energy, epic, espionage, excited, film trailer, game trailer, gripping, movie trailer, mystery, orchestral, promo, scared, soundtrack, spy, suspense, teaser, tense, tension, thriller, trailer",
    "price": 20,
    "date": "2016-12-20",
    "videoId": "92_WVjaxdJo",
    "youtubeUrl": "https://www.youtube.com/watch?v=92_WVjaxdJo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781097-Dark-Dramatic-Cinematic-Background-1m53?ref=dreamnotemusic",
    "duration": "1:53"
  },
  {
    "title": "English Country Garden",
    "description": "A charming, traditional track featuring delicate piano, soft woodwind/brass and glockenspiel. Perfect for adverts/commercials, documentaries, nature/country living videos, baking/cooking channels or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, woodwind, brass, glockenspiel",
    "tags": "advert, baking, british, charming, children, classic, classical, commercial, cooking, country, countryside, Daytime TV, documentary, english, farming, garden, gardening, happy, innocent, kitchen, light, nature, nice, radio, sweet, theme, traditional, twee",
    "price": 16,
    "date": "2016-12-16",
    "videoId": "jiYNPpGAQuk",
    "youtubeUrl": "https://www.youtube.com/watch?v=jiYNPpGAQuk",
    "productUrl": "https://audiojungle.net/item/english-country-garden/19178838",
    "duration": "1:27"
  },
  {
    "title": "Sad Cinematic Cello",
    "description": "An emotional, atmospheric lament featuring a passionate, expressive cello solo over a low orchestral strings drone. Ideal for movie/film soundtracks, games, documentaries or any project with a sorrowful or thought-provoking atmosphere.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Cello, orchestral strings",
    "tags": "atmosphere, atmospheric, cellist, cello, cello solo, celtic, cinematic, dark, death, drama, dramatic, drone, folk, grief, history, lament, loneliness, lonely, loss, moody, passion, period drama, remembrance, sad, sadness, solitude, sorrow, tragedy, tragic, war",
    "price": 16,
    "date": "2016-12-16",
    "videoId": "dicHW5y82ok",
    "youtubeUrl": "https://www.youtube.com/watch?v=dicHW5y82ok",
    "productUrl": "https://audiojungle.net/item/sad-cinematic-cello/19180605",
    "duration": "1:10"
  },
  {
    "title": "Cinematic Logo 7",
    "description": "This dramatic, cinematic logo features an expressive french horn melody accompanied by sustained orchestral strings, woodwind, brass and choir, building towards an expressive climax in true Hollywood style. Ideal for use as a movie opening, film company intro, YouTube video logo, reveal or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion",
    "tags": "big screen, cinematic, climax, credits, crescendo, film, film ident, film intro, growing, hollywood, ident, inspirational, intro, logo, motion picture, movie, opening, orchestra, orchestral, piano, pictures, powerful, reveal, strings, sweeping, title, title music, titles, trailer, youtube",
    "price": 12,
    "date": "2016-12-14",
    "videoId": "hN3RPH8oM_s",
    "youtubeUrl": "https://www.youtube.com/watch?v=hN3RPH8oM_s",
    "productUrl": "https://audiojungle.net/item/cinematic-logo-7/19172217",
    "duration": "0:21"
  },
  {
    "title": "British Military",
    "description": "A majestic, patriotic, traditional track with an uplifting orchestral theme featuring strings, french horn, trumpet, woodwind and brass, accompanied by a rhythmic, marching snare-drum. Perfect for graduation/awards ceremonies, historical documentaries/period dramas, military themed computer/arcade games or film/movie soundtracks.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, french horn, trumpet, woodwind, brass, snare-drum.",
    "tags": "army, brass, ceremonial, ceremony, classical, documentary, fanfare, graduation, grand, historical, history, honor, honour, majestic, march, memorial, military, noble, patriotic, period drama, pompous, pride, proud, regal, royal, royalty, snare-drum, solider, stately, Toy Soldiers",
    "price": 18,
    "date": "2016-12-13",
    "videoId": "0fbUFJmLgrU",
    "youtubeUrl": "https://www.youtube.com/watch?v=0fbUFJmLgrU",
    "productUrl": "https://audiojungle.net/item/british-military/19165757",
    "duration": "1:43"
  },
  {
    "title": "English Waltz",
    "description": "A sweet, charming, traditional classical track featuring orchestral strings, piano, clarinet, glockenspiel and choir. Perfect for use in TV/movies/films, history documentaries, period dramas or adverts/commercials.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, piano, clarinet, glockenspiel, choir",
    "tags": "advert, antiques, ball, british, ceremony, charming, classic, classical, country, country living, countryside, dance, dancing, Daytime TV, documentary, english, heritage, historical, history, love, period drama, princess, proud, regal, royal, royalty, traditional, twee, waltz, wedding",
    "price": 14,
    "date": "2016-12-13",
    "videoId": "7rgYKqoq7Qk",
    "youtubeUrl": "https://www.youtube.com/watch?v=7rgYKqoq7Qk",
    "productUrl": "https://audiojungle.net/item/english-waltz/19167374",
    "duration": "0:55"
  },
  {
    "title": "Comedy Suspense",
    "description": "A quirky background track featuring pizzicato strings, woodwind, glockenspiel, xylophone, bass and percussion. Perfect for adverts/commercials, TV shows, comedy films/movies, apps/games or YouTube videos/vlogs.",
    "genre": "Comedy",
    "instrumentation": "Orchestral strings, woodwind, glockenspiel, xylophone, bass, percussion",
    "tags": "advert, app, background, cleaning, comedic, comedy, comedy drama, comedy movie, commercial, computer game, Daytime TV, fun, funny, gag, game, happy, humor, humour, humourous, lifestyle, lively, playful, playing, quirky, reality show, reality TV, silly, stupid, vlog, youtube",
    "price": 16,
    "date": "2016-12-11",
    "videoId": "OCCeBhjtrfs",
    "youtubeUrl": "https://www.youtube.com/watch?v=OCCeBhjtrfs",
    "productUrl": "https://audiojungle.net/item/comedy-suspense/19155861",
    "duration": "1:09"
  },
  {
    "title": "Beautiful Wedding Day",
    "description": "An expressive, sentimental track featuring piano with orchestral strings, woodwind and choir. An ideal backing for wedding videos, adverts/commercials, family videos, photo slideshows or a video montage.",
    "genre": "Wedding",
    "instrumentation": "Piano. orchestral strings, woodwind, choir",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, family tree, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2016-12-09",
    "videoId": "fa10Km_2M4M",
    "youtubeUrl": "https://www.youtube.com/watch?v=fa10Km_2M4M",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483850-Beautiful-Wedding-Day-3m17?ref=dreamnotemusic",
    "duration": "3:17"
  },
  {
    "title": "Christmas Vlog Intro",
    "description": "A short, bright jingle/logo/ident/intro featuring sleigh bells, piano and glockenspiel. Ideal for use in YouTube vlogmas videos, Christmas TV adverts/commercials, greetings cards, radio intros, xmas games/apps or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, piano, glockenspiel",
    "tags": "advertising, app, bells, bright, christmas, commercial, festive, game, glockenspiel, greetings, greetings card, happy, happy holidays, holiday, ident, intro, jingle, jolly, logo, merry, radio, seasonal, sleigh bells, video intro, vlog, vlogmas, web intro, xmas, youtube, youtube intro",
    "price": 10,
    "date": "2016-12-06",
    "videoId": "j-Dmu2ku0hE",
    "youtubeUrl": "https://www.youtube.com/watch?v=j-Dmu2ku0hE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756125-Christmas-Vlog-Intro-0m12?ref=dreamnotemusic",
    "duration": "0:12"
  },
  {
    "title": "Time Stands Still",
    "description": "An atmospheric, dreamy track featuring soft, layered pianos and ambient synth pads. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse, timelapse",
    "price": 24,
    "date": "2016-12-05",
    "videoId": "dJhU8_Mdm6g",
    "youtubeUrl": "https://www.youtube.com/watch?v=dJhU8_Mdm6g",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805966-Time-Stands-Still-2m34?ref=dreamnotemusic",
    "duration": "2:34"
  },
  {
    "title": "Happy Christmas",
    "description": "A bright, uplifting, cheerful festive Christmas track featuring orchestral strings, woodwind, brass, piano, harp, children’s choir and sleigh bells. Ideal for use in movie/film/TV/game soundtracks, adverts/commercials, YouTube videos or any festive, seasonal videos.",
    "genre": "Christmas",
    "instrumentation": "Orchestral strings, woodwind, brass, piano, harp, choir, sleigh bells",
    "tags": "advertising, beautiful, bright, children, choir, christmas, commercial, fantasy, film, happy, holiday, inspirational, inspiring, magic, magical, movie, orchestral, promo, promotional, reindeer, santa, santa-claus, seasonal, sleigh-bells, snow, tv, uplifting, wonder, wonderland, xmas",
    "price": 24,
    "date": "2016-11-30",
    "videoId": "O6aC_haKE1k",
    "youtubeUrl": "https://www.youtube.com/watch?v=O6aC_haKE1k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786573-Happy-Christmas-2m01?ref=dreamnotemusic",
    "duration": "2:01"
  },
  {
    "title": "Hopeful",
    "description": "A positive, uplifting track featuring piano and orchestral strings. An ideal backing for TV/radio adverts/commercials, documentaries, wedding/family videos, photo slideshows or any project with a light-hearted, optimistic tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, beautiful, bright, business, charity, commercial, education, faith, family, family tree, farming, happy, heartfelt, inspirational, inspiring, life, love, memories, nature, optimistic, pizzicato, positive, romantic, sentimental, strings, thanksgiving, unity, uplifting, video, wedding",
    "price": 20,
    "date": "2016-11-27",
    "videoId": "Q2iSnLSu-ic",
    "youtubeUrl": "https://www.youtube.com/watch?v=Q2iSnLSu-ic",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786601-Hopeful-1m31?ref=dreamnotemusic",
    "duration": "1:31"
  },
  {
    "title": "Magical Story",
    "description": "A bright, enchanting track featuring piano, glockenspiel, orchestral strings and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, orchestral strings, choir",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2016-11-22",
    "videoId": "17mB0slBrKE",
    "youtubeUrl": "https://www.youtube.com/watch?v=17mB0slBrKE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796301-Magical-Story-0m56?ref=dreamnotemusic",
    "duration": "0:56"
  },
  {
    "title": "Saying I Do",
    "description": "An expressive, romantic track featuring piano, cello, acoustic guitar, orchestral strings, brass and woodwind. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, cello, acoustic guitar, orchestral strings, brass, woodwind",
    "tags": "beautiful, believe, bride, ceremony, commitment ceremony, dream, dreamy, enchanting, engagement, expressive, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 24,
    "date": "2016-11-21",
    "videoId": "wDnJH_c3S4A",
    "youtubeUrl": "https://www.youtube.com/watch?v=wDnJH_c3S4A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803459-Saying-I-Do-2m17?ref=dreamnotemusic",
    "duration": "2:17"
  },
  {
    "title": "Christmas Background",
    "description": "A bright, magical track featuring piano, sleigh bells, orchestral strings and choir. Perfect for use in adverts/commercials, YouTube videos or any festive/seasonal project.",
    "genre": "Christmas",
    "instrumentation": "Piano, sleigh bells, orchestra strings, choir",
    "tags": "advert, background, beautiful, bright, children, christmas, commercial, enchanted, fantasy, festive, happy, happy holidays, holiday, inspirational, inspiring, jingle, kids, magic, magical, orchestral, positive, seasonal, sleigh-bells, tv, uplifting, vlogmas, wonder, wonderland, xmas, youtube",
    "price": 20,
    "date": "2016-11-17",
    "videoId": "zO-1Fcp7IOY",
    "youtubeUrl": "https://www.youtube.com/watch?v=zO-1Fcp7IOY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756138-Christmas-Background-1m44?ref=dreamnotemusic",
    "duration": "1:44"
  },
  {
    "title": "Magical Christmas Logo",
    "description": "A short, bright jingle/logo/ident featuring bells, piano, glockenspiel, xylophone, choir and strings. Ideal for use in Christmas adverts/commercials, YouTube vlogmas videos, radio intros, video games/apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Bells, piano, glockenspiel, xylophone, choir, strings",
    "tags": "advertising, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, tubular bells, vlogmas, web intro, xmas, youtube",
    "price": 10,
    "date": "2016-11-15",
    "videoId": "m31Gs20_-lQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=m31Gs20_-lQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796264-Magical-Christmas-Logo-0m10?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Children's TV Theme",
    "description": "‘Children’s TV Theme’ is a fun, happy theme-tune featuring upbeat ukulele, guitar, hand-claps, piano, recorder, percussion, bass and glockenspiel. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Ukulele, guitar, piano, recorder, percussion, bass, glockenspiel",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 14,
    "date": "2016-11-14",
    "videoId": "iUz-wkzi06A",
    "youtubeUrl": "https://www.youtube.com/watch?v=iUz-wkzi06A",
    "productUrl": "https://audiojungle.net/item/childrens-tv-theme/18797140",
    "duration": "0:26"
  },
  {
    "title": "Peace on Earth",
    "description": "A hopeful, thought-provoking track featuring piano, expressive orchestral strings, soft choir, french horn and woodwind. An ideal backing for wedding videos, adverts/commercials, charity campaigns, photo slideshows, family videos or any project with an emotional tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings, choir, french horn, woodwind",
    "tags": "advert, advertising, beautiful, charity, commemorative, commercial, documentary, dreaming, dreamy, expressive, faith, family, heartfelt, inspirational, inspiring, life, love, memories, montage, nature, orchestra, orchestral, piano, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2016-11-09",
    "videoId": "ECbBH8xVW9o",
    "youtubeUrl": "https://www.youtube.com/watch?v=ECbBH8xVW9o",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800400-Peace-on-Earth-2m10?ref=dreamnotemusic",
    "duration": "2:10"
  },
  {
    "title": "Timelapse Background",
    "description": "An ambient, relaxing, dreamy track featuring soft pianos, strings and atmospheric synth pads. Perfect for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, strings",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, slow, soundscape, space, technology, thoughts, time lapse",
    "price": 24,
    "date": "2016-11-09",
    "videoId": "h8cJQhhXGvA",
    "youtubeUrl": "https://www.youtube.com/watch?v=h8cJQhhXGvA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806029-Timelapse-Background-2m20?ref=dreamnotemusic",
    "duration": "2:20"
  },
  {
    "title": "Christmas Logo 8",
    "description": "A short, bright jingle/logo/ident/intro featuring sleigh bells, piano and glockenspiel. deal for use in Christmas adverts/commercials, YouTube vlogmas videos, TV/radio intros, video games/apps, greetings cards or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, piano, glockenspiel",
    "tags": "advert, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, greetings card, happy, ident, inspiring, intro, jingle, jolly, logo, merry, radio, ring-tone, santa, seasonal, sleigh bells, snow, vlog, vlogmas, web intro, xmas, youtube",
    "price": 10,
    "date": "2016-11-07",
    "videoId": "fNN_ErZ6EjY",
    "youtubeUrl": "https://www.youtube.com/watch?v=fNN_ErZ6EjY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756149-Christmas-Logo-8?ref=dreamnotemusic",
    "duration": "0:12"
  },
  {
    "title": "Always Have Hope",
    "description": "A sentimental, hopeful track featuring piano, orchestral strings, woodwind and french horn. Perfect for use in adverts/commercials, charity campaigns or family/wedding videos/photo slideshows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, french horn",
    "tags": "advert, beautiful, belief, believe, campaign, charity, christmas, church, classical, commercial, donation, emotional, expressive, faith, family, god, heartfelt, hope, life, love, memories, montage, piano, religion, romantic, sentimental, spiritual, thanksgiving, wedding, youtube",
    "price": 24,
    "date": "2016-11-06",
    "videoId": "UOpaW1RZ-LU",
    "youtubeUrl": "https://www.youtube.com/watch?v=UOpaW1RZ-LU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311349-Always-Have-Hope-2m36?ref=dreamnotemusic",
    "duration": "2:36"
  },
  {
    "title": "Documentary Background",
    "description": "An atmospheric, ambient track featuring synths, soft string pads and layered pianos. Perfect for use in history/space documentaries, adverts/commercials or time-lapse photography videos.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Synth, string pad, pianos",
    "tags": "advert, ambient, calm, chill, chillout, city, cityscape, digital, documentary, dreaming, dreamy, electronic, futuristic, modern, montage, nature, new-age, night, photography, relaxing, scenery, scenic, sci-fi, science, sleep, space, technology, thoughts, time-lapse, timelapse",
    "price": 24,
    "date": "2016-11-01",
    "videoId": "BE1exzTe_Y0",
    "youtubeUrl": "https://www.youtube.com/watch?v=BE1exzTe_Y0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781196-documentary-background-2m52?ref=dreamnotemusic",
    "duration": "2:52"
  },
  {
    "title": "Christmas Advert",
    "description": "A bright, uplifting, magical Christmas track featuring piano, celesta, glockenspiel, sleigh bells, choir and orchestral strings. Ideal for use in adverts/commercials, movie/film/TV soundtracks, apps/games or any festive holiday/seasonal family/YouTube videos.",
    "genre": "Christmas",
    "instrumentation": "Piano, celesta, glockenspiel, sleigh bells, choir, orchestral strings",
    "tags": "advert, beautiful, bright, children, christmas, commercial, fantasy, film, happy, holiday, inspirational, inspiring, magic, magical, motivational, movie, orchestral, promo, promotional, reindeer, santa, santa-claus, seasonal, sleigh-bells, snow, tv, uplifting, wonder, wonderland, xmas",
    "price": 20,
    "date": "2016-10-27",
    "videoId": "bXmb8VBiio0",
    "youtubeUrl": "https://www.youtube.com/watch?v=bXmb8VBiio0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756191-Christmas-Advert-1m14?ref=dreamnotemusic",
    "duration": "1:14"
  },
  {
    "title": "Corporate Advert",
    "description": "An optimistic, motivational track featuring piano, strings, guitars, synths, bass and drums. Ideal for use in promotional business material, presentations or TV/radio adverts/commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, guitars, synths, bass, drums",
    "tags": "achievement, advert, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2016-10-23",
    "videoId": "JupiXmpios4",
    "youtubeUrl": "https://www.youtube.com/watch?v=JupiXmpios4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756207-Corporate-Advert-1m21?ref=dreamnotemusic",
    "duration": "1:21"
  },
  {
    "title": "Relaxing Timelapse",
    "description": "An ambient, soothing, dreamy track featuring soft layered pianos and atmospheric synth pads. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, calm, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, modern, montage, nature, night, peaceful, photography, relaxing, scenery, scenic, sci-fi, sleep, soft, soundscape, space, thoughts, timelapse",
    "price": 24,
    "date": "2016-10-23",
    "videoId": "THbplUl4Gug",
    "youtubeUrl": "https://www.youtube.com/watch?v=THbplUl4Gug",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803541-Relaxing-Timelapse-2m31?ref=dreamnotemusic",
    "duration": "2:31"
  },
  {
    "title": "Tense Suspense",
    "description": "A dramatic and exciting track featuring intense orchestral strings, woodwind and piano over a persistent ticking sound. Ideal for movie/film/game soundtracks, TV dramas, game shows, competitions, apps, trailers or any project needing an atmospheric, suspenseful backing.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, woodwind, piano, percussion",
    "tags": "atmospheric, bomb, challenge, chase, clock, competition, countdown, danger, drama, dramatic, film, games, gripping, imminent, movie, powerful, promo, scared, scary, suspense, suspenseful, tense, tension, ticktock, time, timer, trailer, tv, urgent, worried",
    "price": 16,
    "date": "2016-10-21",
    "videoId": "kHqbs1ObGLY",
    "youtubeUrl": "https://www.youtube.com/watch?v=kHqbs1ObGLY",
    "productUrl": "https://audiojungle.net/item/tense-suspense/18427990",
    "duration": "1:39"
  },
  {
    "title": "Dark Atmospheric",
    "description": "An ambient, haunting cinematic track featuring piano, synths, cellos, violins and french horn. Perfect for TV/movie/film scenes, space/sci-fi documentaries, time-lapse photography videos or any project with an emotional, expressive, thought-provoking tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, synth, strings, brass",
    "tags": "ambience, ambient, atmosphere, atmospheric, background, calm, chilled, dark, documentary, dreaming, dreamy, emotional, emptiness, expressive, haunting, lonely, mysterious, night, peaceful, relaxing, sad, sci-fi, sleep, slow, soothing, sorrow, soundscape, space, still, timelapse",
    "price": 24,
    "date": "2016-10-18",
    "videoId": "H9hgUSMRweE",
    "youtubeUrl": "https://www.youtube.com/watch?v=H9hgUSMRweE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781211-Dark-Atmospheric-2m06?ref=dreamnotemusic",
    "duration": "2:06"
  },
  {
    "title": "Optimistic Corporate",
    "description": "A positive, inspiring track featuring a piano motif surrounded by sustained strings, acoustic guitars, synth pads, bass and drums. Ideal for use in TV/radio adverts/commercials, corporate promotional material or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, acoustic guitar, synth pads, bass, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2016-10-17",
    "videoId": "8dXerBsgY2s",
    "youtubeUrl": "https://www.youtube.com/watch?v=8dXerBsgY2s",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800561-Optimistic-Corporate-1m24?ref=dreamnotemusic",
    "duration": "1:24"
  },
  {
    "title": "Magical Dream",
    "description": "An uplifting, inspirational track featuring piano, glockenspiel, orchestral strings, woodwind and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind, choir",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2016-10-15",
    "videoId": "uq73riFhgAI",
    "youtubeUrl": "https://www.youtube.com/watch?v=uq73riFhgAI",
    "productUrl": "https://audiojungle.net/item/magical-dream/18330603",
    "duration": "1:12"
  },
  {
    "title": "English Christmas",
    "description": "A charming, traditional track featuring piano, orchestral strings, woodwind, brass, sleigh bells and choir. Perfect for Christmas adverts/commercials, history documentaries, period dramas, nature/country living videos, family videos, TV/radio shows or any seasonal project.",
    "genre": "Christmas",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, sleigh bells, choir",
    "tags": "advert, antiques, british, castle, charming, christmas, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, english, heritage, historical, history, holiday, magical, period drama, regal, royal, royalty, seasonal, stately home, traditional, twee, xmas, youtube",
    "price": 20,
    "date": "2016-10-13",
    "videoId": "rf5cYXmySlY",
    "youtubeUrl": "https://www.youtube.com/watch?v=rf5cYXmySlY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201783590-English-Christmas-1m14?ref=dreamnotemusic",
    "duration": "1:14"
  },
  {
    "title": "Ambient Corporate Background",
    "description": "An atmospheric, mellow track featuring a repeating piano motif surrounded by warm synth pads, strings, bass and a subtle drum beat. Ideal for use in TV/radio adverts/commercials, corporate promotional material or business presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, strings, bass, drums",
    "tags": "achievement, advert, advertising, ambient, atmospheric, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, positive, presentation, promotional, soft, success, successful, uplifting",
    "price": 24,
    "date": "2016-10-11",
    "videoId": "6KYnX98_tTg",
    "youtubeUrl": "https://www.youtube.com/watch?v=6KYnX98_tTg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311415-Ambient-Corporate-Background-2m28?ref=dreamnotemusic",
    "duration": "2:28"
  },
  {
    "title": "Dramatic News",
    "description": "A powerful news channel style theme/intro/opener featuring orchestral strings, brass, woodwind and percussion. Ideal for TV news channels, YouTube news videos, radio station news reports or any type of corporate announcements, breaking news, headlines, media or broadcasting.",
    "genre": "Corporate",
    "instrumentation": "Orchestral strings, brass, woodwind, percussion",
    "tags": "announcement, broadcast, broadcasting, business report, corporate, dramatic, entertainment, evening news, exciting, feature, featurette, global, gripping, headlines, ident, intro, logo, media, network, news, opening, powerful, presentation, promo, radio, sport report, strong, tense, tv, youtube",
    "price": 12,
    "date": "2016-10-09",
    "videoId": "YEL_SyUOATk",
    "youtubeUrl": "https://www.youtube.com/watch?v=YEL_SyUOATk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781210-Dramatic-News-0m27?ref=dreamnotemusic",
    "duration": "0:27"
  },
  {
    "title": "Dramatic History Documentary",
    "description": "A powerful, atmospheric cinematic track featuring orchestral strings, woodwind and choir. Perfect for use in adverts/commercials, historical documentaries, TV/movies/films/games or soundtracks/trailers.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, choir",
    "tags": "action, atmospheric, baroque, cinematic, classical, dark, documentary, drama, dramatic, english, epic, film trailer, game trailer, grand, historical, history, honor, honour, inspirational, inspiring, movie trailer, period drama, powerful, proud, royal, soundtrack, strong, thriller, trailer, war",
    "price": 20,
    "date": "2016-10-07",
    "videoId": "DCcqTNedjxc",
    "youtubeUrl": "https://www.youtube.com/watch?v=DCcqTNedjxc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781279-Dramatic-History-Documentary-1m33?ref=dreamnotemusic",
    "duration": "1:33"
  },
  {
    "title": "Positive and Optimistic",
    "description": "An inspiring and uplifting track featuring lively, rhythmic orchestral strings, piano, acoustic guitars, synth pads, bass and drums. Ideal for use in TV/radio adverts/commercials, corporate promotional material or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Orchestral strings, piano, acoustic guitars, synth pads, bass, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 24,
    "date": "2016-10-07",
    "videoId": "mkArGSOna3A",
    "youtubeUrl": "https://www.youtube.com/watch?v=mkArGSOna3A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800664-Positive-and-Optimistic-2m08?ref=dreamnotemusic",
    "duration": "2:08"
  },
  {
    "title": "Inspiring Hope",
    "description": "An expressive, inspirational track featuring piano and orchestra. An ideal backing for wedding videos, TV/radio adverts/commercials, photo slide shows, family videos or any project with a hopeful, emotional tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra",
    "tags": "advert, advertisement, advertising, beautiful, commemorative, commercial, documentary, dreaming, dreamy, family, heartfelt, inspirational, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, positive, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 20,
    "date": "2016-10-04",
    "videoId": "_Lk_sYuNAYM",
    "youtubeUrl": "https://www.youtube.com/watch?v=_Lk_sYuNAYM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793302-Inspiring-Hope-1m55?ref=dreamnotemusic",
    "duration": "1:55"
  },
  {
    "title": "Silly Fun",
    "description": "A fast, quirky, playful track featuring piano, vibraphone and bass. Perfect for comedy compilation/bloopers videos, YouTube videos/hauls/vlogs, party games, apps/computer games, cartoons/animations or adverts/commercials.",
    "genre": "Comedy",
    "instrumentation": "Piano, vibraphone, bass",
    "tags": "animation, app, bloopers, cartoon, chase, cheerful, cheesy, children, comedian, comedy, fun, funny, gag reel, game, happy, haul, honky tonk, kids, party, piano, platform, playful, quirky, saloon, silly, ska, spoof, tidying, vlog",
    "price": 14,
    "date": "2016-10-01",
    "videoId": "fAUdGglXpRE",
    "youtubeUrl": "https://www.youtube.com/watch?v=fAUdGglXpRE",
    "productUrl": "https://audiojungle.net/item/silly-fun/18137127",
    "duration": "0:47"
  },
  {
    "title": "Happy Vlog Background",
    "description": "A fun, upbeat track featuring glockenspiel, ukulele, guitar, piano, bass and percussion. This bright, playful track is perfect for TV shows, kids cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos/vlogs/hauls or any project with a positive, feel-good vibe.",
    "genre": "Corporate",
    "instrumentation": "Glockenspiel, ukulele, guitar, piano, bass, percussion",
    "tags": "app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, haul, intro, kids, kids tv, party, play, playful, quirky, reggae, school, theme tune, tv, tv theme, upbeat, video background, video intro, vlog, vlog background, youtube",
    "price": 20,
    "date": "2016-09-30",
    "videoId": "QAc0NuwE9Sk",
    "youtubeUrl": "https://www.youtube.com/watch?v=QAc0NuwE9Sk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786641-Happy-Vlog-Background-1m55?ref=dreamnotemusic",
    "duration": "1:55"
  },
  {
    "title": "Magical",
    "description": "An uplifting, inspirational track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, christmas, commercial, company, corporate, dream, fantasy, festive, future, happy, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2016-09-29",
    "videoId": "BeWTXus2Kd4",
    "youtubeUrl": "https://www.youtube.com/watch?v=BeWTXus2Kd4",
    "productUrl": "https://audiojungle.net/item/magical/18093603",
    "duration": "1:00"
  },
  {
    "title": "Life is Magical",
    "description": "A bright, uplifting track featuring piano with orchestral strings and woodwind. Ideal for use in TV/radio adverts/commercials, fantasy film/movie soundtracks, animations or any project of a magical or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2016-09-28",
    "videoId": "5XXSUMIELro",
    "youtubeUrl": "https://www.youtube.com/watch?v=5XXSUMIELro",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795022-Life-is-Magical-0m51?ref=dreamnotemusic",
    "duration": "0:51"
  },
  {
    "title": "Acoustic Background",
    "description": "A nostalgic, sentimental track featuring acoustic guitar, piano and bass. Perfect for family videos, wedding videos, photo slide shows, TV/ movies/films or any project of a peaceful/heartfelt nature.",
    "genre": "Acoustic",
    "instrumentation": "Acoustic guitar, piano, bass",
    "tags": "acoustic, advert, album, beautiful, charity, commercial, dreamy, emotional, family, family album, family tree, family video, folk, friendship, happy, heartfelt, inspirational, inspiring, life, love, memories, montage, nostalgic, photo, photography, relaxing, romantic, sentimental, slideshow, wedding",
    "price": 20,
    "date": "2016-09-27",
    "videoId": "5sESrS9NRPQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=5sESrS9NRPQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311456-Acoustic-Background-1m54?ref=dreamnotemusic",
    "duration": "1:54"
  },
  {
    "title": "Halloween Theme",
    "description": "A dark comedy horror track featuring orchestral strings, brass, woodwind, percussion, harpsichord, choir and ghostly female voice. Perfect for any Halloween or horror themed adverts/commercials, Halloween events, computer games/apps, TV Halloween specials, YouTube videos/vlogs or cartoons/animations.",
    "genre": "Horror",
    "instrumentation": "Strings, brass, woodwind, percussion, harpsichord, choir, female voice",
    "tags": "animation, cartoon, comedy, creepy, dark, dracula, fear, female vocal, fright, funny, ghosts, ghouls, halloween, harpsichord, haunted, haunted house, haunting, horror, monsters, operatic voice, orchestral, playful, quirky, scary, skeletons, spooky, strings, trick or treat, witch",
    "price": 20,
    "date": "2016-09-24",
    "videoId": "BZFokhpQ6zQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=BZFokhpQ6zQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786685-Halloween-Theme-1m52?ref=dreamnotemusic",
    "duration": "1:52"
  },
  {
    "title": "Inspiring Life",
    "description": "An uplifting, cinematic track featuring piano and symphony orchestra. Ideal for use in adverts/commercials, documentaries, TV/movie/film soundtracks/trailers, travel videos or any project requiring a motivational, thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, holiday, hope, inspirational, journey, motivational, movie, moving, powerful, religious, struggle, success, thought-provoking, trailer, travel, triumph, uplifting, win",
    "price": 20,
    "date": "2016-09-23",
    "videoId": "Z53ntHYUYog",
    "youtubeUrl": "https://www.youtube.com/watch?v=Z53ntHYUYog",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793395-Inspiring-Life-1m46?ref=dreamnotemusic",
    "duration": "1:46"
  },
  {
    "title": "Halloween Ident",
    "description": "Featuring haunting harpsichord, ghostly female voice, choir and orchestra, this Halloween ident/logo/intro is perfect for any Halloween/comedy horror themed adverts/commercials, YouTube videos, games, TV/radio specials or cartoons/animations.",
    "genre": "Horror",
    "instrumentation": "Harpsichord, female voice, choir, orchestra",
    "tags": "animation, cartoon, comedy, creepy, dracula, fear, funny, ghosts, ghouls, halloween, harpsichord, haunted, haunted house, haunting, horror, ident, logo, monsters, opener, operatic voice, playful, quirky, scary, skeletons, spooky, strings, trick or treat, vlogtober, witch, youtube",
    "price": 12,
    "date": "2016-09-21",
    "videoId": "UuRwRxCYba0",
    "youtubeUrl": "https://www.youtube.com/watch?v=UuRwRxCYba0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786705-Halloween-Ident-0m19?ref=dreamnotemusic",
    "duration": "0:19"
  },
  {
    "title": "Halloween Logo 4",
    "description": "Featuring harpsichord, glockenspiel and orchestra, this Halloween logo/ident/into/opener is perfect for any Halloween/horror themed adverts/commercials, YouTube videos, games, TV/radio specials or animations.",
    "genre": "Horror",
    "instrumentation": "Harpsichord, xylophone, strings, woodwind, orchestra",
    "tags": "animation, cartoon, comedy, creepy, dracula, fear, funny, ghosts, ghouls, halloween, harpsichord, haunted, haunted house, haunting, horror, ident, logo, monsters, opener, operatic voice, playful, quirky, scary, skeletons, spooky, strings, trick or treat, vlogtober, witch, youtube",
    "price": 10,
    "date": "2016-09-21",
    "videoId": "uydtp92noKY",
    "youtubeUrl": "https://www.youtube.com/watch?v=uydtp92noKY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786675-Halloween-Logo-4-0m12?ref=dreamnotemusic",
    "duration": "0:12"
  },
  {
    "title": "Wedding Dream",
    "description": "A beautiful, romantic track featuring piano, cello, acoustic guitar, orchestral strings and choir. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of an expressive or sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, orchestral strings, choir",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 24,
    "date": "2016-09-17",
    "videoId": "hQbHsrqgua8",
    "youtubeUrl": "https://www.youtube.com/watch?v=hQbHsrqgua8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805677-Wedding-Dream-3m12?ref=dreamnotemusic",
    "duration": "3:12"
  },
  {
    "title": "Happy Days",
    "description": "A fun, upbeat track featuring glockenspiel, vibraphone, acoustic guitar, ukulele, piano and bass. This bright, playful track is perfect for TV shows, computer games/apps, commercials/adverts, children’s cartoons/animations, YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, vibraphone, acoustic guitar, ukulele, piano, bass",
    "tags": "animation, app, bloopers, bright, cartoon, catchy, cheerful, cheesy, children, childrens tv, comedy, comic, fun, funny, game, happy, holiday, jolly, kids, kids tv, play, playful, positive, quirky, theme tune, tv, tv theme, upbeat, vacation, youtube",
    "price": 20,
    "date": "2016-09-15",
    "videoId": "W1MPr_YjZcA",
    "youtubeUrl": "https://www.youtube.com/watch?v=W1MPr_YjZcA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786740-Happy-Days-1m45?ref=dreamnotemusic",
    "duration": "1:45"
  },
  {
    "title": "Jazz Ident",
    "description": "A cool, upbeat ident/opener/jingle/intro featuring piano, vibraphone, muted trumpet, bass and drums. Ideal for use in YouTube videos/vlogs, adverts/commercials, comedy shows/podcasts, radio jingles or as a TV chat show/sitcom theme.",
    "genre": "Jazz",
    "instrumentation": "Piano, vibraphone, trumpet, bass, drums",
    "tags": "advert, advertising, chat show, chatshow, comedy, commercial, cool, fun, funny, gameshow, happy, ident, intro, jazz, jazzy, jingle, logo, opener, podcast, quirky, radio, retro, sitcom, talk show, theme, theme tune, tv, video intro, vlog, youtube",
    "price": 10,
    "date": "2016-09-14",
    "videoId": "Ion3qW-rvbI",
    "youtubeUrl": "https://www.youtube.com/watch?v=Ion3qW-rvbI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795023-Jazz-Ident?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "English Country Life",
    "description": "A charming, traditional track featuring orchestral strings, piano and woodwind. Perfect for adverts/commercials, nature documentaries, period dramas, country living videos, baking/cooking channels or TV/radio shows.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, piano, woodwind",
    "tags": "advert, baking, beautiful, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, cute, Daytime TV, documentary, english, farming, happy, housewife, innocent, kitchen, light-hearted, nature, nice, playful, sweet, traditional, twee, youtube",
    "price": 20,
    "date": "2016-09-13",
    "videoId": "1Re6w9p80Lc",
    "youtubeUrl": "https://www.youtube.com/watch?v=1Re6w9p80Lc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201783915-English-Country-Life-1m55?ref=dreamnotemusic",
    "duration": "1:55"
  },
  {
    "title": "Haunting Vocal Lullaby",
    "description": "A dark, horror lullaby featuring ghostly female voice (Instrumental version also included) with creepy celesta, piano, glockenspiel and eerie orchestral strings. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Female voice, celesta, piano, glockenspiel, orchestral strings",
    "tags": "atmospheric, book trailer, child, creepy, dark, death, dream, evil, fantasy, female voice, ghost, ghostly, girl, gothic, halloween, haunted, haunting, horror, lullaby, magical, nightmare, scary, soundtrack, spooky, suspense, thriller, trailer, twisted, waltz, young girl",
    "price": 16,
    "date": "2016-09-10",
    "videoId": "HfArohPFY1s",
    "youtubeUrl": "https://www.youtube.com/watch?v=HfArohPFY1s",
    "productUrl": "https://audiojungle.net/item/haunting-vocal-lullaby/17723545",
    "duration": "1:14"
  },
  {
    "title": "Classical Phone Loop",
    "description": "A traditional, light, classical style track featuring delicate piano with soft orchestral strings and clarinet. Perfect for business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, clarinet",
    "tags": "answerphone, antiques, architecture, background music, bank, british, call waiting, classic, classical, drama, dramatic, english, historical, history, loop, looped, mozart, old, old-fashioned, on hold, orchestra, phone, phone call, piano, regal, royal, royalty, telephone, traditional, waiting",
    "price": 20,
    "date": "2016-09-09",
    "videoId": "pQfnI-mRnQQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=pQfnI-mRnQQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756252-Classical-Phone-Loop-1m24?ref=dreamnotemusic",
    "duration": "1:24"
  },
  {
    "title": "Creepy Horror Logo",
    "description": "A dark, haunting logo/ident/opener/intro featuring piano, music box, celesta, sustained tremolo strings and sinister orchestral tones. Perfect for horror documentaries, openers, book trailers or halloween/YouTube videos.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, strings, orchestral",
    "tags": "atmospheric, creepy, dark, death, demonic, evil, ghostly, gothic, halloween, haunted, haunted house, haunting, hell, horror, ident, intro, murder, mysterious, mystery, nightmare, opener, outro, psycho, scary, soundtrack, spooky, suspense, thriller, twisted, youtube",
    "price": 12,
    "date": "2016-09-07",
    "videoId": "KziVwsUn_lY",
    "youtubeUrl": "https://www.youtube.com/watch?v=KziVwsUn_lY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756221-Creepy-Horror-Logo?ref=dreamnotemusic",
    "duration": "0:15"
  },
  {
    "title": "Photo Gallery",
    "description": "A heart-warming, sentimental track featuring piano, acoustic guitar, bass, orchestral strings and drums. Perfect for family videos, weddings, photo slide shows, TV, movies/films or any project of an expressive nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, bass, orchestral strings, drums",
    "tags": "advert, advertisement, album, beautiful, birth, charity, commercial, dreamy, emotional, family, family album, family tree, family video, friendship, happy, heartfelt, inspirational, inspiring, life, love, memories, montage, moving, photo, photography, relaxing, romantic, sentimental, slideshow, wedding",
    "price": 24,
    "date": "2016-09-06",
    "videoId": "ChfqQA777f4",
    "youtubeUrl": "https://www.youtube.com/watch?v=ChfqQA777f4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800767-Photo-Gallery-2m31?ref=dreamnotemusic",
    "duration": "2:31"
  },
  {
    "title": "Creepy Vocal Lullaby",
    "description": "A haunting, cinematic horror track featuring female vocals (Instrumental version also included), music box, celesta and eerie, sustained strings. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Female vocals, music box, celesta, strings",
    "tags": "atmospheric, child, creepy, dark, dead, death, fantasy, female, female voice, ghost, girl, gothic, halloween, haunted house, haunting, horror, lullaby, murder, music box, mysterious, mystery, night, nightmare, scary, soundtrack, spooky, suspense, thriller, twisted, vocal",
    "price": 16,
    "date": "2016-09-05",
    "videoId": "5HGmRXLDVKg",
    "youtubeUrl": "https://www.youtube.com/watch?v=5HGmRXLDVKg",
    "productUrl": "https://audiojungle.net/item/creepy-vocal-lullaby/17623208",
    "duration": "1:18"
  },
  {
    "title": "Fun Kids' Logo",
    "description": "An upbeat, happy ident/opener/jingle/intro featuring glockenspiel, recorder, ukulele, guitar, cheerful whistling, hand-claps, piano and bass. Perfect for children’s TV shows, computer games/apps, commercials/adverts, YouTube videos/vlogs or as a comedy TV/radio jingle.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, ukulele, guitar, whistling, piano, bass",
    "tags": "advert, animation, app, bright, cartoon, catchy, cheerful, children, comedy, commercial, fun, happy, ident, intro, jingle, kids, kids tv, logo, opener, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, video intro, vlog, youtube",
    "price": 10,
    "date": "2016-09-05",
    "videoId": "5aFSRYLJKgU",
    "youtubeUrl": "https://www.youtube.com/watch?v=5aFSRYLJKgU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784949-Fun-Kids-Logo-0m12?ref=dreamnotemusic",
    "duration": "0:12"
  },
  {
    "title": "Halloween Logo 3",
    "description": "Featuring harpsichord, ghostly female voice and orchestra, this Halloween logo/ident/opener/intro is perfect for any Halloween/horror themed adverts/commercials, YouTube videos, games, TV/radio specials or cartoons/animations.",
    "genre": "Horror",
    "instrumentation": "Harpsichord, female voice orchestra",
    "tags": "animation, cartoon, comedy, creepy, dracula, fear, funny, ghosts, ghouls, halloween, harpsichord, haunted, haunted house, haunting, horror, ident, logo, monsters, opener, operatic voice, playful, quirky, scary, skeletons, spooky, strings, trick or treat, vlogtober, witch, youtube",
    "price": 10,
    "date": "2016-09-01",
    "videoId": "2AAIhQY5F0I",
    "youtubeUrl": "https://www.youtube.com/watch?v=2AAIhQY5F0I",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786726-Halloween-Logo-3-0m09?ref=dreamnotemusic",
    "duration": "0:09"
  },
  {
    "title": "Together Forever",
    "description": "A beautiful, romantic track featuring piano, cello, acoustic guitar, choir and expressive orchestral strings. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, cello, acoustic guitar, choir, orchestral strings",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 24,
    "date": "2016-09-01",
    "videoId": "H02RxEcduNU",
    "youtubeUrl": "https://www.youtube.com/watch?v=H02RxEcduNU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806158-Together-Forever-2m20?ref=dreamnotemusic",
    "duration": "2:20"
  },
  {
    "title": "Enchanted",
    "description": "A magical, dreamy track featuring an atmospheric piano motif surrounded by expressive orchestral strings, choir, woodwind and brass (version without melody also included). Perfect for use in movies/films, TV, animations, documentaries, adverts/commercials or any magical fantasy/sci-fi scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, woodwind, brass",
    "tags": "beautiful, book trailer, children, dream, dreamy, enchanted, fairies, fairytale, fantasy, film, folk, innocence, inspirational, inspiring, love, magic, magical, movie, mysterious, orchestra, piano, space, strings, theme, trailer, tv, twilight, uplifting, utopian, wonderland",
    "price": 18,
    "date": "2016-08-29",
    "videoId": "9pBIUSVIcJ8",
    "youtubeUrl": "https://www.youtube.com/watch?v=9pBIUSVIcJ8",
    "productUrl": "https://audiojungle.net/item/enchanted/17474033",
    "duration": "1:49"
  },
  {
    "title": "Magical Day",
    "description": "A bright, uplifting track featuring piano, acoustic guitar, glockenspiel, french horn, flute and orchestral strings. Ideal for use in TV/radio adverts/commercials, fantasy film/movie soundtracks, animations or any project of a magical or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, acoustic guitar, glockenspiel, french horn, flute, orchestral strings",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 20,
    "date": "2016-08-28",
    "videoId": "8Pio7Fv4D7A",
    "youtubeUrl": "https://www.youtube.com/watch?v=8Pio7Fv4D7A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796346-Magical-Day-1m43?ref=dreamnotemusic",
    "duration": "1:43"
  },
  {
    "title": "Comedy Piano Logo",
    "description": "A funny, quirky ident/opener/intro/outro featuring ‘honkytonk’ piano (versions also included with a vintage ‘old record’ effect). Perfect for comedy compilation/bloopers videos, YouTube videos, apps/computer games, kids cartoons/animations or adverts/commercials.",
    "genre": "Comedy",
    "instrumentation": "Piano",
    "tags": "comedian, comedic, comedy, fun, funny, gag reel, game, happy, honytonk, ident, intro, jazz piano, kids, logo, opener, outro, party, piano, piano rag, playful, pub piano, quirky, ragtime, saloon piano, scott joplin, show, showbiz, slapstick, slient movie, spoof",
    "price": 10,
    "date": "2016-08-23",
    "videoId": "BtbpF5CxSsE",
    "youtubeUrl": "https://www.youtube.com/watch?v=BtbpF5CxSsE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756226-Comedy-Piano-Logo-0m07?ref=dreamnotemusic",
    "duration": "0:07"
  },
  {
    "title": "Positive Inspiration",
    "description": "An upbeat, optimistic track featuring piano, staccato strings, guitars, synth pads, bass and drums. Ideal for use in TV/radio adverts/commercials, corporate promotional material, YouTube videos or motivational business/company presentations.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, guitar, synth pads, bass, drums",
    "tags": "achievement, advert, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 24,
    "date": "2016-08-22",
    "videoId": "yHtUVqytKKk",
    "youtubeUrl": "https://www.youtube.com/watch?v=yHtUVqytKKk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800840-Positive-Inspiration-2m16?ref=dreamnotemusic",
    "duration": "2:16"
  },
  {
    "title": "Creepy Waltz",
    "description": "A haunting, spooky track featuring piano, harpsichord, glockenspiel, celesta, orchestral strings and woodwind. Ideal for use in horror movie/film soundtracks, kids' cartoons/animations, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a ghostly, scary tone.",
    "genre": "Horror",
    "instrumentation": "Piano, harpsichord, glockenspiel, celesta, orchestral strings and woodwind",
    "tags": "app, atmospheric, creepy, dark, dead, death, film score, game, ghost, gothic, halloween, haunted house, haunting, horror, kids, magic, music box, mysterious, mystery, night, nightmare, possessed, quirky, scary, soundtrack, spooky, suspense, thriller, twisted, waltz",
    "price": 16,
    "date": "2016-08-20",
    "videoId": "P28kcO13DaM",
    "youtubeUrl": "https://www.youtube.com/watch?v=P28kcO13DaM",
    "productUrl": "https://audiojungle.net/item/creepy-waltz/17367658",
    "duration": "1:08"
  },
  {
    "title": "Happy Children",
    "description": "A fun, upbeat track featuring glockenspiel, recorder, ukulele, guitar, cheerful whistling, hand-claps, piano and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, ukulele, guitar, whistling, percussion, piano, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 14,
    "date": "2016-08-19",
    "videoId": "pSP5RnjgaNI",
    "youtubeUrl": "https://www.youtube.com/watch?v=pSP5RnjgaNI",
    "productUrl": "https://audiojungle.net/item/happy-children/17354861",
    "duration": "0:38"
  },
  {
    "title": "Housewife Life",
    "description": "A lively, busy, quirky track featuring pizzicato strings, woodwind and percussion. Perfect for adverts/commercials, documentaries, daytime TV, baking/cooking shows/channels or YouTube organisational/cleaning videos.",
    "genre": "Comedy",
    "instrumentation": "Strings, woodwind, percussion",
    "tags": "1950s, advert, baking, busy, chores, cleaning, comedic, commercial, cooking, Daytime TV, declutter, documentary, domestic, funny, happy, housewife, housework, kitchen, lifestyle, lively, organization, playful, quirky, retro, shopping, supermarket, tidying, time-lapse, vlog, youtube",
    "price": 16,
    "date": "2016-08-15",
    "videoId": "6kYg2GAwaf8",
    "youtubeUrl": "https://www.youtube.com/watch?v=6kYg2GAwaf8",
    "productUrl": "https://audiojungle.net/item/housewife-life/17278784",
    "duration": "1:03"
  },
  {
    "title": "Creepy Lullaby",
    "description": "A dark, haunting lullaby featuring music box, piano, glockenspiel and choir. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Music box, piano, glockenspiel , choir",
    "tags": "child, creepy, dark, death, demon, dream, evil, fantasy, film score, ghost, gothic, halloween, haunted, haunting, hell, horror, lullaby, murder, music box, night, nightmare, possessed, psycho, scary, soundtrack, spooky, suspense, thriller, trailer, twisted",
    "price": 14,
    "date": "2016-08-13",
    "videoId": "HSQeFGMxpOA",
    "youtubeUrl": "https://www.youtube.com/watch?v=HSQeFGMxpOA",
    "productUrl": "https://audiojungle.net/item/creepy-lullaby/17255375",
    "duration": "1:41"
  },
  {
    "title": "Space",
    "description": "An ambient, soothing, dreamy track with soft pianos and atmospheric synth pads. Ideal for time-lapse videos, adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, timelapse",
    "price": 24,
    "date": "2016-08-11",
    "videoId": "hmfVB5_sjeU",
    "youtubeUrl": "https://www.youtube.com/watch?v=hmfVB5_sjeU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803620-Space-3m06?ref=dreamnotemusic",
    "duration": "3:06"
  },
  {
    "title": "New Business",
    "description": "A positive, upbeat track featuring a lively palm-muted guitar motif surrounded by warm synth pads, strings, pianos and drums. Ideal for use in corporate promotional material, business presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, synth pads, strings, pianos, drums",
    "tags": "achievement, advert, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivate, motivation, motivational, optimistic, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2016-08-10",
    "videoId": "AeljBS20nPk",
    "youtubeUrl": "https://www.youtube.com/watch?v=AeljBS20nPk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800894-New-Business-1m33?ref=dreamnotemusic",
    "duration": "1:33"
  },
  {
    "title": "Emotional Atmospheric",
    "description": "An expressive, dark, cinematic soundtrack featuring piano with rich orchestral strings. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a haunting/mysterious mood.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, death, deep, drama, dramatic, emotional, fantasy, film, forbidden, haunting, intense, love, lovers, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 24,
    "date": "2016-08-09",
    "videoId": "bmojZCubeUE",
    "youtubeUrl": "https://www.youtube.com/watch?v=bmojZCubeUE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784159-Emotional-Atmospheric-2m11?ref=dreamnotemusic",
    "duration": "2:11"
  },
  {
    "title": "Successful Business",
    "description": "An upbeat, positive, optimistic track featuring palm-muted guitar surrounded by warm synth pads, bass, piano, strings and drums. Ideal for use in corporate promotional material, presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, synth pads, bass, piano, strings, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2016-08-09",
    "videoId": "KnxqoG9lmSI",
    "youtubeUrl": "https://www.youtube.com/watch?v=KnxqoG9lmSI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803640-Successful-Business-1m48?ref=dreamnotemusic",
    "duration": "1:48"
  },
  {
    "title": "Baroque Beauty",
    "description": "A happy, lively, traditional classical track featuring orchestral strings, violin, harpsichord, trumpet and choir. Perfect for advertising/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, violin, harpsichord, trumpet, choir",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 20,
    "date": "2016-08-07",
    "videoId": "WtgcYr3GgTw",
    "youtubeUrl": "https://www.youtube.com/watch?v=WtgcYr3GgTw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483250-Baroque-Beauty-1m14?ref=dreamnotemusic",
    "duration": "1:14"
  },
  {
    "title": "Love Story",
    "description": "An emotional, romantic track featuring piano, acoustic guitar, cello, choir and lush orchestral strings. Perfect for wedding videos, TV/film/movie scenes, adverts/commercials, family videos or any project with a romantic, expressive theme.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, cello, choir, orchestral strings",
    "tags": "advert, advertising, atmospheric, bank, banking, beautiful, bright, business, christmas, commercial, company, dream, fairytale, fantasy, festive, future, hopeful, innocent, inspirational, investment, magic, magical, marketing, money, optimistic, positive, product, promotional, sales, tv",
    "price": 24,
    "date": "2016-08-05",
    "videoId": "S6ZJLokxqug",
    "youtubeUrl": "https://www.youtube.com/watch?v=S6ZJLokxqug",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795115-Love-Story-2m49?ref=dreamnotemusic",
    "duration": "2:49"
  },
  {
    "title": "Sorrow",
    "description": "A sad, melancholic, cinematic track featuring piano, cello, violin and atmospheric choir. Ideal for TV, adverts/commercials, movie/film soundtracks or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, cello, violin, choir",
    "tags": "atmospheric, calm, cello, cinematic, dark, death, dream, empty, faith, funeral, lament, loneliness, loss, melancholy, memories, minimal, nature, peaceful, religion, remembrance, sad, sadness, slow, solitude, sorrow, thoughtful, timelapse, tranquil, violin, war",
    "price": 24,
    "date": "2016-08-05",
    "videoId": "GT3pGhBrBck",
    "youtubeUrl": "https://www.youtube.com/watch?v=GT3pGhBrBck",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803761-Sorrow-2m19?ref=dreamnotemusic",
    "duration": "2:19"
  },
  {
    "title": "Princess Waltz",
    "description": "An enchanting, atmospheric and dreamy track featuring orchestral strings, piano, harp, woodwind and choir. Perfect for use in movies/films, children’s cartoons/animation, kids' TV, ballet/princess videos, advert/commercials or any project of a magical nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, piano, harp, woodwind, choir",
    "tags": "ball, ballerina, ballet, beautiful, book trailer, children, cute, dance, dancer, dancing, dream, dreamy, enchanted, enchanting, fairies, fairytale, fantasy, innocence, innocent, kids, love, magic, magical, prince, princess, royal, theme, tv, waltz, wonderland",
    "price": 16,
    "date": "2016-08-04",
    "videoId": "nzJekZ45S7E",
    "youtubeUrl": "https://www.youtube.com/watch?v=nzJekZ45S7E",
    "productUrl": "https://audiojungle.net/item/princess-waltz/17091545",
    "duration": "1:00"
  },
  {
    "title": "Beautiful Tragedy",
    "description": "An atmospheric, expressive and thought-provoking solo piano track. Perfect for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of a sentimental or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, background, believe, calm, charity, cinematic, classical, commercial, documentary, emotional, faith, heartfelt, history, hope, hopeful, melancholy, mellow, memories, moving, nostalgic, piano, piano solo, reflective, sad, sentimental, sorrow, soundtrack, story, time-lapse",
    "price": 20,
    "date": "2016-08-03",
    "videoId": "t4yzpFsi6mw",
    "youtubeUrl": "https://www.youtube.com/watch?v=t4yzpFsi6mw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483720-Beautiful-Tragedy-1m55?ref=dreamnotemusic",
    "duration": "1:55"
  },
  {
    "title": "Dramatic History",
    "description": "An atmospheric, thought-provoking cinematic track featuring orchestral strings, brass, woodwind, choir and powerful percussion. Perfect for use in movie/film/game trailers, soundtracks, adverts or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, brass, woodwind, choir, percussion",
    "tags": "action, atmospheric, believe, cinematic, dark, documentary, dramatic, dream, epic, film trailer, game trailer, grand, historical, history, honor, honour, hope, hopeful, inspirational, inspiring, movie trailer, powerful, proud, soundtrack, strength, strong, thriller, trailer, uplifting, war",
    "price": 16,
    "date": "2016-08-03",
    "videoId": "sTXclNvOo84",
    "youtubeUrl": "https://www.youtube.com/watch?v=sTXclNvOo84",
    "productUrl": "https://audiojungle.net/item/dramatic-history/17069493",
    "duration": "1:10"
  },
  {
    "title": "Emotional Cinematic",
    "description": "A dark, atmospheric soundtrack featuring piano with expressive orchestral strings and haunting choir. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a mysterious, tragic tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings, choir",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, death, deep, drama, dramatic, emotional, expressive, fantasy, film, haunting, intense, love, lovers, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 16,
    "date": "2016-08-02",
    "videoId": "_uTY1aii68A",
    "youtubeUrl": "https://www.youtube.com/watch?v=_uTY1aii68A",
    "productUrl": "https://audiojungle.net/item/emotional-cinematic/17033493",
    "duration": "1:29"
  },
  {
    "title": "Magical Waltz",
    "description": "An enchanting fantasy track featuring pianos, pizzicato strings, choir, percussion and glockenspiel. Ideal for use in adverts/commercials, fantasy TV/film/movie soundtracks, children’s animations, corporate presentations or any project of a hopeful or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Pianos, strings, choir, percussion, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, corporate, dream, fairytale, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, princess, product, promo, promotional, tv",
    "price": 20,
    "date": "2016-07-31",
    "videoId": "BXPPtzDiV0Q",
    "youtubeUrl": "https://www.youtube.com/watch?v=BXPPtzDiV0Q",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796394-Magical-Waltz-1m12?ref=dreamnotemusic",
    "duration": "1:12"
  },
  {
    "title": "Happy Background",
    "description": "A fun, positive, optimistic track featuring pianos and glockenspiel. Perfect for use in YouTube videos or adverts/commercials.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel",
    "tags": "advert, animation, app, background, bright, catchy, cheerful, children, comedy, commercial, fun, game, happy, holiday, kids, light, loop, optimistic, play, playful, positive, quirky, school, upbeat, uplifting, vacation, video background, video intro, youtube, youtube video background",
    "price": 20,
    "date": "2016-07-30",
    "videoId": "oHZwkSQw6oA",
    "youtubeUrl": "https://www.youtube.com/watch?v=oHZwkSQw6oA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786765-Happy-Background-1m34?ref=dreamnotemusic",
    "duration": "1:34"
  },
  {
    "title": "1950s",
    "description": "A lively, busy, quirky track featuring piano, glockenspiel, xylophone, orchestral strings, woodwind and percussion. Alternate versions are included, produced with a vintage radio effect. Perfect for retro adverts/commercials, comedy videos, baking/cooking shows/channels or YouTube organisational/cleaning videos.",
    "genre": "Comedy",
    "instrumentation": "Piano, glockenspiel, xylophone, orchestral strings, woodwind, percussion",
    "tags": "advert, baking, busy, chores, cleaning, comedic, commercial, cooking, declutter, documentary, family life, fast, funny, happy, housewife, housework, kitchen, lifestyle, lively, organization, playful, quirky, retro, shopping, supermarket, tidying, time-lapse, vintage, vlog, youtube",
    "price": 12,
    "date": "2016-07-28",
    "videoId": "DU7f6_NTBgQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=DU7f6_NTBgQ",
    "productUrl": "https://audiojungle.net/item/1950s/16983092",
    "duration": "1:06"
  },
  {
    "title": "Country Fun",
    "description": "A fast, positive, energetic country dance track featuring banjo, acoustic guitars, slide guitars, dobro, upright bass, drums, foot stomps and claps, blending elements of American folk and bluegrass music. Perfect for TV, comedy, adverts/commercials, YouTube videos, computer games/apps, cartoons/animations or any country-themed project.",
    "genre": "Acoustic",
    "instrumentation": "Banjo, acoustic guitar, slide guitar, dobro, harmonica, upright bass, drums",
    "tags": "acoustic guitar, america, american, americana, banjo, barn dance, boogie, bright, cartoon, catchy, cheerful, comedy, country, farmer, fiddle, folk, fun, funny, happy, joyful, lively, positive, quirky, redneck, slide guitar, southern, steel guitar, upbeat, usa",
    "price": 14,
    "date": "2016-07-27",
    "videoId": "AvqI3EsGIEI",
    "youtubeUrl": "https://www.youtube.com/watch?v=AvqI3EsGIEI",
    "productUrl": "https://audiojungle.net/item/country-fun/16954597",
    "duration": "0:46"
  },
  {
    "title": "Uplifting",
    "description": "A positive, inspirational cinematic track featuring piano and orchestra. Ideal for use in adverts/commercials, documentaries, trailers, movie/film soundtracks, travel videos or any project requiring a motivational, though-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra, choir",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, hope, inspirational, journey, magical, motivational, movie, moving, powerful, religious, success, thought-provoking, trailer, travel, triumph, uplifting, win, wonder",
    "price": 14,
    "date": "2016-07-27",
    "videoId": "gePhTYg8mhc",
    "youtubeUrl": "https://www.youtube.com/watch?v=gePhTYg8mhc",
    "productUrl": "https://audiojungle.net/item/uplifting/16935895",
    "duration": "Length TBC"
  },
  {
    "title": "Cityscape",
    "description": "An ambient, dreamy timelapse track with soft piano, atmospheric strings, synth pads, bass and drums. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, atmospheric strings, synth pads, bass, drums",
    "tags": "advert, advertising, ambient, art, beautiful, chill, city, cityscape, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 24,
    "date": "2016-07-26",
    "videoId": "5KRFUEn69ps",
    "youtubeUrl": "https://www.youtube.com/watch?v=5KRFUEn69ps",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756127-Cityscape-3m41?ref=dreamnotemusic",
    "duration": "3:41"
  },
  {
    "title": "Cinematic Background",
    "description": "An atmospheric, emotional track featuring piano, cello, orchestral strings and woodwind. Perfect for use in movie/film/game trailers, soundtracks, advertising or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestra",
    "tags": "atmospheric, believe, charity, cinematic, dark, dramatic, dream, emotional, epic, expressive, fantasy, film trailer, game trailer, honor, honour, hope, hopeful, inspirational, inspiring, journey, movie trailer, proud, soundtrack, space, strings, teaser, thriller, trailer, uplifting, wonder",
    "price": 24,
    "date": "2016-07-25",
    "videoId": "BPvMTotzQ6E",
    "youtubeUrl": "https://www.youtube.com/watch?v=BPvMTotzQ6E",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756352-Cinematic-Background-2m59?ref=dreamnotemusic",
    "duration": "2:59"
  },
  {
    "title": "Peaceful Children's Choir",
    "description": "‘Peaceful Children’s Choir’ is an elegant and atmospheric choral track featuring young voices singing in harmony. Both inspiring and emotional, this track would be perfect for use in any expressive film/movie soundtrack, trailer, documentary, wedding video or project of a spiritual/religious nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Choir, voices",
    "tags": "angelic, angels, beautiful, boys, children, choir, church, cinematic, dreamy, emotional, expressive, gentle, glorious, glory, god, hopeful, hymn, inspirational, inspiring, moving, peaceful, reflective, religious, singing, soft, tender, uplifting, vocal, voice, wonderful",
    "price": 20,
    "date": "2016-07-22",
    "videoId": "Z0p71B86Z-I",
    "youtubeUrl": "https://www.youtube.com/watch?v=Z0p71B86Z-I",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800946-Peaceful-Childrens-Choir-1m28?ref=dreamnotemusic",
    "duration": "1:28"
  },
  {
    "title": "Sweet and Fun",
    "description": "A happy, bright, playful track featuring pizzicato strings, piano, glockenspiel, and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, children’s ballet class/tutorials or kids' TV shows.",
    "genre": "Children's",
    "instrumentation": "Strings, piano, glockenspiel, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2016-07-22",
    "videoId": "8B6IZKqaguU",
    "youtubeUrl": "https://www.youtube.com/watch?v=8B6IZKqaguU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803763-Sweet-and-Fun-0m42?ref=dreamnotemusic",
    "duration": "0:42"
  },
  {
    "title": "Superhero",
    "description": "A powerful, dramatic, cinematic orchestral theme featuring french horns, trumpets, strings, woodwind and percussion. Ideal for use in superhero/military-themed videos, cartoons/animations, trailers/teasers, TV/games or YouTube videos.",
    "genre": "Comedy",
    "instrumentation": "French horn, trumpet, strings, woodwind, percussion",
    "tags": "army, battle, cinematic, comic, credits, epic, film, game, hero, heroic, hollywood, honor, honour, intro, military, movie, opening, orchestral, patriotic, powerful, proud, snaredrum, strong, superhero, superman, titles, trailer, video intro, war, youtube",
    "price": 14,
    "date": "2016-07-21",
    "videoId": "7f_yiao16rA",
    "youtubeUrl": "https://www.youtube.com/watch?v=7f_yiao16rA",
    "productUrl": "https://audiojungle.net/item/superhero/16857041",
    "duration": "0:34"
  },
  {
    "title": "A Brighter Life",
    "description": "A magical, uplifting track featuring piano, orchestral strings, woodwind and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project magic or dreamy in nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, choir",
    "tags": "advert, advertising, atmospheric, bright, commercial, company, corporate, dream, enchanting. fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv, uplifting",
    "price": 16,
    "date": "2016-07-20",
    "videoId": "ZHyAnbGMWvk",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZHyAnbGMWvk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311470-A_Brighter_Life?ref=dreamnotemusic",
    "duration": "1:29"
  },
  {
    "title": "Creepy Music Box",
    "description": "A haunting, atmospheric horror track featuring music box and celesta. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers or YouTube videos.",
    "genre": "Horror",
    "instrumentation": "Music box, celesta",
    "tags": "child, creepy, dark, death, demented, demon, evil, film score, ghost, gothic, halloween, haunted, haunting, hell, horror, lullaby, murder, music box, night, nightmare, possessed, psycho, scary, scream, serial killer, soundtrack, spooky, suspense, thriller, trailer",
    "price": 14,
    "date": "2016-07-19",
    "videoId": "GVAUOUqSjns",
    "youtubeUrl": "https://www.youtube.com/watch?v=GVAUOUqSjns",
    "productUrl": "https://audiojungle.net/item/creepy-music-box/16798523",
    "duration": "0:33"
  },
  {
    "title": "Science",
    "description": "A modern, stylish, electronic track featuring a repeating piano motif surrounded by strings, soft atmospheric pads, bass and drums. Perfect for use in electronics adverts/commercials, TV themes, car promo videos, time-lapse/montage videos, Sci-fi movie/film soundtracks or any project with a technological/futuristic theme.",
    "genre": "Ambient",
    "instrumentation": "Piano, strings, synth pads, bass, drums",
    "tags": "advert, ambient, calm, chill, chillout, city, cityscape, digital, documentary, dreaming, dreamy, electronic, futuristic, modern, montage, nature, new-age, night, photography, relaxing, scenery, scenic, sci-fi, science, sleep, space, technology, thoughts, time-lapse, timelapse",
    "price": 24,
    "date": "2016-07-19",
    "videoId": "sNiXY74pBN4",
    "youtubeUrl": "https://www.youtube.com/watch?v=sNiXY74pBN4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803864-Science-2m04?ref=dreamnotemusic",
    "duration": "2:04"
  },
  {
    "title": "Tango Logo",
    "description": "A rhythmic ident/opener/jingle/intro in the style of the traditional dance featuring accordion, castanets, violins, piano, double bass and percussion. Ideal for use in YouTube dance lesson/tutorial videos, adverts/commercials, podcasts or as a TV/radio jingle.",
    "genre": "Classical",
    "instrumentation": "Accordion, castanets, violins, piano, double bass, percussion",
    "tags": "accordion, argentina, argentine tango, ballroom, dance, dance lessons, dance video, dancing, drama, dramatic, flamenco, holiday, ident, intro, jingle, latin, logo, love, opener, podcast, romantic, spanish, strictly, tango, teacher, tuition, vacation, video intro, vlog, youtube",
    "price": 8,
    "date": "2016-07-18",
    "videoId": "cY2FAbDZWt0",
    "youtubeUrl": "https://www.youtube.com/watch?v=cY2FAbDZWt0",
    "productUrl": "https://audiojungle.net/item/tango-logo/16775805",
    "duration": "0:06"
  },
  {
    "title": "Beautiful Wedding",
    "description": "An expressive, romantic track featuring piano, cello, acoustic guitar, orchestral strings, woodwind and choir. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, orchestral strings, woodwind, choir",
    "tags": "beautiful, believe, bride, ceremony, cinematic, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding",
    "price": 24,
    "date": "2016-07-12",
    "videoId": "ZBlbtooX9Qw",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZBlbtooX9Qw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483804-Beautiful-Wedding-2m05?ref=dreamnotemusic",
    "duration": "2:05"
  },
  {
    "title": "Creepy and Haunting",
    "description": "A dark, atmospheric, cinematic track featuring piano, music box, celesta, ethereal female vocals, sustained strings and sinister orchestral tones. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, female vocals, strings, orchestra",
    "tags": "atmospheric, creepy, dark, dead, death, evil, film score, ghost, girl, gothic, halloween, haunted house, haunting, hell, horror, murder, music box, mysterious, mystery, night, nightmare, possessed, scary, soundtrack, spooky, suspense, thriller, twisted, vocals, voice",
    "price": 20,
    "date": "2016-07-10",
    "videoId": "tFI_FMgoRsg",
    "youtubeUrl": "https://www.youtube.com/watch?v=tFI_FMgoRsg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756344-Creepy-and-Haunting-1m49?ref=dreamnotemusic",
    "duration": "1:49"
  },
  {
    "title": "Atmospheric and Emotional",
    "description": "A dark, cinematic movie soundtrack featuring piano with expressive orchestral strings and woodwind. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a haunting mood.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, death, deep, drama, dramatic, emotional, fantasy, film, forbidden, haunting, intense, love, lovers, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 20,
    "date": "2016-07-09",
    "videoId": "pVCvpct6lUs",
    "youtubeUrl": "https://www.youtube.com/watch?v=pVCvpct6lUs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311484-Atmospheric-and-Emotional-1m52?ref=dreamnotemusic",
    "duration": "1:52"
  },
  {
    "title": "Classical Loop",
    "description": "A traditional classical style loop featuring piano with orchestral strings and woodwind. Perfect for business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Piano with orchestral strings, woodwind",
    "tags": "answerphone, antiques, architecture, background music, bank, british, call waiting, classic, classical, drama, dramatic, english, historical, history, loop, looped, mozart, old, old-fashioned, on hold, orchestra, phone, phone call, piano, regal, royal, royalty, telephone, traditional, waiting",
    "price": 16,
    "date": "2016-07-07",
    "videoId": "O79puydX_Zs",
    "youtubeUrl": "https://www.youtube.com/watch?v=O79puydX_Zs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756385-Classical-Loop-0m59?ref=dreamnotemusic",
    "duration": "0:59"
  },
  {
    "title": "Family is Forever",
    "description": "An expressive, emotional track featuring piano and orchestra. Ideal for use in adverts/commercials, documentaries, charity campaigns, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, advertisement, beautiful, dreamy, emotional, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestral, peaceful, piano, romantic, sentimental, strings, time-lapse, uplifting, video, violins, warm, wedding",
    "price": 18,
    "date": "2016-07-06",
    "videoId": "NCx2vM8ztes",
    "youtubeUrl": "https://www.youtube.com/watch?v=NCx2vM8ztes",
    "productUrl": "https://audiojungle.net/item/family-is-forever/16543549",
    "duration": "1:26"
  },
  {
    "title": "Happy Baroque",
    "description": "A lively, traditional classical track featuring orchestral strings, woodwind and harpsichord. Perfect for adverts/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, harpsichord",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 16,
    "date": "2016-07-04",
    "videoId": "V9OCAdSqw2U",
    "youtubeUrl": "https://www.youtube.com/watch?v=V9OCAdSqw2U",
    "productUrl": "https://audiojungle.net/item/happy-baroque/16514657",
    "duration": "1:09"
  },
  {
    "title": "Classical Logo",
    "description": "A happy, lively ident/opener/jingle/intro featuring classical-style piano with light orchestral strings. Ideal for use in YouTube videos/vlogs, adverts/commercials, history documentaries, company presentations or as a TV/radio jingle.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, antique, british, classic, classical, documentary, english, fun, happy, historical, history, ident, intro, jingle, logo, mozart, old, old fashioned, opener, period drama, podcast, radio, stately home, theme, traditional, tv, twee, video intro, vlog, youtube",
    "price": 8,
    "date": "2016-07-02",
    "videoId": "5bRUdbSxjKk",
    "youtubeUrl": "https://www.youtube.com/watch?v=5bRUdbSxjKk",
    "productUrl": "https://audiojungle.net/item/classical-logo/16487214",
    "duration": "0:08"
  },
  {
    "title": "Fairground",
    "description": "A fun, jolly circus theme featuring barrel organ, accordion, brass, bass and drums. Perfect for use in TV, movies/films, comedy shows, YouTube videos or any circus/fairground themed project.",
    "genre": "Comedy",
    "instrumentation": "Barrel organ, accordion, brass, bass, percussion",
    "tags": "amusement park, amusements, arcade, carnival, carousel, cheesy, children, circus, clown, comedy, corny, fair, fairground, fairground ride, festival, fun, funny, happy, kids, organ, quirky, retro, ride, rides, seaside, showground, summer, themepark, upbeat, vintage",
    "price": 16,
    "date": "2016-07-01",
    "videoId": "bwazikfhKeI",
    "youtubeUrl": "https://www.youtube.com/watch?v=bwazikfhKeI",
    "productUrl": "https://audiojungle.net/item/fairground/16472239",
    "duration": "1:11"
  },
  {
    "title": "Baroque Advert",
    "description": "A rhythmic, dramatic traditional classical track featuring orchestral strings, harpsichord, piano, woodwind and choir. Perfect for TV/radio adverts/commercials, documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, piano, woodwind, choir",
    "tags": "advert, advertising, antiques, architecture, bank, baroque, british, classic, classical, countdown, documentary, drama, dramatic, english, exciting, historical, history, intense, old, old-fashioned, period drama, powerful, proud, regal, renaissance, royal, royalty, stately, traditional, tv",
    "price": 16,
    "date": "2016-06-29",
    "videoId": "TpCfWXBP2Kk",
    "youtubeUrl": "https://www.youtube.com/watch?v=TpCfWXBP2Kk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483226-Baroque-Advert-0m46?ref=dreamnotemusic",
    "duration": "0:46"
  },
  {
    "title": "Magical Background",
    "description": "A dreamy, quirky and inspirational track featuring pianos, strings, choir, percussion and glockenspiel. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a hopeful or optimistic nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, strings, choir, percussion, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 16,
    "date": "2016-06-24",
    "videoId": "dWNpeinNBuw",
    "youtubeUrl": "https://www.youtube.com/watch?v=dWNpeinNBuw",
    "productUrl": "https://audiojungle.net/item/magical-background/16337055",
    "duration": "1:47"
  },
  {
    "title": "Beautiful Memories",
    "description": "An inspiring, emotional and sentimental track featuring piano accompanied by expressive violins, cellos, sustained orchestral woodwind, brass and percussion. Ideal for use in movie/film soundtracks, TV, adverts/commercials, photo slideshows, wedding videos or any project of a reflective or heartfelt nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, percussion",
    "tags": "charming, delightful, dreams, dreamy, emotional, family, heartfelt, hope, hopeful, inspirational, inspiring, life, love, love scene, lovely, melancholy, memories, moving, nature, piano, reflective, rich, romantic, sentimental, strings, tender, uplifting, valentines, violins, wedding",
    "price": 20,
    "date": "2016-06-22",
    "videoId": "MzTdDC3tCKw",
    "youtubeUrl": "https://www.youtube.com/watch?v=MzTdDC3tCKw",
    "productUrl": "https://audiojungle.net/item/beautiful-memories/16301549",
    "duration": "2:25"
  },
  {
    "title": "Creepy Horror Background",
    "description": "A twisted, dark, scary track featuring atmospheric drones, eerie sound effects and haunting orchestral strings. Perfect for use in horror movie scenes/trailers, film scores, ghost story audiobooks, book trailer, thrillers or video games.",
    "genre": "Horror",
    "instrumentation": "Orchestral strings, sound effects",
    "tags": "atmospheric, background, book trailer, creepy, dark, dead, death, evil, freaky, ghost, ghostly, gothic, halloween, haunted, haunting, hell, horror, movie, murder, mysterious, mystery, night, scary, soundscape, soundtrack, spooky, suspense, terror, thriller, twisted",
    "price": 20,
    "date": "2016-06-21",
    "videoId": "WyNJxMqoqmU",
    "youtubeUrl": "https://www.youtube.com/watch?v=WyNJxMqoqmU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756388-Creepy-Horror-Background?ref=dreamnotemusic",
    "duration": "1:57"
  },
  {
    "title": "Baroque History",
    "description": "A lively, dramatic traditional classical track featuring orchestral strings, harpsichord and woodwind. Perfect for documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, woodwind",
    "tags": "advert, advertising, allegro, antiques, bach, baroque, british, classic, classical, documentary, drama, heritage, historical, history, italian, lively, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 16,
    "date": "2016-06-20",
    "videoId": "V3Fapa9FJM8",
    "youtubeUrl": "https://www.youtube.com/watch?v=V3Fapa9FJM8",
    "productUrl": "https://audiojungle.net/item/baroque-history/16273670",
    "duration": "1:10"
  },
  {
    "title": "Country Ident",
    "description": "An American country music ident/opener/jingle/intro featuring banjo, slide guitar, harmonica and upright bass. Perfect for use as an intro/opening for YouTube videos/vlogs, apps, TV adverts/commercials, comedy sketches, podcasts or as a TV/radio jingle.",
    "genre": "Acoustic",
    "instrumentation": "Banjo, slide guitar, harmonica, upright bass",
    "tags": "acoustic guitar, america, american, americana, banjo, catchy, comedy, country, country intro, country music, folk, fun, funny, happy, harmonica, ident, intro, jingle, line dancing, line-dancing, logo, opener, quirky, redneck, slide guitar, southern, steel guitar, usa, vlog, youtube",
    "price": 10,
    "date": "2016-06-20",
    "videoId": "2hS2JHsgXHE",
    "youtubeUrl": "https://www.youtube.com/watch?v=2hS2JHsgXHE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756386-Country-Ident?ref=dreamnotemusic",
    "duration": "0:07"
  },
  {
    "title": "Dreamy Time-lapse",
    "description": "An ambient, soothing, atmospheric track featuring soft pianos, synth pads and sustained strings. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Pianos, synth pads, strings",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse, timelapse",
    "price": 24,
    "date": "2016-06-18",
    "videoId": "QBrKlE4HEJI",
    "youtubeUrl": "https://www.youtube.com/watch?v=QBrKlE4HEJI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781406-Dreamy-Time-lapse-2m53?ref=dreamnotemusic",
    "duration": "2:53"
  },
  {
    "title": "English Country Cottage",
    "description": "A charming, traditional track featuring piano, orchestral strings, woodwind and brass. Perfect for adverts/commercials, documentaries, period dramas, nature/country living videos, baking/cooking channels or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, baking, beautiful, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, cute, Daytime TV, documentary, english, farming, happy, housewife, innocent, kitchen, light-hearted, nature, nice, playful, sweet, traditional, twee, youtube",
    "price": 20,
    "date": "2016-06-13",
    "videoId": "9CKYKNXtZG8",
    "youtubeUrl": "https://www.youtube.com/watch?v=9CKYKNXtZG8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784094-English-Country-Cottage-1m20?ref=dreamnotemusic",
    "duration": "1:20"
  },
  {
    "title": "Magical Advert",
    "description": "An uplifting and inspirational track featuring piano, orchestral strings, choir and glockenspiel. Ideal for use in TV/radio adverts/commercials, fantasy film/movie soundtracks, animations or any project of a magical or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 20,
    "date": "2016-06-11",
    "videoId": "fPPf8DxYa_A",
    "youtubeUrl": "https://www.youtube.com/watch?v=fPPf8DxYa_A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796452-Magical-Advert-1m02?ref=dreamnotemusic",
    "duration": "1:02"
  },
  {
    "title": "Sentimental",
    "description": "A beautiful and hopeful track featuring piano, expressive orchestral strings, acoustic guitar and cello. Ideal for use in adverts/commercials, birth announcements, photo slide-shows, family videos or any project of a magical or dreamy nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, acoustic guitar, cello",
    "tags": "advert, baby, beautiful, birth, children, commercial, dream, dreamy, family, gallery, happy, home, hopeful, innocence, innocent, inspirational, inspiring, kids, magical, new, photo, positive, romance, romantic, sentimental, slideshow, soft, sweet, tv, wedding",
    "price": 20,
    "date": "2016-06-09",
    "videoId": "30u7bFYzTns",
    "youtubeUrl": "https://www.youtube.com/watch?v=30u7bFYzTns",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803959-Sentimental-1m06?ref=dreamnotemusic",
    "duration": "1:06"
  },
  {
    "title": "Tango",
    "description": "A rhythmic track in the style of the traditional dance featuring accordion, castanets, violins, piano, double bass and percussion. Perfect for dance routines, resort promotional videos, vacation documentaries, family holiday videos, YouTube or any project needing a traditional tango backing.",
    "genre": "Classical",
    "instrumentation": "Accordion, castanets, violins, piano, double bass, percussion",
    "tags": "accordion, argentina, argentine tango, ballroom, competition, cruise, dance, dance routine, dancing, documentary, drama, dramatic, exhibition, family videos, fiery, flamenco, holiday, latin, love, passionate, resort, romance, romantic, spanish, strictly, tango, traditional, vacation, violins, wedding",
    "price": 16,
    "date": "2016-06-09",
    "videoId": "o7vCcx7ZjwA",
    "youtubeUrl": "https://www.youtube.com/watch?v=o7vCcx7ZjwA",
    "productUrl": "https://audiojungle.net/item/tango/16117757",
    "duration": "1:49"
  },
  {
    "title": "Game Timer",
    "description": "A ticking clock effect along with a tense, dramatic background. Ideal for TV game/quiz shows, news channel reports, computer games/apps, animations or as a timer/countdown.",
    "genre": "Corporate",
    "instrumentation": "Synth, percussion",
    "tags": "30 second, answer, app, challenge, clock, competition, countdown, dramatic, game, game show, games, gameshow, headlines, intense, new year, news, question, questionnaire, questions, quiz, stopclock, stopwatch, tense, tension, thinking, ticking, ticktock, time, timer, tv",
    "price": 20,
    "date": "2016-06-07",
    "videoId": "B-Alb0kpwM4",
    "youtubeUrl": "https://www.youtube.com/watch?v=B-Alb0kpwM4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786797-Game-Timer-1m06?ref=dreamnotemusic",
    "duration": "1:06"
  },
  {
    "title": "Space and Time",
    "description": "An ambient, soothing, dreamy track with soft pianos, atmospheric synth pads and subtle drums. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, drums",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 24,
    "date": "2016-06-05",
    "videoId": "0KuPJ8Xdxgg",
    "youtubeUrl": "https://www.youtube.com/watch?v=0KuPJ8Xdxgg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804128-Space-and-Time-3m02?ref=dreamnotemusic",
    "duration": "3:02"
  },
  {
    "title": "Quirky Mysterious Background",
    "description": "An atmospheric comedy track featuring pizzicato violins, clarinet, orchestral woodwind, glockenspiel, xylophone, bass and percussion. Perfect for computer games/apps, adverts/commercials, TV dramas/reality shows, comedy films/movies or YouTube videos/vlogs.",
    "genre": "Comedy",
    "instrumentation": "Violins, clarinet, orchestral woodwind, glockenspiel, xylophone, bass, percussion",
    "tags": "advert, app, background, cleaning, comedic, comedy, comedy drama, comedy movie, commercial, computer game, Daytime TV, fun, funny, gag, game, happy, humor, humour, humourous, lifestyle, lively, playful, playing, quirky, reality show, reality TV, silly, stupid, vlog, youtube",
    "price": 20,
    "date": "2016-06-01",
    "videoId": "GeXSsb9YzMs",
    "youtubeUrl": "https://www.youtube.com/watch?v=GeXSsb9YzMs",
    "productUrl": "https://audiojungle.net/item/quirky-mysterious-background/16064184",
    "duration": "2:03"
  },
  {
    "title": "Baroque Loop",
    "description": "A traditional baroque/classical style loop featuring violins, violas, cellos, double basses and trumpet. Perfect for business on-hold/call waiting telephone systems/phone answering machines.",
    "genre": "Classical",
    "instrumentation": "Strings, violins, violas, cellos, double basses, trumpet",
    "tags": "answerphone, antiques, architecture, background music, bank, baroque, british, call waiting, classic, classical, drama, dramatic, english, historical, history, loop, looped, old, old-fashioned, on hold, orchestra, phone, phone call, regal, renaissance, royal, royalty, telephone, traditional, waiting",
    "price": 16,
    "date": "2016-05-30",
    "videoId": "2jLjt6gxJKM",
    "youtubeUrl": "https://www.youtube.com/watch?v=2jLjt6gxJKM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483377-Baroque-Loop-0m45?ref=dreamnotemusic",
    "duration": "0:45"
  },
  {
    "title": "Cinematic Advert",
    "description": "An uplifting, magical and inspiring track featuring piano with orchestral strings, woodwind and brass. Ideal for use in adverts/commercials, documentaries, trailers, movie/film soundtracks, charity campaigns or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "accomplish, achieve, adventure, advert, advertising, beautiful, believe, campaign, charity, cinematic, commercial, documentary, dream, emotional, faith, fantasy, hope, hopeful, inspirational, inspiring, journey, magic, magical, movie, moving, religion, story, thought-provoking, trailer, uplifting",
    "price": 20,
    "date": "2016-05-30",
    "videoId": "vMGm8hGw-sQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=vMGm8hGw-sQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756467-Cinematic-Advert-1m53?ref=dreamnotemusic",
    "duration": "1:53"
  },
  {
    "title": "Dark Cinematic Strings",
    "description": "An atmospheric, dramatic track featuring orchestral violins, violas, cellos and double basses. Perfect for use in movie/film/game trailers, soundtracks, advertising or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings",
    "tags": "action, atmospheric, background, book trailer, cinematic, classical, dark, drama, dramatic, emotional, epic, film trailer, game trailer, haunting, inspirational, inspiring, movie, movie trailer, mysterious, mystery, orchestra, soundtrack, strings, teaser, tense, thriller, trailer, underscore, uplifting, violins",
    "price": 24,
    "date": "2016-05-29",
    "videoId": "WhhnAtEe-jg",
    "youtubeUrl": "https://www.youtube.com/watch?v=WhhnAtEe-jg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781536-Dark-Cinematic-Strings-2m21?ref=dreamnotemusic",
    "duration": "2:21"
  },
  {
    "title": "Magical World",
    "description": "An inspiring, uplifting track featuring piano with orchestral strings, woodwind and brass. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, corporate presentations or any project of a hopeful or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, dreamy, fantasy, finance, future, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 14,
    "date": "2016-05-25",
    "videoId": "hbR9Mu-yPBw",
    "youtubeUrl": "https://www.youtube.com/watch?v=hbR9Mu-yPBw",
    "productUrl": "https://audiojungle.net/item/magical-world/15949782",
    "duration": "1:32"
  },
  {
    "title": "Funny Piano",
    "description": "A fast, lively comedy track featuring solo piano Perfect for comedy compilation/bloopers videos, YouTube vlogs, computer games/apps, cartoons/animations or adverts/commercials.",
    "genre": "Comedy",
    "instrumentation": "Piano",
    "tags": "animation, app, bloopers, cartoon, cheerful, cheesy, comedian, comedy, fun, funny, gag reel, game, happy, honytonk, jazz piano, kids, party, piano, piano rag, platform, playful, pub piano, quirky, ragtime, saloon piano, scott joplin, slient movie, spoof, tack piano",
    "price": 14,
    "date": "2016-05-24",
    "videoId": "TK2dUowkf9g",
    "youtubeUrl": "https://www.youtube.com/watch?v=TK2dUowkf9g",
    "productUrl": "https://audiojungle.net/item/funny-piano/15937414",
    "duration": "0:55"
  },
  {
    "title": "Horror Music Box",
    "description": "A creepy, haunting track featuring music box and celesta with a dark accompaniment and ghostly sound effects (version included without sound effects). Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Music box, celesta, sound effects",
    "tags": "child, creepy, dark, death, demented, demon, evil, film score, ghost, gothic, halloween, haunted, haunting, hell, horror, lullaby, murder, music box, night, nightmare, possessed, psycho, scary, scream, serial killer, soundtrack, spooky, suspense, thriller, trailer",
    "price": 18,
    "date": "2016-05-21",
    "videoId": "IF9-vh27k5k",
    "youtubeUrl": "https://www.youtube.com/watch?v=IF9-vh27k5k",
    "productUrl": "https://audiojungle.net/item/horror-music-box/15922558",
    "duration": "1:37"
  },
  {
    "title": "Atmospheric Cinematic",
    "description": "An emotional, passionate track featuring expressive orchestral strings, woodwind and brass. Perfect for use in movie/film/game trailers, soundtracks, advertising or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, woodwind, brass",
    "tags": "atmospheric, believe, charity, cinematic, dark, dramatic, dream, epic, fantasy, film trailer, game trailer, grand, honor, honour, hope, hopeful, inspirational, inspiring, journey, military, movie trailer, proud, soundtrack, space, strings, teaser, thriller, trailer, uplifting, wonder",
    "price": 24,
    "date": "2016-05-18",
    "videoId": "ieQXsH7G0w4",
    "youtubeUrl": "https://www.youtube.com/watch?v=ieQXsH7G0w4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311519-Atmospheric-Cinematic-2m42?ref=dreamnotemusic",
    "duration": "2:42"
  },
  {
    "title": "Happy School Kids",
    "description": "A fun, upbeat track featuring glockenspiel, recorder, ukulele, guitar, cheerful whistling, hand-claps, piano and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, recorder, ukulele, guitar, whistling, percussion, piano, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 14,
    "date": "2016-05-18",
    "videoId": "poLCUKXP26I",
    "youtubeUrl": "https://www.youtube.com/watch?v=poLCUKXP26I",
    "productUrl": "https://audiojungle.net/item/happy-school-kids/15898230",
    "duration": "0:28"
  },
  {
    "title": "Cute Kids' Background",
    "description": "A fun, happy track featuring upbeat ukulele, glockenspiel, piano and bass. This bright, playful track is perfect for children’s TV shows, kids' cartoons/animations, computer games/apps, commercials/adverts, YouTube vlogs/videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Ukulele, glockenspiel, piano, bass",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 16,
    "date": "2016-05-17",
    "videoId": "lMRy9IioknQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=lMRy9IioknQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756487-Cute-Kids-Background-0m46?ref=dreamnotemusic",
    "duration": "0:46"
  },
  {
    "title": "Country Barn Dance",
    "description": "Banjo, violin (fiddle), acoustic guitars, slide guitars, dobro, harmonica, upright bass, drums, foot stomps and claps, blending elements of American folk and bluegrass music. Perfect for TV, adverts/commercials, YouTube videos, computer games/apps, animations or any country-themed project.",
    "genre": "Acoustic",
    "instrumentation": "Banjo, violin, acoustic guitar, slide guitar, dobro, harmonica, upright bass, drums",
    "tags": "acoustic guitar, america, american, americana, banjo, barn dance, boogie, bright, cartoon, catchy, cheerful, comedy, country, country music, farmer, fiddle, folk, fun, funny, happy, joyful, lively, positive, quirky, redneck, slide guitar, southern, steel guitar, upbeat, usa",
    "price": 24,
    "date": "2016-05-14",
    "videoId": "vBx4o0JOplo",
    "youtubeUrl": "https://www.youtube.com/watch?v=vBx4o0JOplo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756517-Country-Barn-Dance-2m22?ref=dreamnotemusic",
    "duration": "2:22"
  },
  {
    "title": "Fashion",
    "description": "A cool, hip electronic dance-influenced track featuring drums, bass and synths. Perfect for fashion/clothes shows, TV adverts/commercials, YouTube celebrity/fashion videos, slide-show presentations or any project with a modern, chic, cosmopolitan vibe.",
    "genre": "Corporate",
    "instrumentation": "Synth, bass, drums",
    "tags": "advertising, attitude, catwalk, celebrity, chic, clothes show, club, commercial, cool, dance, designer, disco, famous, fashion, fashion show, funk, funky, glamour, gossip, groovy, model, modelling, nightclub, party, photo shoot, promo, runway, slideshow, style, trendy",
    "price": 24,
    "date": "2016-05-12",
    "videoId": "WX85jKEVAiU",
    "youtubeUrl": "https://www.youtube.com/watch?v=WX85jKEVAiU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785527-Fashion-2m06?ref=dreamnotemusic",
    "duration": "2:06"
  },
  {
    "title": "Motivational",
    "description": "A positive, optimistic track featuring a lively, rhythmic orchestral strings motif with piano, guitars, bass and drums. Ideal for use in TV/radio adverts/commercials, corporate promotional material, holiday/vacation videos or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Orchestral strings, piano, guitars, bass, drums",
    "tags": "achievement, advert, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, gap year, holiday, inspiration, inspirational, inspiring, marketing, motivation, motivational, optimistic, positive, presentation, progress, promotional, success, successful, upbeat, uplifting, vacation",
    "price": 24,
    "date": "2016-05-08",
    "videoId": "nnuurPWuMB8",
    "youtubeUrl": "https://www.youtube.com/watch?v=nnuurPWuMB8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796607-Motivational-2m15?ref=dreamnotemusic",
    "duration": "2:15"
  },
  {
    "title": "Life is Beautiful",
    "description": "An optimistic, expressive track featuring orchestral strings, woodwind, piano, harp and choir. Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks or any project of a magical or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Orchestral strings, woodwind, piano, harp, choir",
    "tags": "advert, advertising, bank, bright, business, commercial, corporate, dream, enchanting, family, fantasy, finance, future, happy, hopeful, innocent, inspirational, life, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, quirky, tv, wonder",
    "price": 20,
    "date": "2016-05-05",
    "videoId": "yZmuyy2l2uE",
    "youtubeUrl": "https://www.youtube.com/watch?v=yZmuyy2l2uE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795162-Life-is-Beautiful-1m40?ref=dreamnotemusic",
    "duration": "1:40"
  },
  {
    "title": "Toy Soldiers",
    "description": "A fun, happy military-influenced kids track featuring marching snare-drum, glockenspiel, whistling, piano, orchestral strings, woodwind and brass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, YouTube videos or any project with a military theme.",
    "genre": "Children's",
    "instrumentation": "Snare-drum, glockenspiel, piano, orchestral strings, woodwind, brass",
    "tags": "action, animation, app, army, cartoon, child, children, cute, education, fun, game, games, happy, hero, history, kids, learning, marching, marching band, military, Mother Goose, Nursery Rhyme, party, playful, playtime, school, snare-drum, soldier, toy, tv",
    "price": 16,
    "date": "2016-05-03",
    "videoId": "9XTxsaBUC-c",
    "youtubeUrl": "https://www.youtube.com/watch?v=9XTxsaBUC-c",
    "productUrl": "https://audiojungle.net/item/toy-soldiers/15708033",
    "duration": "1:36"
  },
  {
    "title": "Spooky Horror Story",
    "description": "A dark, creepy, cinematic track featuring piano with eerie, sustained strings. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games, YouTube videos or any project with a mysterious, sinister tone.",
    "genre": "Horror",
    "instrumentation": "Piano, orchestral strings",
    "tags": "atmospheric, creepy, dark, dead, death, demented, demon, eerie, evil, film score, ghost, gothic, halloween, haunted house, haunting, hell, horror, murder, mysterious, mystery, night, nightmare, possessed, psycho, scary, soundtrack, spooky, suspense, thriller, twisted",
    "price": 20,
    "date": "2016-05-02",
    "videoId": "Bw8tU5LMl34",
    "youtubeUrl": "https://www.youtube.com/watch?v=Bw8tU5LMl34",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804206-Spooky-Horror-Story-1m50?ref=dreamnotemusic",
    "duration": "1:50"
  },
  {
    "title": "Just Believe",
    "description": "An inspiring, hopeful track featuring piano with orchestral strings, brass and woodwind. Ideal for use in adverts/commercials, documentaries, trailers/soundtracks, movies/films, videos of a religious/spiritual nature, charity appeals or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, brass, woodwind",
    "tags": "advert, atmospheric, belief, believe, charity, church, cinematic, documentary, dream, dreamer, emotional, faith, fantasy, god, hope, hopeful, inspirational, inspiring, journey, magical, moving, religion, religious, soundtrack, spiritual, story, thought-provoking, trailer, uplifting, worship",
    "price": 24,
    "date": "2016-04-27",
    "videoId": "O1NRaC6WR-0",
    "youtubeUrl": "https://www.youtube.com/watch?v=O1NRaC6WR-0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795240-Just-Believe-2m09?ref=dreamnotemusic",
    "duration": "2:09"
  },
  {
    "title": "Happy Kids",
    "description": "Happy Kids' is a fun, cute children’s track featuring glockenspiel, piano, flute and bass. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, piano, flute, bass",
    "tags": "animal, animation, app, background, bloopers, bright, cartoon, catchy, cheerful, children, comedy, cute, fun, funny, game, happy, holiday, kids, kids tv, party, play, playful, playtime, quirky, school, simple, tv, tv theme, vacation, youtube",
    "price": 24,
    "date": "2016-04-24",
    "videoId": "jqT_bNvWCas",
    "youtubeUrl": "https://www.youtube.com/watch?v=jqT_bNvWCas",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786947-Happy-Kids-2m03?ref=dreamnotemusic",
    "duration": "2:03"
  },
  {
    "title": "Just Imagine",
    "description": "A beautiful, expressive track featuring piano with orchestral strings, woodwind, brass and percussion. An ideal backing for advertisements, documentaries, wedding videos, family videos, photo slide shows or a video montage.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, family tree, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2016-04-13",
    "videoId": "NGI713OfDfc",
    "youtubeUrl": "https://www.youtube.com/watch?v=NGI713OfDfc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795283-Just-Imagine-2m37?ref=dreamnotemusic",
    "duration": "2:37"
  },
  {
    "title": "Cool Jazz Logo",
    "description": "A swing jazz ident/opener/jingle/intro featuring piano, muted trumpet, vibraphone, flute, bass and drums. Ideal for use in YouTube videos/vlogs, adverts/commercials, comedy shows/podcasts or as a TV/radio jingle.",
    "genre": "Jazz",
    "instrumentation": "Piano, muted trumpet, vibraphone, flute, bass, drums",
    "tags": "advert, advertising, comedy, commercial, cool, fun, funk, funky, funny, gameshow, happy, ident, intro, jazz, jazzy, jingle, logo, opener, podcast, quirky, radio, retro, sitcom, talk show, theme, theme tune, tv, video intro, vlog, youtube",
    "price": 10,
    "date": "2016-04-12",
    "videoId": "tFbONAU-zsE",
    "youtubeUrl": "https://www.youtube.com/watch?v=tFbONAU-zsE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/200256545-Cool-Jazz-Logo?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Fighting Spirit",
    "description": "A fast, positive rock track with plenty of drive and enthusiasm, featuring electric distortion guitars, drums, bass and strings. Perfect for advertising, sports videos or any project with a lively, energetic feel.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, drums, bass, strings",
    "tags": "action, adventure, advert, advertising, commercial, confident, driven, driving, electric, energetic, exciting, extreme sports, fun, gap year, holiday, loud, marketing, motivational, positive, powerful, racing, rock, rock band, rock climbing, skateboarding, skiing, snowboarding, travel, vacation, Water Sports",
    "price": 24,
    "date": "2016-04-09",
    "videoId": "d3IY1sGBzbQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=d3IY1sGBzbQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785621-Fighting-Spirit-2m38?ref=dreamnotemusic",
    "duration": "2:38"
  },
  {
    "title": "Victorious",
    "description": "A patriotic and inspiring track featuring strings, woodwind, brass, piano, choir, snare-drum and orchestral percussion. Perfect for sporting events, competitions, graduation/awards ceremonies, military videos, movies/film/TV or any project majestic or dramatic in nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, woodwind, brass, piano, choir, snare-drum, orchestral percussion",
    "tags": "adventure, anthem, awards, british, ceremony, competition, dramatic, english, epic, fireworks, game, games, graduation, hero, honour, independence day, inspirational, inspiring, majestic, military, motivational, orchestral, patriotic, powerful, pride, regal, royal, snare-drum, sporting, sports",
    "price": 20,
    "date": "2016-04-05",
    "videoId": "gdjULk4v3L8",
    "youtubeUrl": "https://www.youtube.com/watch?v=gdjULk4v3L8",
    "productUrl": "https://audiojungle.net/item/victorious/15346007",
    "duration": "2:42"
  },
  {
    "title": "Believe in the Magic",
    "description": "An enchanting, atmospheric track featuring piano, harp, orchestral strings, choir and glockenspiel (simplified version also included). Ideal for use in adverts/commercials, TV, fantasy film/movie soundtracks, children’s animations or any project of a magical or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, harp, orchestral strings, choir, glockenspiel",
    "tags": "advert, advertising, bank, bright, business, commercial, corporate, dream, family, fantasy, finance, future, happy, hopeful, innocent, inspirational, kids, life, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, quirky, tv, wonder",
    "price": 18,
    "date": "2016-03-31",
    "videoId": "R8xCFrJTHLk",
    "youtubeUrl": "https://www.youtube.com/watch?v=R8xCFrJTHLk",
    "productUrl": "https://audiojungle.net/item/believe-in-the-magic/15263417",
    "duration": "1:23"
  },
  {
    "title": "A Magical Life",
    "description": "A bright, inspirational track featuring pianos, strings, choir, percussion and glockenspiel. Ideal for use in TV/radio adverts/commercials, fantasy film/movie soundtracks, animations or any project of a magical or dreamy nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, strings, choir, percussion, glockenspiel",
    "tags": "advert, advertising, bank, banking, bright, business, commercial, company, corporate, dream, fantasy, finance, future, happy, hopeful, innocent, inspirational, invest, investment, magic, magical, marketing, money, optimistic, positive, product, promo, promotional, sales, tv",
    "price": 20,
    "date": "2016-03-28",
    "videoId": "G7uBdcNR-5Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=G7uBdcNR-5Y",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201166832-A-Magical-Life-1m29?ref=dreamnotemusic",
    "duration": "1:29"
  },
  {
    "title": "Uplifting Advert",
    "description": "An inspirational cinematic track featuring piano and orchestra. Ideal for use in adverts/commercials, documentaries, movie/film soundtracks/trailers, travel videos, corporate presentations or any project requiring a motivational, thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, hope, inspirational, journey, magical, motivational, movie, moving, powerful, religious, success, thought-provoking, trailer, travel, triumph, uplifting, win, wonder",
    "price": 20,
    "date": "2016-03-26",
    "videoId": "jwXcNdEbwjw",
    "youtubeUrl": "https://www.youtube.com/watch?v=jwXcNdEbwjw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806797-Uplifting-Advert-1m01?ref=dreamnotemusic",
    "duration": "1:01"
  },
  {
    "title": "Calm Piano Logo",
    "description": "Subtle, calm and atmospheric, this piano logo/ident/opener/intro would suit a variety of uses, including advertising, company business projects and YouTube videos.",
    "genre": "Corporate",
    "instrumentation": "Piano",
    "tags": "advert, advertisement, advertising, atmospheric, beautiful, bright, business, calm, classic, classy, clean, company, corporate, elegant, emotional, flash intro, ident, inspirational, inspiring, intro, jingle, logo, modern, opener, presentation, product, smooth, theme, vlog, youtube",
    "price": 10,
    "date": "2016-03-25",
    "videoId": "e-IwL4ciTUo",
    "youtubeUrl": "https://www.youtube.com/watch?v=e-IwL4ciTUo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756526-Calm-Piano-Logo?ref=dreamnotemusic",
    "duration": "Length TBC"
  },
  {
    "title": "Magical Vocal Fantasy",
    "description": "A beautiful, dreamy track featuring angelic female voice with atmospheric orchestral strings and piano (Instrumental version also included). Perfect for use in movies/films, TV/game soundtracks, book trailers, adverts/commercials or any magical/fantasy scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Female voice, piano, orchestral strings, woodwind",
    "tags": "adventure, advert, angelic, animation, atmospheric, beautiful, book trailer, cartoon, cinematic, dream, dreamy, enchanted, fairies, fairytale, fantasy, female vocal, female voice, film, flying, girl, heavenly, hopeful, innocent, magic, magical, movie, singer, trailer, wonder, wonderland",
    "price": 14,
    "date": "2016-03-17",
    "videoId": "KUU5PfDfun4",
    "youtubeUrl": "https://www.youtube.com/watch?v=KUU5PfDfun4",
    "productUrl": "https://audiojungle.net/item/magical-vocal-fantasy/15065291",
    "duration": "1:31"
  },
  {
    "title": "Simple Background",
    "description": "A subtle, optimistic track featuring a repeating motif surrounded by warm synth pads, strings, piano, bass, and percussion. Ideal for use in corporate promotional material, business presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Synth, strings, piano, bass, percussion",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, soft, success, successful, uplifting",
    "price": 24,
    "date": "2016-03-16",
    "videoId": "GhNIeHjseGY",
    "youtubeUrl": "https://www.youtube.com/watch?v=GhNIeHjseGY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804239-Simple-Background-2m03?ref=dreamnotemusic",
    "duration": "2:03"
  },
  {
    "title": "Kids' TV Theme",
    "description": "A fun, happy theme-tune featuring upbeat ukulele, guitar, cheerful whistling, hand-claps, piano, recorder, bass and glockenspiel. This bright, playful track is perfect for TV shows, kids' cartoons/animations, computer games/apps, children’s party games, commercials/adverts, family vacation/YouTube videos or any project with a positive, feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Ukulele, guitar, whistling, percussion, piano, recorder, bass, glockenspiel",
    "tags": "animation, app, bright, cartoon, catchy, cheerful, children, comedy, fun, funny, game, happy, holiday, ident, intro, kids, kids tv, logo, party, play, playful, quirky, school, theme tune, tv, tv theme, upbeat, vacation, video intro, youtube",
    "price": 16,
    "date": "2016-03-14",
    "videoId": "eUGDN4n0AvM",
    "youtubeUrl": "https://www.youtube.com/watch?v=eUGDN4n0AvM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794801-Kids-TV-Theme-0m20?ref=dreamnotemusic",
    "duration": "0:20"
  },
  {
    "title": "Haunting Horror Theme",
    "description": "A dark, creepy, cinematic track featuring piano, music box, celesta and eerie, sustained violins. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games, YouTube videos or any project with a spooky, sinister tone.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, violins",
    "tags": "atmospheric, creepy, dark, dead, death, demented, demon, evil, film score, ghost, gothic, halloween, haunted house, haunting, hell, horror, murder, music box, mysterious, mystery, night, nightmare, possessed, psycho, scary, serial killer, soundtrack, spooky, suspense, thriller",
    "price": 20,
    "date": "2016-03-12",
    "videoId": "w1W52CUkis4",
    "youtubeUrl": "https://www.youtube.com/watch?v=w1W52CUkis4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786897-Haunting-Horror-Theme-1m40?ref=dreamnotemusic",
    "duration": "1:40"
  },
  {
    "title": "Inspiring Advert",
    "description": "An uplifting, commercial track featuring piano and orchestra. Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, travel videos, corporate presentations or any project requiring a motivational, though-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra, choir",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, hope, inspirational, journey, magical, motivational, movie, moving, powerful, religious, success, thought-provoking, trailer, travel, triumph, uplifting, win, wonder",
    "price": 20,
    "date": "2016-03-11",
    "videoId": "GWKbeyQvbEw",
    "youtubeUrl": "https://www.youtube.com/watch?v=GWKbeyQvbEw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793969-Inspiring-Advert-1m00?ref=dreamnotemusic",
    "duration": "1:00"
  },
  {
    "title": "A Moment in Time",
    "description": "An ambient, soothing track featuring atmospheric piano, cello and dreamy orchestral strings. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, cello, orchestral strings",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 24,
    "date": "2016-03-09",
    "videoId": "jxXQTInFAaY",
    "youtubeUrl": "https://www.youtube.com/watch?v=jxXQTInFAaY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311645-A-Moment-in-Time-2m46?ref=dreamnotemusic",
    "duration": "2:46"
  },
  {
    "title": "Country Logo",
    "description": "An American country music ident/opener/jingle/intro featuring acoustic guitars, slide guitars, banjo, drums, foot stomps and claps (versions included without drums). Perfect for use as an opening theme for YouTube videos/vlogs, apps, TV adverts/commercials, comedy sketches, podcasts or as a TV/radio jingle.",
    "genre": "Acoustic",
    "instrumentation": "Acoustic guitar, slide guitar, banjo, drums",
    "tags": "acoustic guitar, america, american, americana, banjo, catchy, cheerful, comedy, country, folk, fun, funny, happy, ident, intro, jingle, line dancing, line-dancing, lively, logo, opener, quirky, redneck, slide guitar, southern, steel guitar, upbeat, usa, vlog, youtube",
    "price": 10,
    "date": "2016-03-09",
    "videoId": "J0zSPAgp-c0",
    "youtubeUrl": "https://www.youtube.com/watch?v=J0zSPAgp-c0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756512-Country-Logo-0m10?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Baroque Logo",
    "description": "A dramatic, traditional intro/logo/opener featuring orchestral strings, woodwind and harpsichord. Perfect for historical documentaries, YouTube videos or any project requiring a dramatic, intense opener.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, woodwind",
    "tags": "advert, antiques, baroque, british, classic, classical, documentary, drama, dramatic, english, exciting, historical, history, ident, intense, intro, log, old, old-fashioned, opener, period drama, powerful, proud, regal, renaissance, royal, royalty, stately, traditional, tv",
    "price": 10,
    "date": "2016-03-04",
    "videoId": "Pu4o3tNdLos",
    "youtubeUrl": "https://www.youtube.com/watch?v=Pu4o3tNdLos",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483330-Baroque_Logo_0m09?ref=dreamnotemusic",
    "duration": "0:09"
  },
  {
    "title": "Country Living Logo",
    "description": "A charming, traditional ident/opener/intro featuring clarinet with piano, orchestral strings and woodwind. Perfect for adverts/commercials, documentaries, nature/country living videos, baking/cooking channels or TV/radio shows.",
    "genre": "Classical",
    "instrumentation": "Clarinet, piano, orchestral strings, woodwind",
    "tags": "advert, baking, british, charming, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, farming, happy, ident, intro, kitchen, light, light-hearted, logo, nature, nice, opener, playful, sweet, traditional, twee, youtube",
    "price": 12,
    "date": "2016-03-03",
    "videoId": "1HFyiSm8xQI",
    "youtubeUrl": "https://www.youtube.com/watch?v=1HFyiSm8xQI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756536-Country-Living-Logo-0m14?ref=dreamnotemusic",
    "duration": "0:14"
  },
  {
    "title": "Spiritual Choir Ident",
    "description": "A beautiful, atmospheric intro/logo/opener featuring a glorious blend of sustained voices singing in harmony. Perfect for spiritual/holy videos, adverts, documentaries, company openers or any project with an emotional, religious tone.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Choir, voices",
    "tags": "angelic, atmospheric, beautiful, belief, believe, charity, choir, church, expressive, faith, god, heaven, heavenly, holy, hymn, intro, logo, opener, peaceful, prayer, reflective, religion, religious, singers, singing, spiritual, vocal, voice, voices, worship",
    "price": 12,
    "date": "2016-03-01",
    "videoId": "120Mu2K_-as",
    "youtubeUrl": "https://www.youtube.com/watch?v=120Mu2K_-as",
    "productUrl": "https://audiojungle.net/item/spiritual-choir-ident/14882057",
    "duration": "0:22"
  },
  {
    "title": "Atmospheric Cinematic Vocals",
    "description": "Heavenly female voice accompanied by orchestral strings, choir and percussion (Instrumental versions also included). This haunting, dark vocal track is perfect for use in movie/film/game trailers, teasers or soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Voice, orchestral strings, choir, percussion",
    "tags": "angelic, atmospheric, beautiful, cinematic, dark, drama, dramatic, emotional, enchanting, epic, fantasy, female vocal, film, game, haunting, heavenly, inspirational, love, magical, movie, moving, mysterious, romance, sad, thriller, trailer, uplifting, vocal, voice, wonder",
    "price": 18,
    "date": "2016-02-29",
    "videoId": "TsJNO7XIzz4",
    "youtubeUrl": "https://www.youtube.com/watch?v=TsJNO7XIzz4",
    "productUrl": "https://audiojungle.net/item/atmospheric-cinematic-vocals/14873267",
    "duration": "1:35"
  },
  {
    "title": "Top Model",
    "description": "Funky guitars, drums, bass, electric piano, strings and percussion, blending elements of funk, disco and house music. Perfect for fashion/clothes shows, TV adverts/commercials, YouTube celebrity/fashion videos, slide-show presentations or any project with a modern, cool, hip vibe.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, drums, bass, electric piano, strings, drums",
    "tags": "advertising, attitude, catwalk, celebrity, chic, clothes show, club, commercial, cool, dance, designer, disco, famous, fashion, fashion show, funk, funky, glamour, gossip, groovy, model, modelling, nightclub, party, photo shoot, promo, runway, slideshow, style, trendy",
    "price": 24,
    "date": "2016-02-26",
    "videoId": "2OtUHnNDw0U",
    "youtubeUrl": "https://www.youtube.com/watch?v=2OtUHnNDw0U",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806895-Top-Model-2m28?ref=dreamnotemusic",
    "duration": "2:28"
  },
  {
    "title": "Comedy Logo",
    "description": "A funny, quirky ident/opener/intro/outro featuring piano, xylophone and orchestra. Perfect for comedy compilation/bloopers videos, YouTube videos, apps/computer games, kids' cartoons/animations or adverts/commercials.",
    "genre": "Comedy",
    "instrumentation": "Piano, xylophone and orchestra.",
    "tags": "animation, app, bloopers, cartoon, cheerful, cheesy, childrens, comedian, comedic, comedy, comedy compilation, fun, funny, gag reel, game, happy, ident, intro, jazz, kids, opener, outro, party, platform, playful, quirky, show, showbiz, slapstick, spoof",
    "price": 8,
    "date": "2016-02-25",
    "videoId": "ZmLsbsBGYKc",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZmLsbsBGYKc",
    "productUrl": "https://audiojungle.net/item/comedy-logo/14826879",
    "duration": "0:08"
  },
  {
    "title": "Countdown",
    "description": "A ticking clock effect along with driving bass drum and atmospheric synth pads, gradually climbing to a dramatic close. Ideal for TV game/quiz shows, news channel reports, games, animations or as a timer/countdown.",
    "genre": "Corporate",
    "instrumentation": "Synth pads, bass drum, percussion",
    "tags": "announcement, bomb, broadcast, challenge, chase, clock, competition, count down, countdown, danger, drama, dramatic, entertainment, evening news, exciting, game show, games, gripping, headlines, new year, news, quiz, race, stopclock, stopwatch, suspense, tense, tension, time, timer",
    "price": 20,
    "date": "2016-02-24",
    "videoId": "c_ghept4JWE",
    "youtubeUrl": "https://www.youtube.com/watch?v=c_ghept4JWE",
    "productUrl": "https://audiojungle.net/item/countdown/14817007",
    "duration": "2:15"
  },
  {
    "title": "My Beautiful Life",
    "description": "A heart-warming, sentimental track featuring piano and orchestral strings. Perfect for family videos, weddings, photo slide shows, adverts/commercials, TV, movies/films or any project of an expressive nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, advertisement, album, beautiful, believe, birth, commercial, dream, dreams, dreamy, emotional, family, family tree, family video, friendship, heartfelt, hope, inspirational, inspiring, life, love, memories, montage, moving, nature, photo, photography, sentimental, slideshow, wedding",
    "price": 20,
    "date": "2016-02-20",
    "videoId": "7bwvblhsKPo",
    "youtubeUrl": "https://www.youtube.com/watch?v=7bwvblhsKPo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796395-My-Beautiful-Life-1m11?ref=dreamnotemusic",
    "duration": "1:11"
  },
  {
    "title": "Honour",
    "description": "Patriotic and inspiring, ‘Honour’ is a proud, cinematic military track featuring rich orchestral strings, brass and choir accompanied by marching snare-drum. Ideal for use in documentaries, trailers/teasers or TV/movie/film/game soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, brass, choir, snare-drum",
    "tags": "army, arrival, atmospheric, battle, choir, cinematic, film, game, honor, honour, inspirational, loyal, march, marching, memorial, military, mission, movie, moving, patriotic, pride, proud, remembrance, snare-drum, soundtrack, space, trailer, tv, uplifting, war",
    "price": 20,
    "date": "2016-02-18",
    "videoId": "o4IVEHU0SN8",
    "youtubeUrl": "https://www.youtube.com/watch?v=o4IVEHU0SN8",
    "productUrl": "https://audiojungle.net/item/honour/14770333",
    "duration": "2:05"
  },
  {
    "title": "Saloon Bar Piano",
    "description": "A funny, quirky track based on traditional American old western saloon bar music, featuring honkytonk solo piano. Perfect for adverts/commercials, comedy videos, YouTube hauls/vlogs, apps/computer games or cartoons/animations.",
    "genre": "Comedy",
    "instrumentation": "Piano",
    "tags": "american, animation, app, bloopers, cartoon, cheerful, cheesy, comedian, comedy, fun, funny, gag reel, game, happy, haul, honytonk, jazz piano, kids, party, piano, piano rag, pub piano, quirky, ragtime, saloon, scott joplin, tack piano, western",
    "price": 16,
    "date": "2016-02-17",
    "videoId": "zljH5lBYk3Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=zljH5lBYk3Y",
    "productUrl": "https://audiojungle.net/item/saloon-bar-piano/14750569",
    "duration": "1:20"
  },
  {
    "title": "TV Comedy Logo",
    "description": "A cool, retro, jazz/blues-influenced ident/opener/jingle/intro featuring piano, organ, wurly, bass and drums. Perfect for use as an opening theme for YouTube videos/vlogs, TV adverts/commercials, podcasts or as a TV/radio jingle.",
    "genre": "Comedy",
    "instrumentation": "Piano, organ, Wurlitzer, bass, drums",
    "tags": "advert, advertising, bright, cheerful, comedy, commercial, cool, fun, funny, happy, ident, intro, jazz, jingle, jolly, lively, logo, opener, podcast, positive, quirky, radio, sassy, short, tv, uplifting, video intro, vlog, webisode, youtube",
    "price": 8,
    "date": "2016-02-14",
    "videoId": "EzU1kD5JhCE",
    "youtubeUrl": "https://www.youtube.com/watch?v=EzU1kD5JhCE",
    "productUrl": "https://audiojungle.net/item/tv-comedy-logo/14714680",
    "duration": "1:03"
  },
  {
    "title": "Hope",
    "description": "An uplifting, optimistic and inspiring track featuring piano with expressive orchestral strings and woodwind. An ideal backing for adverts/commercials, documentaries, family/wedding videos, TV/film/movie soundtracks or any project of an inspirational or hopeful nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, family tree, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 16,
    "date": "2016-02-13",
    "videoId": "hdQJNV6dewM",
    "youtubeUrl": "https://www.youtube.com/watch?v=hdQJNV6dewM",
    "productUrl": "https://audiojungle.net/item/hope/14704625",
    "duration": "1:40"
  },
  {
    "title": "Quirky Logo",
    "description": "A bright, happy, uplifting ident/opener/jingle/intro featuring orchestral strings, woodwind and piano. Ideal for use in YouTube videos/vlogs, adverts/commercials, podcasts or as a TV/radio jingle.",
    "genre": "Comedy",
    "instrumentation": "Orchestral strings, woodwind, piano",
    "tags": "advert, advertising, bright, cheerful, chirpy, comedy, commercial, cool, fun, funny, happy, ident, intro, jingle, jolly, lively, logo, opener, podcast, positive, quirky, radio, sassy, short, tv, uplifting, video intro, vlog, webisode, youtube",
    "price": 10,
    "date": "2016-02-13",
    "videoId": "X_GVAONAYEY",
    "youtubeUrl": "https://www.youtube.com/watch?v=X_GVAONAYEY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804238-Quirky-Logo?ref=dreamnotemusic",
    "duration": "0:06"
  },
  {
    "title": "Our Wedding Day",
    "description": "An expressive, beautiful and magical track featuring piano, cello, acoustic guitar, glockenspiel, orchestral strings, woodwind and choir. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, fantasy themes, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, glockenspiel, orchestral strings, woodwind, choir",
    "tags": "beautiful, believe, bride, ceremony, christmas, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, fairies, fairytale, family, fantasy, film, heartfelt, love, magic, magical, movie, procession, romance, romantic, sentimental, wedding, wedding ceremony, wedding day, wedding music, wonderland",
    "price": 24,
    "date": "2016-02-07",
    "videoId": "wfOcqTBfzvk",
    "youtubeUrl": "https://www.youtube.com/watch?v=wfOcqTBfzvk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801311-Our-Wedding-Day-2m49?ref=dreamnotemusic",
    "duration": "2:49"
  },
  {
    "title": "Dramatic Trailer",
    "description": "Big, bold and tense, this track is perfect for those hard-hitting action film/movie/game trailers, teasers and soundtracks.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, brass, woodwind, percussion",
    "tags": "action, apocalypse, battle, big, blockbuster, combat, drama, dramatic, epic, exciting, fight, fighting, film, gripping, hollywood, loud, massive, movie, orchestral, powerful, revenge, teaser, tense, terror, thriller, thrilling, tough, trailer, video game, war",
    "price": 20,
    "date": "2016-02-04",
    "videoId": "oxOCPP3Uw3Q",
    "youtubeUrl": "https://www.youtube.com/watch?v=oxOCPP3Uw3Q",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781433-Dramatic-Trailer-1m21?ref=dreamnotemusic",
    "duration": "1:21"
  },
  {
    "title": "Fun",
    "description": "A happy, bright, playful track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, children’s cartoons/animations, background comedy music, YouTube videos, ballet class/tutorials or kids TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, children, classical, comedy, commercial, cooking, cute, dance, dancing, english, fun, funny, happy, ident, innocent, intro, kids, light-hearted, logo, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2016-02-03",
    "videoId": "phQUDxuvL7M",
    "youtubeUrl": "https://www.youtube.com/watch?v=phQUDxuvL7M",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785640-Fun-0m52?ref=dreamnotemusic",
    "duration": "0:52"
  },
  {
    "title": "Atmospheric",
    "description": "A slow, ambient and tranquil track featuring solo piano. Perfect for TV/movie/film scenes, space/sci-fi documentaries, time-lapse photography videos or any project needing a peaceful or mysterious background atmosphere.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano",
    "tags": "ambience, ambient, atmosphere, atmospheric, background, calm, chilled, chords, documentary, dreaming, dreamy, emptiness, lonely, meditation, nature, night, peaceful, piano, relaxing, sad, sci-fi, sleep, slow, solo piano, soothing, sorrow, soundscape, space, still, timelapse",
    "price": 24,
    "date": "2016-02-02",
    "videoId": "Dt8RK3sWrCc",
    "youtubeUrl": "https://www.youtube.com/watch?v=Dt8RK3sWrCc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311683-Atmospheric-2m40?ref=dreamnotemusic",
    "duration": "2:40"
  },
  {
    "title": "Cinematic Piano",
    "description": "An atmospheric, expressive and emotional track featuring solo piano. Perfect for use in movie/film soundtracks, adverts/commercials, documentaries, TV charity appeals or any project with an inspirational, hopeful tone.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, belief, believe, calm, charity, cinematic, commercial, documentary, dreamy, emotional, faith, fantasy, heartfelt, hope, hopeful, melancholy, mellow, memories, nostalgic, peaceful, piano, piano solo, reflective, sad, sentimental, sorrow, soundtrack, spiritual, story",
    "price": 20,
    "date": "2016-01-31",
    "videoId": "-6eWi_C-KH4",
    "youtubeUrl": "https://www.youtube.com/watch?v=-6eWi_C-KH4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756557-Cinematic-Piano-1m39?ref=dreamnotemusic",
    "duration": "1:39"
  },
  {
    "title": "Creepy Cello",
    "description": "A dark, haunting, cinematic track featuring cello, piano, glockenspiel, eerie strings and sinister orchestral drones. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audio books, video games, YouTube videos or any project with a spooky, spine-chilling tone.",
    "genre": "Horror",
    "instrumentation": "Cello, piano, glockenspiel, strings, orchestral",
    "tags": "atmospheric, creepy, dark, dead, death, demented, demon, evil, film score, ghost, gothic, halloween, haunted house, haunting, hell, horror, murder, mysterious, mystery, night, nightmare, possessed, psycho, scary, serial killer, soundtrack, spooky, suspense, thriller, twisted",
    "price": 20,
    "date": "2016-01-30",
    "videoId": "JLbxzPjbfJI",
    "youtubeUrl": "https://www.youtube.com/watch?v=JLbxzPjbfJI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756590-Creepy-Cello-1m36?ref=dreamnotemusic",
    "duration": "1:36"
  },
  {
    "title": "Jazzy Logo",
    "description": "A cool jazz ident/opener/jingle/intro featuring piano, vibraphone, bass and drums. Ideal for use in YouTube videos/vlogs, adverts/commercials, comedy shows/podcasts or as a TV/radio jingle.",
    "genre": "Jazz",
    "instrumentation": "Piano, vibraphone, bass, drums",
    "tags": "advert, advertising, comedy, commercial, cool, fun, funk, funky, funny, gameshow, ident, intro, jazz, jazzy, jingle, logo, opener, podcast, quirky, radio, retro, sitcom, swing, talk show, theme, theme tune, tv, video intro, vlog, youtube",
    "price": 10,
    "date": "2016-01-30",
    "videoId": "SllvjBJaCMY",
    "youtubeUrl": "https://www.youtube.com/watch?v=SllvjBJaCMY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795278-jazzy-logo-cool-jazz-ident?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Space Time-lapse",
    "description": "An ambient, soothing, dreamy track with soft pianos, atmospheric synth pads and subtle drums. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, drums",
    "tags": "advert, advertising, ambient, beautiful, chill, cityscape, commercial, cool, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, stars, technology, thoughts, time-lapse",
    "price": 20,
    "date": "2016-01-26",
    "videoId": "lAAUI7_A3ik",
    "youtubeUrl": "https://www.youtube.com/watch?v=lAAUI7_A3ik",
    "productUrl": "https://audiojungle.net/item/space-timelapse/14485722",
    "duration": "2:53"
  },
  {
    "title": "A Beautiful Day",
    "description": "An uplifting, optimistic track featuring piano with expressive orchestral strings, french horn and woodwind. An ideal backing for adverts/commercials, documentaries, family/wedding videos, TV/film/movie soundtracks or any project of an inspirational or hopeful nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, french horn, woodwind",
    "tags": "advert, advertisement, beautiful, commercial, dreams, dreamy, family, heartfelt, hope, inspirational, inspire, inspiring, life, love, memories, montage, nature, photography, piano, reflective, romantic, sentimental, slide-show, slideshow, strings, timeless, uplifting, valentines, video, wedding",
    "price": 18,
    "date": "2016-01-25",
    "videoId": "y_j83745vxw",
    "youtubeUrl": "https://www.youtube.com/watch?v=y_j83745vxw",
    "productUrl": "https://audiojungle.net/item/a-beautiful-day/14474605",
    "duration": "2:21"
  },
  {
    "title": "English Country Manor",
    "description": "A charming, traditional track featuring piano, orchestral strings, woodwind, brass and percussion. Perfect for adverts/commercials, documentaries, baking/cooking/gardening channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, percussion",
    "tags": "antiques, baking, british, castle, ceremony, charming, classic, classical, country, country living, countryside, Daytime TV, documentary, english, gardening, heritage, historical, history, nature, period drama, proud, regal, royal, royalty, spring, summer, traditional, twee, wedding, youtube",
    "price": 16,
    "date": "2016-01-22",
    "videoId": "7EIOcTkrdLg",
    "youtubeUrl": "https://www.youtube.com/watch?v=7EIOcTkrdLg",
    "productUrl": "https://audiojungle.net/item/english-country-manor/14458508",
    "duration": "1:21"
  },
  {
    "title": "English Summer Garden",
    "description": "A charming, traditional track featuring piano, orchestral strings, woodwind, brass and choir. Perfect for documentaries, nature/country living videos, weddings, family/wedding videos or TV/radio shows.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir",
    "tags": "advert, beautiful, british, charming, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, emotional, english, family life, farming, innocent, light, light-hearted, nature, nice, playful, relaxing, romantic, sweet, theme, traditional, twee, wedding, youtube",
    "price": 24,
    "date": "2016-01-21",
    "videoId": "p23FKYfoSww",
    "youtubeUrl": "https://www.youtube.com/watch?v=p23FKYfoSww",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784826-English-Summer-Garden-2m19?ref=dreamnotemusic",
    "duration": "2:19"
  },
  {
    "title": "English Springtime",
    "description": "A beautiful, charming track featuring piano, orchestral strings and woodwind. Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos, gardening shows, family videos or weddings.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "advert, animals, baking, beautiful, british, charming, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, easter, england, english, gardening, kitchen, nature, period drama, picnic, spring, springtime, stately home, summer, traditional, twee, wedding, youtube",
    "price": 20,
    "date": "2016-01-14",
    "videoId": "YujzdPlMP5E",
    "youtubeUrl": "https://www.youtube.com/watch?v=YujzdPlMP5E",
    "productUrl": "https://audiojungle.net/item/english-springtime/14374542",
    "duration": "2:15"
  },
  {
    "title": "Comedy Piano",
    "description": "A fun, quirky, playful track featuring solo piano (‘honkytonk’ piano versions also included). Perfect for comedy compilation/bloopers videos, YouTube hauls/vlogs, children’s parties, apps, computer games, cartoons/animations or adverts/commercials.",
    "genre": "Comedy",
    "instrumentation": "Piano",
    "tags": "animation, app, bloopers, cartoon, cheerful, cheesy, comedian, comedy, comedy compilation, fun, funny, gag reel, game, happy, haul, honytonk, jazz piano, kids, party, piano, piano rag, platform, playful, pub piano, quirky, ragtime, saloon piano, scott joplin, spoof, tack piano",
    "price": 12,
    "date": "2016-01-13",
    "videoId": "PwXipo5DN_U",
    "youtubeUrl": "https://www.youtube.com/watch?v=PwXipo5DN_U",
    "productUrl": "https://audiojungle.net/item/comedy-piano/14352874",
    "duration": "1:09"
  },
  {
    "title": "Valentine's Day Logo",
    "description": "‘Valentine’s Day Logo’ is a short, romantic jingle/logo/ident featuring expressive piano with orchestral strings, woodwind, brass, harp, choir, glockenspiel and bells. Ideal for use in Valentines videos, e-cards, wedding adverts, YouTube videos and advert/commercials.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, harp, choir, glockenspiel, bells",
    "tags": "anniversary, beautiful, bright, cinematic, dreamy, ecard, emotional, engaged, engagement, fiance, girlfriend, ident, intro, jingle, logo, love, lush, marriage, memories, proposal, propose, romance, romantic, sentimental, slushy, valentine, valentines, valentines day, wedding",
    "price": 10,
    "date": "2016-01-13",
    "videoId": "ab-Gu0mYM7Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=ab-Gu0mYM7Y",
    "productUrl": "https://audiojungle.net/item/valentines-day-logo/14350467",
    "duration": "0:15"
  },
  {
    "title": "Dark and Emotional",
    "description": "An atmospheric, tragic movie soundtrack featuring piano with orchestral strings and woodwind. Perfect for film/movie/game trailers, teasers, soundtracks, e-book promos, TV dramas or any project with a haunting, emotional tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind.",
    "tags": "atmosphere, atmospheric, cinematic, classical, dark, death, deep, drama, dramatic, emotional, fantasy, film, forbidden, haunting, intense, love, lovers, movie, mysterious, mystery, night, reflective, romance, sad, soundtrack, thriller, tragic, trailer, twilight, underscore",
    "price": 20,
    "date": "2016-01-12",
    "videoId": "fQOdUh4EE0o",
    "youtubeUrl": "https://www.youtube.com/watch?v=fQOdUh4EE0o",
    "productUrl": "https://audiojungle.net/item/dark-and-emotional/14340049",
    "duration": "2:06"
  },
  {
    "title": "Always Believe",
    "description": "An uplifting, inspiring track featuring piano and orchestra. Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, travel videos, corporate presentations or any project requiring a motivational, thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, choir, percussion",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, dramatic, exploration, explore, faith, grand, hope, inspirational, journey, motivational, movie, powerful, struggle, success, thought-provoking, trailer, travel, triumph, uplifting, win",
    "price": 20,
    "date": "2016-01-10",
    "videoId": "yuvC2vCn95Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=yuvC2vCn95Y",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311719-Always-Believe-1m33?ref=dreamnotemusic",
    "duration": "1:33"
  },
  {
    "title": "On Hold",
    "description": "A light, Bossa Nova styled track featuring piano, acoustic guitar, vibraphone, bass, drums and percussion. Ideal for use as elevator/lift music, on hold phone music, department store style muzak, or in comedy, TV gameshows, shopping network promos and holiday/vacation adverts.",
    "genre": "Corporate",
    "instrumentation": "Piano, acoustic guitar, vibraphone, bass, drums, percussion",
    "tags": "airport, answerphone, background music, bossa nova, call waiting, cheesy, comedy, corny, department store, elevator, elevator music, funny, grocery shopping, holiday, hotel, latin, lift, lift music, lobby, muzak, on hold, phone, phone call, shopping, shopping channel, shopping mall, supermarket, telephone, vacation, waiting",
    "price": 16,
    "date": "2016-01-09",
    "videoId": "0XLV9zHryu0",
    "youtubeUrl": "https://www.youtube.com/watch?v=0XLV9zHryu0",
    "productUrl": "https://audiojungle.net/item/on-hold/14310074",
    "duration": "1:01"
  },
  {
    "title": "Cinematic Trailer",
    "description": "An uplifting, inspirational and atmospheric track featuring piano, orchestral strings, woodwind, brass and percussion. Perfect for use in movie/film/game trailers, soundtracks, adverts or documentaries.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, percussion",
    "tags": "atmospheric, believe, charity, cinematic, dark, dramatic, dream, epic, fantasy, film trailer, game trailer, grand, honor, honour, hope, hopeful, inspirational, inspiring, journey, military, movie trailer, proud, soundtrack, space, strings, teaser, thriller, trailer, uplifting, wonder",
    "price": 24,
    "date": "2016-01-08",
    "videoId": "LIaw0Nsva-M",
    "youtubeUrl": "https://www.youtube.com/watch?v=LIaw0Nsva-M",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756730-Cinematic-Trailer-2m31?ref=dreamnotemusic",
    "duration": "2:31"
  },
  {
    "title": "Happily Ever After",
    "description": "A beautiful, magical track featuring piano, cello and orchestral strings. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, fantasy themes, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, orchestral strings",
    "tags": "beautiful, believe, bride, ceremony, christmas, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, fairies, fairytale, family, fantasy, film, heartfelt, love, magic, magical, movie, procession, romance, romantic, sentimental, wedding, wedding ceremony, wedding day, wedding music, wonderland",
    "price": 24,
    "date": "2016-01-08",
    "videoId": "Byh52lsxb5I",
    "youtubeUrl": "https://www.youtube.com/watch?v=Byh52lsxb5I",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787039-Happily-Ever-After-2m14?ref=dreamnotemusic",
    "duration": "2:14"
  },
  {
    "title": "Family Photos",
    "description": "A nostalgic, sentimental track featuring piano, acoustic guitar, bass, orchestral strings and drums. Perfect for family videos, weddings, photo slide shows, TV, movies/films or any project of an expressive nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, bass, orchestral strings, drums",
    "tags": "advert, advertisement, album, beautiful, birth, charity, commercial, dreamy, emotional, family, family album, family tree, family video, friendship, happy, heartfelt, inspirational, inspiring, life, love, memories, montage, moving, photo, photography, relaxing, romantic, sentimental, slideshow, wedding",
    "price": 24,
    "date": "2016-01-01",
    "videoId": "t6NYcd6BECU",
    "youtubeUrl": "https://www.youtube.com/watch?v=t6NYcd6BECU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785850-Family-Photos-2m35?ref=dreamnotemusic",
    "duration": "2:35"
  },
  {
    "title": "Into the Darkness",
    "description": "Perfect for action film/movie/game trailers, teasers and soundtracks.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Piano, orchestra",
    "tags": "action, apocalypse, battle, blockbuster, combat, drama, dramatic, epic, exciting, fight, fighting, film, hollywood, horror, intense, massive, movie, orchestral, powerful, revenge, scary, superhero, teaser, tense, terror, thriller, tough, trailer, video game, war",
    "price": 24,
    "date": "2015-12-31",
    "videoId": "eJ-Q2oSPkbg",
    "youtubeUrl": "https://www.youtube.com/watch?v=eJ-Q2oSPkbg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793611-Into-the-Darkness-2m36?ref=dreamnotemusic",
    "duration": "2:36"
  },
  {
    "title": "Piano Chillout",
    "description": "An ambient, relaxing, dreamy track featuring piano with soft, atmospheric synth pads. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV or time-lapse videos.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, montage, nature, night, photography, piano, piano solo, relaxing, scenery, scenic, sci-fi, sleep, solo piano, soundscape, space, thoughts, time-lapse",
    "price": 20,
    "date": "2015-12-28",
    "videoId": "WUHrtDH1XD0",
    "youtubeUrl": "https://www.youtube.com/watch?v=WUHrtDH1XD0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801309-Piano-Chillout-1m54?ref=dreamnotemusic",
    "duration": "1:54"
  },
  {
    "title": "News",
    "description": "An exciting news theme featuring a pulsing drum beat with synths and orchestra building in a dramatic crescendo towards a powerful climax. Perfect for TV news channels, YouTube news videos, radio station news reports, corporate announcements, breaking news, headlines, media, broadcasting or as an ident/intro.",
    "genre": "Corporate",
    "instrumentation": "Synth, orchestra, percussion",
    "tags": "announcement, broadcast, broadcasting, business report, corporate, dramatic, entertainment, evening news, exciting, feature, featurette, global, gripping, headlines, ident, intro, logo, media, network, news, opening, powerful, presentation, promo, radio, sport report, strong, tense, tv, youtube",
    "price": 14,
    "date": "2015-12-27",
    "videoId": "ynVsR6_dU1g",
    "youtubeUrl": "https://www.youtube.com/watch?v=ynVsR6_dU1g",
    "productUrl": "https://audiojungle.net/item/news/14119138",
    "duration": "0:36"
  },
  {
    "title": "Baroque",
    "description": "A lively, traditional classical track featuring orchestral strings, woodwind, harpsichord and choir. Perfect for documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, woodwind, harpsichord, choir",
    "tags": "advert, advertising, antiques, architecture, bank, baroque, british, classic, classical, countdown, documentary, drama, dramatic, english, exciting, historical, history, intense, old, old-fashioned, period drama, powerful, proud, regal, renaissance, royal, royalty, stately, traditional, tv",
    "price": 20,
    "date": "2015-12-25",
    "videoId": "xq_UzkTM4MQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=xq_UzkTM4MQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483196-Baroque-1m50?ref=dreamnotemusic",
    "duration": "1:50"
  },
  {
    "title": "Sadness",
    "description": "An atmospheric and emotional cinematic track featuring piano, violin, cello and orchestral strings. Ideal for use in charity campaigns/adverts, movie/film soundtracks, historical documentaries, photo montages or time-lapse videos.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, violin, cello, orchestral strings.",
    "tags": "atmosphere, atmospheric, calm, cello, charity, chillout, dark, death, dream, emotional, expressive, funeral, goodbye, haunting, history, lonely, loss, love story, memories, mourning, nostalgic, peaceful, reflective, remembrance, sad, sleep, slow, timelapse, tragic, war",
    "price": 24,
    "date": "2015-12-25",
    "videoId": "N539fo7ERc8",
    "youtubeUrl": "https://www.youtube.com/watch?v=N539fo7ERc8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804458-Sadness-2m55?ref=dreamnotemusic",
    "duration": "2:55"
  },
  {
    "title": "Motivation",
    "description": "A positive, optimistic track featuring lively, rhythmic orchestral strings and confident piano melody surrounded by warm synth pads, bass and drums. Ideal for use in TV/radio adverts/commercials, corporate promotional material or business presentations.",
    "genre": "Corporate",
    "instrumentation": "Orchestral strings, piano, synth pads, bass, drums",
    "tags": "achievement, advert, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2015-12-23",
    "videoId": "AwZAWcJNTbQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=AwZAWcJNTbQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796494-Motivation-1m03?ref=dreamnotemusic",
    "duration": "1:03"
  },
  {
    "title": "Emotional Piano Solo",
    "description": "An atmospheric, expressive and thought-provoking track. Perfect for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of a sentimental or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, background, believe, calm, charity, cinematic, classical, commercial, documentary, emotional, faith, heartfelt, history, hope, hopeful, melancholy, mellow, memories, moving, nostalgic, piano, piano solo, reflective, sad, sentimental, sorrow, soundtrack, story, time-lapse",
    "price": 24,
    "date": "2015-12-21",
    "videoId": "LDNapNAVEjE",
    "youtubeUrl": "https://www.youtube.com/watch?v=LDNapNAVEjE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784703-Emotional-Piano-Solo-3m06?ref=dreamnotemusic",
    "duration": "3:06"
  },
  {
    "title": "Wedding Day",
    "description": "A beautiful, romantic track featuring piano, cello, acoustic guitar, orchestral strings, woodwind and percussion. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, orchestral strings, woodwind, percussion",
    "tags": "beautiful, believe, bride, ceremony, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, family, film, friends, heartfelt, love, magic, magical, memories, movie, photo, procession, romance, romantic, sentimental, slideshow, wedding, wedding ceremony, wedding day, wedding music, wedding video",
    "price": 20,
    "date": "2015-12-19",
    "videoId": "omgQmFDVhHo",
    "youtubeUrl": "https://www.youtube.com/watch?v=omgQmFDVhHo",
    "productUrl": "https://audiojungle.net/item/wedding-day/14015975",
    "duration": "3:01"
  },
  {
    "title": "Home Sweet Home",
    "description": "A charming, traditional track, featuring piano, glockenspiel, orchestral strings and percussion. Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, orchestral strings, percussion",
    "tags": "advert, antiques, baking, british, charming, classic, classical, commercial, country, country living, countryside, cute, Daytime TV, documentary, english, fun, heritage, historical, history, intro, kitchen, nature, nice, period drama, playful, sweet, traditional, twee, wedding, youtube",
    "price": 14,
    "date": "2015-12-18",
    "videoId": "TjQX9tant8g",
    "youtubeUrl": "https://www.youtube.com/watch?v=TjQX9tant8g",
    "productUrl": "https://audiojungle.net/item/home-sweet-home/14007880",
    "duration": "0:54"
  },
  {
    "title": "Cinematic Strings",
    "description": "An atmospheric, dramatic track featuring orchestral violins, violas, cellos and double basses. Perfect for use in movie/film/game trailers, soundtracks, advertising or documentaries.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings",
    "tags": "atmospheric, believe, charity, cinematic, dark, dramatic, dream, epic, fantasy, film trailer, game trailer, grand, honor, honour, hope, hopeful, inspirational, inspiring, journey, military, movie trailer, proud, soundtrack, space, strings, teaser, thriller, trailer, uplifting, wonder",
    "price": 20,
    "date": "2015-12-17",
    "videoId": "yQo21OrZyHs",
    "youtubeUrl": "https://www.youtube.com/watch?v=yQo21OrZyHs",
    "productUrl": "https://audiojungle.net/item/cinematic-strings/13986364",
    "duration": "2:38"
  },
  {
    "title": "Home",
    "description": "A heart-warming, sentimental track featuring piano, acoustic guitar, bass, orchestral strings and drums (versions also included without drums). Perfect for family videos, real estate/wedding videos, photo slide shows, TV, movies/films or any project of an expressive nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, bass, orchestral strings, drums",
    "tags": "advert, album, beautiful, charity, commercial, dreamy, emotional, family, family album, family tree, family video, friendship, happy, heartfelt, home, inspirational, life, love, memories, montage, moving, photo, photography, real estate, realestate, relaxing, romantic, sentimental, slideshow, wedding",
    "price": 20,
    "date": "2015-12-16",
    "videoId": "gAnh5u81CpA",
    "youtubeUrl": "https://www.youtube.com/watch?v=gAnh5u81CpA",
    "productUrl": "https://audiojungle.net/item/home/13954123",
    "duration": "2:22"
  },
  {
    "title": "Corporate Logo 1",
    "description": "Fresh, bright and positive, this logo would suit a variety of uses in business/corporate advertising, TV, YouTube videos and radio.",
    "genre": "Corporate",
    "instrumentation": "Synth, bass",
    "tags": "achievement, advert, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 10,
    "date": "2015-12-12",
    "videoId": "NFCu8_qws_0",
    "youtubeUrl": "https://www.youtube.com/watch?v=NFCu8_qws_0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756606-Corporate-Logo-1?ref=dreamnotemusic",
    "duration": "0:08"
  },
  {
    "title": "Dramatic",
    "description": "A lively, rhythmic classical track featuring orchestral strings, piano, woodwind and choir. Perfect for documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, piano, woodwind, choir",
    "tags": "advert, advertising, antiques, architecture, bank, baroque, british, classic, classical, countdown, documentary, drama, dramatic, english, exciting, historical, history, intense, old, old-fashioned, period drama, powerful, proud, quick, regal, renaissance, royal, royalty, traditional, tv",
    "price": 24,
    "date": "2015-12-12",
    "videoId": "4Pv20AWV-Ek",
    "youtubeUrl": "https://www.youtube.com/watch?v=4Pv20AWV-Ek",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781677-Dramatic-3m08?ref=dreamnotemusic",
    "duration": "3:08"
  },
  {
    "title": "Christmas Logo 7",
    "description": "A short, bright jingle/logo/ident featuring sleigh bells, piano, glockenspiel, choir and strings. Ideal for use in Christmas advertisements, commercials, YouTube vlogmas videos, radio intros, video games, apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, piano, glockenspiel, choir, strings.",
    "tags": "advertising, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, tubular bells, vlogmas, web intro, xmas, youtube",
    "price": 12,
    "date": "2015-12-10",
    "videoId": "hQLpVT_wzFE",
    "youtubeUrl": "https://www.youtube.com/watch?v=hQLpVT_wzFE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756625-Christmas-Logo-7-0m13?ref=dreamnotemusic",
    "duration": "0:13"
  },
  {
    "title": "Jazz Logo",
    "description": "A cool, lively and positive ident/opener/jingle/intro featuring piano, vibraphone, bass and drums. Ideal for use in YouTube videos/vlogs, adverts/commercials, comedy shows/podcasts or as a TV/radio jingle.",
    "genre": "Jazz",
    "instrumentation": "Piano, vibraphone, bass, drums",
    "tags": "advert, advertising, comedy, commercial, cool, fun, funk, funky, funny, gameshow, happy, ident, intro, jazz, jazzy, jingle, logo, opener, podcast, quirky, radio, retro, sitcom, talk show, theme, theme tune, tv, video intro, vlog, youtube",
    "price": 10,
    "date": "2015-12-03",
    "videoId": "pCgspXHjOx8",
    "youtubeUrl": "https://www.youtube.com/watch?v=pCgspXHjOx8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201218821-Jazz-Logo?ref=dreamnotemusic",
    "duration": "0:08"
  },
  {
    "title": "Cinematic Cello",
    "description": "An emotional, atmospheric lament featuring a passionate folk-influenced cello solo over a low orchestral strings drone. Ideal for movie/film soundtracks, games, documentaries or any project with a sorrowful or thought-provoking atmosphere.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Cello, orchestral strings",
    "tags": "atmosphere, atmospheric, cellist, cello, cello solo, celtic, cinematic, dark, death, drama, dramatic, drone, folk, grief, history, lament, loneliness, lonely, loss, passion, period drama, remembrance, sad, sadness, solitude, sorrow, tragedy, tragic, violin, war",
    "price": 16,
    "date": "2015-12-02",
    "videoId": "QEhx-VkMF4Q",
    "youtubeUrl": "https://www.youtube.com/watch?v=QEhx-VkMF4Q",
    "productUrl": "https://audiojungle.net/item/cinematic-cello/13756108",
    "duration": "1:26"
  },
  {
    "title": "Wedding",
    "description": "A beautiful, magical track featuring piano, acoustic guitar, harp, glockenspiel, orchestral strings and woodwind. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, fantasy themes, TV, movies/films or any project of a sentimental nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, acoustic guitar, harp, glockenspiel, orchestral strings, woodwind",
    "tags": "beautiful, believe, bride, ceremony, christmas, cinematic, commitment ceremony, dream, dreamy, enchanting, engagement, fairies, fairytale, family, fantasy, film, heartfelt, love, magic, magical, movie, procession, romance, romantic, sentimental, wedding, wedding ceremony, wedding day, wedding music, wonderland",
    "price": 24,
    "date": "2015-11-25",
    "videoId": "XusrfJHUkFM",
    "youtubeUrl": "https://www.youtube.com/watch?v=XusrfJHUkFM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201807014-Wedding-2m57?ref=dreamnotemusic",
    "duration": "2:57"
  },
  {
    "title": "Our Beautiful Memories",
    "description": "An expressive, emotional track featuring piano with orchestral strings. An ideal backing for photo slide-shows/montages, adverts/commercials, documentaries, wedding videos, TV/film/movie soundtracks or any project of an inspirational, reflective nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, advertisement, beautiful, commercial, dreams, dreamy, family, heartfelt, hope, inspirational, inspire, inspiring, life, love, memories, montage, nature, photography, piano, reflective, romantic, sentimental, slide-show, slideshow, strings, timeless, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2015-11-23",
    "videoId": "1TV9cbA_40o",
    "youtubeUrl": "https://www.youtube.com/watch?v=1TV9cbA_40o",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801338-Our-Beautiful-Memories-2m14?ref=dreamnotemusic",
    "duration": "2:14"
  },
  {
    "title": "Atmospheric Piano",
    "description": "An emotional, sentimental and thought-provoking track featuring solo piano. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, belief, believe, calm, charity, cinematic, commercial, documentary, dreamy, emotional, faith, heartfelt, hope, hopeful, melancholy, mellow, memories, moving, nostalgic, peaceful, piano, piano solo, reflective, sad, sentimental, sorrow, soundtrack, spiritual, story",
    "price": 24,
    "date": "2015-11-20",
    "videoId": "3kFX07hOKIY",
    "youtubeUrl": "https://www.youtube.com/watch?v=3kFX07hOKIY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311742-Atmospheric-Piano-2m22?ref=dreamnotemusic",
    "duration": "2:22"
  },
  {
    "title": "Happy",
    "description": "A fun, positive, playful track featuring piano, glockenspiel, acoustic guitar, percussion and pizzicato strings. Perfect for children’s parties, apps, computer games, YouTube hauls/vlogs, cartoons/animations or adverts/commercials.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, acoustic guitar, percussion, orchestral strings",
    "tags": "animation, app, bouncy, bright, bubbly, cartoon, catchy, cheerful, cheery, children, energy, fun, funny, happy, haul, innocent, joyful, kids, lively, merry, party, piano, platform game, play, positive, quirky, upbeat, uplifting, vlog, youtube",
    "price": 20,
    "date": "2015-11-19",
    "videoId": "NOvyrkRRo_0",
    "youtubeUrl": "https://www.youtube.com/watch?v=NOvyrkRRo_0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786986-Happy-1m46?ref=dreamnotemusic",
    "duration": "1:46"
  },
  {
    "title": "A Dream Come True",
    "description": "A magical, heart-warming track featuring piano, acoustic guitar and orchestral strings. Perfect for family videos, weddings, photo slide shows, TV, movies/films or any project of a positive, optimistic nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, acoustic guitar, orchestral strings",
    "tags": "advert, advertisement, beautiful, commercial, dream, dreamy, emotional, family, family tree, family video, fantasy, friendship, happy, heartfelt, inspirational, inspiring, life, love, magic, magical, memories, montage, photo, photography, positive, sentimental, slideshow, video, wedding, wish",
    "price": 24,
    "date": "2015-11-18",
    "videoId": "KwM0qXI_bPs",
    "youtubeUrl": "https://www.youtube.com/watch?v=KwM0qXI_bPs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311752-A-Dream-Come-True-2m06?ref=dreamnotemusic",
    "duration": "2:06"
  },
  {
    "title": "Atmospheric Time-lapse",
    "description": "An ambient, dreamy track featuring a blend of soft pianos and synth pads. Ideal for time-lapse videos, photography presentations, adverts/commercials, TV/movie/film soundtracks or space/sci-fi documentaries.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, dark, documentary, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 20,
    "date": "2015-11-16",
    "videoId": "Qpq2Q9Xmy4w",
    "youtubeUrl": "https://www.youtube.com/watch?v=Qpq2Q9Xmy4w",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311784-Atmospheric-Time-lapse-1m57?ref=dreamnotemusic",
    "duration": "1:57"
  },
  {
    "title": "Cute",
    "description": "A happy, bright, playful track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 14,
    "date": "2015-11-16",
    "videoId": "cFomeL_wJLw",
    "youtubeUrl": "https://www.youtube.com/watch?v=cFomeL_wJLw",
    "productUrl": "https://audiojungle.net/item/cute/13565714",
    "duration": "Length TBC"
  },
  {
    "title": "Family Memories",
    "description": "A beautiful, expressive track featuring piano and orchestra. An ideal backing for adverts, documentaries, film/TV soundtracks, wedding videos, family videos, photo slide shows or a YouTube video/montage.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, expressive, family, family tree, friendship, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, movie, moving, nature, piano, reflective, romantic, sentimental, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2015-11-14",
    "videoId": "U9FN33E8-lI",
    "youtubeUrl": "https://www.youtube.com/watch?v=U9FN33E8-lI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785889-Family-Memories-2m58?ref=dreamnotemusic",
    "duration": "2:58"
  },
  {
    "title": "Inspirational Journey",
    "description": "An uplifting, inspiring track featuring piano and orchestra. Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, travel videos, corporate presentations or any project requiring a motivational, though-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, strings, woodwind, brass, chor, percussion",
    "tags": "accomplish, achieve, adventure, advert, advertising, believe, challenge, cinematic, commercial, company, corporate, documentary, epic, faith, holiday, hope, inspirational, inspiring, journey, motivational, movie, moving, powerful, story, success, thought-provoking, trailer, travel, triumph, uplifting",
    "price": 20,
    "date": "2015-11-13",
    "videoId": "usbIg2WfNMk",
    "youtubeUrl": "https://www.youtube.com/watch?v=usbIg2WfNMk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793662-Inspirational-Journey-1m45?ref=dreamnotemusic",
    "duration": "1:45"
  },
  {
    "title": "English Pride",
    "description": "A charming, traditional classical-styled track, featuring piano, orchestral strings and woodwind. Perfect for adverts/commercials, historical documentaries, nature/country living videos, family/wedding videos or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "advert, antiques, britain, british, castle, ceremony, charming, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, english, heritage, historical, history, nature, period drama, pride, proud, regal, royal, royalty, traditional, twee, wedding, youtube",
    "price": 16,
    "date": "2015-11-12",
    "videoId": "0hG880ZXkFE",
    "youtubeUrl": "https://www.youtube.com/watch?v=0hG880ZXkFE",
    "productUrl": "https://audiojungle.net/item/english-pride/13510729",
    "duration": "1:19"
  },
  {
    "title": "Atmospheric Voices",
    "description": "A beautiful, spiritual track featuring a glorious blend of sustained voices singing in harmony. Perfect for weddings, funerals, remembrance services, commemorative videos, advertisements, documentaries, family videos, photo slide shows or any project with an emotional, inspirational tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Choir",
    "tags": "angelic, angels, beautiful, children, choir, church, cinematic, emotional, expressive, female voice, funeral, glorious, glory, god, heaven, heavenly, hopeful, hymn, inspirational, moving, peaceful, reflective, religious, singers, singing, spiritual, uplifting, vocal, voice, wedding",
    "price": 20,
    "date": "2015-11-10",
    "videoId": "rxv4jGhdFdc",
    "youtubeUrl": "https://www.youtube.com/watch?v=rxv4jGhdFdc",
    "productUrl": "https://audiojungle.net/item/atmospheric-voices/13487874",
    "duration": "3:00"
  },
  {
    "title": "Upbeat Corporate",
    "description": "A motivational, optimistic track featuring muted guitar surrounded by piano, warm synth pads, strings and drums. Ideal for use in corporate promotional material, business presentations or TV/radio adverts or commercials.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, piano, synth pads, strings, drums",
    "tags": "achievement, advertisement, advertising, ambient, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspirational, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, timelapse, upbeat, uplifting",
    "price": 24,
    "date": "2015-11-08",
    "videoId": "P3TiNM70BpU",
    "youtubeUrl": "https://www.youtube.com/watch?v=P3TiNM70BpU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806634-Upbeat-Corporate-2m20?ref=dreamnotemusic",
    "duration": "2:20"
  },
  {
    "title": "Keep on Dreaming",
    "description": "An expressive, inspiring track featuring piano, acoustic guitar, orchestral strings, woodwind and brass. Ideal for use in adverts/commercials, documentaries, family videos/montages, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, acoustic guitar, orchestral strings, woodwind, brass",
    "tags": "advert, advertisement, beautiful, dreamy, emotional, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestral, peaceful, piano, romantic, sentimental, strings, time-lapse, uplifting, video, violins, warm, wedding",
    "price": 24,
    "date": "2015-11-06",
    "videoId": "LO_Kido_JJ8",
    "youtubeUrl": "https://www.youtube.com/watch?v=LO_Kido_JJ8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201795186-Keep-on-Dreaming-3m10?ref=dreamnotemusic",
    "duration": "3:10"
  },
  {
    "title": "Baroque Drama",
    "description": "A lively, dramatic classical track featuring piano, harpsichord, orchestral strings, woodwind and choir. Perfect for documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Piano, harpsichord, orchestral strings, woodwind, choir",
    "tags": "advert, advertising, antiques, architecture, bank, baroque, british, classic, classical, countdown, documentary, drama, dramatic, english, exciting, historical, history, intense, old, old-fashioned, period drama, powerful, proud, regal, renaissance, royal, royalty, stately, traditional, tv",
    "price": 20,
    "date": "2015-11-03",
    "videoId": "UINOnxIgOAU",
    "youtubeUrl": "https://www.youtube.com/watch?v=UINOnxIgOAU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483350-Baroque-Drama-1m37?ref=dreamnotemusic",
    "duration": "1:37"
  },
  {
    "title": "Treasure the Good Times",
    "description": "A heart-warming, sentimental track featuring piano, acoustic guitar and orchestral strings. Perfect for family videos, weddings, photo slide shows, TV, movies/films or any project of an expressive nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, acoustic guitar, orchestral strings",
    "tags": "advert, advertisement, beautiful, birth, charity, commercial, dreamy, emotional, family, family tree, family video, friendship, happy, heartfelt, inspirational, inspiring, life, love, memories, montage, moving, photo, photography, piano, relaxing, romantic, sentimental, slideshow, video, wedding",
    "price": 20,
    "date": "2015-11-01",
    "videoId": "FmNSOGUxydg",
    "youtubeUrl": "https://www.youtube.com/watch?v=FmNSOGUxydg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806989-Treasure-the-Good-Times-1m27?ref=dreamnotemusic",
    "duration": "1:27"
  },
  {
    "title": "English Summer Days",
    "description": "A light-hearted track featuring piano, acoustic guitar, glockenspiel, orchestral strings and woodwind. Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos, family videos or TV.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, acoustic guitar, glockenspiel, orchestral strings, woodwind",
    "tags": "advert, baking, beautiful, british, castle, ceremony, charming, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, english, heritage, historical, history, kitchen, nature, period drama, proud, regal, royal, royalty, traditional, twee, wedding, youtube",
    "price": 20,
    "date": "2015-10-31",
    "videoId": "cMxGV_-tqOE",
    "youtubeUrl": "https://www.youtube.com/watch?v=cMxGV_-tqOE",
    "productUrl": "https://audiojungle.net/item/english-summer-days/13361819",
    "duration": "1:17"
  },
  {
    "title": "Christmas Logo 6",
    "description": "A short, bright jingle/logo/ident featuring sleigh bells, piano, glockenspiel, xylophone, choir and strings. Ideal for use in Christmas advertisements, commercials, YouTube vlogs/videos, radio intros, video games, apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, piano, glockenspiel, xylophone, choir, strings",
    "tags": "advertising, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, tubular bells, vlogmas, web intro, xmas, youtube",
    "price": 12,
    "date": "2015-10-30",
    "videoId": "LvFzhtroORM",
    "youtubeUrl": "https://www.youtube.com/watch?v=LvFzhtroORM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201755898-christmas-logo-6-bright-orchestral-jingle-0m22?ref=dreamnotemusic",
    "duration": "0:22"
  },
  {
    "title": "Believe in Your Dreams",
    "description": "An emotional, inspirational track, featuring piano and symphony orchestra. Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, charity/faith campaigns or any project requiring a moving, inspiring musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra",
    "tags": "accomplish, achieve, adventure, advert, atmospheric, belief, believe, challenge, champion, charity, cinematic, commercial, documentary, dream, emotional, epic, faith, hope, hopeful, inspirational, inspiring, journey, motivational, movie, moving, religious, success, successful, trailer, uplifting",
    "price": 24,
    "date": "2015-10-29",
    "videoId": "yzznpAh-0oc",
    "youtubeUrl": "https://www.youtube.com/watch?v=yzznpAh-0oc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483931-Believe-in-Your-Dreams-2m10?ref=dreamnotemusic",
    "duration": "2:10"
  },
  {
    "title": "Positive Business",
    "description": "An inspiring, optimistic track featuring piano surrounded by warm synth pads, strings and guitar. Ideal for use in corporate promotional material, presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, synth pad, strings and guitar",
    "tags": "achievement, advertisement, advertising, ambient, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspirational, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, timelapse, upbeat, uplifting",
    "price": 24,
    "date": "2015-10-27",
    "videoId": "0s_7XSYJpbY",
    "youtubeUrl": "https://www.youtube.com/watch?v=0s_7XSYJpbY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800995-Positive-Business-2m22?ref=dreamnotemusic",
    "duration": "2:22"
  },
  {
    "title": "Telling My Story",
    "description": "An atmospheric, sentimental and thought-provoking track featuring solo piano. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of an expressive or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, piano solo, reflective, religion, romantic, sad, sentimental, sorrow, story, thoughtful",
    "price": 20,
    "date": "2015-10-24",
    "videoId": "8qOtNPf0N60",
    "youtubeUrl": "https://www.youtube.com/watch?v=8qOtNPf0N60",
    "productUrl": "https://audiojungle.net/item/telling-my-story/13272805",
    "duration": "3:45"
  },
  {
    "title": "Beautiful Christmas Snowflakes",
    "description": "A magical, atmospheric Christmas track featuring pianos, harp, acoustic guitar, bells, glockenspiel, strings and orchestra. Perfect for time-lapse/photography videos, seasonal adverts/commercials, TV/movies, documentaries, YouTube videos, animations or any project requiring a dreamy, festive backing.",
    "genre": "Christmas",
    "instrumentation": "Piano, harp, acoustic guitar, bells, glockenspiel, strings, woodwind, brass",
    "tags": "advert, ambient, atmospheric, beautiful, bright, christmas, documentary, dreamy, fantasy, festive, holidays, magic, magical, minimalism, nature, photography, relaxing, romantic, scenic, seasonal, sentimental, snow, snowflakes, timelapse, wildlife, winter, wish, wonder, wonderland, xmas",
    "price": 24,
    "date": "2015-10-22",
    "videoId": "Ragoq1yMnqg",
    "youtubeUrl": "https://www.youtube.com/watch?v=Ragoq1yMnqg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483497-Beautiful-Christmas-Snowflakes-2m00?ref=dreamnotemusic",
    "duration": "2:00"
  },
  {
    "title": "Believe and You Will Achieve",
    "description": "An inspiring, uplifting, motivational track featuring a rhythmic string motif, piano and orchestra over a pulsing drum beat. Perfect for use in advertisements, commercials, documentaries, trailers, travel/sport videos, corporate promotions or any project requiring a driven, inspirational musical backing.",
    "genre": "Corporate",
    "instrumentation": "Strings, piano, orchestra, drums",
    "tags": "achieve, adventure, advert, belief, believe, business, cinematic, commercial, company, corporate, documentary, dramatic, dream, driven, exciting, holiday, hopeful, inspirational, journey, motivational, powerful, sports, success, trailer, travel, triumph, uplifting, vacation, win, youtube",
    "price": 24,
    "date": "2015-10-21",
    "videoId": "OAQGr8aCrNk",
    "youtubeUrl": "https://www.youtube.com/watch?v=OAQGr8aCrNk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483894-Believe-and-You-Will-Achieve-2m29?ref=dreamnotemusic",
    "duration": "2:29"
  },
  {
    "title": "Time-lapse Photography",
    "description": "A soothing, relaxing, dreamy track with soft pianos and atmospheric synth pads. Ideal for time-lapse videos, photography presentations, adverts/commercials, TV/movie/film soundtracks or space/sci-fi documentaries.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 24,
    "date": "2015-10-18",
    "videoId": "qfK7t8eIm30",
    "youtubeUrl": "https://www.youtube.com/watch?v=qfK7t8eIm30",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806304-time-lapse-photography-relaxing-ambient-piano-2m06?ref=dreamnotemusic",
    "duration": "2:06"
  },
  {
    "title": "Give Thanks",
    "description": "A heart-warming, sentimental track featuring piano, cello, orchestral strings, woodwind, brass and percussion (piano solo version also included). Perfect for use in adverts/commercials, charity campaigns, Thanksgiving/Christmas themed promotions or wedding videos/slideshows.",
    "genre": "Sentimental",
    "instrumentation": "Piano, cello, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, beautiful, belief, believe, campaign, charity, christmas, church, classical, commercial, donation, emotional, faith, family, god, heartfelt, hope, life, love, memories, montage, moving, piano, religion, romantic, sentimental, spiritual, thanksgiving, wedding, youtube",
    "price": 20,
    "date": "2015-10-17",
    "videoId": "fzEx8-nztIc",
    "youtubeUrl": "https://www.youtube.com/watch?v=fzEx8-nztIc",
    "productUrl": "https://audiojungle.net/item/give-thanks/13162645",
    "duration": "2:34"
  },
  {
    "title": "Ambient Timelapse",
    "description": "A soothing, relaxing, dreamy track with soft pianos, atmospheric synth pads, bass and percussion. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, bass, percussion",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 20,
    "date": "2015-10-16",
    "videoId": "ehmapEHg5jg",
    "youtubeUrl": "https://www.youtube.com/watch?v=ehmapEHg5jg",
    "productUrl": "https://audiojungle.net/item/ambient-timelapse/13135128",
    "duration": "2:42"
  },
  {
    "title": "Playing with Fire",
    "description": "A powerful track with plenty of attitude, featuring a punchy string motif with distortion guitars, hip-hop/rock drums, bass and orchestral brass. Ideal for use in adverts/commercials, movie/film scenes, trailers, video game soundtracks or any project needing a dramatic, intense backing.",
    "genre": "Corporate",
    "instrumentation": "Strings, electric guitars, drums, bass, brass",
    "tags": "action, attitude, battle, cinematic, commercial, confident, dangerous, dark, dramatic, driving, energetic, epic, exciting, fight, gang, gangster, hard, heroic, hip-hop, huge, intense, metal, powerful, rock, spy, thrilling, tough, trailer, video game, war",
    "price": 24,
    "date": "2015-10-12",
    "videoId": "FV59GbX5Ntg",
    "youtubeUrl": "https://www.youtube.com/watch?v=FV59GbX5Ntg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801423-Playing-with-Fire-2m02?ref=dreamnotemusic",
    "duration": "2:02"
  },
  {
    "title": "Happy Playtime",
    "description": "A fun, cheerful track featuring glockenspiel, xylophone, vibraphone and pizzicato strings. Ideal for children’s parties, computer games, youtube videos, comedy sketches, apps, commercials, animations or advertising.",
    "genre": "Children's",
    "instrumentation": "Glockenspiel, xylophone, vibraphone, strings",
    "tags": "animation, bouncy, bright, bubbly, cartoon, catchy, cheerful, cheery, children, energy, fun, funny, glockenspiel, guitar, happy, innocent, joyful, kids, lively, melodic, merry, party, piano, positive, quirky, smile, upbeat, uplifting, vibrant, youthful",
    "price": 16,
    "date": "2015-10-07",
    "videoId": "bLiSZwelClY",
    "youtubeUrl": "https://www.youtube.com/watch?v=bLiSZwelClY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787098-Happy-Playtime-0m43?ref=dreamnotemusic",
    "duration": "0:43"
  },
  {
    "title": "A Beautiful Story",
    "description": "An expressive, emotional track featuring piano, orchestral strings, woodwind, brass and percussion. Ideal for use in adverts/commercials, documentaries, charity campaigns, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, advertisement, beautiful, dreamy, emotional, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestral, peaceful, piano, romantic, sentimental, strings, time-lapse, uplifting, video, violins, warm, wedding",
    "price": 18,
    "date": "2015-10-06",
    "videoId": "I9R-n1hqdG8",
    "youtubeUrl": "https://www.youtube.com/watch?v=I9R-n1hqdG8",
    "productUrl": "https://audiojungle.net/item/a-beautiful-story/13028731",
    "duration": "2:12"
  },
  {
    "title": "African Voices",
    "description": "‘African Voices’ is an uplifting, cinematic track featuring authentic African mixed voices accompanied by choir, percussion, bass and clapping. Perfect for movie/film soundtracks, documentaries, adverts/commercials, vacation/holiday channels, family videos, YouTube or any African themed project.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Choir, voices, percussion, bass, clapping",
    "tags": "adventure, advert, africa, african, chant, choir, cinematic, commercial, cultural, culture, documentary, ethnic, gap year, gospel, holiday, kenya, religious, safari, serengeti, singers, spiritual, summer, traditional, travel, tribal, uplifting, vacation, voice, wildlife, world music",
    "price": 24,
    "date": "2015-10-03",
    "videoId": "0cdwJO5VfkE",
    "youtubeUrl": "https://www.youtube.com/watch?v=0cdwJO5VfkE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/335200747-african-voices-3m25?ref=dreamnotemusic",
    "duration": "3:25"
  },
  {
    "title": "Cute and Fun",
    "description": "A happy, bright, playful track featuring piano, glockenspiel, pizzicato strings and woodwind. Perfect for adverts/commercials, cartoons/animations, background comedy music, YouTube videos, baking/cooking channels, kids ballet class/tutorials or children’s TV shows.",
    "genre": "Children's",
    "instrumentation": "Piano, glockenspiel, strings, woodwind",
    "tags": "advert, background, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, comedy, commercial, cooking, countryside, cute, dance, dancing, english, fun, funny, happy, innocent, kids, kitchen, light-hearted, playful, sweet, twee, youtube",
    "price": 16,
    "date": "2015-10-01",
    "videoId": "g6JW9C7sUw8",
    "youtubeUrl": "https://www.youtube.com/watch?v=g6JW9C7sUw8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756743-Cute-and-Fun-0m43?ref=dreamnotemusic",
    "duration": "0:43"
  },
  {
    "title": "Christmas Logo 5",
    "description": "A short, bright jingle/logo/ident featuring sleigh bells, flute, piano, glockenspiel, xylophone, woodwind and strings. Ideal for use in Christmas advertisements, commercials, YouTube vlogs/videos, radio intros, video games, apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, flute, piano, glockenspiel, xylophone, woodwindl strings",
    "tags": "advertising, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, tubular bells, vlogmas, web intro, xmas, youtube",
    "price": 10,
    "date": "2015-09-30",
    "videoId": "lSxcEgricIs",
    "youtubeUrl": "https://www.youtube.com/watch?v=lSxcEgricIs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756745-Christmas-Logo-5?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Never Stop Believing",
    "description": "An inspiring, expressive and beautiful track featuring piano with french horn, cello and orchestral strings. An ideal backing for advertisements, documentaries, wedding videos, family videos, photo slide shows or a video montage.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, french horn, cello. orchestral strings",
    "tags": "advert, advertisement, beautiful, belief, believe, campaign, charity, church, commemorative, commercial, documentary, donate, dreaming, family, family tree, heartfelt, inspirational, life, love, memories, montage, moving, nature, reflective, religion, romantic, sentimental, spiritual, uplifting, youtube",
    "price": 24,
    "date": "2015-09-30",
    "videoId": "kcrZtDOMlzs",
    "youtubeUrl": "https://www.youtube.com/watch?v=kcrZtDOMlzs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800540-Never-Stop-Believing-3m24?ref=dreamnotemusic",
    "duration": "3:24"
  },
  {
    "title": "Hope and Faith",
    "description": "An emotional, uplifting track featuring piano with orchestral strings, choir, woodwind and brass. Ideal for use in adverts/commercials, TV charity appeals, documentaries, movie/film trailers/soundtracks, videos of a religious/spiritual nature or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano with orchestral strings, choir, woodwind, brass",
    "tags": "advert, atmospheric, beautiful, belief, believe, charity, church, cinematic, commercial, documentary, donate, emotional, faith, god, good will, hope, hopeful, inspirational, jesus, love, memories, moving, prayer, religion, religious, soundtrack, spiritual, trailer, uplifting, worship",
    "price": 20,
    "date": "2015-09-29",
    "videoId": "eNl2zlHTYLw",
    "youtubeUrl": "https://www.youtube.com/watch?v=eNl2zlHTYLw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787142-Hope-and-Faith-1m49?ref=dreamnotemusic",
    "duration": "1:49"
  },
  {
    "title": "Royal Baroque",
    "description": "A regal, traditional classical track featuring orchestral strings, harpsichord and trumpet. Perfect for advertising/commercials, history documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, harpsichord, trumpet",
    "tags": "advert, allegro, antiques, bach, baroque, british, classic, classical, commercial, documentary, drama, heritage, historical, history, lively, majestic, old, old-fashioned, period drama, proud, regal, renaissance, royal, royalty, stately, traditional, tv, twee, vivaldi, wedding",
    "price": 16,
    "date": "2015-09-29",
    "videoId": "wYhMw5DnHXQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=wYhMw5DnHXQ",
    "productUrl": "https://audiojungle.net/item/royal-baroque/12967585",
    "duration": "1:26"
  },
  {
    "title": "British Period Drama",
    "description": "A charming, traditional track, featuring piano, oboe, french horn, harp, orchestral strings, woodwind, brass and percussion. Perfect for adverts/commercials, TV period dramas, historical documentaries, baking/cooking channels, nature/country living channels or family videos.",
    "genre": "Classical",
    "instrumentation": "Piano, oboe, french horn, harp, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, antiques, baking, british, castle, ceremony, charming, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, english, heritage, historical, history, kitchen, nature, period drama, proud, regal, royal, royalty, traditional, twee, wedding, youtube",
    "price": 18,
    "date": "2015-09-26",
    "videoId": "YPgo1TPvGX0",
    "youtubeUrl": "https://www.youtube.com/watch?v=YPgo1TPvGX0",
    "productUrl": "https://audiojungle.net/item/british-period-drama/12944242",
    "duration": "1:42"
  },
  {
    "title": "Sentimental Piano",
    "description": "An atmospheric, emotional and thought-provoking track featuring solo piano. Ideal for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of a reflective or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, beautiful, belief, believe, calm, charity, commercial, documentary, donate, dreamy, emotional, heartfelt, lonely, love, melancholy, mellow, memories, nostalgic, peaceful, piano, piano solo, reflective, religion, romantic, sad, sentimental, sorrow, story, thoughtful",
    "price": 24,
    "date": "2015-09-24",
    "videoId": "gnOqyB5-HAI",
    "youtubeUrl": "https://www.youtube.com/watch?v=gnOqyB5-HAI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804486-Sentimental-Piano-2m20?ref=dreamnotemusic",
    "duration": "2:20"
  },
  {
    "title": "British History",
    "description": "A majestic, patriotic, traditional track with an uplifting orchestral theme featuring strings, french horn, trumpet, woodwind and brass, accompanied by a rhythmic, marching snare-drum. Perfect for graduation/awards ceremonies, historical documentaries/period dramas, military-themed computer/arcade games or film/movie soundtracks.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, french horn, trumpet, woodwind, brass, snare-drum.",
    "tags": "army, brass, ceremonial, ceremony, classical, documentary, fanfare, graduation, grand, historical, history, honor, honour, majestic, march, memorial, military, noble, patriotic, period drama, pompous, pride, proud, regal, royal, royalty, snare-drum, solider, stately, Toy Soldiers",
    "price": 18,
    "date": "2015-09-23",
    "videoId": "2ZYSA-CpaUw",
    "youtubeUrl": "https://www.youtube.com/watch?v=2ZYSA-CpaUw",
    "productUrl": "https://audiojungle.net/item/british-history/12913384",
    "duration": "1:32"
  },
  {
    "title": "Family Moments",
    "description": "An expressive, emotional track featuring piano, acoustic guitar, orchestral strings, woodwind and brass. Ideal for use in adverts/commercials, documentaries, family videos/montages, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, orchestral strings, woodwind, brass",
    "tags": "advert, advertisement, beautiful, dreamy, emotional, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestral, peaceful, piano, romantic, sentimental, strings, time-lapse, uplifting, video, violins, warm, wedding",
    "price": 20,
    "date": "2015-09-22",
    "videoId": "mWYn5AODWfk",
    "youtubeUrl": "https://www.youtube.com/watch?v=mWYn5AODWfk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785917-Family-Moments-1m47?ref=dreamnotemusic",
    "duration": "1:47"
  },
  {
    "title": "Corporate Business",
    "description": "A positive, optimistic track featuring piano surrounded by warm synth pads, strings and drums (version without drums included). Ideal for use in corporate promotional material, presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, synth pads, strings, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2015-09-20",
    "videoId": "SLDkv9Dq-WU",
    "youtubeUrl": "https://www.youtube.com/watch?v=SLDkv9Dq-WU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756772-Corporate-Business-1m55?ref=dreamnotemusic",
    "duration": "1:55"
  },
  {
    "title": "Beautiful English Countryside",
    "description": "A charming, traditional, classical track, featuring piano, oboe, clarinet, french horn, glockenspiel, orchestral strings and woodwind. Perfect for adverts/commercials, nature/history documentaries, farming/country living videos, TV dramas or YouTube videos.",
    "genre": "Classical",
    "instrumentation": "Piano, oboe, clarinet, french horn, glockenspiel, orchestral strings, woodwind",
    "tags": "advert, advertising, antique, baking, bright, british, classic, classical, commercial, cooking, cooking show, country living, countryside, Daytime TV, documentary, english, family, farming, food, happy, historical, history, kitchen, nature, period drama, playful, traditional, tv, twee, youtube",
    "price": 16,
    "date": "2015-09-17",
    "videoId": "HNP8kEQI5sA",
    "youtubeUrl": "https://www.youtube.com/watch?v=HNP8kEQI5sA",
    "productUrl": "https://audiojungle.net/item/beautiful-english-countryside/12860580",
    "duration": "1:15"
  },
  {
    "title": "Ambient Advert",
    "description": "An atmospheric, soothing, dreamy track with soft pianos, synth pads and warm strings. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, synth pads, strings",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 18,
    "date": "2015-09-15",
    "videoId": "kF3Csm5rKA4",
    "youtubeUrl": "https://www.youtube.com/watch?v=kF3Csm5rKA4",
    "productUrl": "https://audiojungle.net/item/ambient-advert/12847754",
    "duration": "1:57"
  },
  {
    "title": "Cooking Up a Storm",
    "description": "A lively, charming, traditional track, featuring piano, glockenspiel, clarinet, bassoon, oboe, orchestral strings and brass. Perfect for adverts/commercials, baking/cooking/food channels, nature/history documentaries, farming/country living videos or TV/YouTube videos.",
    "genre": "Classical",
    "instrumentation": "Piano, glockenspiel, clarinet, bassoon, oboe, orchestral strings and brass.",
    "tags": "advert, advertising, baking, bright, british, classic, classical, commercial, cooking, cooking show, country living, countryside, Daytime TV, documentary, english, family, farmer, farming, food, happy, historical, history, kitchen, nature, period drama, playful, traditional, tv, twee, youtube",
    "price": 16,
    "date": "2015-09-13",
    "videoId": "2vTCklInJ8s",
    "youtubeUrl": "https://www.youtube.com/watch?v=2vTCklInJ8s",
    "productUrl": "https://audiojungle.net/item/cooking-up-a-storm/12831497",
    "duration": "1:14"
  },
  {
    "title": "Halloween Night",
    "description": "A quirky, spooky track featuring harpsichord, piano, glockenspiel, orchestral strings, woodwind, brass and percussion. Perfect for use in horror animations, movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, video games, YouTube videos or any project with a spooky tone.",
    "genre": "Horror",
    "instrumentation": "Harpsichord, piano, glockenspiel, orchestral strings, woodwind, brass, percussion",
    "tags": "animation, cartoon, comedy, creepy, dead, death, evil, fear, funny, ghost, ghouls, halloween, harpsichord, haunted, haunted house, horror, ident, logo, murder, mysterious, mystery, nightmare, opener, quirky, scary, spooky, suspense, thriller, trick or treat, vlogtober",
    "price": 16,
    "date": "2015-09-11",
    "videoId": "qo1lfVUW-EQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=qo1lfVUW-EQ",
    "productUrl": "https://audiojungle.net/item/halloween-night/12814278",
    "duration": "1:27"
  },
  {
    "title": "Passing of Time",
    "description": "An ambient, soothing, dreamy track with soft pianos and atmospheric synth pads. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 18,
    "date": "2015-09-10",
    "videoId": "GaqZ4KCUV_8",
    "youtubeUrl": "https://www.youtube.com/watch?v=GaqZ4KCUV_8",
    "productUrl": "https://audiojungle.net/item/passing-of-time/12800303",
    "duration": "1:52"
  },
  {
    "title": "Cinematic Logo 6",
    "description": "This dramatic, cinematic logo features french horn, cellos, piano and trumpets accompanied by strings, choir, woodwind, brass and percussion, building towards an expressive orchestral climax in true Hollywood style. Ideal for use as a movie opening, film company intro, YouTube video logo, reveal or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion",
    "tags": "big screen, cinematic, climax, credits, crescendo, film, film ident, film intro, growing, hollywood, ident, inspirational, intro, logo, motion picture, movie, opening, orchestra, orchestral, piano, pictures, powerful, reveal, strings, sweeping, title, title music, titles, trailer",
    "price": 12,
    "date": "2015-09-08",
    "videoId": "uit01EwD-wc",
    "youtubeUrl": "https://www.youtube.com/watch?v=uit01EwD-wc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756477-Cinematic-Logo-6?ref=dreamnotemusic",
    "duration": "0:18"
  },
  {
    "title": "English Country Living",
    "description": "A charming, traditional track featuring piano, glockenspiel, orchestral strings, woodwind and brass. Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind and brass",
    "tags": "advert, baking, british, charming, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, family life, farming, happy, innocent, kitchen, light, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 20,
    "date": "2015-09-07",
    "videoId": "VlvNVoheSrc",
    "youtubeUrl": "https://www.youtube.com/watch?v=VlvNVoheSrc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784591-English-Country-Living-1m22?ref=dreamnotemusic",
    "duration": "1:22"
  },
  {
    "title": "English Stately Home",
    "description": "A charming, traditional track featuring piano, glockenspiel, orchestral strings, woodwind, brass and percussion. Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, antiques, baking, british, ceremony, charming, classic, classical, commercial, country, country living, countryside, Daytime TV, documentary, england, english, heritage, historical, history, kitchen, nature, period drama, proud, regal, royal, royalty, traditional, twee, wedding, youtube",
    "price": 16,
    "date": "2015-09-03",
    "videoId": "N2HAAc9kwjg",
    "youtubeUrl": "https://www.youtube.com/watch?v=N2HAAc9kwjg",
    "productUrl": "https://audiojungle.net/item/english-stately-home/12721462",
    "duration": "1:15"
  },
  {
    "title": "Life is a Gift",
    "description": "An expressive, emotional track featuring piano, acoustic guitar, glockenspiel, orchestral strings and brass. Ideal for use in adverts/commercials, documentaries, family videos/montages, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, glockenspiel, orchestral strings, brass",
    "tags": "advert, advertisement, commemorative, dreaming, dreamy, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, romantic, sentimental, strings, time-lapse, uplifting, video, warm, wedding",
    "price": 20,
    "date": "2015-09-03",
    "videoId": "OUGSW4FiNnE",
    "youtubeUrl": "https://www.youtube.com/watch?v=OUGSW4FiNnE",
    "productUrl": "https://audiojungle.net/item/life-is-a-gift/12717418",
    "duration": "2:08"
  },
  {
    "title": "English Countryside",
    "description": "A charming, traditional track featuring piano, glockenspiel, orchestral strings, woodwind, brass and percussion. Perfect for adverts/commercials, documentaries, baking/cooking channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, baking, british, charming, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, family life, farming, happy, innocent, kitchen, light, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 16,
    "date": "2015-08-30",
    "videoId": "uT3RiVs3MoA",
    "youtubeUrl": "https://www.youtube.com/watch?v=uT3RiVs3MoA",
    "productUrl": "https://audiojungle.net/item/english-countryside/12666972",
    "duration": "1:06"
  },
  {
    "title": "Christmas Logo 4",
    "description": "A short, bright jingle/logo/ident featuring sleigh bells, piano, glockenspiel, xylophone, choir and strings. Ideal for use in Christmas advertisements, commercials, YouTube vlogs/videos, radio intros, video games, apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, piano, glockenspiel, xylophone, choir, strings",
    "tags": "advertising, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, tubular bells, vlogmas, web intro, xmas, youtube",
    "price": 10,
    "date": "2015-08-28",
    "videoId": "bKCFCa3EEVY",
    "youtubeUrl": "https://www.youtube.com/watch?v=bKCFCa3EEVY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756624-christmas-logo-4-bright-orchestral-jingle?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Dramatic Baroque",
    "description": "A lively, traditional classical track featuring piano, orchestral strings, harpsichord, woodwind and choir. Perfect for documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Classical",
    "instrumentation": "Piano, orchestral strings, harpsichord, woodwind, choir",
    "tags": "advert, advertising, antiques, architecture, bank, baroque, british, classic, classical, countdown, documentary, drama, dramatic, english, exciting, historical, history, intense, old, old-fashioned, period drama, powerful, proud, regal, renaissance, royal, royalty, stately, traditional, tv",
    "price": 16,
    "date": "2015-08-27",
    "videoId": "Y6UBEsqD36g",
    "youtubeUrl": "https://www.youtube.com/watch?v=Y6UBEsqD36g",
    "productUrl": "https://audiojungle.net/item/dramatic-baroque/12631360",
    "duration": "1:10"
  },
  {
    "title": "Halloween Logo 2",
    "description": "Featuring harpsichord, ghostly female voice and orchestra, this Halloween logo/ident/intro/opener is perfect for any Halloween/horror themed adverts/commercials, YouTube videos, games, TV/radio specials or cartoons/animations.",
    "genre": "Horror",
    "instrumentation": "Harpsichord, female voice, choir, orchestra",
    "tags": "animation, cartoon, comedy, creepy, dracula, fear, funny, ghosts, ghouls, halloween, harpsichord, haunted, haunted house, haunting, horror, ident, logo, monsters, opener, operatic voice, playful, quirky, scary, skeletons, spooky, strings, trick or treat, vlogtober, witch, youtube",
    "price": 10,
    "date": "2015-08-27",
    "videoId": "1QtTbnhG2GY",
    "youtubeUrl": "https://www.youtube.com/watch?v=1QtTbnhG2GY",
    "productUrl": "https://audiojungle.net/item/halloween-logo-2/12640407",
    "duration": "0:12"
  },
  {
    "title": "Creepy Horror Theme",
    "description": "A dark, haunting, cinematic track featuring piano, music box, celesta, sustained tremolo strings and sinister orchestral tones. Ideal for use in horror and thriller movie/film soundtracks, trailers, mystery documentaries, Halloween TV/radio specials, ghost story audiobooks, video games, YouTube videos or any project with a spooky, creepy tone.",
    "genre": "Horror",
    "instrumentation": "Piano, music box, celesta, orchestral strings, woodwind, brass",
    "tags": "atmospheric, creepy, dark, dead, death, demented, evil, film score, ghost, ghost story, gothic, halloween, haunted house, haunting, hell, history, horror, murder, music box, mysterious, mystery, night, nightmare, scary, sinister, soundtrack, spooky, suspense, thriller, twisted",
    "price": 18,
    "date": "2015-08-26",
    "videoId": "8NLHC5eRIro",
    "youtubeUrl": "https://www.youtube.com/watch?v=8NLHC5eRIro",
    "productUrl": "https://audiojungle.net/item/creepy-horror-theme/12609620",
    "duration": "1:30"
  },
  {
    "title": "To Have and To Hold",
    "description": "A beautiful and romantic track featuring piano, acoustic guitar and orchestral strings. An ideal backing for weddings, family videos, photo slide shows, a video montage or any project of an expressive nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, acoustic guitar, orchestral strings",
    "tags": "advert, advertisement, beautiful, bride, ceremony, dream, dreamy, family, family tree, happy, heartfelt, hopeful, inspirational, inspiring, life, love, marriage, memories, montage, moving, nature, piano, proposal, romance, romantic, sentimental, strings, valentines, video, wedding",
    "price": 20,
    "date": "2015-08-26",
    "videoId": "ddmuwqyeaTg",
    "youtubeUrl": "https://www.youtube.com/watch?v=ddmuwqyeaTg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806721-To-Have-and-To-Hold-1m53?ref=dreamnotemusic",
    "duration": "1:53"
  },
  {
    "title": "Family Life",
    "description": "A quirky, lively track featuring piano, harp, orchestral strings, woodwind, glockenspiel, xylophone, bass and percussion. Perfect for apps, computer games, adverts/commercials, YouTube organizational/cleaning videos/vlogs, daytime TV or baking/cooking shows/channels.",
    "genre": "Comedy",
    "instrumentation": "Piano, harp, orchestral strings, woodwind, glockenspiel, xylophone, bass and percussion.",
    "tags": "advert, app, baking, busy, chores, cleaning, comedic, commercial, computer game, cooking, Daytime TV, de-clutter, domestic, funny, game, happy, housewife, housework, kitchen, lifestyle, lively, organization, playful, quirky, shopping, supermarket, tidying, time-lapse, vlog, youtube",
    "price": 16,
    "date": "2015-08-24",
    "videoId": "_r-1-ROeLdc",
    "youtubeUrl": "https://www.youtube.com/watch?v=_r-1-ROeLdc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785969-Family-Life-0m50?ref=dreamnotemusic",
    "duration": "0:50"
  },
  {
    "title": "Twisted Circus",
    "description": "A weird, creepy, dark circus theme, featuring accordion, psaltery, guitar, glockenspiel, clarinet, drums and bass. Perfect for use in horror movie/film soundtracks, trailers, TV, mystery documentaries, Halloween specials, YouTube videos or video games.",
    "genre": "Horror",
    "instrumentation": "Accordion, psaltery, guitar, glockenspiel, clarinet, drums, bass",
    "tags": "carnival, circus, clown, creepy, dark, freakshow, freaky, ghost, halloween, haunted, haunting, horror, ident, intro, logo, murder, mysterious, mystery, night, nightmare, opener, scary, spooky, suspense, theme, trailer, tv, twisted, weird, youtube",
    "price": 14,
    "date": "2015-08-21",
    "videoId": "qoXoldvSMk4",
    "youtubeUrl": "https://www.youtube.com/watch?v=qoXoldvSMk4",
    "productUrl": "https://audiojungle.net/item/twisted-circus/12518000",
    "duration": "1:06"
  },
  {
    "title": "Baking Up a Treat",
    "description": "A quaint, playful track, featuring piano, glockenspiel, strings and woodwind. Perfect for adverts/commercials, documentaries, nature/country living videos, baking/cooking/food channels, ballet class/tutorials or children’s TV shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, strings, woodwind",
    "tags": "advert, baking, ballerina, ballet, ballet class, british, charming, child, children, classical, commercial, cooking, country, country living, countryside, cute, dance, dancing, english, food, fun, happy, innocent, kitchen, light-hearted, nature, playful, sweet, twee, youtube",
    "price": 14,
    "date": "2015-08-20",
    "videoId": "D2av53HD23A",
    "youtubeUrl": "https://www.youtube.com/watch?v=D2av53HD23A",
    "productUrl": "https://audiojungle.net/item/baking-up-a-treat/12497788",
    "duration": "1:05"
  },
  {
    "title": "Music Box Lullaby",
    "description": "A dreamy, soothing lullaby. Perfect for crib/cot mobiles, apps, kids' TV/animations or YouTube videos.",
    "genre": "Children's",
    "instrumentation": "Music box",
    "tags": "angelic, animation, app, baby, ballerina, ballet, beautiful, bedtime, cartoon, child, children, cot, crib, dream, dreamy, fairytale, fantasy, fiction, kids, lullaby, magical, mobile, music box, Nursery Rhyme, relaxing, sleep, sleeping, soothing, toddler, youtube",
    "price": 16,
    "date": "2015-08-20",
    "videoId": "GI2RnKDie8k",
    "youtubeUrl": "https://www.youtube.com/watch?v=GI2RnKDie8k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796697-Music-Box-Lullaby-0m49?ref=dreamnotemusic",
    "duration": "0:49"
  },
  {
    "title": "Time-lapse",
    "description": "An ambient, soothing, dreamy track with soft pianos, atmospheric synth pads, warm strings, bass and drums. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pad, strings, bass, drums",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 20,
    "date": "2015-08-20",
    "videoId": "sSVLJuik97o",
    "youtubeUrl": "https://www.youtube.com/watch?v=sSVLJuik97o",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201807132-time-lapse-ambient-dreamy-background-1m59?ref=dreamnotemusic",
    "duration": "1:59"
  },
  {
    "title": "Tidying Up",
    "description": "A lively, busy, quirky track featuring piano, ukulele, glockenspiel, xylophone, bass, orchestral strings, woodwind, brass and percussion. Perfect for adverts/commercials, documentaries, daytime TV, baking/cooking shows/channels or YouTube organisational/cleaning videos.",
    "genre": "Comedy",
    "instrumentation": "Piano, ukulele, glockenspiel, xylophone, bass, orchestral strings, woodwind, brass, percussion",
    "tags": "1950s, advert, baking, busy, chores, cleaning, comedic, commercial, cooking, Daytime TV, declutter, documentary, domestic, funny, happy, housewife, housework, kitchen, lifestyle, lively, organization, playful, quirky, retro, shopping, supermarket, tidying, time-lapse, vlog, youtube",
    "price": 20,
    "date": "2015-08-19",
    "videoId": "LZmh52o-4NY",
    "youtubeUrl": "https://www.youtube.com/watch?v=LZmh52o-4NY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806197-Tidying-Up-1m26?ref=dreamnotemusic",
    "duration": "1:26"
  },
  {
    "title": "Christmas Logo 3",
    "description": "A short, bright jingle/logo/ident featuring sleigh bells, piano, glockenspiel, xylophone and strings. Ideal for use in Christmas advertisements, commercials, YouTube vlogs/videos, radio intros, video games, apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, piano, glockenspiel, xylophone, strings",
    "tags": "advertising, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, tubular bells, vlogmas, web intro, xmas, youtube",
    "price": 10,
    "date": "2015-08-17",
    "videoId": "ADQvfLEKBb0",
    "youtubeUrl": "https://www.youtube.com/watch?v=ADQvfLEKBb0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756771-christmas-logo-3-bright-orchestral-jingle?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Halloween Logo 1",
    "description": "Featuring harpsichord, ghostly female voice and orchestra, this Halloween logo/intro/ident/opener is perfect for any Halloween/horror themed adverts/commercials, YouTube videos, games, TV/radio specials or cartoons/animations.",
    "genre": "Horror",
    "instrumentation": "Harpsichord, female voice, orchestra",
    "tags": "animation, cartoon, comedy, creepy, dracula, fear, funny, ghosts, ghouls, halloween, harpsichord, haunted, haunted house, haunting, horror, ident, logo, monsters, opener, operatic voice, playful, quirky, scary, skeletons, spooky, strings, trick or treat, vlogtober, witch, youtube",
    "price": 12,
    "date": "2015-08-17",
    "videoId": "-7yjBtJEgJE",
    "youtubeUrl": "https://www.youtube.com/watch?v=-7yjBtJEgJE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787141-Halloween-Logo-1?ref=dreamnotemusic",
    "duration": "0:11"
  },
  {
    "title": "Icing the Cake",
    "description": "A charming, traditional track, featuring pianos, glockenspiel, orchestral strings, woodwind and brass. Perfect for adverts/commercials, documentaries, baking/cooking/food channels, nature/country living videos, family videos or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind, brass",
    "tags": "advert, baking, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, farming, food, happy, innocent, kitchen, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 20,
    "date": "2015-08-16",
    "videoId": "C3a3OTO45gc",
    "youtubeUrl": "https://www.youtube.com/watch?v=C3a3OTO45gc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793715-Icing-the-Cake-1m16?ref=dreamnotemusic",
    "duration": "1:16"
  },
  {
    "title": "Optimistic Future",
    "description": "An ambient and atmospheric track featuring layered pianos and dreamy synth pads. Ideal for adverts/commercials, movie/film soundtracks, corporate/business presentations and time-lapse videos.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertisement, advertising, beautiful, charity, commercial, corporate, documentary, dreaming, dreamy, emotional, family, heartfelt, inspiring, life, love, magical, memories, montage, moving, nature, romantic, sentimental, space, thoughtful, time-lapse, tv, wedding, wildlife, wonderland",
    "price": 18,
    "date": "2015-08-15",
    "videoId": "jEBQ7oeZero",
    "youtubeUrl": "https://www.youtube.com/watch?v=jEBQ7oeZero",
    "productUrl": "https://audiojungle.net/item/optimistic-future/12424815",
    "duration": "1:30"
  },
  {
    "title": "Bright Ideas",
    "description": "With a hopeful, positive tone, ‘Bright Ideas’ features a repeating piano motif surrounded by warm synth pads, strings, pianos and drums. Ideal for use in corporate promotional material, presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, synth pads, strings, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 16,
    "date": "2015-08-07",
    "videoId": "miCGWmGzNpQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=miCGWmGzNpQ",
    "productUrl": "https://audiojungle.net/item/bright-ideas/12342447",
    "duration": "1:17"
  },
  {
    "title": "English Country Kitchen",
    "description": "A charming, traditional track featuring piano, orchestral strings, woodwind and brass. Perfect for adverts/commercials, documentaries, nature/country living videos, baking/cooking/food channels or TV/radio shows.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, clarinet, cello, orchestral strings, woodwind, brass",
    "tags": "advert, baking, british, charming, children, classic, classical, commercial, cooking, country, country living, countryside, Daytime TV, documentary, english, farming, food, happy, innocent, kitchen, light-hearted, nature, nice, playful, radio, sweet, theme, traditional, twee, youtube",
    "price": 20,
    "date": "2015-08-06",
    "videoId": "erzC0Iv8K3M",
    "youtubeUrl": "https://www.youtube.com/watch?v=erzC0Iv8K3M",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784506-English-Country-Kitchen-1m04?ref=dreamnotemusic",
    "duration": "1:04"
  },
  {
    "title": "A Wise Investment",
    "description": "A positive and inspirational track, featuring piano and orchestra. Ideal for use in TV adverts/commercials, documentaries, movie/film soundtracks, radio, corporate presentations or any project requiring a positive, motivational musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra",
    "tags": "accomplish, achieve, adventure, advert, banking, believe, challenge, cinematic, commercial, company, confident, corporate, documentary, faith, grand, holiday, hope, journey, lively, money, motivational, movie, powerful, struggle, success, travel, triumph, tv, uplifting, win",
    "price": 20,
    "date": "2015-08-05",
    "videoId": "ifDdlMhR3_A",
    "youtubeUrl": "https://www.youtube.com/watch?v=ifDdlMhR3_A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311789-A-Wise-Investment-1m07?ref=dreamnotemusic",
    "duration": "1:07"
  },
  {
    "title": "Friends and Family",
    "description": "An expressive, emotional track featuring piano, acoustic guitar, orchestral strings and brass. Ideal for use in adverts/commercials, documentaries, family videos/montages, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, acoustic guitar, orchestral string, brass",
    "tags": "advert, advertisement, commemorative, dreaming, dreamy, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, romantic, sentimental, strings, time-lapse, uplifting, video, warm, wedding",
    "price": 24,
    "date": "2015-08-03",
    "videoId": "4hxlpL9MXWM",
    "youtubeUrl": "https://www.youtube.com/watch?v=4hxlpL9MXWM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785986-Friends-and-Family-2m12?ref=dreamnotemusic",
    "duration": "2:12"
  },
  {
    "title": "English Heritage",
    "description": "A positive, traditional track featuring piano, orchestral strings, woodwind, brass and percussion. Perfect for wedding ceremonies, wedding videos, documentaries, TV/movie/film scenes, period dramas or any project of a historical nature.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, glockenspiel, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, advertising, antiques, bank, bright, british, ceremony, classic, classical, confident, countryside, documentary, english, historical, history, inspiring, motivational, nature, old, old-fashioned, period drama, proud, regal, royal, royalty, stately, traditional, tv, uplifting, wedding",
    "price": 16,
    "date": "2015-07-31",
    "videoId": "g_R7cDrms24",
    "youtubeUrl": "https://www.youtube.com/watch?v=g_R7cDrms24",
    "productUrl": "https://audiojungle.net/item/english-heritage/12278048",
    "duration": "1:23"
  },
  {
    "title": "Heavenly Atmospheric Choir",
    "description": "A beautiful, spiritual track featuring a glorious blend of sustained voices singing in harmony. Perfect for weddings, funerals, remembrance services, commemorative videos, advertisements, documentaries, family videos, photo slide shows or any project with an emotional, inspirational tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Choir, voices",
    "tags": "angelic, angels, beautiful, children, choir, church, cinematic, emotional, expressive, female voice, funeral, glorious, glory, god, heaven, heavenly, hopeful, hymn, inspirational, moving, peaceful, reflective, religious, singers, singing, spiritual, uplifting, vocal, voice, wedding",
    "price": 24,
    "date": "2015-07-29",
    "videoId": "Ssm6jyi4vgU",
    "youtubeUrl": "https://www.youtube.com/watch?v=Ssm6jyi4vgU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787042-Heavenly-Atmospheric-Choir-2m03?ref=dreamnotemusic",
    "duration": "2:03"
  },
  {
    "title": "This is Our Business",
    "description": "With a hopeful, positive tone, ‘This is Our Business’ features a repeating piano motif surrounded by warm synth pads, strings, pianos and percussion. Ideal for use in corporate promotional material, presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, synth pad, strings, drums",
    "tags": "achievement, advertisement, advertising, background, brand, bright, business, commercial, confidence, confident, corporate, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 24,
    "date": "2015-07-28",
    "videoId": "9R3mZPbVKHQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=9R3mZPbVKHQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806306-This-is-Our-Business-2m18?ref=dreamnotemusic",
    "duration": "2:18"
  },
  {
    "title": "Find Beauty in Everything",
    "description": "A beautiful and tranquil track, featuring piano, acoustic guitar and strings. Ideal for use in advertisements, commercials, documentaries, TV, movies, family videos or any project requiring an expressive, thought-provoking musical backing.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, strings",
    "tags": "advert, advertising, atmospheric, beautiful, beauty, calm, cinematic, commercial, documentary, emotional, expressive, family tree, family video, inspirational, love, memories, movie, moving, peaceful, pensive, piano, relaxing, romantic, serene, soundtrack, strings, thought-provoking, time-lapse, tranquil, uplifting",
    "price": 20,
    "date": "2015-07-27",
    "videoId": "t3jEw8BilZs",
    "youtubeUrl": "https://www.youtube.com/watch?v=t3jEw8BilZs",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785995-Find-Beauty-in-Everything-1m30?ref=dreamnotemusic",
    "duration": "1:30"
  },
  {
    "title": "Sad Piano",
    "description": "An emotional and thought-provoking track featuring solo piano. Ideal for use in advertisements, commercials, documentaries, movie/film soundtracks or any project of a reflective or melancholic nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "ambient, atmospheric, beautiful, calm, cinematic, dark, death, depressing, dream, elegant, emotional, film, haunting, lonely, melancholy, mellow, memories, movie, nostalgic, peaceful, piano, piano solo, reflective, relaxed, romantic, sad, sentimental, sorrow, thoughtful, twilight",
    "price": 16,
    "date": "2015-07-24",
    "videoId": "QFrAKODrZ84",
    "youtubeUrl": "https://www.youtube.com/watch?v=QFrAKODrZ84",
    "productUrl": "https://audiojungle.net/item/sad-piano/12211493",
    "duration": "1:01"
  },
  {
    "title": "Our Special Day",
    "description": "A beautiful, expressive and dreamy track featuring piano, cello, acoustic guitar, harp, orchestral strings and woodwind. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, fantasy/love themes, TV, documentaries, movies/films, period dramas or any project of a heartfelt, romantic nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, acoustic guitar, harp, orchestral strings, woodwind",
    "tags": "anniversary, baby, beautiful, birth, bride, classic, dreaming, dreamy, enchanting, engagement, fairytale, family, happiness, heartfelt, inspirational, life, love, magical, marriage, marry, movie, nature, procession, proposal, romance, romantic, sentimental, wedding, wedding ceremony, wedding music",
    "price": 24,
    "date": "2015-07-19",
    "videoId": "RehRd4oDwUE",
    "youtubeUrl": "https://www.youtube.com/watch?v=RehRd4oDwUE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801508-Our-Special-Day-2m05?ref=dreamnotemusic",
    "duration": "2:05"
  },
  {
    "title": "Majestic Brass Fanfare Ident",
    "description": "Trumpets, trombones and french horns playing a confident, uplifting regal fanfare. Perfect for graduation/awards ceremonies, sporting events, film/movie company intros/logos, TV or YouTube videos.",
    "genre": "Classical",
    "instrumentation": "Trumpets, trombones, french horns",
    "tags": "atmospheric, brass, celebration, ceremony, epic, event, fanfare, festive, glory, graduation, heroes, honour, joyous, majestic, march, memorial, military, moving, olympics, patriotic, pride, regal, remembrance, royal, royalty, sporting, summer games, trumpet, uplifting, war",
    "price": 10,
    "date": "2015-07-18",
    "videoId": "XdtrSxPGdqI",
    "youtubeUrl": "https://www.youtube.com/watch?v=XdtrSxPGdqI",
    "productUrl": "https://audiojungle.net/item/majestic-brass-fanfare-ident/12130909",
    "duration": "0:17"
  },
  {
    "title": "In a Time-lapse",
    "description": "An ambient, soothing, dreamy track with soft pianos, atmospheric synth pads and subtle drums. Ideal for adverts/commercials, movie/film soundtracks, space/sci-fi documentaries, TV, time-lapse videos or photography presentations.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads, drums",
    "tags": "advert, advertising, ambient, art, beautiful, chill, cityscape, commercial, corporate, documentary, dreaming, dreamy, inspiring, life, modern, montage, moving, nature, night, photography, relaxing, scenery, scenic, sci-fi, sleep, soundscape, space, technology, thoughts, time-lapse",
    "price": 16,
    "date": "2015-07-17",
    "videoId": "9iXSG1kRoiM",
    "youtubeUrl": "https://www.youtube.com/watch?v=9iXSG1kRoiM",
    "productUrl": "https://audiojungle.net/item/in-a-timelapse/12125688",
    "duration": "1:28"
  },
    {
    "title": "Birthday Wishes",
    "description": "A dreamy, magical original birthday song, featuring female vocals, piano, orchestral strings, woodwind, brass, choir and percussion. Perfect for films/movies, TV, animations, adverts/commercials and family videos. Included in both wav and mp3 formats.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Female vocals, piano, orchestral strings, woodwind, brass, choir and percussion",
    "tags": "angelic, animation, atmospheric, beautiful, believe, birthday, celebration, child, children, dream, dreamy, emotional, fairy, fantasy, female voice, festive, happiness, happy birthday, magic, magical, memories, musical theatre, princess, song, soundtrack, sweet, uplifting, wish, wonderland, young voice",
    "price": 20,
    "date": "2015-07-16",
    "videoId": "I8tJwUju4wM",
    "youtubeUrl": "https://www.youtube.com/watch?v=I8tJwUju4wM",
    "productUrl": "https://audiojungle.net/item/birthday-wishes/55772306",
    "duration": "2:56"
  },
  {
    "title": "Family Tree",
    "description": "A beautiful, peaceful track featuring piano with expressive strings and orchestra. An ideal backing for advertisements, documentaries, wedding/family videos, photo slide shows/video montage or any project with an emotional or optimistic tone.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, heartfelt, hope, hopeful, inspirational, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2015-07-07",
    "videoId": "hcqUUJrWjP8",
    "youtubeUrl": "https://www.youtube.com/watch?v=hcqUUJrWjP8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785434-Family-Tree-2m16?ref=dreamnotemusic",
    "duration": "2:16"
  },
  {
    "title": "A New Beginning",
    "description": "A calm, soothing, dreamy track with subtle pianos, atmospheric strings and synth pads. Ideal for adverts/commercials, movie/film soundtracks, wildlife/nature documentaries, corporate presentations, wedding videos, family videos or any project with an inspirational tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, synth pads",
    "tags": "advert, advertisement, advertising, beautiful, charity, commercial, corporate, documentary, dreaming, dreamy, emotional, family, heartfelt, inspiring, life, love, magical, memories, montage, moving, nature, romantic, sentimental, space, thoughtful, time-lapse, tv, wedding, wildlife, wonderland",
    "price": 24,
    "date": "2015-07-03",
    "videoId": "iB23JH2Y0CY",
    "youtubeUrl": "https://www.youtube.com/watch?v=iB23JH2Y0CY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311548-A-New-Beginning-2m24?ref=dreamnotemusic",
    "duration": "2:24"
  },
  {
    "title": "Cinematic Logo 5",
    "description": "This dramatic, cinematic logo features a powerful french horn melody accompanied by orchestral strings, brass, woodwind and percussion, building towards an expressive orchestral climax in true Hollywood style. Ideal for use as a movie opening, film company intro, youtube video logo, reveal or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion",
    "tags": "action, adventure, big screen, blockbuster, cinematic, credits, dramatic, epic, film, hollywood, honor, honour, ident, intro, journey, logo, military, motion picture, movie, opening, pictures, pirates, powerful, reveal, sailor, sea, titles, trailer, voyage, youtube",
    "price": 12,
    "date": "2015-06-25",
    "videoId": "U8rGW2uE0Uo",
    "youtubeUrl": "https://www.youtube.com/watch?v=U8rGW2uE0Uo",
    "productUrl": "https://audiojungle.net/item/cinematic-logo-5/11883979",
    "duration": "0:20"
  },
  {
    "title": "Atmospheric Movie Trailer",
    "description": "An uplifting, patriotic, cinematic orchestral track featuring french horn solo, strings, brass, woodwind, choir and military snare-drum. Perfect for use in movie/film/game soundtracks, trailers, teasers, promos, TV, documentaries or any sci-fi/fantasy/military/historically themed project.",
    "genre": "Cinematic Trailers",
    "instrumentation": "French horn, strings, brass, woodwind, choir, snare-drum",
    "tags": "army, atmospheric, battle, choir, cinematic, dramatic, epic, fantasy, film, game, grand, historic, honor, honour, hope, inspiring, love, memorial, military, mission, movie, patriotic, pride, soundtrack, space, teaser, trailer, tv, uplifting, war",
    "price": 24,
    "date": "2015-06-24",
    "videoId": "QDeKILqZgwI",
    "youtubeUrl": "https://www.youtube.com/watch?v=QDeKILqZgwI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311810-Atmospheric-Movie-Trailer-2m30?ref=dreamnotemusic",
    "duration": "2:30"
  },
  {
    "title": "Cinematic Logo 4",
    "description": "This magical, cinematic logo features an expressive orchestral crescendo in true Hollywood style, making the perfect movie opening, film company intro, YouTube video logo, reveal or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion",
    "tags": "big screen, cinematic, climax, credits, crescendo, film, film ident, film intro, growing, hollywood, ident, intro, logo, magical, motion picture, movie, opening, orchestra, piano, pictures, powerful, reveal, strings, sweeping, title, title music, titles, trailer, violins, youtube",
    "price": 12,
    "date": "2015-06-16",
    "videoId": "6wSZBhxkrBM",
    "youtubeUrl": "https://www.youtube.com/watch?v=6wSZBhxkrBM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756465-Cinematic-Logo-4?ref=dreamnotemusic",
    "duration": "0:18"
  },
  {
    "title": "Happy Memories",
    "description": "Featuring piano with acoustic guitar, expressive strings and orchestra, this beautiful, uplifting track builds gradually from a subtle piano motif before fading away to end peacefully. An ideal backing for advertisements, documentaries, wedding videos, family videos, photo slide shows or a video montage.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, orchestral strings, brass, woodwind",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, family tree, happiness, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2015-06-16",
    "videoId": "yP7K9gjv3xo",
    "youtubeUrl": "https://www.youtube.com/watch?v=yP7K9gjv3xo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787228-Happy-Memories-2m49?ref=dreamnotemusic",
    "duration": "2:49"
  },
  {
    "title": "Summer",
    "description": "A happy, positive indie rock track featuring female vocals with electric guitars, bass, drums and tambourine (Instrumental versions also included). An ideal backing for TV/radio advertisements, YouTube videos, vacation videos, family videos, photo slide shows or any project with a fun, cheerful mood.",
    "genre": "Corporate",
    "instrumentation": "Female voice, electric guitar, bass, drums, percussion",
    "tags": "advert, band, beach, bright, california, catchy, cheerful, commercial, dance, energetic, fun, gap year, happiness, happy, holiday, indie, marketing, memories, motivational, party, playful, positive, rock, song, summer, surf, tv, uplifting, vacation, vocals",
    "price": 24,
    "date": "2015-06-16",
    "videoId": "gKsla6U-05I",
    "youtubeUrl": "https://www.youtube.com/watch?v=gKsla6U-05I",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804603-Summer-2m37?ref=dreamnotemusic",
    "duration": "2:37"
  },
  {
    "title": "Dreaming",
    "description": "An emotional and atmospheric track, featuring classical guitar, sustained piano and warm orchestral strings. Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, family videos, photo slide shows or any project of a reflective or romantic nature.",
    "genre": "Sentimental",
    "instrumentation": "Classical guitar, piano, orchestral strings",
    "tags": "ambient, atmospheric, beautiful, book trailer, calm, cinematic, classical, dream, dreamy, elegant, emotional, film, heaven, honeymoon, love, meditation, melancholy, mellow, memories, movie, nostalgic, peaceful, reflective, relaxed, romantic, sad, sentimental, sunset, thoughtful, twilight",
    "price": 24,
    "date": "2015-05-27",
    "videoId": "tTnjsprn8x8",
    "youtubeUrl": "https://www.youtube.com/watch?v=tTnjsprn8x8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781758-Dreaming-2m46?ref=dreamnotemusic",
    "duration": "2:46"
  },
  {
    "title": "Catwalk Fashion Show",
    "description": "Funky guitars, drums, bass, electric pianos, strings and percussion, blending elements of funk, disco and house music. Perfect for fashion/clothes shows, TV adverts/commercials, YouTube celebrity/fashion videos, slide-show presentations or any project with a modern, cool, hip vibe.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, drums, bass, electric piano, strings, percussion",
    "tags": "advertising, attitude, catwalk, celebrity, chic, clothes show, club, commercial, cool, dance, designer, disco, famous, fashion, fashion show, funk, funky, glamour, gossip, groovy, model, modelling, nightclub, party, photo shoot, promo, runway, slideshow, style, trendy",
    "price": 20,
    "date": "2015-05-26",
    "videoId": "ZeYadoSIzB4",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZeYadoSIzB4",
    "productUrl": "https://audiojungle.net/item/catwalk-fashion-show/11551561",
    "duration": "Length TBC"
  },
  {
    "title": "Inspire the World",
    "description": "An uplifting, cinematic track featuring piano and orchestra. Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, travel videos, corporate presentations or any project requiring a motivational, thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestra",
    "tags": "accomplish, achieve, adventure, advert, believe, challenge, cinematic, commercial, company, corporate, documentary, faith, grand, hope, inspirational, journey, magical, motivational, movie, moving, powerful, religious, success, thought-provoking, trailer, travel, triumph, uplifting, win, wonder",
    "price": 16,
    "date": "2015-05-21",
    "videoId": "rxzG3RwW4Gk",
    "youtubeUrl": "https://www.youtube.com/watch?v=rxzG3RwW4Gk",
    "productUrl": "https://audiojungle.net/item/inspire-the-world/11511668",
    "duration": "1:40"
  },
  {
    "title": "Atmospheric Vocal Ident",
    "description": "With haunting female vocals accompanied by sustained orchestral strings, this cinematic vocal ident is both dark and atmospheric. Perfect for use in a movie/film/game soundtrack, trailer, teaser, TV drama or youtube intro/video.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Female voice, orchestral strings",
    "tags": "angelic, apocalypse, atmospheric, beautiful, cinematic, dark, documentary, fantasy, female voice, film, game, ghostly, haunting, heavenly, horror, ident, intro, logo, movie, moving, mysterious, mystery, opener, scary, suspense, teaser, tense, video game, war, war cry",
    "price": 12,
    "date": "2015-05-20",
    "videoId": "6g_jF8zbMko",
    "youtubeUrl": "https://www.youtube.com/watch?v=6g_jF8zbMko",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311807-Atmospheric-Vocal-Ident?ref=dreamnotemusic",
    "duration": "0:24"
  },
  {
    "title": "Spiritual Choir",
    "description": "A beautiful, atmospheric track featuring a glorious blend of sustained voices singing in harmony. Perfect for weddings, funerals, remembrance services, commemorative videos, advertisements, documentaries, family videos, photo slide shows or any project with an emotional, inspirational tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Choir, voices",
    "tags": "angelic, angels, beautiful, children, choir, church, cinematic, emotional, expressive, female voice, funeral, glory, god, heaven, heavenly, hopeful, hymn, inspirational, male voice, moving, peaceful, reflective, religious, singers, singing, spiritual, uplifting, vocal, voice, wedding",
    "price": 20,
    "date": "2015-05-16",
    "videoId": "4ZNsfWhCjGQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=4ZNsfWhCjGQ",
    "productUrl": "https://audiojungle.net/item/spiritual-choir/11456108",
    "duration": "2:27"
  },
  {
    "title": "New-Age Wonder",
    "description": "A calm, soothing, dreamy track with subtle pianos and atmospheric synth pads. Ideal for adverts/commercials, TV/movie/film soundtracks, wildlife/nature documentaries, wedding videos, family videos or any project with an emotional or sentimental tone.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertisement, advertising, beautiful, birth, charity, children, commercial, documentary, dreaming, dreamy, emotional, family, heartfelt, inspirational, life, love, memories, montage, moving, nature, romantic, sentimental, space, thoughtful, time-lapse, tv, wedding, wildlife, wonderland",
    "price": 20,
    "date": "2015-05-12",
    "videoId": "rkX1S6euBF0",
    "youtubeUrl": "https://www.youtube.com/watch?v=rkX1S6euBF0",
    "productUrl": "https://audiojungle.net/item/newage-wonder/11416053",
    "duration": "2:21"
  },
  {
    "title": "Something to Believe in",
    "description": "A beautiful, emotional and hopeful track, featuring piano, orchestral strings, woodwind, brass and percussion. Ideal for use in adverts/commercials, documentaries, family videos/montages, movie/film/TV soundtracks, videos of a religious/spiritual nature or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, atmospheric, beautiful, belief, church, cinematic, commemorative, documentary, emotional, faith, family, god, heartfelt, hopeful, inspirational, jesus, journey, life, love, memories, moving, nature, piano, prayer, religious, romantic, sentimental, spiritual, wedding, worship",
    "price": 20,
    "date": "2015-05-11",
    "videoId": "q9E4Th-mmU8",
    "youtubeUrl": "https://www.youtube.com/watch?v=q9E4Th-mmU8",
    "productUrl": "https://audiojungle.net/item/something-to-believe-in/11409590",
    "duration": "1:46"
  },
  {
    "title": "Beautiful Children's Choir",
    "description": "This elegant and uplifting choral track features young children’s voices singing peacefully in harmony. Both inspiring and emotional, this cinematic track would be perfect for any atmospheric film/movie soundtrack, trailer, documentary, wedding video or projects of a spiritual nature.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Voices, choir",
    "tags": "angelic, angels, beautiful, boys, children, choir, church, cinematic, dreamy, emotional, expressive, gentle, glorious, glory, god, hopeful, hymn, inspirational, inspiring, moving, peaceful, reflective, religious, singing, soft, tender, uplifting, vocal, voice, wonderful",
    "price": 24,
    "date": "2015-05-06",
    "videoId": "yUMmJ0UB9z4",
    "youtubeUrl": "https://www.youtube.com/watch?v=yUMmJ0UB9z4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483479-Beautiful-Children's-Choir-2m04?ref=dreamnotemusic",
    "duration": "2:04"
  },
  {
    "title": "Cinematic Logo 3",
    "description": "This dramatic, cinematic logo features french horn, cello and trumpet melody accompanied by strings, woodwind, brass and percussion, building towards an expressive orchestral climax in true Hollywood style. Ideal for use as a movie opening, film company intro, youtube video logo, reveal or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion",
    "tags": "big screen, cinematic, climax, credits, crescendo, film, film ident, film intro, growing, hollywood, ident, inspirational, intro, logo, motion picture, movie, opening, orchestra, orchestral, piano, pictures, powerful, reveal, strings, sweeping, title, title music, titles, trailer, youtube",
    "price": 10,
    "date": "2015-05-04",
    "videoId": "E0H2MNbvr-E",
    "youtubeUrl": "https://www.youtube.com/watch?v=E0H2MNbvr-E",
    "productUrl": "https://audiojungle.net/item/cinematic-logo-3/11314755",
    "duration": "0:18"
  },
  {
    "title": "Timeless",
    "description": "Featuring piano with expressive strings, acoustic guitar and orchestra, this beautiful track builds gradually over a subtle piano motif towards an emotional climax. An ideal backing for adverts/commercials, documentaries, wedding videos, TV/film/movie soundtracks, family videos, photo slide-shows or any project with an inspiring, hopeful tone.",
    "genre": "Wedding",
    "instrumentation": "Piano, strings, acoustic guitar, orchestra",
    "tags": "advert, advertisement, beautiful, classic, commemorative, commercial, dreams, dreamy, family, heartfelt, hope, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, piano, reflective, romantic, sentimental, strings, timeless, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2015-04-28",
    "videoId": "fKmLYY0q_xc",
    "youtubeUrl": "https://www.youtube.com/watch?v=fKmLYY0q_xc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201805739-Timeless-2m25?ref=dreamnotemusic",
    "duration": "2:25"
  },
  {
    "title": "Together at Last",
    "description": "An expressive, romantic track featuring beautiful piano, acoustic guitar and orchestra (piano solo version also included). Perfect for Valentine’s Day videos, weddings, movie love scenes, advertisements, family videos or a photo montage.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, orchestra",
    "tags": "anniversary, beautiful, dreamy, emotional, engagement, fiance, girlfriend, husband, inspirational, joyful, life, love, marriage, memories, montage, moving, orchestra, piano, proposal, propose, romance, romantic, sentimental, strings, valentine, valentine's day, valentines, video, wedding, wife",
    "price": 24,
    "date": "2015-04-24",
    "videoId": "fiNVi7uWpag",
    "youtubeUrl": "https://www.youtube.com/watch?v=fiNVi7uWpag",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201807353-Together-at-Last-3m23?ref=dreamnotemusic",
    "duration": "3:23"
  },
  {
    "title": "Country Folk Groove",
    "description": "Acoustic guitars, slide guitars, banjo, upright bass, drums, percussion, foot stomps and claps, blending elements of American country music with a fun blues boogie vibe. Perfect for TV, adverts/commercials, computer/arcade games, YouTube videos, comedy sketches, kids' TV, apps or animations.",
    "genre": "Acoustic",
    "instrumentation": "Banjo, acoustic guitar, slide guitar, dobro, harmonica, upright bass, drums",
    "tags": "acoustic guitar, america, american, americana, banjo, boogie, bouncy, bright, cartoon, catchy, cheerful, children, comedy, country, folk, fun, funny, happy, joyful, kids, lively, merry, positive, quirky, redneck, slide guitar, southern, steel guitar, upbeat, usa",
    "price": 20,
    "date": "2015-04-22",
    "videoId": "eUymLFzbd-0",
    "youtubeUrl": "https://www.youtube.com/watch?v=eUymLFzbd-0",
    "productUrl": "https://audiojungle.net/item/country-folk-groove/11168960",
    "duration": "2:08"
  },
  {
    "title": "Serenity",
    "description": "A beautiful, dreamy track featuring piano, cello, strings and glockenspiel (two piano solo versions also included). Perfect for weddings, wedding videos, family videos, remembrance videos, film/movie scenes, TV, meditation recordings or any project requiring a subtle, calm backing.",
    "genre": "Sentimental",
    "instrumentation": "Piano, cello, strings, glockenspiel",
    "tags": "beautiful, bride, dreaming, dreamy, emotional, enchanting, engagement, fairytale, family, fantasy, heartfelt, honeymoon, laid-back, love, magical, marriage, marry, meditation, nature, proposal, relaxing, romantic, sad, sentimental, slow, soothing, sunrise, wedding, wedding ceremony, wedding music",
    "price": 24,
    "date": "2015-04-22",
    "videoId": "zRfY4dtdBUQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=zRfY4dtdBUQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804629-Serenity-2m05?ref=dreamnotemusic",
    "duration": "2:05"
  },
  {
    "title": "Sentimental Feelings",
    "description": "Featuring an atmospheric piano motif and orchestra, this beautiful track builds gradually with the introduction of cello, acoustic guitar, strings, woodwind, brass and percussion towards an emotional climax, before fading away to end peacefully. An ideal backing for advertisements, documentaries, film/TV soundtracks, wedding videos, family videos, photo slide shows or a youtube video/montage.",
    "genre": "Sentimental",
    "instrumentation": "Piano, cello, acoustic guitar, strings, woodwind, brass",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, family tree, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, movie, moving, nature, orchestral, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2015-04-20",
    "videoId": "Z8erMllKnGY",
    "youtubeUrl": "https://www.youtube.com/watch?v=Z8erMllKnGY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804715-Sentimental-Feelings-2m18?ref=dreamnotemusic",
    "duration": "2:18"
  },
  {
    "title": "Corporate Success",
    "description": "An encouraging and optimistic track featuring piano, guitar, drums, bass and orchestral strings. Ideal for any motivational production, corporate presentation, promotional material or inspirational video.",
    "genre": "Corporate",
    "instrumentation": "Piano, guitar, drums, bass, orchestral strings",
    "tags": "achievement, advert, aspiring, business, challenge, college, commercial, company, confidence, corporate, energetic, finance, happy, hopeful, inspirational, journey, marketing, motivational, open day, optimistic, pitch, positive, presentation, product, promo, promotional, sales, success, university, uplifting",
    "price": 24,
    "date": "2015-04-18",
    "videoId": "p4_IJYi-uEE",
    "youtubeUrl": "https://www.youtube.com/watch?v=p4_IJYi-uEE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756458-Corporate-Success-2m45?ref=dreamnotemusic",
    "duration": "2:45"
  },
  {
    "title": "Dramatic Cinematic Ident",
    "description": "A gripping, powerful, intense track featuring orchestra backed by persistent, forceful taiko drums. Big, bold and tense, this is perfect for those hard-hitting action film/movie/game trailers/teasers or as an intro, logo or riser.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, brass, percussion",
    "tags": "action, aggressive, apocalypse, battle, big, build up, dramatic, epic trailer, exciting, fighting, film trailer, game trailer, hit, ident, intense, intro, logo, loud, movie trailer, powerful, riser, rising, scary, teaser, tense, terror, thriller, tough, video game, war",
    "price": 14,
    "date": "2015-04-18",
    "videoId": "JVf-iivvg8E",
    "youtubeUrl": "https://www.youtube.com/watch?v=JVf-iivvg8E",
    "productUrl": "https://audiojungle.net/item/dramatic-cinematic-ident/11118583",
    "duration": "0:30"
  },
  {
    "title": "Horror Movie Lullaby",
    "description": "An atmospheric, creepy, haunting lullaby/film score theme featuring music box, celeste and piano. Ideal for use in horror movie trailers, documentaries, Halloween specials, movie scores, TV soundtracks, ghost story audiobooks, thrillers and video games.",
    "genre": "Horror",
    "instrumentation": "Music box, celesta, piano",
    "tags": "carnival, child, circus, creepy, dark, death, demented, demon, evil, film score, ghost, gothic, halloween, haunted, haunting, hell, horror, lullaby, murder, music box, night, nightmare, possessed, psycho, scary, serial killer, soundtrack, spooky, suspense, trailer",
    "price": 20,
    "date": "2015-04-17",
    "videoId": "5V4ipKw4mGk",
    "youtubeUrl": "https://www.youtube.com/watch?v=5V4ipKw4mGk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787196-Horror-Movie-Lullaby-1m05?ref=dreamnotemusic",
    "duration": "1:05"
  },
  {
    "title": "Sunrise",
    "description": "A beautiful, expressive and dreamy track featuring piano, cello, orchestral strings and woodwind. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, fantasy/love themes, TV, documentaries, movies/films, period dramas or any project of a heartfelt, romantic nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, cello, orchestral strings, woodwind",
    "tags": "beautiful, bride, classic, documentary, dreaming, dreamy, enchanting, engagement, fairytale, family, fantasy, film, happiness, heartfelt, inspirational, love, magical, marriage, marry, movie, nature, proposal, romantic, sentimental, sunrise, time-lapse, waltz, wedding, wedding ceremony, wedding music",
    "price": 24,
    "date": "2015-04-16",
    "videoId": "yx9ZNUAxvVE",
    "youtubeUrl": "https://www.youtube.com/watch?v=yx9ZNUAxvVE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804785-Sunrise-2m18?ref=dreamnotemusic",
    "duration": "2:18"
  },
  {
    "title": "Retro TV Ident",
    "description": "A quirky, happy, uplifting theme-tune featuring piano, Hammond organ, wurly, Rhodes piano, bass, hand claps and drums. Ideal for use in a TV sitcom, comedy show, web series, YouTube video, video intro or as a TV/radio jingle.",
    "genre": "Comedy",
    "instrumentation": "Piano, Hammond organ, Wurlitzer, Rhodes piano, bass, hand claps and drums.",
    "tags": "60s, 70s, advert, advertising, comedian, comedy, commercial, cool, friends, fun, funky, funny, happy, ident, intro, jingle, logo, opener, podcast, quirky, radio, sitcom, talk show, theme, theme tune, tv, video intro, vlog, webisode, youtube",
    "price": 10,
    "date": "2015-04-15",
    "videoId": "DlB-Eq0QRt0",
    "youtubeUrl": "https://www.youtube.com/watch?v=DlB-Eq0QRt0",
    "productUrl": "https://audiojungle.net/item/retro-tv-ident/11068111",
    "duration": "0:17"
  },
  {
    "title": "Heaven on Earth",
    "description": "A beautiful, atmospheric track featuring piano, choir and orchestra. Ideal for use in TV, movies/films, game soundtracks, videos of a religious or spiritual nature or any project requiring a thought-provoking, heavenly musical backing.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings, choir",
    "tags": "advert, afterlife, angel, angelic, atmospheric, beautiful, believe, choir, church, cinematic, death, dreamy, ebook trailer, emotional, faith, fantasy, ghost, god, haunting, heaven, heavenly, love, memories, prayer, religious, remembrance, romance, soundtrack, spiritual, thought-provoking",
    "price": 24,
    "date": "2015-04-14",
    "videoId": "YbT-add5Vyo",
    "youtubeUrl": "https://www.youtube.com/watch?v=YbT-add5Vyo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787259-Heaven-on-Earth-2m26?ref=dreamnotemusic",
    "duration": "2:26"
  },
  {
    "title": "The Beauty of Life",
    "description": "An emotional and thought-provoking track featuring piano and orchestra (piano solo version also included). Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, family videos or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestra",
    "tags": "advert, atmospheric, beautiful, book trailer, calm, cinematic, commercial, documentary, emotional, family, film, heartfelt, hope, hopeful, inspirational, love, memories, movie, moving, nature, nostalgic, orchestral, piano, romance, romantic, sad, soundtrack, thought-provoking, trailer, wedding",
    "price": 24,
    "date": "2015-04-11",
    "videoId": "YoVaH_-3ZW8",
    "youtubeUrl": "https://www.youtube.com/watch?v=YoVaH_-3ZW8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806450-The-Beauty-of-Life-2m32?ref=dreamnotemusic",
    "duration": "2:32"
  },
  {
    "title": "Cinematic Movie Ident",
    "description": "An exciting, powerful, epic track featuring suspenseful orchestral strings backed by persistent, aggressive synth bass, taiko drums and percussion (version without strings also included). Big, bold and tense, this is perfect for those hard-hitting action film/movie/game trailers/teasers or as an intro, logo or riser.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestra, percussion",
    "tags": "action, aggressive, apocalypse, battle, big, build up, dramatic, epic trailer, exciting, fighting, film trailer, game trailer, hit, ident, intense, intro, logo, loud, massive, movie trailer, powerful, riser, rising, scary, teaser, tense, terror, tough, video game, war",
    "price": 20,
    "date": "2015-04-10",
    "videoId": "JFFZtCcEeBg",
    "youtubeUrl": "https://www.youtube.com/watch?v=JFFZtCcEeBg",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756789-Cinematic-Movie-Ident?ref=dreamnotemusic",
    "duration": "0:25"
  },
  {
    "title": "Dangerous Games",
    "description": "A powerful track with plenty of force and attitude, featuring a fearless string motif with distortion guitars, hip-hop/rock drums, bass, orchestra and synths. Ideal for use in adverts/commercials, movie/film scenes, trailers, sports videos or any project needing a dramatic, intense backing.",
    "genre": "Corporate",
    "instrumentation": "Electric guitars, drums, bass, orchestra, synths",
    "tags": "action, attitude, battle, cinematic, commercial, confident, danger, dark, determined, dramatic, driving, energetic, epic, exciting, gangster, hard, heavy, heroic, hip-hop, huge, intense, motivational, positive, powerful, rock, thrilling, tough, trailer, video game, war",
    "price": 24,
    "date": "2015-04-08",
    "videoId": "4WQtz5eUeXE",
    "youtubeUrl": "https://www.youtube.com/watch?v=4WQtz5eUeXE",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781790-Dangerous-Games-2m09?ref=dreamnotemusic",
    "duration": "2:09"
  },
  {
    "title": "Happy School Days",
    "description": "An uplifting, fun track with upbeat ukulele, whistling, hand-claps, piano, recorder, guitars, upright bass, drums, vibraphone and glockenspiel. This positive track is perfect for commercials, advertising, motivational corporate presentations, TV, children’s games, educational apps/videos, family vacation videos or any project with a feel-good vibe.",
    "genre": "Children's",
    "instrumentation": "Ukulele, piano, recorder, guitars, upright bass, drums, vibraphone, glockenspiel",
    "tags": "advert, app, carefree, catchy, cheerful, children, commercial, confident, corporate, energetic, family, fun, game, happy, holiday, inspirational, kids, motivational, optimistic, party, play, playful, positive, presentation, school, summer, tv, ukulele, uplifting, vacation",
    "price": 20,
    "date": "2015-04-04",
    "videoId": "WFpr3i-qjFw",
    "youtubeUrl": "https://www.youtube.com/watch?v=WFpr3i-qjFw",
    "productUrl": "https://audiojungle.net/item/happy-school-days/10933395",
    "duration": "2:07"
  },
  {
    "title": "Modern News Ident",
    "description": "This modern news theme features a pulsing drum beat, synth pads, bass, ticking clock and beep effect, building towards a powerful close. Ideal for TV news channels, YouTube news videos, radio station news reports or any type of corporate announcements, breaking news, headlines, media or broadcasting.",
    "genre": "Corporate",
    "instrumentation": "Drums, synth pads, bass, sound effects",
    "tags": "announcement, broadcast, broadcasting, business report, celebrity, corporate, dramatic, entertainment, evening news, exciting, feature, featurette, global, gossip, gripping, headlines, ident, intro, logo, media, network, news, opening, presentation, promo, radio, sports report, tense, tv, youtube",
    "price": 12,
    "date": "2015-04-02",
    "videoId": "gjOXQlNZtuA",
    "youtubeUrl": "https://www.youtube.com/watch?v=gjOXQlNZtuA",
    "productUrl": "https://audiojungle.net/item/modern-news-ident/10904784",
    "duration": "Length TBC"
  },
  {
    "title": "Have Faith",
    "description": "An uplifting, inspiring track featuring piano and orchestra. Ideal for use in advertisements, commercials, documentaries, trailers/soundtracks, movies/films, videos of a religious or spiritual nature, charity appeals, sporting events/presentations or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "piano, orchestral strings, woodwind, brass, choir",
    "tags": "advert, atmospheric, beautiful, belief, believe, champion, charity, church, cinematic, documentary, education, emotional, faith, god, grand, hope, hopeful, inspirational, love, memories, moving, prayer, religious, soundtrack, spiritual, sport, thought-provoking, trailer, uplifting, worship",
    "price": 20,
    "date": "2015-04-01",
    "videoId": "4pScZuRQeV8",
    "youtubeUrl": "https://www.youtube.com/watch?v=4pScZuRQeV8",
    "productUrl": "https://audiojungle.net/item/have-faith/10885267",
    "duration": "1:42"
  },
  {
    "title": "Follow Your Dreams",
    "description": "Piano with expressive strings and orchestra. The track builds gradually from a dreamy piano introduction towards an emotional climax, before fading away to end peacefully. An ideal backing for advertisements, documentaries, wedding videos, family videos, photo slide shows or a video montage.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, family tree, heartfelt, hope, hopeful, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 24,
    "date": "2015-03-31",
    "videoId": "-Lenoee82G0",
    "youtubeUrl": "https://www.youtube.com/watch?v=-Lenoee82G0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785300-Follow-Your-Dreams-3m30?ref=dreamnotemusic",
    "duration": "3:30"
  },
  {
    "title": "New Ideas",
    "description": "With a hopeful, bright, inspiring tone, ‘New Ideas’ features a repeating piano motif surrounded by warm strings, pads and percussion. Ideal for use in advertising/commercials, radio, documentaries, family videos or any project with an optimistic, hopeful tone.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, synth pads, percussion",
    "tags": "achievement, advert, advertising, beautiful, bright, business, children, commercial, corporate, documentary, family, freedom, happy, hopeful, innocence, inspirational, inspiring, kids, marketing, motivational, nature, optimistic, positive, presentation, promotional, sales, successful, sweet, uplifting, youthful",
    "price": 24,
    "date": "2015-03-31",
    "videoId": "jTOg0O-Xmz0",
    "youtubeUrl": "https://www.youtube.com/watch?v=jTOg0O-Xmz0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801168-New-Ideas-2m50?ref=dreamnotemusic",
    "duration": "2:50"
  },
  {
    "title": "Classical Wedding",
    "description": "A beautiful, expressive and dreamy track featuring piano, cello, brass, strings and oboe. Perfect for wedding/commitment ceremonies, wedding videos, family videos, photo slide shows, fantasy/love themes, TV, documentaries, movies/films, period dramas or any project of a heartfelt, romantic nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, brass, strings, oboe",
    "tags": "beautiful, bride, classic, documentary, dreaming, dreamy, enchanting, engagement, fairytale, family, fantasy, film, happiness, heartfelt, inspirational, love, magical, marriage, marry, movie, nature, procession, proposal, romantic, sentimental, time-lapse, waltz, wedding, wedding ceremony, wedding music",
    "price": 24,
    "date": "2015-03-29",
    "videoId": "oqV323O4DXw",
    "youtubeUrl": "https://www.youtube.com/watch?v=oqV323O4DXw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756841-Classical-Wedding-2m57?ref=dreamnotemusic",
    "duration": "2:57"
  },
  {
    "title": "The Journey Begins",
    "description": "An atmospheric, inspirational track featuring piano, strings, brass, woodwind and orchestral percussion. Ideal for use in movie/film/game soundtracks, trailers, commercials, documentaries, TV, animation or any project requiring a thought-provoking, uplifting musical backing.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestral strings, brass, woodwind, percussion",
    "tags": "adventure, army, atmospheric, cinematic, documentary, emotional, epic, fantasy, film, game, honour, hope, hopeful, innocence, inspirational, magical, memories military, mission, movie, moving, patriotic, proud, remembrance, soundtrack, space, trailer, uplifting, war",
    "price": 20,
    "date": "2015-03-27",
    "videoId": "c9AQ_w9KXaA",
    "youtubeUrl": "https://www.youtube.com/watch?v=c9AQ_w9KXaA",
    "productUrl": "https://audiojungle.net/item/the-journey-begins/10822964",
    "duration": "2:54"
  },
  {
    "title": "Cheeky Monkeys",
    "description": "A fun, playful track featuring piano, drums, guitar, bass, glockenspiel, vibraphone and percussion. Perfect for children’s parties, computer/arcade games, YouTube videos, comedy sketches, kids' TV, apps, cartoons/animations and adverts/commercials.",
    "genre": "Children's",
    "instrumentation": "Piano, drums, guitar, bass, glockenspiel, vibraphone, percussion.",
    "tags": "animation, app, bouncy, bright, bubbly, cartoon, catchy, cheerful, cheery, children, comedy, fun, funny, happy, innocent, joyful, kids, lively, merry, party, platform game, play, positive, quirky, smile, tv, upbeat, uplifting, vibrant, youthful",
    "price": 20,
    "date": "2015-03-25",
    "videoId": "hFtOkWkDO00",
    "youtubeUrl": "https://www.youtube.com/watch?v=hFtOkWkDO00",
    "productUrl": "https://audiojungle.net/item/cheeky-monkeys/10780932",
    "duration": "Length TBC"
  },
  {
    "title": "Memories",
    "description": "An emotional, reflective track for solo piano. Ideal for use in advertisements, commercials, documentaries, movie/film/TV, family/commemorative videos or any project requiring a thought-provoking, expressive musical backing.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advert, atmospheric, beautiful, book trailer, calm, cinematic, commercial, documentary, emotional, expressive, family video, film, inspirational, love, lullaby, melancholy, memories, movie, moving, passionate, piano, reflective, romantic, sad, sorrow, soundtrack, thought-provoking, tragic, trailer, twilight",
    "price": 24,
    "date": "2015-03-25",
    "videoId": "K5pITC_bBjc",
    "youtubeUrl": "https://www.youtube.com/watch?v=K5pITC_bBjc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796798-Memories-2m30?ref=dreamnotemusic",
    "duration": "2:30"
  },
  {
    "title": "Dreamy Piano",
    "description": "A peaceful and reflective track featuring expressive piano, subtle strings and acoustic guitar. Perfect for adverts/commercials, documentaries, remembrance/commemorative videos, photo slide shows or any project of an emotional nature.",
    "genre": "Piano",
    "instrumentation": "Piano, strings, acoustic guitar",
    "tags": "advert, advertisement, atmospheric, beautiful, birth, chillout, commercial, documentary, dreaming, dreamy, family, heartfelt, inspirational, inspiring, life, love, lullaby, memories, moving, nature, peaceful, piano, relaxing, romantic, sentimental, soothing, sunrise, sunset, wedding, wildlife",
    "price": 24,
    "date": "2015-03-23",
    "videoId": "WLY41c9yc7E",
    "youtubeUrl": "https://www.youtube.com/watch?v=WLY41c9yc7E",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781281-Dreamy-Piano-2m08?ref=dreamnotemusic",
    "duration": "2:08"
  },
  {
    "title": "Against the Clock",
    "description": "A dramatic and exciting track featuring intense orchestra and driving percussion over a persistent ticking sound. Ideal for movie/film /game soundtracks, TV dramas, game shows, competitions, trailers or any project needing a tense, suspenseful backing.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestra, percussion, sound effects",
    "tags": "bomb, challenge, chase, clock, competition, countdown, danger, drama, dramatic, exciting, film, game show, games, gripping, imminent, movie, powerful, promo, race, running, scared, sports, suspense, tense, tick-tock, time, timer, trailer, tv, urgent",
    "price": 16,
    "date": "2015-03-21",
    "videoId": "JVlntglgalY",
    "youtubeUrl": "https://www.youtube.com/watch?v=JVlntglgalY",
    "productUrl": "https://audiojungle.net/item/against-the-clock/10703325",
    "duration": "1:34"
  },
  {
    "title": "Renaissance Dream",
    "description": "A beautiful, atmospheric, enchanting track featuring harp, harpsichord, strings and orchestra. Perfect for wedding ceremonies, wedding videos, documentaries, family videos, photo slide shows, fantasy themes, TV/movie/film scenes, period dramas or any project of an expressive or historical nature.",
    "genre": "Classical",
    "instrumentation": "Harp, harpsichord, orchestral strings, choir",
    "tags": "baroque, beautiful, book trailer, classic, documentary, dreaming, dreamy, enchanting, engagement, fairies, fairytale, family, fantasy, film, folk, heartfelt, historical, history, love, magical, movie, nature, old, romantic, sentimental, soundtrack, tudors, tv, wedding, wonderland",
    "price": 24,
    "date": "2015-03-19",
    "videoId": "M2kzGc7d1F0",
    "youtubeUrl": "https://www.youtube.com/watch?v=M2kzGc7d1F0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804821-Renaissance-Dream-2m08?ref=dreamnotemusic",
    "duration": "2:08"
  },
  {
    "title": "Beautiful World",
    "description": "A calm, soothing, dreamy track with subtle pianos and atmospheric synth pads. Ideal for adverts/commercials, movie/film soundtracks, wildlife/nature documentaries, wedding videos, family videos or any project with an emotional tone.",
    "genre": "Ambient",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertisement, advertising, beautiful, birth, charity, children, commercial, documentary, dreaming, dreamy, emotional, family, heartfelt, inspirational, inspiring, life, love, memories, montage, moving, nature, romantic, sentimental, thoughtful, time-lapse, tv, wedding, wildlife, wonderland",
    "price": 20,
    "date": "2015-03-18",
    "videoId": "Gv_i7MVqbpg",
    "youtubeUrl": "https://www.youtube.com/watch?v=Gv_i7MVqbpg",
    "productUrl": "https://audiojungle.net/item/beautiful-world/10668752",
    "duration": "2:18"
  },
  {
    "title": "Emotional Piano 3",
    "description": "A expressive and thought-provoking track featuring piano with orchestra (piano solo version also included). Ideal for use in advertisements, commercials, documentaries, trailers, movie/film soundtracks, family videos or any project requiring a thought-provoking, inspirational musical backing.",
    "genre": "Piano",
    "instrumentation": "Piano, orchestra",
    "tags": "advert, atmospheric, book trailer, calm, cinematic, commercial, documentary, emotional, fantasy, heartfelt, hope, hopeful, inspirational, love, memories, movie, moving, orchestral, piano, romance, romantic, sad, soundtrack, tearjerker, thought-provoking, time-lapse, trailer, twilight, wedding",
    "price": 24,
    "date": "2015-03-18",
    "videoId": "ZILBBJ3vKeI",
    "youtubeUrl": "https://www.youtube.com/watch?v=ZILBBJ3vKeI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784352-Emotional-Piano-3-3m36?ref=dreamnotemusic",
    "duration": "3:36"
  },
  {
    "title": "Positive Holiday Background",
    "description": "An inspirational, motivational track with a uplifting, feel-good vide featuring piano, strings, bass and drums. Ideal for use in adverts/commercials, vacation/travel videos, holiday resort promos, daytime TV/quiz shows, business presentations, school/university/college promotions or any project of an optimistic, feel-good nature.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, bass, drums, voice",
    "tags": "achievement, advert, business, commercial, company, corporate, Daytime TV, education, encouraging, exercise, freedom, health, healthy living, holiday, hopeful, inspirational, journey, marketing, motivational, open day, optimistic, positive, promo, resort, success, summer, travel, upbeat, uplifting, vacation",
    "price": 24,
    "date": "2015-03-16",
    "videoId": "E7jDSGeHhCU",
    "youtubeUrl": "https://www.youtube.com/watch?v=E7jDSGeHhCU",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801094-Positive-Holiday-Background-2m28?ref=dreamnotemusic",
    "duration": "2:28"
  },
  {
    "title": "Electricity",
    "description": "A fast-paced, motivational dance track featuring pumping drums, lead synth, pads and digital electronic effects. Perfect for use in adverts/commercials, workout/sports videos, commercial business presentations, technological projects, movie/film/TV club scenes or anything with a positive, high-energy vibe.",
    "genre": "Corporate",
    "instrumentation": "Synth, pads, drums",
    "tags": "advert, ambient, atmospheric, beat, car, club, commercial, dance, disco, dj, driving, energetic, energy, exercise, fun, industrial, jumping, lively, motivational, night, party, positive, powerful, pumping, robot, space, techno, technology, time-lapse, workout",
    "price": 24,
    "date": "2015-03-11",
    "videoId": "gRtK-adVZFI",
    "youtubeUrl": "https://www.youtube.com/watch?v=gRtK-adVZFI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784823-Electricity-3m21?ref=dreamnotemusic",
    "duration": "3:21"
  },
  {
    "title": "World of Wonders",
    "description": "An atmospheric, cinematic fantasy track featuring a dreamy harp motif surrounded by sustained orchestral strings, brass, choir, drums and piano. Perfect for movie/film/game soundtracks, adverts/commercials, documentaries, TV dramas or any fantasy/love scene.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Harp, orchestral strings, brass, choir, drums, piano",
    "tags": "atmospheric, beautiful, cinematic, dark, discovery, documentary, dreamy, emotional, enchanting, fantasy, film, harp, haunting, love theme, magical, midnight, movie, mysterious, mystical, nature, night, orchestra, romance, soundtrack, space, tv, twilight, wonder, wonderland, world",
    "price": 24,
    "date": "2015-03-11",
    "videoId": "6FxJyK9LaSA",
    "youtubeUrl": "https://www.youtube.com/watch?v=6FxJyK9LaSA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201807387-World-of-Wonders-3m14?ref=dreamnotemusic",
    "duration": "3:14"
  },
  {
    "title": "Atmospheric Choir",
    "description": "A beautiful, spiritual track featuring a glorious blend of sustained voices singing in harmony. Perfect for weddings, funerals, remembrance services, commemorative videos, advertisements, documentaries, family videos, photo slide shows or any project with an emotional, inspirational tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Choir",
    "tags": "angelic, angels, beautiful, children, choir, church, cinematic, emotional, expressive, female voice, funeral, glorious, glory, god, heaven, heavenly, hopeful, hymn, inspirational, moving, peaceful, reflective, religious, singers, singing, spiritual, uplifting, vocal, voice, wedding",
    "price": 20,
    "date": "2015-03-09",
    "videoId": "gr9BdSNALUk",
    "youtubeUrl": "https://www.youtube.com/watch?v=gr9BdSNALUk",
    "productUrl": "https://audiojungle.net/item/atmospheric-choir/10997555",
    "duration": "2:51"
  },
  {
    "title": "Kids' Party Games",
    "description": "A cheerful, playful track featuring piano, guitar, percussion, hand-claps, bass, trumpets, flute, strings and drums. Ideal for children’s parties, computer games, YouTube videos, comedy sketches, apps, commercials, cartoons/animations or advertising.",
    "genre": "Children's",
    "instrumentation": "Piano, guitar, percussion, bass, trumpets, flute, strings and drums",
    "tags": "animation, beach, bouncy, carnival, catchy, cheesy, children, claps, comedy, dance, energetic, entertaining, fiesta, football, fun, funny, happy, holiday, kids, latin, lively, mariachi, party, platform game, quirky, summer, sun, upbeat, vacation",
    "price": 24,
    "date": "2015-03-03",
    "videoId": "bRlinv1ywOc",
    "youtubeUrl": "https://www.youtube.com/watch?v=bRlinv1ywOc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794911-Kids-Party-Games-2m19?ref=dreamnotemusic",
    "duration": "2:19"
  },
  {
    "title": "Magical Wedding",
    "description": "A beautiful, enchanting track featuring harp, flute, strings and orchestra. Perfect for wedding ceremonies, wedding videos, family videos, photo slide shows, fantasy themes, TV, movies/films, period dramas or any project of an expressive nature.",
    "genre": "Wedding",
    "instrumentation": "Harp, flute, strings, orchestra",
    "tags": "beautiful, bride, child, classical, dreaming, dreamy, enchanting, engagement, fairies, fairytale, family, fantasy, film, flowers, harp, heartfelt, history, innocence, love, magical, movie, nature, period drama, procession, romantic, sentimental, wedding, wedding ceremony, wedding music, wonderland",
    "price": 24,
    "date": "2015-02-25",
    "videoId": "-pcEtQb1o54",
    "youtubeUrl": "https://www.youtube.com/watch?v=-pcEtQb1o54",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201796651-Magical-Wedding-2m27?ref=dreamnotemusic",
    "duration": "2:27"
  },
  {
    "title": "Family",
    "description": "An expressive, sentimental track featuring piano with orchestral strings, woodwind and brass. An ideal backing for advertisements, documentaries, film/TV soundtracks, wedding videos, family videos, photo slide shows or a YouTube video/montage.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind, brass",
    "tags": "advert, advertisement, beautiful, commemorative, commercial, dreaming, dreamy, family, family tree, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, movie, moving, nature, orchestral, piano, reflective, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 20,
    "date": "2015-02-18",
    "videoId": "pInP9qJFVgQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=pInP9qJFVgQ",
    "productUrl": "https://audiojungle.net/item/family/10374698",
    "duration": "3:05"
  },
  {
    "title": "Dramatic News Theme",
    "description": "A pulsing drum beat and strings with an exciting orchestral build-up towards a powerful close. Ideal for TV news channels, YouTube news videos, radio station news reports or any type of corporate announcements, breaking news, headlines, media or broadcasting.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, brass, woodwind, percussion",
    "tags": "announcement, broadcast, broadcasting, business report, corporate, dramatic, entertainment, evening news, exciting, feature, featurette, global, gripping, headlines, ident, intro, logo, media, network, news, opening, powerful, presentation, promo, radio, sport report, strong, tense, tv, youtube",
    "price": 14,
    "date": "2015-02-16",
    "videoId": "pouIraw_j4E",
    "youtubeUrl": "https://www.youtube.com/watch?v=pouIraw_j4E",
    "productUrl": "https://audiojungle.net/item/dramatic-news-theme/10353707",
    "duration": "0:30"
  },
  {
    "title": "Time to Inspire",
    "description": "An encouraging and optimistic track featuring an atmospheric guitar motif surrounded by soft strings, pianos, synth pads, bass and drums. Ideal for any motivational project, TV commercial/advert, news channel, corporate presentation or inspirational video.",
    "genre": "Corporate",
    "instrumentation": "Electric guitar, strings, piano, synth pads, bass, drums",
    "tags": "achievement, advert, business, challenge, commercial, company, conference, corporate, encouraging, finance, freedom, hopeful, industry, innovative, journey, marketing, motivational, multimedia, optimistic, pitch, podcast, positive, presentation, product, promo, promotional, sales, success, training video, uplifting",
    "price": 24,
    "date": "2015-02-14",
    "videoId": "SG6GqXjYT_Q",
    "youtubeUrl": "https://www.youtube.com/watch?v=SG6GqXjYT_Q",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806540-Time-to-Inspire-2m49?ref=dreamnotemusic",
    "duration": "2:49"
  },
  {
    "title": "The Perfect Moment",
    "description": "A beautiful and inspirational track featuring piano with expressive strings and orchestra. An ideal backing for advertisements, documentaries, family videos, photo slide shows, a video montage or any project of an expressive nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, brass",
    "tags": "advert, advertisement, commemorative, dreaming, dreamy, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, romantic, sentimental, strings, time-lapse, uplifting, valentines, video, warm, wedding",
    "price": 24,
    "date": "2015-02-07",
    "videoId": "ngoX-kpLpao",
    "youtubeUrl": "https://www.youtube.com/watch?v=ngoX-kpLpao",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806531-The-Perfect-Moment-2m52?ref=dreamnotemusic",
    "duration": "2:52"
  },
  {
    "title": "Daydreaming",
    "description": "A soft, peaceful and atmospheric piece for solo piano. Perfect for advertisements, documentaries, commemorative videos, photo slide shows or any project of a reflective nature.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "ambient, atmospheric, beautiful, calm, cinematic, classical, dream, dreamy, elegant, emotional, film music, french, lonely, meditation, melancholy, mellow, minimal, minimalism, nostalgic, peaceful, piano, reflective, relaxed, romantic, sad, satie, sentimental, simple, soft, thoughtful",
    "price": 24,
    "date": "2015-02-05",
    "videoId": "oz_Bjp7saa4",
    "youtubeUrl": "https://www.youtube.com/watch?v=oz_Bjp7saa4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781930-Daydreaming-2m26?ref=dreamnotemusic",
    "duration": "2:26"
  },
  {
    "title": "Cinematic Logo 2",
    "description": "This dramatic, cinematic logo features french horn and trumpet melody accompanied by sustained strings and a lively violin motif, building towards an expressive orchestral climax in true Hollywood style. Ideal for use as a movie opening, film company intro, YouTube video logo, reveal or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion",
    "tags": "big screen, cinematic, climax, credits, crescendo, film, film ident, film intro, growing, hollywood, ident, inspirational, intro, logo, motion picture, movie, opening, orchestra, orchestral, piano, pictures, powerful, reveal, strings, sweeping, title, title music, titles, trailer, youtube",
    "price": 12,
    "date": "2015-01-31",
    "videoId": "Bkg9d0pj5Lw",
    "youtubeUrl": "https://www.youtube.com/watch?v=Bkg9d0pj5Lw",
    "productUrl": "https://audiojungle.net/item/cinematic-logo-2/10202162",
    "duration": "0:22"
  },
  {
    "title": "Angelic Choir",
    "description": "A beautiful, spiritual track featuring a glorious blend of sustained voices singing in harmony. Perfect for weddings, funerals, remembrance services, commemorative videos, advertisements, documentaries, family videos, photo slide shows or any project with an emotional, inspirational tone.",
    "genre": "Classical",
    "instrumentation": "Choir",
    "tags": "angelic, angels, beautiful, children, choir, church, cinematic, emotional, expressive, female voice, funeral, glorious, glory, god, heaven, heavenly, hopeful, hymn, inspirational, moving, peaceful, reflective, religious, singers, singing, spiritual, uplifting, vocal, voice, wedding",
    "price": 20,
    "date": "2015-01-29",
    "videoId": "H2M5_SSx-Lc",
    "youtubeUrl": "https://www.youtube.com/watch?v=H2M5_SSx-Lc",
    "productUrl": "https://audiojungle.net/item/angelic-choir/10190237",
    "duration": "2:21"
  },
  {
    "title": "Hopes and Dreams",
    "description": "A beautiful, expressive track featuring piano with orchestral strings, woodwind, brass and percussion. An ideal backing for advertisements, documentaries, wedding videos, family videos, photo slide shows or a video montage.",
    "genre": "Sentimental",
    "instrumentation": "Piano, orchestral strings, woodwind, brass, percussion",
    "tags": "advert, advertisement, beautiful, believe, charity, commercial, dream, dreamy, faith, family, family tree, heartfelt, hope, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestral, piano, reflective, romantic, sentimental, strings, uplifting, wedding",
    "price": 24,
    "date": "2015-01-28",
    "videoId": "KFshZgz0iOI",
    "youtubeUrl": "https://www.youtube.com/watch?v=KFshZgz0iOI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786835-Hopes-and-Dreams-3m30?ref=dreamnotemusic",
    "duration": "3:30"
  },
  {
    "title": "Gifts of Nature",
    "description": "A beautiful, expressive track featuring piano, pizzicato strings and orchestra. An ideal backing for wedding videos, advertisements, photo slideshows, family videos or any project with an emotional tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, pizzicato strings, orchestra",
    "tags": "advert, advertisement, advertising, beautiful, commemorative, commercial, documentary, dreaming, dreamy, family, heartfelt, inspirational, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, positive, romantic, sentimental, strings, uplifting, valentines, video, wedding",
    "price": 20,
    "date": "2015-01-26",
    "videoId": "0Lmpqa5JbZM",
    "youtubeUrl": "https://www.youtube.com/watch?v=0Lmpqa5JbZM",
    "productUrl": "https://audiojungle.net/item/gifts-of-nature/10156076",
    "duration": "2:21"
  },
  {
    "title": "Cinematic Logo 1",
    "description": "This cinematic logo features an expressive orchestral crescendo in true Hollywood style, making the perfect movie opening, film company intro, YouTube video logo, reveal or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion",
    "tags": "big screen, cinematic, climax, credits, crescendo, film, film ident, film intro, growing, hollywood, ident, inspirational, intro, logo, motion picture, movie, opening, orchestra, orchestral, piano, pictures, powerful, reveal, strings, sweeping, title, title music, titles, trailer, youtube",
    "price": 10,
    "date": "2015-01-23",
    "videoId": "KvXsafQeOAA",
    "youtubeUrl": "https://www.youtube.com/watch?v=KvXsafQeOAA",
    "productUrl": "https://audiojungle.net/item/cinematic-logo-1/10116921",
    "duration": "0:15"
  },
  {
    "title": "In the Moonlight",
    "description": "An atmospheric and emotional track featuring a haunting piano motif surrounded by sustained orchestral harmonies and angelic choir. Perfect for film/movie soundtracks, book trailers, TV dramas or any fantasy/love scene.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Piano, orchestra, choir",
    "tags": "angelic, atmospheric, beautiful, choir, cinematic, dark, dreamy, dystopia, enchanting, fantasy, forbidden, haunting, heartfelt, heavenly, hope, inspirational, inspiring, love theme, magical, midnight, moody, moving, mysterious, orchestra, piano, romance, soundtrack, twilight, utopia, vampire",
    "price": 20,
    "date": "2015-01-22",
    "videoId": "JRqhQb6EHPo",
    "youtubeUrl": "https://www.youtube.com/watch?v=JRqhQb6EHPo",
    "productUrl": "https://audiojungle.net/item/in-the-moonlight/10105786",
    "duration": "2:54"
  },
  {
    "title": "Elegant Piano Logo 4",
    "description": "Elegant, bright and positive, this logo would suit a variety of uses in TV, radio, YouTube videos and advertising.",
    "genre": "Corporate",
    "instrumentation": "Piano",
    "tags": "advert, advertisement, advertising, atmospheric, beautiful, bright, classic, classy, clean, company, corporate, elegant, emotional, flash intro, ident, inspirational, inspiring, intro, jingle, logo, modern, opener, optimistic, piano, positive, presentation, product, smooth, theme, video",
    "price": 10,
    "date": "2015-01-20",
    "videoId": "QjyufvGL5YQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=QjyufvGL5YQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784790-Elegant-Piano-Logo-4?ref=dreamnotemusic",
    "duration": "0:13"
  },
  {
    "title": "A New Day",
    "description": "A beautiful, uplifting track, full of positivity and hope. An ideal backing for advertisements, family videos, documentaries, commercials, photo slide shows or a video montage.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, advertisement, corporate, enthusiastic, family tree, fast, happy, heartfelt, hope, inspirational, inspire, inspiring, life, love, memories, motivational, movement, moving, optimistic, orchestra, passion, piano, positive, quick, romantic, sentimental, strings, uplifting, warm, wedding",
    "price": 24,
    "date": "2015-01-19",
    "videoId": "npq_ccdLo4k",
    "youtubeUrl": "https://www.youtube.com/watch?v=npq_ccdLo4k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311472-A-New-Day-2m31?ref=dreamnotemusic",
    "duration": "2:31"
  },
  {
    "title": "No Limits",
    "description": "A high-energy track with plenty of drive and enthusiasm, featuring distortion guitars, rock drums, bass, piano and synths. Inspiring and motivating, this would be perfect for advertising, sports videos, holiday/travel/gap year videos and anything needing that lively, positive, feel-good vibe.",
    "genre": "Corporate",
    "instrumentation": "Electric guitars, drums, bass, piano, synth",
    "tags": "adventure, advert, advertising, commercial, confident, driven, driving, electric, energetic, exciting, extreme sports, fun, gap year, holiday, loud, marketing, motivational, positive, powerful, racing, rock band, rock climbing, skateboarding, skiing, snowboarding, spring break, travel, vacation, Water Sports",
    "price": 24,
    "date": "2015-01-15",
    "videoId": "KZuyW-8mWKc",
    "youtubeUrl": "https://www.youtube.com/watch?v=KZuyW-8mWKc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801666-No-Limits-3m22?ref=dreamnotemusic",
    "duration": "3:22"
  },
  {
    "title": "Piano and Orchestra Logo 1",
    "description": "This cinematic logo features a bright, cascading piano scale with orchestral strings crescendo, making the perfect movie opening, intro, YouTube video, reveal, logo or ident.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Piano, orchestra",
    "tags": "cascade, cinematic, climatic, climax, credits, crescendo, film, film ident, film intro, flourish, game, game intro, growing, ident, inspirational, intro, logo, movie, opening, orchestra, orchestral, piano, powerful, reveal, strings, sweeping, title, title music, titles, trailer",
    "price": 10,
    "date": "2015-01-09",
    "videoId": "8x1Izb2A6H4",
    "youtubeUrl": "https://www.youtube.com/watch?v=8x1Izb2A6H4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201800662-Piano-and-Orchestra-Logo-1?ref=dreamnotemusic",
    "duration": "0:08"
  },
  {
    "title": "For You, My Love",
    "description": "An expressive, romantic track featuring beautiful piano, acoustic guitar and orchestra. Perfect for Valentine’s Day videos, weddings, movie love scenes, advertisements, family videos or a photo montage.",
    "genre": "Wedding",
    "instrumentation": "Piano, acoustic guitar, orchestra",
    "tags": "anniversary, beautiful, dreamy, emotional, engagement, fiance, girlfriend, husband, inspirational, joyful, life, love, marriage, memories, montage, moving, orchestra, piano, proposal, propose, romance, romantic, sentimental, strings, valentine, valentine's day, valentines, video, wedding, wife",
    "price": 24,
    "date": "2015-01-08",
    "videoId": "iFEPkN9kpEw",
    "youtubeUrl": "https://www.youtube.com/watch?v=iFEPkN9kpEw",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785217-For-You,-My-Love-2m37?ref=dreamnotemusic",
    "duration": "2:37"
  },
  {
    "title": "Special Moments",
    "description": "A beautiful, expressive track featuring piano, cello, orchestral strings, woodwind and brass. An ideal backing for advertisements, family videos, photo slide shows or a video montage.",
    "genre": "Wedding",
    "instrumentation": "Piano, cello, orchestral strings, woodwind, brass",
    "tags": "advert, advertisement, commemorative, dreaming, dreamy, family, family tree, happy, heartfelt, inspirational, inspire, inspiring, life, love, memories, montage, moving, nature, orchestra, orchestral, piano, romantic, sentimental, strings, time-lapse, uplifting, valentines, video, warm, wedding",
    "price": 24,
    "date": "2015-01-05",
    "videoId": "MzLNv8limTM",
    "youtubeUrl": "https://www.youtube.com/watch?v=MzLNv8limTM",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201803929-Special-Moments-2m32?ref=dreamnotemusic",
    "duration": "2:32"
  },
  {
    "title": "Elegant Piano Logo 3",
    "description": "Elegant, bright and positive, this logo would suit a variety of uses in TV, YouTube videos, radio and advertising.",
    "genre": "Corporate",
    "instrumentation": "Piano, synth pads",
    "tags": "advert, advertisement, advertising, atmospheric, beautiful, bright, chill, classic, classy, clean, company, corporate, elegant, emotional, flash intro, ident, inspirational, inspiring, intro, jingle, logo, modern, opener, optimistic, piano, positive, presentation, product, smooth, theme",
    "price": 10,
    "date": "2015-01-02",
    "videoId": "Wx4hDGXraXg",
    "youtubeUrl": "https://www.youtube.com/watch?v=Wx4hDGXraXg",
    "productUrl": "https://audiojungle.net/item/elegant-piano-logo-3/9946281",
    "duration": "0:10"
  },
  {
    "title": "Far Away Lands",
    "description": "An encouraging and optimistic track featuring electric guitars, piano, drums, bass and orchestral strings. Ideal for any motivational production, corporate presentation, promotional material or inspirational video.",
    "genre": "Corporate",
    "instrumentation": "Electric guitars, piano, drums, bass, orchestral strings",
    "tags": "advert, advertisement, band, business, commercial, corporate, drums, dynamic, encouraging, energetic, energy, freedom, guitar, happy, hopeful, inspirational, inspiring, lively, motivation, motivational, optimistic, piano, pop, positive, rock, sales, strings, success, successful, uplifting",
    "price": 24,
    "date": "2015-01-02",
    "videoId": "v0Cb3Cg2_oY",
    "youtubeUrl": "https://www.youtube.com/watch?v=v0Cb3Cg2_oY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201785276-Far-Away-Lands-2m47?ref=dreamnotemusic",
    "duration": "2:47"
  },
  {
    "title": "Elegant Piano Logo 1",
    "description": "Elegant, bright and positive, this logo would suit a variety of uses in TV, YouTube videos, radio and advertising.",
    "genre": "Corporate",
    "instrumentation": "Piano",
    "tags": "advert, advertisement, advertising, atmospheric, beautiful, bright, chilled, classic, classy, clean, company, corporate, elegant, emotional, flash intro, ident, inspirational, inspiring, intro, jingle, logo, modern, opener, optimistic, piano, positive, presentation, product, smooth, theme",
    "price": 10,
    "date": "2014-12-30",
    "videoId": "VbSFHWHDEc0",
    "youtubeUrl": "https://www.youtube.com/watch?v=VbSFHWHDEc0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784793-Elegant-Piano-Logo-1?ref=dreamnotemusic",
    "duration": "0:10"
  },
  {
    "title": "Elegant Piano Logo 2",
    "description": "Elegant, bright and positive, this logo would suit a variety of uses in TV, YouTube videos, radio and advertising.",
    "genre": "Corporate",
    "instrumentation": "Piano",
    "tags": "advert, advertisement, advertising, atmospheric, beautiful, bright, chill, classic, classy, clean, company, corporate, elegant, emotional, flash intro, ident, inspirational, inspiring, intro, jingle, logo, modern, opener, optimistic, piano, positive, presentation, product, smooth, theme",
    "price": 10,
    "date": "2014-12-30",
    "videoId": "PRQSJj6Eh9Y",
    "youtubeUrl": "https://www.youtube.com/watch?v=PRQSJj6Eh9Y",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784791-Elegant-Piano-Logo-2?ref=dreamnotemusic",
    "duration": "Length TBC"
  },
  {
    "title": "New Horizons",
    "description": "With a hopeful, inspiring tone, ‘New Horizons’ features a repeating piano motif surrounded by warm pads, strings, pianos and percussion, building gradually with drums towards a positive end. Perfect for use in corporate promotional material, presentations, adverts and commercials.",
    "genre": "Corporate",
    "instrumentation": "Piano, synth pad, strings, percussion",
    "tags": "achievement, advertisement, advertising, background, bright, business, commercial, confidence, confident, corporate, happy, hope, hopeful, inspiration, inspirational, inspiring, light, marketing, motivation, motivational, optimistic, piano, positive, presentation, progress, promotional, success, successful, upbeat, uplifting",
    "price": 20,
    "date": "2014-12-29",
    "videoId": "OnngLCOiI7w",
    "youtubeUrl": "https://www.youtube.com/watch?v=OnngLCOiI7w",
    "productUrl": "https://audiojungle.net/item/new-horizons/9848986",
    "duration": "Length TBC"
  },
  {
    "title": "Moments in Time",
    "description": "An expressive, inspirational track featuring piano and orchestra. Perfect for use in adverts/commercials, documentaries, family videos/montages, movie/film/TV soundtracks or any project requiring a thought-provoking musical backing.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, beautiful, believe, charity, commercial, dream, dreaming, dreamy, emotional, expressive, faith, family, family tree, happy, hope, hopeful, inspirational, inspiring, life, love, memories, moving, nature, positive, religion, romantic, sentimental, timelapse, uplifting, wedding",
    "price": 20,
    "date": "2014-12-19",
    "videoId": "uvJ6jVScEKg",
    "youtubeUrl": "https://www.youtube.com/watch?v=uvJ6jVScEKg",
    "productUrl": "https://audiojungle.net/item/moments-in-time/9813239",
    "duration": "2:02"
  },
  {
    "title": "The Start of Something New",
    "description": "An optimistic, positive and rhythmic track featuring layered pianos, pizzicato strings and atmospheric guitar harmonics. Perfect for adverts/commercials, corporate presentations or any project needing an inspirational background.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, electric guitar",
    "tags": "achieve, advert, advertising, background, business, commercial, confident, corporate, encouraging, hope, hopeful, inspiration, inspirational, inspired, inspiring, marketing, motivate, motivated, motivating, motivation, motivational, piano, presentation, progress, promotion, promotional, prosperous, success, successful, uplifting",
    "price": 24,
    "date": "2014-12-09",
    "videoId": "saYMpfLSOHA",
    "youtubeUrl": "https://www.youtube.com/watch?v=saYMpfLSOHA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806720-The-Start-of-Something-New-2m23?ref=dreamnotemusic",
    "duration": "2:23"
  },
  {
    "title": "Innocence",
    "description": "A beautiful, peaceful track featuring a gentle, flowing piano motif accompanied by acoustic guitar and strings. Perfect for family/wedding videos, films/movies/TV or any project of an emotional nature.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, strings",
    "tags": "acoustic guitar, advert, advertising, beautiful, calm, cello, commercial, easy-going, emotion, emotional, flowing, gentle, gently, guitar, mellow, orchestral, peace, peaceful, piano, quiet, relaxing, sentimental, smooth, soothing, still, strings, subtle, tranquil, uplifting, violin",
    "price": 24,
    "date": "2014-12-05",
    "videoId": "sFahe_zUb3c",
    "youtubeUrl": "https://www.youtube.com/watch?v=sFahe_zUb3c",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793445-Innocence-2m31?ref=dreamnotemusic",
    "duration": "2:31"
  },
  {
    "title": "Majestic Fanfare and Theme",
    "description": "Patriotic and moving, this piece combines a majestic brass fanfare with an uplifting orchestral theme, accompanied by rhythmic, marching snare-drum. Perfect for graduation and awards ceremonies, sporting events, live outdoor events, film, TV or any project of an inspirational or motivational nature.",
    "genre": "Classical",
    "instrumentation": "Orchestral strings, brass, snare-drum",
    "tags": "anthem, atmospheric, brass, fanfare, film, graduation, heroes, honour, inspirational, inspiring, majestic, march, memorial, military, movie, moving, nostalgic, olympics, orchestra, orchestral, patriotic, pride, proud, regal, royal, snare-drum, soundtrack, sporting, trumpet, war",
    "price": 20,
    "date": "2014-12-04",
    "videoId": "80we8WOGpmY",
    "youtubeUrl": "https://www.youtube.com/watch?v=80we8WOGpmY",
    "productUrl": "https://audiojungle.net/item/majestic-fanfare-and-theme/9674822",
    "duration": "3:29"
  },
  {
    "title": "Christmas Eve",
    "description": "A magical, atmospheric song featuring angelic female vocals with piano and orchestra. Perfect for Christmas adverts/commercials, TV/films, animations or charity campaigns.",
    "genre": "Christmas",
    "instrumentation": "Female vocals, piano, orchestra",
    "tags": "advert, angelic, beautiful, bright, cheerful, children, christmas, commercial, delightful, emotional, enchanting, fantasy, female vocals, festive, girl, hopeful, inspirational, inspiring, love, lovely, magic, magical, seasonal, sentimental, singer, singing, snow, snowflakes, winter, xmas",
    "price": 20,
    "date": "2014-12-02",
    "videoId": "8Xmm76WB-kw",
    "youtubeUrl": "https://www.youtube.com/watch?v=8Xmm76WB-kw",
    "productUrl": "https://audiojungle.net/item/christmas-eve/55665154",
    "duration": "2:25"
  },
  {
    "title": "Aspire to Inspire",
    "description": "An uplifting, optimistic and positively inspirational track featuring bright piano, energetic drums, guitars, strings and bass. Ideal for any motivational production, business/corporate presentation, promotional material or inspirational video.",
    "genre": "Corporate",
    "instrumentation": "Piano, drums, guitar, strings, bass",
    "tags": "advert, advertisement, band, business, commercial, corporate, drums, dynamic, encouraging, energetic, energy, freedom, guitar, happy, hopeful, inspirational, inspiring, lively, motivation, motivational, optimistic, piano, pop, positive, rock, sales, strings, success, successful, uplifting",
    "price": 24,
    "date": "2014-11-26",
    "videoId": "xrCZuoABw8E",
    "youtubeUrl": "https://www.youtube.com/watch?v=xrCZuoABw8E",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311591-Aspire-to-Inspire-2m05?ref=dreamnotemusic",
    "duration": "2:05"
  },
  {
    "title": "Beautiful Moments",
    "description": "An inspirational and emotional track with an elegant piano motif surrounded by acoustic guitars, bass, light drums and rich orchestral strings. Perfect for inspiring presentations, adverts/commercials, TV/movie/film scenes, romantic videos or family/wedding videos.",
    "genre": "Sentimental",
    "instrumentation": "Piano, acoustic guitar, bass, drums, orchestral strings",
    "tags": "advert, advertisement, beautiful, bright, cinematic, commercial, contemplative, corporate, dreamy, elegant, emotional, hopeful, inspiration, inspirational, inspire, inspired, inspiring, motivation, motivational, moving, nostalgic, piano, reflective, romantic, sentimental, strings, success, uplifting, wedding",
    "price": 24,
    "date": "2014-11-20",
    "videoId": "-89OC2OvMJI",
    "youtubeUrl": "https://www.youtube.com/watch?v=-89OC2OvMJI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483646-Beautiful-Moments-2m34?ref=dreamnotemusic",
    "duration": "2:34"
  },
  {
    "title": "Dancing Snowflakes",
    "description": "A magical, atmospheric Christmas track featuring pianos, bright bells, glockenspiel, strings and orchestra. Perfect for Christmas adverts/commercials, TV/movies, documentaries, YouTube videos, animations or any project requiring a cheerful, festive backing.",
    "genre": "Christmas",
    "instrumentation": "Piano, bells, glockenspiel, orchestral strings",
    "tags": "advert, ambient, atmospheric, beautiful, bells, bright, cheerful, children, christmas, dancing, documentary, dreamy, fantasy, festive, holidays, magic, magical, photography, romantic, scenic, seasonal, sentimental, snow, snowflakes, timelapse, winter, wish, wonder, wonderland, xmas",
    "price": 20,
    "date": "2014-11-12",
    "videoId": "zAqYXT_wCoU",
    "youtubeUrl": "https://www.youtube.com/watch?v=zAqYXT_wCoU",
    "productUrl": "https://audiojungle.net/item/dancing-snowflakes/9449391",
    "duration": "2:30"
  },
  {
    "title": "Inspire to Achieve",
    "description": "A positive and inspirational track featuring subtle, layered pianos and soft strings over a pulsing bass drum. Ideal for use in corporate promotional material, presentations, adverts and commercials or any project with an optimistic, motivational tone.",
    "genre": "Corporate",
    "instrumentation": "Piano, strings, drums",
    "tags": "achieve, advert, advertising, background, bright, business, commercial, confident, corporate, encouraging, hope, hopeful, inspiration, inspirational, inspired, inspiring, marketing, motivate, motivated, motivation, motivational, presentation, progress, promotion, promotional, prosperous, success, successful, upbeat, uplifting",
    "price": 24,
    "date": "2014-11-11",
    "videoId": "Y_z28WEs1Po",
    "youtubeUrl": "https://www.youtube.com/watch?v=Y_z28WEs1Po",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793938-Inspire-to-Achieve-2m07?ref=dreamnotemusic",
    "duration": "2:07"
  },
  {
    "title": "Emotional Piano 2",
    "description": "A sentimental, melancholic and expressive track featuring piano accompanied by orchestral strings. Perfect for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of a sentimental or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, advertisement, background, beautiful, commercial, contemplative, corporate, dream, elegant, emotional, emotive, film, haunting, hopeful, inspirational, inspiring, loss, love, melancholic, memories, piano, reflective, romantic, sad, sentimental, soft, strings, thoughtful, video, wedding",
    "price": 24,
    "date": "2014-11-07",
    "videoId": "eJOjPu99nMc",
    "youtubeUrl": "https://www.youtube.com/watch?v=eJOjPu99nMc",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784431-Emotional-Piano-2-2m15?ref=dreamnotemusic",
    "duration": "2:15"
  },
  {
    "title": "Pass the Parcel",
    "description": "A cheerful, playful track featuring piano, guitar, glockenspiel and drums. Ideal for children’s parties, computer games, YouTube videos, comedy sketches, apps, commercials, cartoons/animations or advertising.",
    "genre": "Children's",
    "instrumentation": "Piano, guitar, glockenspiel, drums",
    "tags": "animation, app, bouncy, bright, bubbly, cartoon, catchy, cheerful, cheery, children, comedy, fun, funny, game, happy, innocent, kids, lively, loop, party, platform game, play, positive, quirky, summer, toy, upbeat, uplifting, vibrant, youtube",
    "price": 24,
    "date": "2014-11-06",
    "videoId": "9vuJqs_iNvk",
    "youtubeUrl": "https://www.youtube.com/watch?v=9vuJqs_iNvk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201801664-Pass-the-Parcel?ref=dreamnotemusic",
    "duration": "Length TBC"
  },
  {
    "title": "Remember",
    "description": "A nostalgic and sentimental track featuring piano accompanied by soft, subtle orchestral strings. Perfect for history documentaries, remembrance services, memorial videos, adverts/commercials, charity campaigns or any project with a sincere, heartfelt, emotional tone.",
    "genre": "Piano",
    "instrumentation": "Piano, orchestral strings",
    "tags": "beautiful, cinematic, contemplative, dreamy, elegant, emotional, expressive, gentle, haunting, heartfelt, hopeful, innocent, melancholic, memorial, memorial video, memories, moving, nostalgic, peaceful, piano, remember, remembrance, Remembrance Day, sad, sadness, sentimental, sorrow, thought-provoking, thoughtful, touching",
    "price": 24,
    "date": "2014-11-04",
    "videoId": "8TYtFhRYGdk",
    "youtubeUrl": "https://www.youtube.com/watch?v=8TYtFhRYGdk",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201804150-Remember-2m12?ref=dreamnotemusic",
    "duration": "2:12"
  },
  {
    "title": "Be Inspired",
    "description": "A positive, energetic track featuring melodic piano and layered guitars accompanied by feel-good drums and driving bass. Confident, optimistic and motivational, this track would suit a variety of applications.",
    "genre": "Corporate",
    "instrumentation": "Piano, guitar, drums, bass",
    "tags": "advert, advertisement, advertising, bright, business, confidence, confident, corporate, drums, energetic, energy, feel good, free, freedom, guitar, happy, hope, motivation, motivational, optimistic, piano, pop, positive, power, powerful, rock, strong, success, trust, uplifting",
    "price": 24,
    "date": "2014-10-28",
    "videoId": "f9n2wwBSYgY",
    "youtubeUrl": "https://www.youtube.com/watch?v=f9n2wwBSYgY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201483476-Be-Inspired-2m39?ref=dreamnotemusic",
    "duration": "2:39"
  },
  {
    "title": "Emotional Piano 1",
    "description": "A sentimental, reflective track featuring piano accompanied by expressive orchestral strings. Perfect for use in adverts/commercials, documentaries, TV charity appeals, movie/film soundtracks or any project of a sentimental or heartfelt nature.",
    "genre": "Piano",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, background, beautiful, commercial, contemplative, corporate, dream, elegant, emotional, emotive, family, film, haunting, hopeful, inspirational, inspiring, loss, love, melancholic, memories, piano, reflective, romantic, sad, sentimental, soft, thoughtful, uplifting, video, wedding",
    "price": 24,
    "date": "2014-10-28",
    "videoId": "oWkvn5b1w3U",
    "youtubeUrl": "https://www.youtube.com/watch?v=oWkvn5b1w3U",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201784517-Emotional-Piano-1-2m53?ref=dreamnotemusic",
    "duration": "2:53"
  },
  {
    "title": "Magical Snowflakes",
    "description": "An atmospheric, dreamy Christmas track featuring pianos, glockenspiel and percussion. Perfect for seasonal adverts/commercials, TV/movies, Christmas YouTube videos, animations or any project requiring a beautiful, festive backing.",
    "genre": "Christmas",
    "instrumentation": "Piano, glockenspiel, percussion",
    "tags": "advert, atmospheric, beautiful, bright, children, christmas, documentary, dreamy, fantasy, festive, holidays, magic, magical, nature, photography, relaxing, romantic, scenic, seasonal, sentimental, snow, snowflakes, timelapse, vlogmas, wildlife, winter, wish, wonder, wonderland, xmas",
    "price": 20,
    "date": "2014-10-23",
    "videoId": "tG1YH2Zs53g",
    "youtubeUrl": "https://www.youtube.com/watch?v=tG1YH2Zs53g",
    "productUrl": "https://audiojungle.net/item/magical-snowflakes/9266022",
    "duration": "2:18"
  },
  {
    "title": "Christmas Logo 1",
    "description": "A short, bright jingle/logo/ident featuring sleigh bells, glockenspiel, choir and strings. Ideal for use in Christmas advertisements, commercials, YouTube vlogs/videos, radio intros, video games, apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Piano, sleigh bells, glockenspiel, choir, strings",
    "tags": "advertising, app, bells, bright, carol, carols, christian, christmas, festive, glockenspiel, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, tubular bells, vlogmas, web intro, xmas, youtube",
    "price": 10,
    "date": "2014-10-22",
    "videoId": "rn4VP6skQEo",
    "youtubeUrl": "https://www.youtube.com/watch?v=rn4VP6skQEo",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201756838-christmas-logo-1-bright-orchestral-jingle?ref=dreamnotemusic",
    "duration": "0:11"
  },
  {
    "title": "Christmas Logo 2",
    "description": "A happy, bright logo/ident/jingle featuring sleigh bells, celesta and warm strings. Ideal for use in Christmas advertisements, commercials, YouTube vlogs/videos, radio intros, video games, apps, corporate promotional material, TV or any project of a festive nature.",
    "genre": "Christmas",
    "instrumentation": "Sleigh bells, celesta, strings",
    "tags": "advertising, bells, bright, carol, carols, christian, christmas, festive, happy, ident, inspiring, intro, jingle, jolly, logo, merry, orchestra, radio, ring-tone, santa, seasonal, sleigh bells, snow, strings, tubular bells, video intro, vlogmas, web intro, xmas, youtube",
    "price": 8,
    "date": "2014-10-22",
    "videoId": "cCQeJg0-hso",
    "youtubeUrl": "https://www.youtube.com/watch?v=cCQeJg0-hso",
    "productUrl": "https://audiojungle.net/item/christmas-logo-2/9253711",
    "duration": "0:08"
  },
  {
    "title": "Musical Chairs",
    "description": "A positively happy and playful track featuring bouncy piano, guitar, glockenspiel and percussion effects. Perfect for children’s parties, computer games, YouTube videos, apps, cartoons/animations or advertising.",
    "genre": "Children's",
    "instrumentation": "Piano, guitar, glockenspiel, percussion",
    "tags": "animation, app, bouncy, bright, bubbly, cartoon, catchy, cheerful, cheery, children, comedy, fun, funny, game, happy, innocent, kids, lively, loop, party, platform game, play, positive, quirky, summer, toy, upbeat, uplifting, vibrant",
    "price": 20,
    "date": "2014-10-20",
    "videoId": "Rfm7OYIvQ10",
    "youtubeUrl": "https://www.youtube.com/watch?v=Rfm7OYIvQ10",
    "productUrl": "https://audiojungle.net/item/musical-chairs/9237366",
    "duration": "2:29"
  },
  {
    "title": "Deep in Thought",
    "description": "A mellow, solo piano track, blending rippling arpeggios with soft melodies, creating a sentimental, atmospheric tone. Ideal for adverts/commercials, documentaries, TV/film/movie soundtracks or time-lapse videos.",
    "genre": "Piano",
    "instrumentation": "Piano",
    "tags": "advertisement, ambient, arpeggios, atmospheric, classical, commercial, documentary, emotion, emotional, family, film, love, marriage, melancholic, mellow, minimal, minimalistic, movie, nostalgic, passion, pianist, piano, sad, sensitive, sentimental, solo travel, sorrow, soundtrack, time-lapse, wedding",
    "price": 20,
    "date": "2014-10-19",
    "videoId": "gWj01qBQfmY",
    "youtubeUrl": "https://www.youtube.com/watch?v=gWj01qBQfmY",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781586-Deep-in-Thought-1m50?ref=dreamnotemusic",
    "duration": "1:50"
  },
  {
    "title": "Dramatic and Inspirational Trailer with Vocals",
    "description": "Heavenly female voice accompanied by full orchestra and drums. This epic, dramatic track is both atmospheric and uplifting. Perfect for use as a movie/film/game trailer or soundtrack.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Female voice, orchestra, percussion",
    "tags": "angelic, atmospheric, beautiful, choir, cinematic, dramatic, dystopia, enchanting, epic, fantasy, female vocal, female voice, film trailer, flying, game trailer, grand, heavenly, hope, inspirational, inspiring, magical, movie trailer, new world, orchestral, uplifting, utopia, vocal, voice, womans voice, wonderland",
    "price": 20,
    "date": "2014-10-18",
    "videoId": "MBnEAImA_gM",
    "youtubeUrl": "https://www.youtube.com/watch?v=MBnEAImA_gM",
    "productUrl": "https://audiojungle.net/item/dramatic-inspirational-trailer-with-vocals/9067212",
    "duration": "2:55"
  },
  {
    "title": "Happy Halloween",
    "description": "A classic comedy horror track featuring harpsichord, orchestra, haunting choir and ghostly female voice. Perfect for any Halloween or horror themed advertising, events, games, TV specials, YouTube videos or animations.",
    "genre": "Horror",
    "instrumentation": "Harpsichord, orchestra, haunting choir, female voice",
    "tags": "animation, cartoon, comedy, creepy, dark, dracula, fear, female vocal, fright, funny, ghosts, ghouls, halloween, harpsichord, haunted, haunted house, haunting, horror, monsters, operatic voice, orchestral, playful, quirky, scary, skeletons, spooky, strings, trick or treat, witch",
    "price": 20,
    "date": "2014-10-15",
    "videoId": "HP-NeYlrlP4",
    "youtubeUrl": "https://www.youtube.com/watch?v=HP-NeYlrlP4",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787097-Happy-Halloween?ref=dreamnotemusic",
    "duration": "1:28"
  },
  {
    "title": "Horror Suspense",
    "description": "A dark, scary and suspenseful track featuring orchestral strings, woodwind, brass and percussion with atmospheric drones and eerie sound effects. Perfect for use in horror movie trailers, film scores, ghost story audiobooks, thrillers or video games.",
    "genre": "Horror",
    "instrumentation": "Orchestral strings, woodwind, brass, percussion, sound effects.",
    "tags": "atmospheric, background, book trailer, creepy, dark, dead, death, evil, freaky, ghost, ghostly, gothic, halloween, haunted, haunting, hell, horror, movie, murder, mysterious, mystery, night, scary, soundscape, soundtrack, spooky, suspense, terror, thriller, twisted",
    "price": 16,
    "date": "2014-10-15",
    "videoId": "pXiRAplTT6k",
    "youtubeUrl": "https://www.youtube.com/watch?v=pXiRAplTT6k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201786917-Horror-Suspense?ref=dreamnotemusic",
    "duration": "0:48"
  },
  {
    "title": "Twisted Lullaby",
    "description": "A creepy, haunting music box lullaby with dark piano accompaniment and ghostly sound effects. Ideal for use in horror movie trailers, mystery documentaries, Halloween TV specials, film scores, ghost story audiobooks, thrillers, YouTube videos or computer games.",
    "genre": "Horror",
    "instrumentation": "Music box, piano, sound effects",
    "tags": "child, creepy, dark, death, demented, demon, evil, film score, ghost, gothic, halloween, haunted, haunting, hell, horror, lullaby, murder, music box, night, nightmare, possessed, psycho, scary, serial killer, soundtrack, spooky, suspense, thriller, trailer, twisted",
    "price": 14,
    "date": "2014-10-15",
    "videoId": "aCn8kmihB5E",
    "youtubeUrl": "https://www.youtube.com/watch?v=aCn8kmihB5E",
    "productUrl": "https://audiojungle.net/item/twisted-lullaby/9190596",
    "duration": "0:43"
  },
  {
    "title": "Inspirational Piano 3",
    "description": "An inspirational and expressive track featuring piano and orchestra. Perfect for weddings, adverts/commercials, family photo slideshows or any project of an emotional nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, orchestra",
    "tags": "advert, beautiful, commercial, dreaming, dreamy, emotional, expressive, family, heartfelt, inspirational, inspire, inspiring, life, love, magical, memories, moving, orchestral, piano, reflective, rich, romance, romantic, sentimental, strings, uplifting, valentines, video, wedding, wedding video",
    "price": 24,
    "date": "2014-10-11",
    "videoId": "iQv2PCFdXO0",
    "youtubeUrl": "https://www.youtube.com/watch?v=iQv2PCFdXO0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793879-Inspirational-Piano-3-2m10?ref=dreamnotemusic",
    "duration": "2:10"
  },
  {
    "title": "Inspirational Piano 2",
    "description": "An atmospheric, emotional track featuring an expressive piano motif accompanied by warm orchestral strings building gradually towards an emotional climax before a peaceful conclusion. Perfect for adverts/commercials, wedding videos, TV/movie/film soundtracks or any project of an emotional nature.",
    "genre": "Piano",
    "instrumentation": "Piano, orchestral strings",
    "tags": "beautiful, business, cinematic, contemplative, corporate, dreamy, elegant, emotional, exploration, freedom, hopeful, inspiration, inspirational, inspired, inspiring, motivating, motivational, moving, nostalgic, optimistic, orchestral, piano, positive, reflective, sentimental, soft, strings, success, uplifting, wedding",
    "price": 24,
    "date": "2014-10-09",
    "videoId": "C3h4riGuCZI",
    "youtubeUrl": "https://www.youtube.com/watch?v=C3h4riGuCZI",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201794005-Inspirational-Piano-2-2m13?ref=dreamnotemusic",
    "duration": "2:13"
  },
  {
    "title": "A Beautiful Life",
    "description": "A heartfelt and emotional track featuring warm strings building gradually over a repeating piano motif. An ideal backing for documentaries, adverts/commercials, wedding videos, commemorative photo slideshows, family videos or any project with a sentimental tone.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings",
    "tags": "advert, beautiful, believe, charity, commercial, dream, dreaming, dreamy, emotional, expressive, faith, family, family tree, happy, heartfelt, hope, hopeful, inspirational, inspiring, life, love, memories, moving, nature, positive, religion, romantic, sentimental, uplifting, wedding",
    "price": 24,
    "date": "2014-10-04",
    "videoId": "SI5j9HDceYQ",
    "youtubeUrl": "https://www.youtube.com/watch?v=SI5j9HDceYQ",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201311706-A-Beautiful-Life-2m39?ref=dreamnotemusic",
    "duration": "2:39"
  },
  {
    "title": "Angelic Children's Choir",
    "description": "‘Angelic Children’s Choir’ is an elegant and uplifting choral track featuring young voices singing in harmony. Both inspiring and emotional, this cinematic track would be perfect for any emotional, atmospheric film/movie soundtrack, trailer, documentary, wedding video or projects of a spiritual nature.",
    "genre": "Classical",
    "instrumentation": "Choir",
    "tags": "angelic, atmospheric, beautiful, believe, boys choir, children, choir, church, cinematic, dreamy, emotional, expressive, faith, glorious, glory, hope, hopeful, hymn, kids, moving, peaceful, reflective, religion, religious, singing, spiritual, vocal, voice, voices, wedding",
    "price": 20,
    "date": "2014-10-04",
    "videoId": "Jq-R2m79Cuc",
    "youtubeUrl": "https://www.youtube.com/watch?v=Jq-R2m79Cuc",
    "productUrl": "https://audiojungle.net/item/angelic-childrens-choir/9091488",
    "duration": "2:24"
  },
  {
    "title": "Dark Action Movie Trailer",
    "description": "Big, bold and tense, this track is perfect for those hard-hitting action film/movie/game trailers, teasers and soundtracks.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, woodwind, brass",
    "tags": "action, apocalypse, battle, big, blockbuster, combat, crime, drama, dramatic, epic, exciting, fight, fighting, film, hit, hollywood, loud, massive, movie, orchestral, powerful, revenge, teaser, tense, terror, thriller, tough, trailer, video game, war",
    "price": 24,
    "date": "2014-09-30",
    "videoId": "eJAO8u58dN8",
    "youtubeUrl": "https://www.youtube.com/watch?v=eJAO8u58dN8",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201781479-Dark-Action-Movie-Trailer-2m20?ref=dreamnotemusic",
    "duration": "2:20"
  },
  {
    "title": "Magical Christmas",
    "description": "A bright, uplifting festive Christmas fantasy featuring piano and sleigh bells with orchestral accompaniment. Ideal for use in movie/film/TV/game soundtracks, adverts/commercials or any festive, seasonal videos.",
    "genre": "Christmas",
    "instrumentation": "Piano, sleigh bells, orchestra",
    "tags": "advertising, beautiful, bright, children, christmas, commercial, fantasy, film, happy, holiday, inspirational, inspiring, magic, magical, motivational, movie, orchestral, promo, promotional, reindeer, santa, santa-claus, seasonal, sleigh-bells, snow, tv, uplifting, wonder, wonderland, xmas",
    "price": 18,
    "date": "2014-09-25",
    "videoId": "fJWZRlKJIPM",
    "youtubeUrl": "https://www.youtube.com/watch?v=fJWZRlKJIPM",
    "productUrl": "https://audiojungle.net/item/magical-christmas/8953891",
    "duration": "1:36"
  },
  {
    "title": "Technology of Tomorrow",
    "description": "A modern, evocative fusion of electronic tones and acoustic drums. This stylish, laid-back track features warm, haunting pads and lead synth melody, creating a lazy retro feel. Perfect for use in technological/electronics adverts or commercials, TV themes, car promo videos, time-lapse/montage videos, Sci-fi movie/film soundtracks or any project with a futuristic theme.",
    "genre": "Ambient",
    "instrumentation": "Lead synth, synth pads, drums",
    "tags": "advert, ambient, car, city, club, commercial, cool, digital, driving, electronic, energy, futuristic, game, industrial, innovative, lights, manufacturing, modern, movie, new-age, night, quirky, robots, sci-fi, science, space, technology, time-lapse, timelapse, tv",
    "price": 24,
    "date": "2014-09-19",
    "videoId": "1knb7R8Sj0A",
    "youtubeUrl": "https://www.youtube.com/watch?v=1knb7R8Sj0A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201807167-Technology-of-Tomorrow-2m04?ref=dreamnotemusic",
    "duration": "2:04"
  },
  {
    "title": "Inspirational Piano 1",
    "description": "An inspiring, emotional and thought-provoking track featuring piano accompanied by violins, cellos, french horn with orchestral woodwind, brass and percussion. Ideal for use in movie/film soundtracks, TV dramas, photo slideshows, wedding videos or any project of a reflective or heartfelt nature.",
    "genre": "Wedding",
    "instrumentation": "Piano, orchestra",
    "tags": "charming, delightful, dreams, dreamy, emotional, family, heartfelt, hope, hopeful, inspirational, inspiring, life, love, love scene, lovely, melancholy, memories, moving, nature, piano, reflective, rich, romantic, sentimental, strings, tender, uplifting, valentines, violins, wedding",
    "price": 24,
    "date": "2014-09-17",
    "videoId": "yKW6ioLl94A",
    "youtubeUrl": "https://www.youtube.com/watch?v=yKW6ioLl94A",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201793840-Inspirational-Piano-1-2m05?ref=dreamnotemusic",
    "duration": "2:05"
  },
  {
    "title": "Haunting Lost Souls",
    "description": "A haunting soundscape of vocals, pads and orchestral tones, creating an ethereal, atmospheric mood. Ideal for movies, TV, documentaries and video game soundtracks.",
    "genre": "Horror",
    "instrumentation": "Voice, pads, orchestra",
    "tags": "afraid, afterlife, atmosphere, atmospheric, dark, darkness, death, evil, film, game, ghosts, haunting, heaven, hell, horror, mourning, movie, out-of-body, purgatory, religious, sad, sadness, scary, sorrow, soundtrack, spooky, tv, vocal, voice, war cry",
    "price": 20,
    "date": "2014-09-09",
    "videoId": "SlfxliEsp9k",
    "youtubeUrl": "https://www.youtube.com/watch?v=SlfxliEsp9k",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201787260-Haunting-Lost-Souls?ref=dreamnotemusic",
    "duration": "1:14"
  },
  {
    "title": "Magical Fantasy",
    "description": "A beautiful, dreamy track featuring an atmospheric piano motif accompanied by warm orchestral strings, choir, woodwind, brass, percussion and magical effects (piano solo loop also included). Perfect for use in movies/films, TV, game soundtracks, documentaries, commercials or any magical fantasy/sci-fi scene.",
    "genre": "Cinematic Advert",
    "instrumentation": "Piano, orchestral strings, choir, woodwind, brass, percussion",
    "tags": "beautiful, book trailer, children, dream, dreamy, enchanted, fairies, fairytale, fantasy, film, folk, innocence, inspirational, inspiring, love, magic, magical, movie, mysterious, orchestra, piano, space, strings, theme, trailer, tv, twilight, uplifting, utopian, wonderland",
    "price": 20,
    "date": "2014-09-09",
    "videoId": "otsS3SCW5Kw",
    "youtubeUrl": "https://www.youtube.com/watch?v=otsS3SCW5Kw",
    "productUrl": "https://audiojungle.net/item/magical-fantasy/8801606",
    "duration": "2:47"
  },
  {
    "title": "Movie Company Ident",
    "description": "A powerful, suspenseful orchestral track featuring orchestral strings, brass and percussion. Perfect for use as a film/movie/TV company ident, intro or trailer.",
    "genre": "Cinematic Trailers",
    "instrumentation": "Orchestral strings, brass, percussion",
    "tags": "brass, cinematic, dark, epic, exciting, fear, film, game, ident, intro, introduction, logo, movie, opener, orchestra, orchestral, powerful, reveal, sample, scary, score, soundtrack, strings, suspense, suspenseful, teaser, theme, trailer, tv, youtube",
    "price": 10,
    "date": "2014-09-09",
    "videoId": "D53Zq1p_ZZ4",
    "youtubeUrl": "https://www.youtube.com/watch?v=D53Zq1p_ZZ4",
    "productUrl": "https://audiojungle.net/item/movie-company-ident/8805084",
    "duration": "0:18"
  },
  {
    "title": "TV Detective Theme",
    "description": "A mysterious, atmospheric track with a suspenseful, dark tone featuring classical guitar accompanied by orchestra. Perfect for murder-mystery TV dramas, documentaries or movie/film soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Classical guitar, orchestra",
    "tags": "book trailer, classic, classical guitar, clue, creepy, crime, dark, detective, documentary, drama, dramatic, film, haunting, horror, love, movie, murder, mysterious, mystery, strange, suspense, suspenseful, television, theme, thriller, tv, tv theme, twisted, weird, youtube",
    "price": 20,
    "date": "2014-09-09",
    "videoId": "0dD8BrbZGGA",
    "youtubeUrl": "https://www.youtube.com/watch?v=0dD8BrbZGGA",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201806901-TV-Detective-Theme-1m44?ref=dreamnotemusic",
    "duration": "1:44"
  },
  {
    "title": "War of Betrayal",
    "description": "A majestic, dignified and solemn military march beginning with a heavy string motif, leading into a choir and full orchestra climax. Perfect for movies/films, TV, game soundtracks, trailers or any project with a dark, suspenseful tone.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Orchestral strings, brass, choir, snare-drum",
    "tags": "apocalypse, army, battle, betray, cinematic, dark, darkness, death, devastating, epic, evil, fear, fighting, film, game soundtrack, military, movie, murder, orchestral, powerful, religion, revenge, sad, sadness, scary, solemn, suspense, tragedy, tragic, war",
    "price": 20,
    "date": "2014-09-09",
    "videoId": "1sNJbSFPWh0",
    "youtubeUrl": "https://www.youtube.com/watch?v=1sNJbSFPWh0",
    "productUrl": "https://www.pond5.com/royalty-free-music/item/201807080-War-of-Betrayal-1m52?ref=dreamnotemusic",
    "duration": "1:52"
  },
  {
    "title": "Military Procession",
    "description": "Patriotic and inspiring, this epic, orchestral theme opens with marching snare-drum before gradually expanding into a powerful choir and full orchestra crescendo. Ideal for use in documentaries, trailers, teasers, TV and movie/film/game soundtracks.",
    "genre": "Cinematic Soundtracks",
    "instrumentation": "Snare-drum, choir, strings, brass, woodwind, percussion",
    "tags": "army, arrival, atmospheric, battle, choir, cinematic, epic, film, game, honour, inspirational, loyal, memorial, military, mission, movie, moving, new world, orchestral, patriotic, pride, proud, remembrance, snare-drum, soundtrack, space, trailer, tv, uplifting, war",
    "price": 20,
    "date": "2014-09-08",
    "videoId": "MGdGrKr3q2A",
    "youtubeUrl": "https://www.youtube.com/watch?v=MGdGrKr3q2A",
    "productUrl": "https://audiojungle.net/item/military-procession/8796090",
    "duration": "2:11"
  },
  {
    "title": "TV Sitcom Ident",
    "description": "A quirky, fun, happy, uplifting theme tune featuring piano, bass and drums. Ideal for use in a TV sitcom, web series, YouTube video intro or as a TV/radio jingle.",
    "genre": "Comedy",
    "instrumentation": "Piano, Wurlitzer, bass, drums",
    "tags": "advert, advertising, comedian, comedy, commercial, cool, friends, fun, funky, funny, happy, ident, intro, jingle, logo, opener, podcast, quirky, radio, sassy, sitcom, sitcom theme, talk show, theme, theme tune, tv, video intro, vlog, webisode, youtube",
    "price": 10,
    "date": "2014-09-04",
    "videoId": "sQePvjTVVQo",
    "youtubeUrl": "https://www.youtube.com/watch?v=sQePvjTVVQo",
    "productUrl": "https://audiojungle.net/item/tv-sitcom-ident/8756789",
    "duration": "0:08"
  }
];
window.DREAMNOTE_CATEGORIES = [
  "Acoustic",
  "Ambient",
  "Children's",
  "Christmas",
  "Cinematic Advert",
  "Cinematic Soundtracks",
  "Cinematic Trailers",
  "Classical",
  "Comedy",
  "Corporate",
  "Horror",
  "Jazz",
  "Piano",
  "Sentimental",
  "Wedding"
];
